export interface IGeoLocation {
  state_id: string;
  state_code: number;
  state_name: string;
  district_id: string;
  district_code: number;
  district_name: string;
  block_id: string;
  block_code: number;
  block_name: string;
}

export const GEO_LOCATION: IGeoLocation[] = [
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150073',
    block_code: 1511001,
    block_name: 'BELTANGADI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17024',
    district_code: 1744,
    district_name: 'KATNI',
    block_id: 'B-170144',
    block_code: 1744001,
    block_name: 'RITHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313519',
    block_code: 3136008,
    block_name: 'SANDALPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4026',
    district_code: 412,
    district_name: 'MORIGAON',
    block_id: 'B-40164',
    block_code: 412098,
    block_name: 'MOIRABARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313395',
    block_code: 3160003,
    block_name: 'SADAT',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13011',
    district_code: 1311,
    district_name: 'SOLAN',
    block_id: 'B-130081',
    block_code: 1311001,
    block_name: 'DHARAMPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20200',
    block_code: 219019,
    block_name: 'MUDINEPALLE',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230058',
    block_code: 2306007,
    block_name: 'SHAMATOR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170155',
    block_code: 1724005,
    block_name: 'BHIKANGAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17030',
    district_code: 1732,
    district_name: 'NARMADAPURAM',
    block_id: 'B-170189',
    block_code: 1732005,
    block_name: 'SOHAGPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270160',
    block_code: 2712010,
    block_name: 'AMBER',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4028',
    district_code: 406,
    district_name: 'NALBARI',
    block_id: 'B-40182',
    block_code: 406003,
    block_name: 'PASCHIM NALBARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20458',
    block_code: 209033,
    block_name: 'KANDUKUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20116',
    block_code: 221009,
    block_name: 'INKOLLU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20442',
    block_code: 208001,
    block_name: 'YERRAGONDAPALEM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17044',
    district_code: 1719,
    district_name: 'SHAJAPUR',
    block_id: 'B-170272',
    block_code: 1719006,
    block_name: 'MOMAN BADODIY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240157',
    block_code: 2408023,
    block_name: 'TIKABALI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160122',
    block_code: 1614001,
    block_name: 'ATHIYANNUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20001',
    block_code: 215001,
    block_name: 'ADDATEEGALA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110143',
    block_code: 1110001,
    block_name: 'MAHESANA',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1002',
    district_code: 103,
    district_name: 'NORTH AND MIDDLE ANDAMAN',
    block_id: 'B-10006',
    block_code: 103003,
    block_name: 'RANGAT',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11013',
    district_code: 1111,
    district_name: 'GANDHINAGAR',
    block_id: 'B-110095',
    block_code: 1111002,
    block_name: 'GANDHINAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270015',
    block_code: 2706003,
    block_name: 'KATHUMAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50136',
    block_code: 507002,
    block_name: 'Tikari',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310208',
    block_code: 3124008,
    block_name: 'DAHGAVAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20277',
    block_code: 206017,
    block_name: 'GUDURU',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30005',
    district_code: 3007,
    district_name: 'SEPAHIJALA',
    block_id: 'B-300035',
    block_code: 3007003,
    block_name: 'KATHALIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313767',
    block_code: 3174002,
    block_name: 'KHALILABAD',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32014',
    district_code: 3224,
    district_name: 'KALIMPONG',
    block_id: 'B-320185',
    block_code: 3224005,
    block_name: 'PEDONG',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29009',
    district_code: 2901,
    district_name: 'KANCHIPURAM',
    block_id: 'B-290092',
    block_code: 2901002,
    block_name: 'WALAJABAD',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180201',
    block_code: 1806008,
    block_name: 'CHANDVAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290234',
    block_code: 2934018,
    block_name: 'TENKASI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320244',
    block_code: 3201017,
    block_name: 'TEHATTA TWO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20231',
    block_code: 217005,
    block_name: 'KAKINADA RURAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31350',
    district_code: 3170,
    district_name: 'KAUSHAMBI',
    block_id: 'B-313543',
    block_code: 3170002,
    block_name: 'NEVADA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320223',
    block_code: 3212023,
    block_name: 'SAGARDIGHI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33022',
    district_code: 3331,
    district_name: 'MANENDRAGARH CHIRIMIRI BHARATPUR',
    block_id: 'B-330100',
    block_code: 3331004,
    block_name: 'MANENDRAGARH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50423',
    block_code: 518003,
    block_name: 'DALSINGHSARAI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110122',
    block_code: 1107001,
    block_name: 'BHUJ',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10002',
    district_code: 1002,
    district_name: 'SOUTH GOA',
    block_id: 'B-100006',
    block_code: 1002004,
    block_name: 'CANACONA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240261',
    block_code: 2413006,
    block_name: 'ASTARANGA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140184',
    block_code: 1411004,
    block_name: 'BUFLIAZ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24025',
    district_code: 2428,
    district_name: 'NUAPADA',
    block_id: 'B-240259',
    block_code: 2428001,
    block_name: 'NUAPADA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50027',
    block_code: 545002,
    block_name: 'BANKA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320159',
    block_code: 3205004,
    block_name: 'SANKRAIL',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4010',
    district_code: 411,
    district_name: 'DHEMAJI',
    block_id: 'B-40054',
    block_code: 411091,
    block_name: 'BORDOLONI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290196',
    block_code: 2907009,
    block_name: 'GANGAVALLI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350078',
    block_code: 3513004,
    block_name: 'JAUNPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313841',
    block_code: 3163001,
    block_name: 'GHORAWAL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270238',
    block_code: 2715016,
    block_name: 'TIWANRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20168',
    block_code: 204003,
    block_name: 'GOKAVARAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20633',
    block_code: 211031,
    block_name: 'CHINTAKOMMA DINNE',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23001',
    district_code: 2308,
    district_name: 'DIMAPUR',
    block_id: 'B-230004',
    block_code: 2308002,
    block_name: 'KUHUBOTO',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13012',
    district_code: 1312,
    district_name: 'UNA',
    block_id: 'B-130088',
    block_code: 1312001,
    block_name: 'AMB',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13010',
    district_code: 1310,
    district_name: 'SIRMAUR',
    block_id: 'B-130077',
    block_code: 1310005,
    block_name: 'SANGRAH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31353',
    district_code: 3140,
    district_name: 'LALITPUR',
    block_id: 'B-313575',
    block_code: 3140003,
    block_name: 'BAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150072',
    block_code: 1511002,
    block_name: 'BANTVAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17024',
    district_code: 1744,
    district_name: 'KATNI',
    block_id: 'B-170140',
    block_code: 1744003,
    block_name: 'BADWARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313518',
    block_code: 3136005,
    block_name: 'RASULABAD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4026',
    district_code: 412,
    district_name: 'MORIGAON',
    block_id: 'B-40163',
    block_code: 412097,
    block_name: 'MAYONG',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140273',
    block_code: 1410014,
    block_name: 'JAGANOO',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13011',
    district_code: 1311,
    district_name: 'SOLAN',
    block_id: 'B-130083',
    block_code: 1311003,
    block_name: 'KUNIHAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20205',
    block_code: 219024,
    block_name: 'PEDAVEGI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230051',
    block_code: 2306001,
    block_name: 'CHARE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170158',
    block_code: 1724006,
    block_name: 'KHARGONE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17030',
    district_code: 1732,
    district_name: 'NARMADAPURAM',
    block_id: 'B-170187',
    block_code: 1732006,
    block_name: 'PIPARIYA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270167',
    block_code: 2712011,
    block_name: 'JAMWA RAMGARH',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4028',
    district_code: 406,
    district_name: 'NALBARI',
    block_id: 'B-40183',
    block_code: 406004,
    block_name: 'PUB NALBARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20465',
    block_code: 209011,
    block_name: 'MARRIPADU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20115',
    block_code: 221008,
    block_name: 'CHIRALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20433',
    block_code: 208002,
    block_name: 'PULLALACHERUVU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340234',
    block_code: 3409003,
    block_name: 'RAJNAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240154',
    block_code: 2408024,
    block_name: 'PHIRINGIA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120071',
    block_code: 1205003,
    block_name: 'NISSING',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20018',
    block_code: 215017,
    block_name: 'PEDA BAYALU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110141',
    block_code: 1110002,
    block_name: 'KADI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33004',
    district_code: 3311,
    district_name: 'BASTAR',
    block_id: 'B-330017',
    block_code: 3311011,
    block_name: 'BAKAWAND',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11013',
    district_code: 1111,
    district_name: 'GANDHINAGAR',
    block_id: 'B-110094',
    block_code: 1111003,
    block_name: 'DEHGAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270016',
    block_code: 2706004,
    block_name: 'KISHANGARH BAS',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50129',
    block_code: 507009,
    block_name: 'Manpur',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310205',
    block_code: 3124010,
    block_name: 'AMBIAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20270',
    block_code: 206024,
    block_name: 'BANTUMILLI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30005',
    district_code: 3007,
    district_name: 'SEPAHIJALA',
    block_id: 'B-300034',
    block_code: 3007005,
    block_name: 'JAMPUIJALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313768',
    block_code: 3174003,
    block_name: 'MEHDAWAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32014',
    district_code: 3224,
    district_name: 'KALIMPONG',
    block_id: 'B-320183',
    block_code: 3224004,
    block_name: 'KALIMPONG ONE',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290047',
    block_code: 2909002,
    block_name: 'NALLAMPALLI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180214',
    block_code: 1806010,
    block_name: 'YEVLA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290227',
    block_code: 2934009,
    block_name: 'KADAYAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320241',
    block_code: 3201014,
    block_name: 'RANAGHAT TWO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20241',
    block_code: 217015,
    block_name: 'SANKHAVARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31350',
    district_code: 3170,
    district_name: 'KAUSHAMBI',
    block_id: 'B-313542',
    block_code: 3170003,
    block_name: 'MOORATGANJ',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320204',
    block_code: 3212004,
    block_name: 'BHAGWANGOLA ONE',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33022',
    district_code: 3331,
    district_name: 'MANENDRAGARH CHIRIMIRI BHARATPUR',
    block_id: 'B-330099',
    block_code: 3331005,
    block_name: 'BHARATPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50425',
    block_code: 518005,
    block_name: 'KALYANPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110126',
    block_code: 1107002,
    block_name: 'MUNDRA',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10002',
    district_code: 1002,
    district_name: 'SOUTH GOA',
    block_id: 'B-100008',
    block_code: 1002006,
    block_name: 'MORMUGAO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240268',
    block_code: 2413007,
    block_name: 'NIMAPADA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140183',
    block_code: 1411006,
    block_name: 'BALAKOTE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240051',
    block_code: 2409006,
    block_name: 'SAINTALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50028',
    block_code: 545003,
    block_name: 'BARAHAT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320158',
    block_code: 3205005,
    block_name: 'PANCHLA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4010',
    district_code: 411,
    district_name: 'DHEMAJI',
    block_id: 'B-40057',
    block_code: 411002,
    block_name: 'MURKONGSELEK',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290204',
    block_code: 2907014,
    block_name: 'OMALUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350082',
    block_code: 3513005,
    block_name: 'THAULDHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313846',
    block_code: 3163002,
    block_name: 'ROBERTSGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31340',
    district_code: 3141,
    district_name: 'HAMIRPUR',
    block_id: 'B-313441',
    block_code: 3141025,
    block_name: 'SARILA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20166',
    block_code: 204014,
    block_name: 'CHAGALLU',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15020',
    district_code: 1520,
    district_name: 'KOPPAL',
    block_id: 'B-150141',
    block_code: 1520006,
    block_name: 'KARATAGI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23001',
    district_code: 2308,
    district_name: 'DIMAPUR',
    block_id: 'B-230003',
    block_code: 2308001,
    block_name: 'DHANSIRIPAR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13012',
    district_code: 1312,
    district_name: 'UNA',
    block_id: 'B-130089',
    block_code: 1312002,
    block_name: 'BANGANA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13010',
    district_code: 1310,
    district_name: 'SIRMAUR',
    block_id: 'B-130076',
    block_code: 1310004,
    block_name: 'RAJGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31353',
    district_code: 3140,
    district_name: 'LALITPUR',
    block_id: 'B-313580',
    block_code: 3140001,
    block_name: 'TALBEHAT',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150078',
    block_code: 1511004,
    block_name: 'PUTTUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17024',
    district_code: 1744,
    district_name: 'KATNI',
    block_id: 'B-170141',
    block_code: 1744005,
    block_name: 'BAHORIBAND',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313513',
    block_code: 3136009,
    block_name: 'DERAPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4026',
    district_code: 412,
    district_name: 'MORIGAON',
    block_id: 'B-40162',
    block_code: 412096,
    block_name: 'LAHARIGHAT',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140284',
    block_code: 1410022,
    block_name: 'TIKRI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13011',
    district_code: 1311,
    district_name: 'SOLAN',
    block_id: 'B-130082',
    block_code: 1311002,
    block_name: 'KANDAGHAT',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20192',
    block_code: 219011,
    block_name: 'JEELUGUMILLI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230059',
    block_code: 2306008,
    block_name: 'THONOKNYU',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170154',
    block_code: 1724008,
    block_name: 'BHAGVANPURA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17045',
    district_code: 1739,
    district_name: 'SHEOPUR',
    block_id: 'B-170277',
    block_code: 1739001,
    block_name: 'VIJAYPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270162',
    block_code: 2712012,
    block_name: 'BASSI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4028',
    district_code: 406,
    district_name: 'NALBARI',
    block_id: 'B-40179',
    block_code: 406005,
    block_name: 'BARKHETRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20447',
    block_code: 209012,
    block_name: 'ATMAKUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20110',
    block_code: 221003,
    block_name: 'BALLIKURAVA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20440',
    block_code: 208003,
    block_name: 'TRIPURANTHAKAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340231',
    block_code: 3409005,
    block_name: 'KUCHAI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240151',
    block_code: 2408025,
    block_name: 'KHAJURIPADA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120065',
    block_code: 1205092,
    block_name: 'GHARAUNDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20010',
    block_code: 215010,
    block_name: 'GUDEM KOTHA VEEDHI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110142',
    block_code: 1110008,
    block_name: 'KHERALU',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33004',
    district_code: 3311,
    district_name: 'BASTAR',
    block_id: 'B-330022',
    block_code: 3311008,
    block_name: 'LOHANDIGUDA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11013',
    district_code: 1111,
    district_name: 'GANDHINAGAR',
    block_id: 'B-110096',
    block_code: 1111004,
    block_name: 'KALOL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270017',
    block_code: 2706005,
    block_name: 'KOTKASIM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50124',
    block_code: 507011,
    block_name: 'Guraru',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310215',
    block_code: 3124011,
    block_name: 'SALARPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20280',
    block_code: 206025,
    block_name: 'KRUTTIVENNU',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30005',
    district_code: 3007,
    district_name: 'SEPAHIJALA',
    block_id: 'B-300037',
    block_code: 3007004,
    block_name: 'NALCHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313769',
    block_code: 3174004,
    block_name: 'NATH NAGAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32014',
    district_code: 3224,
    district_name: 'KALIMPONG',
    block_id: 'B-320184',
    block_code: 3224001,
    block_name: 'LAVA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290046',
    block_code: 2909005,
    block_name: 'MORAPPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180213',
    block_code: 1806015,
    block_name: 'TRIMBAKESHWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310202',
    block_code: 3109001,
    block_name: 'NAJIBABAD',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320233',
    block_code: 3201006,
    block_name: 'KARIMPUR ONE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20228',
    block_code: 217002,
    block_name: 'GOLLAPROLU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31350',
    district_code: 3170,
    district_name: 'KAUSHAMBI',
    block_id: 'B-313540',
    block_code: 3170004,
    block_name: 'KAUSHAMBI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320205',
    block_code: 3212005,
    block_name: 'BHAGWANGOLA TWO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140256',
    block_code: 1422010,
    block_name: 'CHITRAGAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50429',
    block_code: 518009,
    block_name: 'MORWA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110125',
    block_code: 1107003,
    block_name: 'MANDVI',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10002',
    district_code: 1002,
    district_name: 'SOUTH GOA',
    block_id: 'B-100009',
    block_code: 1002008,
    block_name: 'PONDA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240269',
    block_code: 2413008,
    block_name: 'PIPILI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140187',
    block_code: 1411002,
    block_name: 'MANDI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50159',
    block_code: 550008,
    block_name: 'LAKSHMIPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5018',
    district_code: 546,
    district_name: 'LAKHISARAI',
    block_id: 'B-50213',
    block_code: 546004,
    block_name: 'LAKHISARAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320162',
    block_code: 3205010,
    block_name: 'UDAYNARAYANPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40118',
    block_code: 407004,
    block_name: 'CHAMARIA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290201',
    block_code: 2907020,
    block_name: 'MAC. CHOULTRY',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350075',
    block_code: 3513006,
    block_name: 'CHAMBA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313839',
    block_code: 3163005,
    block_name: 'CHOPAN',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16005',
    district_code: 1601,
    district_name: 'KASARGODE',
    block_id: 'B-160046',
    block_code: 1601001,
    block_name: 'KANHANGAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20173',
    block_code: 204012,
    block_name: 'NALLAJERLA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15020',
    district_code: 1520,
    district_name: 'KOPPAL',
    block_id: 'B-150143',
    block_code: 1520007,
    block_name: 'KUKKANURU',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23001',
    district_code: 2308,
    district_name: 'DIMAPUR',
    block_id: 'B-230005',
    block_code: 2308003,
    block_name: 'MEDZIPHEMA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13012',
    district_code: 1312,
    district_name: 'UNA',
    block_id: 'B-130091',
    block_code: 1312004,
    block_name: 'HAROLI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13010',
    district_code: 1310,
    district_name: 'SIRMAUR',
    block_id: 'B-130073',
    block_code: 1310001,
    block_name: 'NAHAN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290072',
    block_code: 2910003,
    block_name: 'KODUMUDI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150079',
    block_code: 1511005,
    block_name: 'SULYA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17024',
    district_code: 1744,
    district_name: 'KATNI',
    block_id: 'B-170145',
    block_code: 1744004,
    block_name: 'VIJAYRAGHAVGADH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313511',
    block_code: 3136010,
    block_name: 'AKBARPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26013',
    district_code: 2624,
    district_name: 'MALERKOTLA',
    block_id: 'B-260093',
    block_code: 2624001,
    block_name: 'MALERKOTLA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140275',
    block_code: 1410016,
    block_name: 'KULWANTA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13011',
    district_code: 1311,
    district_name: 'SOLAN',
    block_id: 'B-130084',
    block_code: 1311004,
    block_name: 'NALAGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20199',
    block_code: 219018,
    block_name: 'MANDAVALLI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230056',
    block_code: 2306009,
    block_name: 'PANSO',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33026',
    district_code: 3313,
    district_name: 'RAIGARH',
    block_id: 'B-330109',
    block_code: 3313001,
    block_name: 'DHARAMJAIGARH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17030',
    district_code: 1732,
    district_name: 'NARMADAPURAM',
    block_id: 'B-170186',
    block_code: 1732003,
    block_name: 'NARMADAPURAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270163',
    block_code: 2712013,
    block_name: 'CHAKSU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4028',
    district_code: 406,
    district_name: 'NALBARI',
    block_id: 'B-40180',
    block_code: 406009,
    block_name: 'BORBHAG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20444',
    block_code: 209015,
    block_name: 'ALLUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20111',
    block_code: 221004,
    block_name: 'BAPATLA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20413',
    block_code: 208007,
    block_name: 'DORNALA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340229',
    block_code: 3409006,
    block_name: 'ICHAGARH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240153',
    block_code: 2408026,
    block_name: 'KOTAGARH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17019',
    district_code: 1703,
    district_name: 'GWALIOR',
    block_id: 'B-170118',
    block_code: 1703001,
    block_name: 'GHATIGAON',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20002',
    block_code: 215002,
    block_name: 'ANANTHAGIRI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110148',
    block_code: 1110009,
    block_name: 'VISNAGAR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33004',
    district_code: 3311,
    district_name: 'BASTAR',
    block_id: 'B-330018',
    block_code: 3311009,
    block_name: 'BASTANAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11013',
    district_code: 1111,
    district_name: 'GANDHINAGAR',
    block_id: 'B-110097',
    block_code: 1111005,
    block_name: 'MANSA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270020',
    block_code: 2706007,
    block_name: 'MANDAWAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320031',
    block_code: 3216009,
    block_name: 'CANNING ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310207',
    block_code: 3124006,
    block_name: 'BISAULI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20288',
    block_code: 206023,
    block_name: 'PEDANA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30005',
    district_code: 3007,
    district_name: 'SEPAHIJALA',
    block_id: 'B-300036',
    block_code: 3007007,
    block_name: 'MOHANBHOG',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313772',
    block_code: 3174005,
    block_name: 'SEMARIYAWAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32014',
    district_code: 3224,
    district_name: 'KALIMPONG',
    block_id: 'B-320182',
    block_code: 3224002,
    block_name: 'GORUBATHAN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290045',
    block_code: 2909007,
    block_name: 'KARIMANGALAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31335',
    district_code: 3164,
    district_name: 'GAUTAM BUDDHA NAGAR',
    block_id: 'B-313378',
    block_code: 3164001,
    block_name: 'DANKAUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313245',
    block_code: 3148002,
    block_name: 'FATEHPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320236',
    block_code: 3201009,
    block_name: 'KRISHNAGAR ONE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20233',
    block_code: 217007,
    block_name: 'KIRLAMPUDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31350',
    district_code: 3170,
    district_name: 'KAUSHAMBI',
    block_id: 'B-313538',
    block_code: 3170001,
    block_name: 'CHAIL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320272',
    block_code: 3210017,
    block_name: 'SABONG',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140257',
    block_code: 1422011,
    block_name: 'HARMAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50424',
    block_code: 518004,
    block_name: 'HASANPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110119',
    block_code: 1107004,
    block_name: 'ABDASA',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10002',
    district_code: 1002,
    district_name: 'SOUTH GOA',
    block_id: 'B-100012',
    block_code: 1002002,
    block_name: 'SANGUEM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240263',
    block_code: 2413009,
    block_name: 'DELANGA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140193',
    block_code: 1411003,
    block_name: 'SURANKOTE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50154',
    block_code: 550003,
    block_name: 'GIDHAUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5018',
    district_code: 546,
    district_name: 'LAKHISARAI',
    block_id: 'B-50214',
    block_code: 546005,
    block_name: 'PIPARIYA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320151',
    block_code: 3205006,
    block_name: 'AMTA ONE',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40122',
    block_code: 407005,
    block_name: 'HAJO',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290206',
    block_code: 2907007,
    block_name: 'P.N.PALAYAM',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350077',
    block_code: 3513003,
    block_name: 'JAKHNIDHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313844',
    block_code: 3163006,
    block_name: 'MYORPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16005',
    district_code: 1601,
    district_name: 'KASARGODE',
    block_id: 'B-160047',
    block_code: 1601002,
    block_name: 'KARADKA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20179',
    block_code: 204001,
    block_name: 'SEETHANAGARAM',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15020',
    district_code: 1520,
    district_name: 'KOPPAL',
    block_id: 'B-150140',
    block_code: 1520005,
    block_name: 'KANAKAGIRI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23001',
    district_code: 2308,
    district_name: 'DIMAPUR',
    block_id: 'B-230006',
    block_code: 2308004,
    block_name: 'NIULAND',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13012',
    district_code: 1312,
    district_name: 'UNA',
    block_id: 'B-130092',
    block_code: 1312005,
    block_name: 'UNA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13010',
    district_code: 1310,
    district_name: 'SIRMAUR',
    block_id: 'B-130074',
    block_code: 1310002,
    block_name: 'PACHHAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290069',
    block_code: 2910005,
    block_name: 'CHENNIMALAI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15024',
    district_code: 1529,
    district_name: 'RAMANAGARA',
    block_id: 'B-150172',
    block_code: 1529004,
    block_name: 'RAMANAGARAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170074',
    block_code: 1736001,
    block_name: 'TAMIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313520',
    block_code: 3136011,
    block_name: 'SARBANKHERA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26013',
    district_code: 2624,
    district_name: 'MALERKOTLA',
    block_id: 'B-260091',
    block_code: 2624002,
    block_name: 'AHMEDGARH',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140276',
    block_code: 1410017,
    block_name: 'LATTI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13011',
    district_code: 1311,
    district_name: 'SOLAN',
    block_id: 'B-130087',
    block_code: 1311005,
    block_name: 'SOLAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20206',
    block_code: 219025,
    block_name: 'POLAVARAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360097',
    block_code: 3607005,
    block_name: 'IEEJA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33026',
    district_code: 3313,
    district_name: 'RAIGARH',
    block_id: 'B-330115',
    block_code: 3313004,
    block_name: 'TAMNAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17030',
    district_code: 1732,
    district_name: 'NARMADAPURAM',
    block_id: 'B-170185',
    block_code: 1732004,
    block_name: 'MAKHAN NAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27004',
    district_code: 2731,
    district_name: 'BARAN',
    block_id: 'B-270039',
    block_code: 2731001,
    block_name: 'ANTAH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240272',
    block_code: 2429001,
    block_name: 'BISSAMCUTTACK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20468',
    block_code: 209024,
    block_name: 'PODALAKUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20113',
    block_code: 221006,
    block_name: 'CHERUKUPALLE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20412',
    block_code: 208005,
    block_name: 'DONAKONDA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340227',
    block_code: 3409007,
    block_name: 'CHANDIL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240150',
    block_code: 2408027,
    block_name: 'G.UDAYAGIRI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17019',
    district_code: 1703,
    district_name: 'GWALIOR',
    block_id: 'B-170119',
    block_code: 1703002,
    block_name: 'MORAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20016',
    block_code: 215022,
    block_name: 'NELLIPAKA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110147',
    block_code: 1110010,
    block_name: 'VIJAPUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33004',
    district_code: 3311,
    district_name: 'BASTAR',
    block_id: 'B-330019',
    block_code: 3311010,
    block_name: 'BASTAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2023',
    district_code: 203,
    district_name: 'VISAKHAPATANAM',
    block_id: 'B-20577',
    block_code: 203004,
    block_name: 'BHEEMUNIPATNAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270022',
    block_code: 2706009,
    block_name: 'RAJGARH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320033',
    block_code: 3216017,
    block_name: 'DIAMOND HARBOUR ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310211',
    block_code: 3124012,
    block_name: 'JAGAT',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20272',
    block_code: 206011,
    block_name: 'CHALLAPALLI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30005',
    district_code: 3007,
    district_name: 'SEPAHIJALA',
    block_id: 'B-300033',
    block_code: 3007006,
    block_name: 'CHARILAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313764',
    block_code: 3174006,
    block_name: 'BAGHAULI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17033',
    district_code: 1752,
    district_name: 'NIWARI',
    block_id: 'B-170199',
    block_code: 1752001,
    block_name: 'NIWARI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29009',
    district_code: 2901,
    district_name: 'KANCHIPURAM',
    block_id: 'B-290088',
    block_code: 2901001,
    block_name: 'KANCHIPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180210',
    block_code: 1806002,
    block_name: 'PETH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313251',
    block_code: 3148004,
    block_name: 'RAMNAGAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320237',
    block_code: 3201010,
    block_name: 'KRISHNAGAR TWO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20232',
    block_code: 217006,
    block_name: 'KARAPA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31350',
    district_code: 3170,
    district_name: 'KAUSHAMBI',
    block_id: 'B-313541',
    block_code: 3170005,
    block_name: 'MANJHANPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320216',
    block_code: 3212016,
    block_name: 'MURSHIDABAD-JIAGANJ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140258',
    block_code: 1422012,
    block_name: 'IMMAMSIHAB',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50433',
    block_code: 518013,
    block_name: 'SAMASTIPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110124',
    block_code: 1107005,
    block_name: 'LAKHPAT',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10002',
    district_code: 1002,
    district_name: 'SOUTH GOA',
    block_id: 'B-100010',
    block_code: 1002003,
    block_name: 'QUEPEM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240271',
    block_code: 2413011,
    block_name: 'SATYABADI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140189',
    block_code: 1411005,
    block_name: 'MENDHAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360120',
    block_code: 3608016,
    block_name: 'PEDDA KODAPGAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5018',
    district_code: 546,
    district_name: 'LAKHISARAI',
    block_id: 'B-50215',
    block_code: 546006,
    block_name: 'RAMGARH CHOWK',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320152',
    block_code: 3205007,
    block_name: 'AMTA TWO',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40123',
    block_code: 407007,
    block_name: 'KAMALPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290212',
    block_code: 2907002,
    block_name: 'VEERAPANDY',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350080',
    block_code: 3513007,
    block_name: 'NARENDRA NAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313837',
    block_code: 3163008,
    block_name: 'BABHANI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16005',
    district_code: 1601,
    district_name: 'KASARGODE',
    block_id: 'B-160048',
    block_code: 1601003,
    block_name: 'KASARGOD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20178',
    block_code: 204004,
    block_name: 'RANGAMPETA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20640',
    block_code: 211001,
    block_name: 'KONDAPURAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290119',
    block_code: 2930003,
    block_name: 'VEPPANAPALLI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13012',
    district_code: 1312,
    district_name: 'UNA',
    block_id: 'B-130090',
    block_code: 1312003,
    block_name: 'GAGRET',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13010',
    district_code: 1310,
    district_name: 'SIRMAUR',
    block_id: 'B-130075',
    block_code: 1310003,
    block_name: 'PAONTA SAHIB',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290065',
    block_code: 2910012,
    block_name: 'AMMAPET',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150075',
    block_code: 1511003,
    block_name: 'MANGALORE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170064',
    block_code: 1736003,
    block_name: 'AMARWARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313517',
    block_code: 3136012,
    block_name: 'RAJPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26013',
    district_code: 2624,
    district_name: 'MALERKOTLA',
    block_id: 'B-260092',
    block_code: 2624003,
    block_name: 'AMARGARH',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140281',
    block_code: 1410020,
    block_name: 'PARLI DHAR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13011',
    district_code: 1311,
    district_name: 'SOLAN',
    block_id: 'B-130094',
    block_code: 1311009,
    block_name: 'PATTA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20197',
    block_code: 219016,
    block_name: 'KUKKUNUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360101',
    block_code: 3607009,
    block_name: 'MANOPADU',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33026',
    district_code: 3313,
    district_name: 'RAIGARH',
    block_id: 'B-330114',
    block_code: 3313005,
    block_name: 'RAIGARH',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340042',
    block_code: 3411001,
    block_name: 'DUMKA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29031',
    district_code: 2933,
    district_name: 'TIRUPATTUR',
    block_id: 'B-290313',
    block_code: 2933004,
    block_name: 'MADHANUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240273',
    block_code: 2429002,
    block_name: 'CHANDRAPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35006',
    district_code: 3503,
    district_name: 'HARIDWAR',
    block_id: 'B-350035',
    block_code: 3503001,
    block_name: 'BHAGWANPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20108',
    block_code: 221001,
    block_name: 'ADDANKI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20421',
    block_code: 208004,
    block_name: 'KURICHEDU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340230',
    block_code: 3409008,
    block_name: 'KHARSAWAN',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4014',
    district_code: 404,
    district_name: 'GOALPARA',
    block_id: 'B-40085',
    block_code: 404005,
    block_name: 'KRISHNAI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17019',
    district_code: 1703,
    district_name: 'GWALIOR',
    block_id: 'B-170117',
    block_code: 1703003,
    block_name: 'DABRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20004',
    block_code: 215004,
    block_name: 'CHINTAPALLE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110145',
    block_code: 1110013,
    block_name: 'UNJHA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33004',
    district_code: 3311,
    district_name: 'BASTAR',
    block_id: 'B-330021',
    block_code: 3311012,
    block_name: 'JAGDALPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2023',
    district_code: 203,
    district_name: 'VISAKHAPATANAM',
    block_id: 'B-20578',
    block_code: 203003,
    block_name: 'PADMANABHAM',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3004',
    district_code: 307,
    district_name: 'EAST SIANG',
    block_id: 'B-30118',
    block_code: 307009,
    block_name: 'BILAT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320038',
    block_code: 3216012,
    block_name: 'JAYNAGAR TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310217',
    block_code: 3124013,
    block_name: 'UJHANI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20271',
    block_code: 206005,
    block_name: 'BAPULAPADU',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30005',
    district_code: 3007,
    district_name: 'SEPAHIJALA',
    block_id: 'B-300031',
    block_code: 3007001,
    block_name: 'BISHALGHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313771',
    block_code: 3174007,
    block_name: 'SANTHA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120040',
    block_code: 1215006,
    block_name: 'UKLANA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29009',
    district_code: 2901,
    district_name: 'KANCHIPURAM',
    block_id: 'B-290090',
    block_code: 2901004,
    block_name: 'SRIPERUMBUDUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18014',
    district_code: 1816,
    district_name: 'JALNA',
    block_id: 'B-180140',
    block_code: 1816001,
    block_name: 'JALNA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313246',
    block_code: 3148011,
    block_name: 'HAIDARGARH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320240',
    block_code: 3201013,
    block_name: 'RANAGHAT ONE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20240',
    block_code: 217014,
    block_name: 'SAMALKOTA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29011',
    district_code: 2917,
    district_name: 'KARUR',
    block_id: 'B-290108',
    block_code: 2917002,
    block_name: 'THANTHONI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320218',
    block_code: 3212018,
    block_name: 'NOWDA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140260',
    block_code: 1422015,
    block_name: 'KAPRIN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50085',
    block_code: 548001,
    block_name: 'Barhampur',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110127',
    block_code: 1107006,
    block_name: 'NAKHATRANA',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10002',
    district_code: 1002,
    district_name: 'SOUTH GOA',
    block_id: 'B-100007',
    block_code: 1002007,
    block_name: 'DHARBANDORA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240270',
    block_code: 2413003,
    block_name: 'PURI SADAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17038',
    district_code: 1713,
    district_name: 'REWA',
    block_id: 'B-170225',
    block_code: 1713004,
    block_name: 'GANGEV',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360224',
    block_code: 3615001,
    block_name: 'ALLADURG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5018',
    district_code: 546,
    district_name: 'LAKHISARAI',
    block_id: 'B-50216',
    block_code: 546007,
    block_name: 'SURAJGARHA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320163',
    block_code: 3205011,
    block_name: 'ULUBERIA ONE',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40116',
    block_code: 407008,
    block_name: 'BOKO',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290195',
    block_code: 2907004,
    block_name: 'AYOTHIYAPATTINAM',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350076',
    block_code: 3513008,
    block_name: 'DEOPRAYAG',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31340',
    district_code: 3141,
    district_name: 'HAMIRPUR',
    block_id: 'B-313442',
    block_code: 3141020,
    block_name: 'SUMERPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16005',
    district_code: 1601,
    district_name: 'KASARGODE',
    block_id: 'B-160049',
    block_code: 1601004,
    block_name: 'MANJESHWAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20164',
    block_code: 204008,
    block_name: 'ANAPARTHY',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20644',
    block_code: 211002,
    block_name: 'MYLAVARAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290110',
    block_code: 2930004,
    block_name: 'BARGUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110044',
    block_code: 1108014,
    block_name: 'PALANPUR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13010',
    district_code: 1310,
    district_name: 'SIRMAUR',
    block_id: 'B-130078',
    block_code: 1310006,
    block_name: 'SHILAI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290074',
    block_code: 2910016,
    block_name: 'NAMBIYUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110111',
    block_code: 1106001,
    block_name: 'JUNAGADH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170066',
    block_code: 1736004,
    block_name: 'CHAURAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313516',
    block_code: 3136013,
    block_name: 'MALASA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140022',
    block_code: 1419014,
    block_name: 'GANSTAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140269',
    block_code: 1410013,
    block_name: 'CHANUNTA DALSAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150220',
    block_code: 1507003,
    block_name: 'INDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20182',
    block_code: 219001,
    block_name: 'AGIRIPALLI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290336',
    block_code: 2906005,
    block_name: 'KALASAPAKKAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33026',
    district_code: 3313,
    district_name: 'RAIGARH',
    block_id: 'B-330111',
    block_code: 3313007,
    block_name: 'KHARSIA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340045',
    block_code: 3411003,
    block_name: 'JARMUNDI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29031',
    district_code: 2933,
    district_name: 'TIRUPATTUR',
    block_id: 'B-290314',
    block_code: 2933019,
    block_name: 'NATRAMPALLI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240274',
    block_code: 2429003,
    block_name: 'GUDARI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35006',
    district_code: 3503,
    district_name: 'HARIDWAR',
    block_id: 'B-350038',
    block_code: 3503003,
    block_name: 'NARSAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20117',
    block_code: 221010,
    block_name: 'JANAKAVARAM PONGULURU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20425',
    block_code: 208014,
    block_name: 'MUNDLAMURU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340232',
    block_code: 3409009,
    block_name: 'KUKRU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4014',
    district_code: 404,
    district_name: 'GOALPARA',
    block_id: 'B-40083',
    block_code: 404007,
    block_name: 'JALESWAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17019',
    district_code: 1703,
    district_name: 'GWALIOR',
    block_id: 'B-170116',
    block_code: 1703004,
    block_name: 'BHITARWAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20003',
    block_code: 215003,
    block_name: 'ARAKU VALLEY',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110146',
    block_code: 1110014,
    block_name: 'VADNAGAR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33004',
    district_code: 3311,
    district_name: 'BASTAR',
    block_id: 'B-330023',
    block_code: 3311013,
    block_name: 'TOKAPAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2023',
    district_code: 203,
    district_name: 'VISAKHAPATANAM',
    block_id: 'B-20579',
    block_code: 203001,
    block_name: 'PENDURTHI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3024',
    district_code: 302,
    district_name: 'WEST KAMENG',
    block_id: 'B-30109',
    block_code: 302005,
    block_name: 'SINGCHUNG',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320045',
    block_code: 3216019,
    block_name: 'MATHURAPUR ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310213',
    block_code: 3124014,
    block_name: 'QADAR CHOWK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20283',
    block_code: 206009,
    block_name: 'MOVVA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320075',
    block_code: 3213001,
    block_name: 'SALTORA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313770',
    block_code: 3174008,
    block_name: 'PAULI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120034',
    block_code: 1215007,
    block_name: 'BARWALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31341',
    district_code: 3182,
    district_name: 'HAPUR',
    block_id: 'B-313445',
    block_code: 3182001,
    block_name: 'HAPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17051',
    district_code: 1740,
    district_name: 'UMARIA',
    block_id: 'B-170305',
    block_code: 1740001,
    block_name: 'MANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313253',
    block_code: 3148017,
    block_name: 'SIRAULI GAUSPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320234',
    block_code: 3201007,
    block_name: 'KARIMPUR TWO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20230',
    block_code: 217004,
    block_name: 'KAJULURU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27022',
    district_code: 2709,
    district_name: 'KARAULI',
    block_id: 'B-270242',
    block_code: 2709007,
    block_name: 'MASALPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320225',
    block_code: 3212025,
    block_name: 'SUTI ONE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140259',
    block_code: 1422013,
    block_name: 'KANJIULLAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50094',
    block_code: 548010,
    block_name: 'Rajpur',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110128',
    block_code: 1107007,
    block_name: 'RAPAR',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10002',
    district_code: 1002,
    district_name: 'SOUTH GOA',
    block_id: 'B-100011',
    block_code: 1002005,
    block_name: 'SALCETE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24006',
    district_code: 2426,
    district_name: 'BOUDH',
    block_id: 'B-240054',
    block_code: 2426001,
    block_name: 'BOUDH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17038',
    district_code: 1713,
    district_name: 'REWA',
    block_id: 'B-170231',
    block_code: 1713008,
    block_name: 'REWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360226',
    block_code: 3615003,
    block_name: 'CHILPCHED',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5018',
    district_code: 546,
    district_name: 'LAKHISARAI',
    block_id: 'B-50212',
    block_code: 546003,
    block_name: 'HALSI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320154',
    block_code: 3205009,
    block_name: 'BAGNAN TWO',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40121',
    block_code: 407010,
    block_name: 'GOROIMARI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290209',
    block_code: 2907010,
    block_name: 'THALAIVASAL',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350074',
    block_code: 3513002,
    block_name: 'BHILANGANA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31340',
    district_code: 3141,
    district_name: 'HAMIRPUR',
    block_id: 'B-313439',
    block_code: 3141022,
    block_name: 'MUSKARA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16005',
    district_code: 1601,
    district_name: 'KASARGODE',
    block_id: 'B-160050',
    block_code: 1601005,
    block_name: 'NILESHWAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20180',
    block_code: 204010,
    block_name: 'THALLAPUDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20645',
    block_code: 211003,
    block_name: 'PEDDAMUDIUM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290115',
    block_code: 2930005,
    block_name: 'MATHUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110042',
    block_code: 1108017,
    block_name: 'KANKREJ',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13010',
    district_code: 1310,
    district_name: 'SIRMAUR',
    block_id: 'B-130079',
    block_code: 1310007,
    block_name: 'TILORDHAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290070',
    block_code: 2910001,
    block_name: 'ERODE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110116',
    block_code: 1106002,
    block_name: 'MENDARDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170069',
    block_code: 1736005,
    block_name: 'JAMAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313512',
    block_code: 3136014,
    block_name: 'AMRODHA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140025',
    block_code: 1419015,
    block_name: 'NAIDKHAY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140270',
    block_code: 1410002,
    block_name: 'CHENANI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150222',
    block_code: 1507004,
    block_name: 'MUDDEBIHAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20188',
    block_code: 219007,
    block_name: 'DWARAKATIRUMALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290340',
    block_code: 2906008,
    block_name: 'PUDUPALAYAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33026',
    district_code: 3313,
    district_name: 'RAIGARH',
    block_id: 'B-330110',
    block_code: 3313003,
    block_name: 'GHARGODA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340044',
    block_code: 3411004,
    block_name: 'JAMA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270177',
    block_code: 2712005,
    block_name: 'SAMBHER',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240275',
    block_code: 2429004,
    block_name: 'GUNUPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35006',
    district_code: 3503,
    district_name: 'HARIDWAR',
    block_id: 'B-350034',
    block_code: 3503004,
    block_name: 'BAHADRABAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20119',
    block_code: 221012,
    block_name: 'KARLAPALEM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20411',
    block_code: 208013,
    block_name: 'DARSI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340033',
    block_code: 3421004,
    block_name: 'BALIAPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4029',
    district_code: 416,
    district_name: 'SIVASAGAR',
    block_id: 'B-40189',
    block_code: 416001,
    block_name: 'SIVASAGAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4016',
    district_code: 422,
    district_name: 'HAILAKANDI',
    block_id: 'B-40102',
    block_code: 422005,
    block_name: 'SOUTH HAILAKANDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20005',
    block_code: 215005,
    block_name: 'CHINTOOR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110140',
    block_code: 1110016,
    block_name: 'JOTANA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20004',
    district_code: 2009,
    district_name: 'IMPHAL EAST',
    block_id: 'B-200023',
    block_code: 2009010,
    block_name: 'KHETRIGAO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2023',
    district_code: 203,
    district_name: 'VISAKHAPATANAM',
    block_id: 'B-20576',
    block_code: 203002,
    block_name: 'ANANDAPURAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270014',
    block_code: 2706015,
    block_name: 'GOVINDGARH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320043',
    block_code: 3216022,
    block_name: 'MAGRAHAT TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310216',
    block_code: 3124015,
    block_name: 'SAMRER',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20282',
    block_code: 206012,
    block_name: 'MOPIDEVI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320070',
    block_code: 3213002,
    block_name: 'MEJHIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313765',
    block_code: 3174009,
    block_name: 'BELHAR KALA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120033',
    block_code: 1215008,
    block_name: 'AGROHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31341',
    district_code: 3182,
    district_name: 'HAPUR',
    block_id: 'B-313443',
    block_code: 3182002,
    block_name: 'DHAULANA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17051',
    district_code: 1740,
    district_name: 'UMARIA',
    block_id: 'B-170306',
    block_code: 1740003,
    block_name: 'PALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31039',
    district_code: 3139,
    district_name: 'JHANSI',
    block_id: 'B-310445',
    block_code: 3139001,
    block_name: 'MOTH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320228',
    block_code: 3201002,
    block_name: 'CHAPRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20235',
    block_code: 217009,
    block_name: 'PEDAPUDI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27022',
    district_code: 2709,
    district_name: 'KARAULI',
    block_id: 'B-270245',
    block_code: 2709008,
    block_name: 'SRI MAHAVEER JI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320226',
    block_code: 3212026,
    block_name: 'SUTI TWO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140264',
    block_code: 1422014,
    block_name: 'ZAINAPORA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50089',
    block_code: 548005,
    block_name: 'Chausa',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110120',
    block_code: 1107009,
    block_name: 'ANJAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17038',
    district_code: 1713,
    district_name: 'REWA',
    block_id: 'B-170230',
    block_code: 1713009,
    block_name: 'RAIPUR KARCHULIYAN',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24006',
    district_code: 2426,
    district_name: 'BOUDH',
    block_id: 'B-240055',
    block_code: 2426002,
    block_name: 'HARABHANGA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17047',
    district_code: 1715,
    district_name: 'SIDHI',
    block_id: 'B-170289',
    block_code: 1715002,
    block_name: 'SIDHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360234',
    block_code: 3615011,
    block_name: 'NIZAMPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5018',
    district_code: 546,
    district_name: 'LAKHISARAI',
    block_id: 'B-50210',
    block_code: 546001,
    block_name: 'BARAHIYA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320160',
    block_code: 3205013,
    block_name: 'SHYAMPUR ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50235',
    block_code: 520006,
    block_name: 'GHOGHARDIHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290210',
    block_code: 2907015,
    block_name: 'THARAMANGALAM',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350081',
    block_code: 3513001,
    block_name: 'PRATAP NAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31340',
    district_code: 3141,
    district_name: 'HAMIRPUR',
    block_id: 'B-313436',
    block_code: 3141024,
    block_name: 'GOHAND',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16005',
    district_code: 1601,
    district_name: 'KASARGODE',
    block_id: 'B-160051',
    block_code: 1601006,
    block_name: 'PARAPPA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20170',
    block_code: 204007,
    block_name: 'KADIAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20634',
    block_code: 211005,
    block_name: 'DUVVUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290116',
    block_code: 2930008,
    block_name: 'SHOOLAGIRI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110048',
    block_code: 1108019,
    block_name: 'VAV',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150001',
    block_code: 1501001,
    block_name: 'BADAMI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290075',
    block_code: 2910004,
    block_name: 'PERUNDURAI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110113',
    block_code: 1106005,
    block_name: 'MALIA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170072',
    block_code: 1736006,
    block_name: 'PARASIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313514',
    block_code: 3136006,
    block_name: 'JHINJHAK',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40035',
    block_code: 423008,
    block_name: 'NARSINGPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140277',
    block_code: 1410007,
    block_name: 'MAJALTA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15027',
    district_code: 1526,
    district_name: 'UDUPI',
    block_id: 'B-150192',
    block_code: 1526004,
    block_name: 'HEBRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20208',
    block_code: 219027,
    block_name: 'UNGUTURU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290346',
    block_code: 2906013,
    block_name: 'VEMBAKKAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33026',
    district_code: 3313,
    district_name: 'RAIGARH',
    block_id: 'B-330113',
    block_code: 3313006,
    block_name: 'PUSORE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340048',
    block_code: 3411005,
    block_name: 'RAMGARH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270166',
    block_code: 2712014,
    block_name: 'JALSOO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240276',
    block_code: 2429005,
    block_name: 'KALYANSINGPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35006',
    district_code: 3503,
    district_name: 'HARIDWAR',
    block_id: 'B-350036',
    block_code: 3503006,
    block_name: 'KHANPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20109',
    block_code: 221002,
    block_name: 'AMRUTHALUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20423',
    block_code: 208009,
    block_name: 'MARKAPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340040',
    block_code: 3421007,
    block_name: 'TOPCHANCHI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4029',
    district_code: 416,
    district_name: 'SIVASAGAR',
    block_id: 'B-40186',
    block_code: 416004,
    block_name: 'DEMOW',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50008',
    block_code: 541008,
    block_name: 'Raniganj',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20019',
    block_code: 215018,
    block_name: 'RAJAVOMMANGI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110144',
    block_code: 1110012,
    block_name: 'SATLASANA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20004',
    district_code: 2009,
    district_name: 'IMPHAL EAST',
    block_id: 'B-200022',
    block_code: 2009005,
    block_name: 'IMPHAL EAST I SAWOMBUNG',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35002',
    district_code: 3512,
    district_name: 'BAGESHWAR',
    block_id: 'B-350014',
    block_code: 3512001,
    block_name: 'KAPKOTE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31356',
    district_code: 3179,
    district_name: 'MAHOBA',
    block_id: 'B-313601',
    block_code: 3179003,
    block_name: 'CHARKHARI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33009',
    district_code: 3309,
    district_name: 'DHAMTARI',
    block_id: 'B-330040',
    block_code: 3309001,
    block_name: 'DHAMTARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310209',
    block_code: 3124016,
    block_name: 'DATAGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20287',
    block_code: 206008,
    block_name: 'PAMIDIMUKKALA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320063',
    block_code: 3213003,
    block_name: 'GANGAJAL GHATI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270270',
    block_code: 2720001,
    block_name: 'JAITARAN',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120032',
    block_code: 1215009,
    block_name: 'ADAMPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31341',
    district_code: 3182,
    district_name: 'HAPUR',
    block_id: 'B-313446',
    block_code: 3182003,
    block_name: 'SIMBHAWALI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12003',
    district_code: 1222,
    district_name: 'CHARKHI DADRI',
    block_id: 'B-120017',
    block_code: 1222094,
    block_name: 'JHOJHU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31039',
    district_code: 3139,
    district_name: 'JHANSI',
    block_id: 'B-310444',
    block_code: 3139006,
    block_name: 'MAURANIPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320232',
    block_code: 3201018,
    block_name: 'KALYANI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20243',
    block_code: 217017,
    block_name: 'THONDANGI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29011',
    district_code: 2917,
    district_name: 'KARUR',
    block_id: 'B-290104',
    block_code: 2917001,
    block_name: 'KARUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320266',
    block_code: 3210009,
    block_name: 'KHARAGPUR ONE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140262',
    block_code: 1422016,
    block_name: 'RAMNAGRI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50088',
    block_code: 548004,
    block_name: 'Chaugain',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110123',
    block_code: 1107010,
    block_name: 'GANDHIDHAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360479',
    block_code: 3626019,
    block_name: 'PALAKEEDU',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24006',
    district_code: 2426,
    district_name: 'BOUDH',
    block_id: 'B-240056',
    block_code: 2426003,
    block_name: 'KANTAMAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17038',
    district_code: 1713,
    district_name: 'REWA',
    block_id: 'B-170227',
    block_code: 1713001,
    block_name: 'JAWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360242',
    block_code: 3615019,
    block_name: 'TUPRAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5018',
    district_code: 546,
    district_name: 'LAKHISARAI',
    block_id: 'B-50211',
    block_code: 546002,
    block_name: 'CHANAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320153',
    block_code: 3205008,
    block_name: 'BAGNAN ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50236',
    block_code: 520007,
    block_name: 'HARLAKHI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290198',
    block_code: 2907016,
    block_name: 'KADAYAMPATTI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35011',
    district_code: 3513,
    district_name: 'TEHRI GARWAL',
    block_id: 'B-350079',
    block_code: 3513009,
    block_name: 'KIRTI NAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29001',
    district_code: 2931,
    district_name: 'ARIYALUR',
    block_id: 'B-290002',
    block_code: 2931003,
    block_name: 'ARIYALUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31340',
    district_code: 3141,
    district_name: 'HAMIRPUR',
    block_id: 'B-313438',
    block_code: 3141021,
    block_name: 'MAUDAHA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20169',
    block_code: 204011,
    block_name: 'GOPALAPURAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20637',
    block_code: 211009,
    block_name: 'KALASAPADU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290114',
    block_code: 2930001,
    block_name: 'KRISHNAGIRI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110046',
    block_code: 1108020,
    block_name: 'THARAD',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150002',
    block_code: 1501002,
    block_name: 'BAGALKOT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290067',
    block_code: 2910014,
    block_name: 'BHAVANI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110115',
    block_code: 1106006,
    block_name: 'MANGROL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170070',
    block_code: 1736007,
    block_name: 'MOHKHED',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21007',
    district_code: 2106,
    district_name: 'SOUTH GARO HILLS',
    block_id: 'B-210026',
    block_code: 2106011,
    block_name: 'BAGHMARA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40037',
    block_code: 423013,
    block_name: 'RAJABAZAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140282',
    block_code: 1410010,
    block_name: 'RAMNAGAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15027',
    district_code: 1526,
    district_name: 'UDUPI',
    block_id: 'B-150190',
    block_code: 1526006,
    block_name: 'BAINDURU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20191',
    block_code: 219010,
    block_name: 'JANGAREDDIGUDEM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290342',
    block_code: 2906015,
    block_name: 'THELLAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170156',
    block_code: 1724007,
    block_name: 'GOGANWA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340046',
    block_code: 3411008,
    block_name: 'KATHIKUND',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270175',
    block_code: 2712015,
    block_name: 'PAWTA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240279',
    block_code: 2429008,
    block_name: 'MUNIGUDA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35006',
    district_code: 3503,
    district_name: 'HARIDWAR',
    block_id: 'B-350039',
    block_code: 3503002,
    block_name: 'ROORKEE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20118',
    block_code: 221011,
    block_name: 'KARAMCHEDU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20406',
    block_code: 208008,
    block_name: 'ARDHAVEEDU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340041',
    block_code: 3421008,
    block_name: 'TUNDI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4029',
    district_code: 416,
    district_name: 'SIVASAGAR',
    block_id: 'B-40187',
    block_code: 416009,
    block_name: 'GAURISAGAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50001',
    block_code: 541002,
    block_name: 'Araria',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20013',
    block_code: 215013,
    block_name: 'KUNAVARAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11019',
    district_code: 1110,
    district_name: 'MAHESANA',
    block_id: 'B-110139',
    block_code: 1110015,
    block_name: 'BECHARAJI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20004',
    district_code: 2009,
    district_name: 'IMPHAL EAST',
    block_id: 'B-200020',
    block_code: 2009008,
    block_name: 'HEINGANG',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35002',
    district_code: 3512,
    district_name: 'BAGESHWAR',
    block_id: 'B-350012',
    block_code: 3512002,
    block_name: 'BAGESHWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313827',
    block_code: 3129018,
    block_name: 'MAHMUDABAD',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33009',
    district_code: 3309,
    district_name: 'DHAMTARI',
    block_id: 'B-330041',
    block_code: 3309002,
    block_name: 'KURUD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310214',
    block_code: 3124009,
    block_name: 'SAHASWAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20290',
    block_code: 206001,
    block_name: 'PENAMALURU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320062',
    block_code: 3213004,
    block_name: 'CHHATNA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270273',
    block_code: 2720002,
    block_name: 'RAIPUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120039',
    block_code: 1215014,
    block_name: 'NARNAUND',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31341',
    district_code: 3182,
    district_name: 'HAPUR',
    block_id: 'B-313444',
    block_code: 3182004,
    block_name: 'GARH MUKTESHWAR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12003',
    district_code: 1222,
    district_name: 'CHARKHI DADRI',
    block_id: 'B-120016',
    block_code: 1222004,
    block_name: 'CHARKHI DADRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31039',
    district_code: 3139,
    district_name: 'JHANSI',
    block_id: 'B-310442',
    block_code: 3139002,
    block_name: 'CHIRGAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17015',
    district_code: 1720,
    district_name: 'DEWAS',
    block_id: 'B-170085',
    block_code: 1720005,
    block_name: 'BAGLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20246',
    block_code: 217020,
    block_name: 'YELESWARAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29011',
    district_code: 2917,
    district_name: 'KARUR',
    block_id: 'B-290102',
    block_code: 2917003,
    block_name: 'ARAVAKURICHI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320260',
    block_code: 3210019,
    block_name: 'GARHBETA ONE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140263',
    block_code: 1422001,
    block_name: 'SHOPIAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50087',
    block_code: 548003,
    block_name: 'Chakki',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11017',
    district_code: 1107,
    district_name: 'KACHCHH',
    block_id: 'B-110121',
    block_code: 1107008,
    block_name: 'BHACHAU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360469',
    block_code: 3626009,
    block_name: 'KODAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240264',
    block_code: 2413004,
    block_name: 'GOP',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17038',
    district_code: 1713,
    district_name: 'REWA',
    block_id: 'B-170233',
    block_code: 1713002,
    block_name: 'TEONTHAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360114',
    block_code: 3608010,
    block_name: 'LINGAMPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50032',
    block_code: 545007,
    block_name: 'DHURAIYA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320161',
    block_code: 3205014,
    block_name: 'SHYAMPUR TWO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50238',
    block_code: 520009,
    block_name: 'JHANJHARPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290197',
    block_code: 2907018,
    block_name: 'IDAPPADY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360408',
    block_code: 3623023,
    block_name: 'SHAMSHABAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29001',
    district_code: 2931,
    district_name: 'ARIYALUR',
    block_id: 'B-290004',
    block_code: 2931010,
    block_name: 'SENDURAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31340',
    district_code: 3141,
    district_name: 'HAMIRPUR',
    block_id: 'B-313440',
    block_code: 3141023,
    block_name: 'RATH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20172',
    block_code: 204015,
    block_name: 'KOVVUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20647',
    block_code: 211010,
    block_name: 'PORUMAMILLA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290112',
    block_code: 2930002,
    block_name: 'KAVERIPATTANAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110041',
    block_code: 1108021,
    block_name: 'DHANERA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150005',
    block_code: 1501004,
    block_name: 'HUNGUND',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290071',
    block_code: 2910015,
    block_name: 'GOBI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110112',
    block_code: 1106007,
    block_name: 'KESHOD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170067',
    block_code: 1736008,
    block_name: 'CHHINDWARA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21007',
    district_code: 2106,
    district_name: 'SOUTH GARO HILLS',
    block_id: 'B-210027',
    block_code: 2106012,
    block_name: 'CHOKPOT',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40038',
    block_code: 423014,
    block_name: 'SALCHAPRA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140285',
    block_code: 1410012,
    block_name: 'UDHAMPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15027',
    district_code: 1526,
    district_name: 'UDUPI',
    block_id: 'B-150191',
    block_code: 1526007,
    block_name: 'BRAMHAVARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20202',
    block_code: 219021,
    block_name: 'NIDAMARRU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290344',
    block_code: 2906001,
    block_name: 'TIRUVANNAMALAI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33026',
    district_code: 3313,
    district_name: 'RAIGARH',
    block_id: 'B-330112',
    block_code: 3313002,
    block_name: 'LAILUNGA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340049',
    block_code: 3411010,
    block_name: 'RANISHWAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270171',
    block_code: 2712019,
    block_name: 'KOTKHAWDA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240280',
    block_code: 2429009,
    block_name: 'PADMAPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35006',
    district_code: 3503,
    district_name: 'HARIDWAR',
    block_id: 'B-350037',
    block_code: 3503005,
    block_name: 'LAKSAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20112',
    block_code: 221005,
    block_name: 'BHATTIPROLU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20431',
    block_code: 208012,
    block_name: 'PODILI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340038',
    block_code: 3421005,
    block_name: 'NIRSA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4014',
    district_code: 404,
    district_name: 'GOALPARA',
    block_id: 'B-40088',
    block_code: 404002,
    block_name: 'MATIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50005',
    block_code: 541005,
    block_name: 'Kursakatta',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20022',
    block_code: 215021,
    block_name: 'Y  RAMAVARAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17035',
    district_code: 1730,
    district_name: 'RAISEN',
    block_id: 'B-170207',
    block_code: 1730003,
    block_name: 'BEGUMGANJ',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20004',
    district_code: 2009,
    district_name: 'IMPHAL EAST',
    block_id: 'B-200021',
    block_code: 2009006,
    block_name: 'IMPHAL EAST II KEIRAO',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35002',
    district_code: 3512,
    district_name: 'BAGESHWAR',
    block_id: 'B-350013',
    block_code: 3512003,
    block_name: 'GARUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313834',
    block_code: 3129012,
    block_name: 'REUSA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33009',
    district_code: 3309,
    district_name: 'DHAMTARI',
    block_id: 'B-330042',
    block_code: 3309004,
    block_name: 'MAGARLOD',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370020',
    block_code: 3701001,
    block_name: 'LEH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20292',
    block_code: 206006,
    block_name: 'UNGUTURU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320060',
    block_code: 3213008,
    block_name: 'BARJORA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270276',
    block_code: 2720003,
    block_name: 'SOJAT',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120037',
    block_code: 1215010,
    block_name: 'HISAR1',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290041',
    block_code: 2909001,
    block_name: 'DHARMAPURI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12003',
    district_code: 1222,
    district_name: 'CHARKHI DADRI',
    block_id: 'B-120015',
    block_code: 1222093,
    block_name: 'BAUND',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31039',
    district_code: 3139,
    district_name: 'JHANSI',
    block_id: 'B-310441',
    block_code: 3139005,
    block_name: 'BANGRA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17015',
    district_code: 1720,
    district_name: 'DEWAS',
    block_id: 'B-170088',
    block_code: 1720006,
    block_name: 'KHATEGAON',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20242',
    block_code: 217016,
    block_name: 'THALLAREVU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29011',
    district_code: 2917,
    district_name: 'KARUR',
    block_id: 'B-290106',
    block_code: 2917006,
    block_name: 'KRISHNARAYAPURAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320254',
    block_code: 3210025,
    block_name: 'CHANDRAKONA TWO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14018',
    district_code: 1422,
    district_name: 'SHOPIAN',
    block_id: 'B-140261',
    block_code: 1422002,
    block_name: 'KELLER  PART ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50436',
    block_code: 518016,
    block_name: 'SINGHIA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15025',
    district_code: 1524,
    district_name: 'SHIVAMOGGA',
    block_id: 'B-150177',
    block_code: 1524005,
    block_name: 'SHIMOGA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360464',
    block_code: 3626004,
    block_name: 'CHINTHALAPALEM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5016',
    district_code: 525,
    district_name: 'KHAGARIA',
    block_id: 'B-50200',
    block_code: 525005,
    block_name: 'KHAGARIA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17038',
    district_code: 1713,
    district_name: 'REWA',
    block_id: 'B-170232',
    block_code: 1713003,
    block_name: 'SIRMOUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360225',
    block_code: 3615002,
    block_name: 'CHEGUNTA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50033',
    block_code: 545008,
    block_name: 'KATORIA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320164',
    block_code: 3205012,
    block_name: 'ULUBERIA TWO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50247',
    block_code: 520019,
    block_name: 'PANDAUL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270038',
    block_code: 2728010,
    block_name: 'TALWARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360411',
    block_code: 3623026,
    block_name: 'YACHARAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29001',
    district_code: 2931,
    district_name: 'ARIYALUR',
    block_id: 'B-290005',
    block_code: 2931004,
    block_name: 'THIRUMANUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313842',
    block_code: 3163009,
    block_name: 'KARMA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20181',
    block_code: 204017,
    block_name: 'UNDRAJAVARAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20627',
    block_code: 211011,
    block_name: 'BADVEL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290118',
    block_code: 2930006,
    block_name: 'UTHANGARAI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110037',
    block_code: 1108022,
    block_name: 'DANTA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360052',
    block_code: 3604001,
    block_name: 'BEERPUR ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290076',
    block_code: 2910018,
    block_name: 'SATHY',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110114',
    block_code: 1106011,
    block_name: 'MANAVADAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17024',
    district_code: 1744,
    district_name: 'KATNI',
    block_id: 'B-170142',
    block_code: 1744006,
    block_name: 'DHIMARKHEDA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21007',
    district_code: 2106,
    district_name: 'SOUTH GARO HILLS',
    block_id: 'B-210029',
    block_code: 2106013,
    block_name: 'RONGGARA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40031',
    block_code: 423015,
    block_name: 'BORKHOLA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140272',
    block_code: 1410004,
    block_name: 'GHORDI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150216',
    block_code: 1507006,
    block_name: 'BABALESHWARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20209',
    block_code: 219028,
    block_name: 'VELAIRPAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290339',
    block_code: 2906004,
    block_name: 'POLUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16011',
    district_code: 1612,
    district_name: 'PATHANAMTHITTA',
    block_id: 'B-160116',
    block_code: 1612003,
    block_name: 'KOYIPRAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340043',
    block_code: 3411007,
    block_name: 'GOPIKANDER',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31354',
    district_code: 3132,
    district_name: 'LUCKNOW',
    block_id: 'B-313585',
    block_code: 3132001,
    block_name: 'MALIHABAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240282',
    block_code: 2429011,
    block_name: 'RAYAGADA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17025',
    district_code: 1725,
    district_name: 'KHANDWA',
    block_id: 'B-170149',
    block_code: 1725003,
    block_name: 'KHALAWA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20114',
    block_code: 221007,
    block_name: 'CHINAGANJAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20438',
    block_code: 208035,
    block_name: 'TANGUTUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340235',
    block_code: 3409001,
    block_name: 'SERAIKELLA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4029',
    district_code: 416,
    district_name: 'SIVASAGAR',
    block_id: 'B-40185',
    block_code: 416002,
    block_name: 'AMGURI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50009',
    block_code: 541009,
    block_name: 'Sikti',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20017',
    block_code: 215016,
    block_name: 'PADERU',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23010',
    district_code: 2304,
    district_name: 'WOKHA',
    block_id: 'B-230061',
    block_code: 2304006,
    block_name: 'CHANGPANG',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12022',
    district_code: 1202,
    district_name: 'YAMUNANAGAR',
    block_id: 'B-120139',
    block_code: 1202100,
    block_name: 'JAGADHRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313821',
    block_code: 3129005,
    block_name: 'GONDLAMAU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313835',
    block_code: 3129013,
    block_name: 'SAKRAN',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33009',
    district_code: 3309,
    district_name: 'DHAMTARI',
    block_id: 'B-330043',
    block_code: 3309003,
    block_name: 'NAGRI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370027',
    block_code: 3701007,
    block_name: 'SASPOL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20274',
    block_code: 206010,
    block_name: 'GHANTASALA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320078',
    block_code: 3213009,
    block_name: 'SONAMUKHI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270275',
    block_code: 2720004,
    block_name: 'ROHAT',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120036',
    block_code: 1215015,
    block_name: 'HANSI2',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290050',
    block_code: 2909003,
    block_name: 'PENNAGARAM',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12003',
    district_code: 1222,
    district_name: 'CHARKHI DADRI',
    block_id: 'B-120014',
    block_code: 1222005,
    block_name: 'BADHRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31039',
    district_code: 3139,
    district_name: 'JHANSI',
    block_id: 'B-310438',
    block_code: 3139007,
    block_name: 'BABINA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17036',
    district_code: 1726,
    district_name: 'RAJGARH',
    block_id: 'B-170214',
    block_code: 1726002,
    block_name: 'KHILCHIPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20229',
    block_code: 217003,
    block_name: 'JAGGAMPETA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29011',
    district_code: 2917,
    district_name: 'KARUR',
    block_id: 'B-290103',
    block_code: 2917007,
    block_name: 'KADAVUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320257',
    block_code: 3210028,
    block_name: 'DASPUR ONE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170021',
    block_code: 1738009,
    block_name: 'BIRSA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50391',
    block_code: 523014,
    block_name: 'SRINAGAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15025',
    district_code: 1524,
    district_name: 'SHIVAMOGGA',
    block_id: 'B-150173',
    block_code: 1524001,
    block_name: 'BHADRAVATI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360463',
    block_code: 3626003,
    block_name: 'CHILKUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5016',
    district_code: 525,
    district_name: 'KHAGARIA',
    block_id: 'B-50197',
    block_code: 525002,
    block_name: 'BELDAUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17047',
    district_code: 1715,
    district_name: 'SIDHI',
    block_id: 'B-170288',
    block_code: 1715001,
    block_name: 'RAMPUR NAIKIN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360229',
    block_code: 3615006,
    block_name: 'KULCHARAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50026',
    block_code: 545001,
    block_name: 'AMARPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320013',
    block_code: 3215005,
    block_name: 'HABRA ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50250',
    block_code: 520021,
    block_name: 'RAJNAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290208',
    block_code: 2907017,
    block_name: 'SANKARI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360392',
    block_code: 3623004,
    block_name: 'CHEVELLA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29001',
    district_code: 2931,
    district_name: 'ARIYALUR',
    block_id: 'B-290003',
    block_code: 2931007,
    block_name: 'JAYAMKONDAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313843',
    block_code: 3163010,
    block_name: 'KONE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20171',
    block_code: 204002,
    block_name: 'KORUKONDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20635',
    block_code: 211012,
    block_name: 'GOPAVARAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290113',
    block_code: 2930009,
    block_name: 'KELAMANGALAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110036',
    block_code: 1108030,
    block_name: 'BHABHAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360053',
    block_code: 3604002,
    block_name: 'BUGGARAM ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290078',
    block_code: 2910017,
    block_name: 'T.N. PALAYAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110117',
    block_code: 1106012,
    block_name: 'VANTHALI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360448',
    block_code: 3625011,
    block_name: 'KOMURAVELLI',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21007',
    district_code: 2106,
    district_name: 'SOUTH GARO HILLS',
    block_id: 'B-210028',
    block_code: 2106014,
    block_name: 'GASUAPARA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40029',
    block_code: 423016,
    block_name: 'BINNAKANDI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140271',
    block_code: 1410003,
    block_name: 'DUDU',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150218',
    block_code: 1507007,
    block_name: 'CHADA CHANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20193',
    block_code: 219012,
    block_name: 'KAIKALUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290332',
    block_code: 2906007,
    block_name: 'CHENGAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16011',
    district_code: 1612,
    district_name: 'PATHANAMTHITTA',
    block_id: 'B-160118',
    block_code: 1612005,
    block_name: 'PANDALAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340047',
    block_code: 3411009,
    block_name: 'MASALIYA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31354',
    district_code: 3132,
    district_name: 'LUCKNOW',
    block_id: 'B-313581',
    block_code: 3132003,
    block_name: 'BAKSHI-KA-TALAB',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4028',
    district_code: 406,
    district_name: 'NALBARI',
    block_id: 'B-40184',
    block_code: 406008,
    block_name: 'TIHU',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15008',
    district_code: 1528,
    district_name: 'CHIKKABALLAPURA',
    block_id: 'B-150052',
    block_code: 1528002,
    block_name: 'CHIKBALLAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20129',
    block_code: 221022,
    block_name: 'TSUNDUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20426',
    block_code: 208033,
    block_name: 'NAGULUPPALA PADU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340233',
    block_code: 3409004,
    block_name: 'NIMDEEH',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4029',
    district_code: 416,
    district_name: 'SIVASAGAR',
    block_id: 'B-40188',
    block_code: 416003,
    block_name: 'NAZIRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50006',
    block_code: 541006,
    block_name: 'Narpatganj',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20009',
    block_code: 215008,
    block_name: 'G MADUGULA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23010',
    district_code: 2304,
    district_name: 'WOKHA',
    block_id: 'B-230065',
    block_code: 2304004,
    block_name: 'WOKHA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12022',
    district_code: 1202,
    district_name: 'YAMUNANAGAR',
    block_id: 'B-120138',
    block_code: 1202101,
    block_name: 'CHHACHHRAULI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313818',
    block_code: 3129006,
    block_name: 'AILIYA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313833',
    block_code: 3129019,
    block_name: 'RAMPUR MATHURA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20015',
    district_code: 2005,
    district_name: 'THOUBAL',
    block_id: 'B-200064',
    block_code: 2005003,
    block_name: 'LILONG',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370018',
    block_code: 3701002,
    block_name: 'KHALTSI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20273',
    block_code: 206004,
    block_name: 'GANNAVARAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320072',
    block_code: 3213010,
    block_name: 'PATRASAYER',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270272',
    block_code: 2720005,
    block_name: 'PALI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120035',
    block_code: 1215016,
    block_name: 'HANSI1',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290043',
    block_code: 2909004,
    block_name: 'HARUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17051',
    district_code: 1740,
    district_name: 'UMARIA',
    block_id: 'B-170304',
    block_code: 1740002,
    block_name: 'KARKELI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31039',
    district_code: 3139,
    district_name: 'JHANSI',
    block_id: 'B-310439',
    block_code: 3139008,
    block_name: 'BADAGAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17036',
    district_code: 1726,
    district_name: 'RAJGARH',
    block_id: 'B-170216',
    block_code: 1726003,
    block_name: 'RAJGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20239',
    block_code: 217013,
    block_name: 'ROUTHULAPUDI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29011',
    district_code: 2917,
    district_name: 'KARUR',
    block_id: 'B-290105',
    block_code: 2917004,
    block_name: 'K.PARAMATHI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320201',
    block_code: 3212001,
    block_name: 'BELDANGA ONE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240179',
    block_code: 2403005,
    block_name: 'SAHARAPADA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50380',
    block_code: 523003,
    block_name: 'BAISI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15015',
    district_code: 1516,
    district_name: 'HASSAN',
    block_id: 'B-150107',
    block_code: 1516007,
    block_name: 'HOLENARSIPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360465',
    block_code: 3626005,
    block_name: 'CHIVVEMLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5016',
    district_code: 525,
    district_name: 'KHAGARIA',
    block_id: 'B-50201',
    block_code: 525006,
    block_name: 'MANSI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240048',
    block_code: 2409005,
    block_name: 'MURIBAHAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360231',
    block_code: 3615008,
    block_name: 'MEDAK',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50030',
    block_code: 545005,
    block_name: 'BELHAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320014',
    block_code: 3215006,
    block_name: 'HABRA TWO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50244',
    block_code: 520015,
    block_name: 'LAUKAHI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270032',
    block_code: 2728002,
    block_name: 'CHOTI SARVAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360405',
    block_code: 3623018,
    block_name: 'MOINABAD',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30006',
    block_code: 310001,
    block_name: 'CHANGLANG',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28003',
    district_code: 2801,
    district_name: 'MANGAN',
    block_id: 'B-280014',
    block_code: 2801002,
    block_name: 'MANGAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20167',
    block_code: 204013,
    block_name: 'DEVARAPALLE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20639',
    block_code: 211013,
    block_name: 'KHAJIPET',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290117',
    block_code: 2930010,
    block_name: 'THALLY',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110035',
    block_code: 1108036,
    block_name: 'AMIRGADH',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150003',
    block_code: 1501003,
    block_name: 'BILAGI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290073',
    block_code: 2910002,
    block_name: 'MODAKKURUCHI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110110',
    block_code: 1106013,
    block_name: 'BHESAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360456',
    block_code: 3625018,
    block_name: 'RAIPOLE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170065',
    block_code: 1736010,
    block_name: 'BICHHUA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40036',
    block_code: 423018,
    block_name: 'PALONGHAT',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140280',
    block_code: 1410008,
    block_name: 'PANCHERI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15027',
    district_code: 1526,
    district_name: 'UDUPI',
    block_id: 'B-150193',
    block_code: 1526005,
    block_name: 'KAAPU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20183',
    block_code: 219002,
    block_name: 'BHIMADOLE',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290341',
    block_code: 2906009,
    block_name: 'THANDRAMPET',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16011',
    district_code: 1612,
    district_name: 'PATHANAMTHITTA',
    block_id: 'B-160119',
    block_code: 1612006,
    block_name: 'PARAKKODU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340051',
    block_code: 3411006,
    block_name: 'SIKARIPARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31354',
    district_code: 3132,
    district_name: 'LUCKNOW',
    block_id: 'B-313586',
    block_code: 3132002,
    block_name: 'MALL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240277',
    block_code: 2429006,
    block_name: 'KASHIPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15008',
    district_code: 1528,
    district_name: 'CHIKKABALLAPURA',
    block_id: 'B-150055',
    block_code: 1528005,
    block_name: 'GUDIBANDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20126',
    block_code: 221019,
    block_name: 'PITTALAVANIPALEM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20443',
    block_code: 208036,
    block_name: 'ZARUGUMILLI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34022',
    district_code: 3409,
    district_name: 'SARAIKELA KHARSAWAN',
    block_id: 'B-340228',
    block_code: 3409002,
    block_name: 'GAMARHIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50024',
    block_code: 505010,
    block_name: 'Obra',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50004',
    block_code: 541004,
    block_name: 'Jokihat',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20014',
    block_code: 215014,
    block_name: 'MAREDUMILLI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23010',
    district_code: 2304,
    district_name: 'WOKHA',
    block_id: 'B-230060',
    block_code: 2304001,
    block_name: 'BHANDARI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12022',
    district_code: 1202,
    district_name: 'YAMUNANAGAR',
    block_id: 'B-120137',
    block_code: 1202103,
    block_name: 'BILASPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313822',
    block_code: 3129007,
    block_name: 'HARGAON',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313836',
    block_code: 3129016,
    block_name: 'SIDHAULI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20015',
    district_code: 2005,
    district_name: 'THOUBAL',
    block_id: 'B-200066',
    block_code: 2005004,
    block_name: 'WANGJING TENTHA',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370031',
    block_code: 3701010,
    block_name: 'TURRTAK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20278',
    block_code: 206003,
    block_name: 'KANKIPADU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320069',
    block_code: 3213012,
    block_name: 'KOTULPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270269',
    block_code: 2720007,
    block_name: 'DESURI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12007',
    district_code: 1215,
    district_name: 'HISAR',
    block_id: 'B-120038',
    block_code: 1215011,
    block_name: 'HISAR2',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290049',
    block_code: 2909006,
    block_name: 'PAPPIREDDIPATTI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50409',
    block_code: 504018,
    block_name: 'SURYAPURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310197',
    block_code: 3109004,
    block_name: 'HALDAUR-KHARI JHALU',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17036',
    district_code: 1726,
    district_name: 'RAJGARH',
    block_id: 'B-170213',
    block_code: 1726004,
    block_name: 'BIAORA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20245',
    block_code: 217019,
    block_name: 'U KOTHAPALLE',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29011',
    district_code: 2917,
    district_name: 'KARUR',
    block_id: 'B-290109',
    block_code: 2917008,
    block_name: 'THOGAMALAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320255',
    block_code: 3210013,
    block_name: 'DANTAN ONE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240174',
    block_code: 2403009,
    block_name: 'HATADIHI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50388',
    block_code: 523011,
    block_name: 'KRITYANAND NAGAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15015',
    district_code: 1516,
    district_name: 'HASSAN',
    block_id: 'B-150108',
    block_code: 1516008,
    block_name: 'SAKALESHPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360461',
    block_code: 3626001,
    block_name: 'ANANTHAGIRI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5016',
    district_code: 525,
    district_name: 'KHAGARIA',
    block_id: 'B-50198',
    block_code: 525003,
    block_name: 'CHAUTHAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240050',
    block_code: 2409011,
    block_name: 'PUINTALA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360235',
    block_code: 3615012,
    block_name: 'PAPANNAPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50031',
    block_code: 545006,
    block_name: 'CHANAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320018',
    block_code: 3215016,
    block_name: 'MINAKHAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50241',
    block_code: 520012,
    block_name: 'LADANIA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270029',
    block_code: 2728009,
    block_name: 'ARTHOONA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360395',
    block_code: 3623009,
    block_name: 'IBRAHIMPATNAM',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30034',
    block_code: 316003,
    block_name: 'NYAPIN',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28003',
    district_code: 2801,
    district_name: 'MANGAN',
    block_id: 'B-280013',
    block_code: 2801003,
    block_name: 'KABI TINGDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20174',
    block_code: 204016,
    block_name: 'NIDADAVOLE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20636',
    block_code: 211016,
    block_name: 'JAMMALAMADUGU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29012',
    district_code: 2930,
    district_name: 'KRISHNAGIRI',
    block_id: 'B-290111',
    block_code: 2930007,
    block_name: 'HOSUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110210',
    block_code: 1117001,
    block_name: 'CHORASI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150004',
    block_code: 1501007,
    block_name: 'GULEDAGUDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290066',
    block_code: 2910013,
    block_name: 'ANTHIYUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11016',
    district_code: 1106,
    district_name: 'JUNAGADH',
    block_id: 'B-110118',
    block_code: 1106014,
    block_name: 'VISAVADAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360455',
    block_code: 3625023,
    block_name: 'NARAYANARAOPET',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17046',
    district_code: 1705,
    district_name: 'SHIVPURI',
    block_id: 'B-170280',
    block_code: 1705008,
    block_name: 'KHANIYADHANA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40041',
    block_code: 423020,
    block_name: 'TAPANG',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140279',
    block_code: 1410019,
    block_name: 'NARSOO',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150223',
    block_code: 1507010,
    block_name: 'NIDAGUNDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20185',
    block_code: 219004,
    block_name: 'CHATRAI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290345',
    block_code: 2906014,
    block_name: 'VANDAVASI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16011',
    district_code: 1612,
    district_name: 'PATHANAMTHITTA',
    block_id: 'B-160120',
    block_code: 1612007,
    block_name: 'PULIKKEEZHU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34005',
    district_code: 3411,
    district_name: 'DUMKA',
    block_id: 'B-340050',
    block_code: 3411002,
    block_name: 'SARAIYAHAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31354',
    district_code: 3132,
    district_name: 'LUCKNOW',
    block_id: 'B-313588',
    block_code: 3132006,
    block_name: 'SAROJNINAGAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340131',
    block_code: 3416001,
    block_name: 'SADAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15008',
    district_code: 1528,
    district_name: 'CHIKKABALLAPURA',
    block_id: 'B-150056',
    block_code: 1528006,
    block_name: 'SIDLAGHATTA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20132',
    block_code: 221025,
    block_name: 'YDDANA PUDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20420',
    block_code: 208034,
    block_name: 'KOTHA PATNAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340034',
    block_code: 3421001,
    block_name: 'DHANBAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50022',
    block_code: 505008,
    block_name: 'Madanpur',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50003',
    block_code: 541003,
    block_name: 'Forbesganj',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20021',
    block_code: 215020,
    block_name: 'VARARAMACHANDRAPURAM',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23010',
    district_code: 2304,
    district_name: 'WOKHA',
    block_id: 'B-230062',
    block_code: 2304002,
    block_name: 'CHUKITONG',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12022',
    district_code: 1202,
    district_name: 'YAMUNANAGAR',
    block_id: 'B-120142',
    block_code: 1202104,
    block_name: 'SADAURA-PART',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313831',
    block_code: 3129008,
    block_name: 'PARSENDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313832',
    block_code: 3129001,
    block_name: 'PISAWAN',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20015',
    district_code: 2005,
    district_name: 'THOUBAL',
    block_id: 'B-200065',
    block_code: 2005001,
    block_name: 'THOUBAL',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370023',
    block_code: 3701004,
    block_name: 'NYOMA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20279',
    block_code: 206015,
    block_name: 'KODURU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320071',
    block_code: 3213015,
    block_name: 'ONDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270277',
    block_code: 2720008,
    block_name: 'SUMERPUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12008',
    district_code: 1220,
    district_name: 'JHAJJAR',
    block_id: 'B-120041',
    block_code: 1220006,
    block_name: 'BADLI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290048',
    block_code: 2909008,
    block_name: 'PALACODE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50397',
    block_code: 504006,
    block_name: 'DINARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313249',
    block_code: 3148001,
    block_name: 'NINDURA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17036',
    district_code: 1726,
    district_name: 'RAJGARH',
    block_id: 'B-170217',
    block_code: 1726005,
    block_name: 'SARANGPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20234',
    block_code: 217008,
    block_name: 'KOTANANDURU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27022',
    district_code: 2709,
    district_name: 'KARAULI',
    block_id: 'B-270241',
    block_code: 2709006,
    block_name: 'MANDRAYAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320224',
    block_code: 3212024,
    block_name: 'SAMSERGANJ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240173',
    block_code: 2403002,
    block_name: 'HARICHADANPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50383',
    block_code: 523006,
    block_name: 'BHAWANIPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15025',
    district_code: 1524,
    district_name: 'SHIVAMOGGA',
    block_id: 'B-150174',
    block_code: 1524002,
    block_name: 'HOSANAGARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360467',
    block_code: 3626007,
    block_name: 'HUZURNAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240265',
    block_code: 2413005,
    block_name: 'KAKATPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240040',
    block_code: 2409012,
    block_name: 'AGALPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360236',
    block_code: 3615013,
    block_name: 'RAMAYAMPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50034',
    block_code: 545009,
    block_name: 'PHULIDUMAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320004',
    block_code: 3215002,
    block_name: 'BARASAT ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50237',
    block_code: 520008,
    block_name: 'JAINAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313257',
    block_code: 3125019,
    block_name: 'BAHERI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360410',
    block_code: 3623025,
    block_name: 'TALAKONDAPALLE',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30032',
    block_code: 316004,
    block_name: 'DAMIN',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28003',
    district_code: 2801,
    district_name: 'MANGAN',
    block_id: 'B-280011',
    block_code: 2801001,
    block_name: 'CHUNGTHANG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20175',
    block_code: 204018,
    block_name: 'PERAVALI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20642',
    block_code: 211017,
    block_name: 'MUDDANUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180237',
    block_code: 1817008,
    block_name: 'PURNA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110215',
    block_code: 1117002,
    block_name: 'OLPAD',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150006',
    block_code: 1501008,
    block_name: 'ILKAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313279',
    block_code: 3153001,
    block_name: 'PARAS RAMPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360414',
    block_code: 3624003,
    block_name: 'GUMMADIDALA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360458',
    block_code: 3625019,
    block_name: 'SIDDIPET URBAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17012',
    district_code: 1736,
    district_name: 'CHHINDWARA',
    block_id: 'B-170068',
    block_code: 1736002,
    block_name: 'HARAI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40028',
    block_code: 423021,
    block_name: 'BANSKANDI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140274',
    block_code: 1410015,
    block_name: 'KHOON',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150219',
    block_code: 1507009,
    block_name: 'DEVARA HIPPARAGI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20203',
    block_code: 219022,
    block_name: 'NUZVID',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290334',
    block_code: 2906011,
    block_name: 'CHEYYAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170153',
    block_code: 1724001,
    block_name: 'BARWAH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31354',
    district_code: 3132,
    district_name: 'LUCKNOW',
    block_id: 'B-313583',
    block_code: 3132007,
    block_name: 'GOSAIGANJ',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21008',
    district_code: 2111,
    district_name: 'SOUTH WEST GARO HILLS',
    block_id: 'B-210031',
    block_code: 2111004,
    block_name: 'DAMALGRE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340127',
    block_code: 3416019,
    block_name: 'KATKAMDAG',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340089',
    block_code: 3419006,
    block_name: 'GANDEY',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20130',
    block_code: 221023,
    block_name: 'VEMURU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20430',
    block_code: 208028,
    block_name: 'PEDACHERLO PALLE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340036',
    block_code: 3421003,
    block_name: 'GOVINDPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50025',
    block_code: 505011,
    block_name: 'Rafiganj',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50007',
    block_code: 541007,
    block_name: 'Palasi',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20012',
    block_code: 215012,
    block_name: 'KOYYURU',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23010',
    district_code: 2304,
    district_name: 'WOKHA',
    block_id: 'B-230064',
    block_code: 2304003,
    block_name: 'SANIS',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12010',
    district_code: 1204,
    district_name: 'KAITHAL',
    block_id: 'B-120060',
    block_code: 1204003,
    block_name: 'PUNDRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313824',
    block_code: 3129009,
    block_name: 'KHAIRABAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313828',
    block_code: 3129002,
    block_name: 'MAHOLI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4003',
    district_code: 405,
    district_name: 'BARPETA',
    block_id: 'B-40012',
    block_code: 405007,
    block_name: 'MANDIA',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370017',
    block_code: 3701005,
    block_name: 'DURBUK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20269',
    block_code: 206013,
    block_name: 'AVANIGADDA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320079',
    block_code: 3213016,
    block_name: 'TALDANGRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270274',
    block_code: 2720010,
    block_name: 'RANI STATION',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12008',
    district_code: 1220,
    district_name: 'JHAJJAR',
    block_id: 'B-120045',
    block_code: 1220007,
    block_name: 'MACHHRAULI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31335',
    district_code: 3164,
    district_name: 'GAUTAM BUDDHA NAGAR',
    block_id: 'B-313376',
    block_code: 3164005,
    block_name: 'BISRAKH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50404',
    block_code: 504013,
    block_name: 'RAJPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180351',
    block_code: 1825016,
    block_name: 'ZARI JAMNI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17036',
    district_code: 1726,
    district_name: 'RAJGARH',
    block_id: 'B-170215',
    block_code: 1726006,
    block_name: 'NARSINGHGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20244',
    block_code: 217018,
    block_name: 'TUNI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27022',
    district_code: 2709,
    district_name: 'KARAULI',
    block_id: 'B-270239',
    block_code: 2709001,
    block_name: 'HINDAUN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320202',
    block_code: 3212002,
    block_name: 'BELDANGA TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240178',
    block_code: 2403003,
    block_name: 'PATANA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50390',
    block_code: 523013,
    block_name: 'RUPAULI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15025',
    district_code: 1524,
    district_name: 'SHIVAMOGGA',
    block_id: 'B-150175',
    block_code: 1524003,
    block_name: 'SAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360474',
    block_code: 3626014,
    block_name: 'MUNAGALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5016',
    district_code: 525,
    district_name: 'KHAGARIA',
    block_id: 'B-50202',
    block_code: 525007,
    block_name: 'PARBATTA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240044',
    block_code: 2409013,
    block_name: 'DEOGAON',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360123',
    block_code: 3608019,
    block_name: 'RAMAREDDY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31316',
    district_code: 3169,
    district_name: 'AURAIYA',
    block_id: 'B-313159',
    block_code: 3169006,
    block_name: 'BHAGYANAGAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320006',
    block_code: 3215008,
    block_name: 'BARRACKPORE ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50245',
    block_code: 520016,
    block_name: 'MADHEPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313262',
    block_code: 3125022,
    block_name: 'FARIDPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360402',
    block_code: 3623015,
    block_name: 'MADGUL',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30033',
    block_code: 316005,
    block_name: 'KOLORIANG',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28003',
    district_code: 2801,
    district_name: 'MANGAN',
    block_id: 'B-280012',
    block_code: 2801004,
    block_name: 'DZONGU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20177',
    block_code: 204005,
    block_name: 'RAJANAGARAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20652',
    block_code: 211018,
    block_name: 'SIMHADRIPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180239',
    block_code: 1817009,
    block_name: 'SONPETH',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110211',
    block_code: 1117003,
    block_name: 'KAMREJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150009',
    block_code: 1501009,
    block_name: 'RABA KAVI BANAHATTI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313275',
    block_code: 3153002,
    block_name: 'GAUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360412',
    block_code: 3624001,
    block_name: 'AMEENPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360444',
    block_code: 3625007,
    block_name: 'GAJWEL',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12014',
    district_code: 1219,
    district_name: 'NUH MEWAT ',
    block_id: 'B-120087',
    block_code: 1219009,
    block_name: 'FEROZEPUR JHIRKA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40032',
    block_code: 423022,
    block_name: 'KALAIN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140278',
    block_code: 1410018,
    block_name: 'MOUNGRI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150225',
    block_code: 1507011,
    block_name: 'THAALIKOTE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20204',
    block_code: 219023,
    block_name: 'PEDAPADU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290337',
    block_code: 2906002,
    block_name: 'KILPENNATHUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17037',
    district_code: 1717,
    district_name: 'RATLAM',
    block_id: 'B-170222',
    block_code: 1717001,
    block_name: 'PIPLODA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31354',
    district_code: 3132,
    district_name: 'LUCKNOW',
    block_id: 'B-313587',
    block_code: 3132008,
    block_name: 'MOHANLALGANJ',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21008',
    district_code: 2111,
    district_name: 'SOUTH WEST GARO HILLS',
    block_id: 'B-210030',
    block_code: 2111002,
    block_name: 'BETASING',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340132',
    block_code: 3416020,
    block_name: 'TATIJHARIYA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340093',
    block_code: 3419009,
    block_name: 'PIRTAND',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20131',
    block_code: 221024,
    block_name: 'VETAPALEM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20432',
    block_code: 208029,
    block_name: 'PONNALURU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340032',
    block_code: 3421006,
    block_name: 'BAGHMARA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50015',
    block_code: 505001,
    block_name: 'Aurangabad',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4016',
    district_code: 422,
    district_name: 'HAILAKANDI',
    block_id: 'B-40099',
    block_code: 422001,
    block_name: 'HAILAKANDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20007',
    block_code: 215007,
    block_name: 'DUMBRIGUDA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23010',
    district_code: 2304,
    district_name: 'WOKHA',
    block_id: 'B-230063',
    block_code: 2304007,
    block_name: 'RALAN',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12010',
    district_code: 1204,
    district_name: 'KAITHAL',
    block_id: 'B-120061',
    block_code: 1204004,
    block_name: 'RAJOUND',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313819',
    block_code: 3129011,
    block_name: 'BEHTA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313826',
    block_code: 3129004,
    block_name: 'MACHHREHTA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4003',
    district_code: 405,
    district_name: 'BARPETA',
    block_id: 'B-40011',
    block_code: 405009,
    block_name: 'GOMAPHULBARI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370019',
    block_code: 3701006,
    block_name: 'KHARU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20291',
    block_code: 206002,
    block_name: 'THOTLAVALLURU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320077',
    block_code: 3213017,
    block_name: 'SIMLAPAL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270113',
    block_code: 2729005,
    block_name: 'CHHITTORGARH',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12008',
    district_code: 1220,
    district_name: 'JHAJJAR',
    block_id: 'B-120047',
    block_code: 1220005,
    block_name: 'SALHAWAS',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29009',
    district_code: 2901,
    district_name: 'KANCHIPURAM',
    block_id: 'B-290089',
    block_code: 2901005,
    block_name: 'KUNDRATHUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50410',
    block_code: 504019,
    block_name: 'TILOUTHU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180344',
    block_code: 1825018,
    block_name: 'MAREGAON',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33010',
    district_code: 3303,
    district_name: 'DURG',
    block_id: 'B-330044',
    block_code: 3303005,
    block_name: 'DHAMDHA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20236',
    block_code: 217010,
    block_name: 'PEDDAPURAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27022',
    district_code: 2709,
    district_name: 'KARAULI',
    block_id: 'B-270240',
    block_code: 2709002,
    block_name: 'KARAULI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320207',
    block_code: 3212007,
    block_name: 'BHARATPUR TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240172',
    block_code: 2403004,
    block_name: 'GHATGAON',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50384',
    block_code: 523007,
    block_name: 'DAGARUA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15025',
    district_code: 1524,
    district_name: 'SHIVAMOGGA',
    block_id: 'B-150176',
    block_code: 1524004,
    block_name: 'SHIKARPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360462',
    block_code: 3626002,
    block_name: 'ATMAKUR  S ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5016',
    district_code: 525,
    district_name: 'KHAGARIA',
    block_id: 'B-50199',
    block_code: 525004,
    block_name: 'GOGRI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240045',
    block_code: 2409021,
    block_name: 'GUDVELLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360238',
    block_code: 3615016,
    block_name: 'SHANKARAMPET A ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31316',
    district_code: 3169,
    district_name: 'AURAIYA',
    block_id: 'B-313160',
    block_code: 3169002,
    block_name: 'BIDHUNA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320008',
    block_code: 3215011,
    block_name: 'BASIRHAT ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50230',
    block_code: 520001,
    block_name: 'ANDHRATHARHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313267',
    block_code: 3125027,
    block_name: 'NAWABGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360406',
    block_code: 3623019,
    block_name: 'NANDIGAMA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30037',
    block_code: 316007,
    block_name: 'SARLI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50170',
    block_code: 549002,
    block_name: 'BHABUA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20165',
    block_code: 204009,
    block_name: 'BICCAVOLU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20649',
    block_code: 211020,
    block_name: 'PULIVENDLA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180234',
    block_code: 1817010,
    block_name: 'PALAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110214',
    block_code: 1117004,
    block_name: 'MANGROL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360063',
    block_code: 3604012,
    block_name: 'MALLIAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313276',
    block_code: 3153003,
    block_name: 'HARRAIYA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360435',
    block_code: 3624024,
    block_name: 'SIRGAPOOR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360453',
    block_code: 3625016,
    block_name: 'MULUG',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12014',
    district_code: 1219,
    district_name: 'NUH MEWAT ',
    block_id: 'B-120089',
    block_code: 1219007,
    block_name: 'NAGINA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40034',
    block_code: 423009,
    block_name: 'LAKHIPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14020',
    district_code: 1410,
    district_name: 'UDHAMPUR',
    block_id: 'B-140283',
    block_code: 1410021,
    block_name: 'SEWNA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150215',
    block_code: 1507013,
    block_name: 'ALMEL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20201',
    block_code: 219020,
    block_name: 'MUSUNURU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290333',
    block_code: 2906006,
    block_name: 'CHETPET',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17037',
    district_code: 1717,
    district_name: 'RATLAM',
    block_id: 'B-170221',
    block_code: 1717002,
    block_name: 'JAORA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27004',
    district_code: 2731,
    district_name: 'BARAN',
    block_id: 'B-270040',
    block_code: 2731003,
    block_name: 'ATRU',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21008',
    district_code: 2111,
    district_name: 'SOUTH WEST GARO HILLS',
    block_id: 'B-210032',
    block_code: 2111003,
    block_name: 'ZIKZAK',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340121',
    block_code: 3416016,
    block_name: 'CHALKUSHA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340085',
    block_code: 3419003,
    block_name: 'BIRNI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20123',
    block_code: 221016,
    block_name: 'NAGARAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20419',
    block_code: 208030,
    block_name: 'KONDAPI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340039',
    block_code: 3421009,
    block_name: 'PURVI TUNDI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50016',
    block_code: 505002,
    block_name: 'Barun',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4016',
    district_code: 422,
    district_name: 'HAILAKANDI',
    block_id: 'B-40101',
    block_code: 422002,
    block_name: 'LALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20006',
    block_code: 215006,
    block_name: 'DEVIPATNAM',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23010',
    district_code: 2304,
    district_name: 'WOKHA',
    block_id: 'B-230066',
    block_code: 2304005,
    block_name: 'WOZHURO',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12010',
    district_code: 1204,
    district_name: 'KAITHAL',
    block_id: 'B-120059',
    block_code: 1204005,
    block_name: 'KALAYAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313823',
    block_code: 3129015,
    block_name: 'KASMANDA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21002',
    district_code: 2104,
    district_name: 'EAST GARO HILLS',
    block_id: 'B-210003',
    block_code: 2104002,
    block_name: 'DAMBO RONGJENG',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4003',
    district_code: 405,
    district_name: 'BARPETA',
    block_id: 'B-40013',
    block_code: 405010,
    block_name: 'PAKABETBARI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370016',
    block_code: 3701003,
    block_name: 'CHUCHOT',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20293',
    block_code: 206007,
    block_name: 'VUYYURU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320064',
    block_code: 3213019,
    block_name: 'HIRBANDH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270271',
    block_code: 2720006,
    block_name: 'KHARCHI  MARWAR JUNCTION ',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12008',
    district_code: 1220,
    district_name: 'JHAJJAR',
    block_id: 'B-120042',
    block_code: 1220001,
    block_name: 'BAHADURGARH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29009',
    district_code: 2901,
    district_name: 'KANCHIPURAM',
    block_id: 'B-290091',
    block_code: 2901003,
    block_name: 'UTHIRAMERUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50407',
    block_code: 504016,
    block_name: 'SASARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31039',
    district_code: 3139,
    district_name: 'JHANSI',
    block_id: 'B-310440',
    block_code: 3139003,
    block_name: 'BAMAUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33010',
    district_code: 3303,
    district_name: 'DURG',
    block_id: 'B-330045',
    block_code: 3303006,
    block_name: 'DURG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20227',
    block_code: 217001,
    block_name: 'GANDEPALLE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27022',
    district_code: 2709,
    district_name: 'KARAULI',
    block_id: 'B-270244',
    block_code: 2709004,
    block_name: 'SAPOTRA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320253',
    block_code: 3210026,
    block_name: 'CHANDRAKONA ONE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240180',
    block_code: 2403006,
    block_name: 'TELKOI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50387',
    block_code: 523010,
    block_name: 'KASBA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15025',
    district_code: 1524,
    district_name: 'SHIVAMOGGA',
    block_id: 'B-150178',
    block_code: 1524006,
    block_name: 'SORAB',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360478',
    block_code: 3626018,
    block_name: 'NUTHANKAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5016',
    district_code: 525,
    district_name: 'KHAGARIA',
    block_id: 'B-50196',
    block_code: 525001,
    block_name: 'ALAULI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240049',
    block_code: 2409001,
    block_name: 'PATNAGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360232',
    block_code: 3615009,
    block_name: 'NARSAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31316',
    district_code: 3169,
    district_name: 'AURAIYA',
    block_id: 'B-313158',
    block_code: 3169007,
    block_name: 'AURAIYA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320020',
    block_code: 3215017,
    block_name: 'SANDESHKHALI ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50233',
    block_code: 520004,
    block_name: 'BENIPATTI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313266',
    block_code: 3125030,
    block_name: 'MIRGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360404',
    block_code: 3623017,
    block_name: 'MANCHAL',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30036',
    block_code: 316008,
    block_name: 'SANGRAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50169',
    block_code: 549001,
    block_name: 'ADHAURA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2007',
    district_code: 204,
    district_name: 'EAST GODAVARI',
    block_id: 'B-20176',
    block_code: 204006,
    block_name: 'RAJAHMUNDRY RURAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20658',
    block_code: 211021,
    block_name: 'VEMULA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180236',
    block_code: 1817013,
    block_name: 'PATHRI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110213',
    block_code: 1117005,
    block_name: 'MANDVI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360057',
    block_code: 3604006,
    block_name: 'JAGITIAL RURAL ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313284',
    block_code: 3153004,
    block_name: 'VIKRAM JOT',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360421',
    block_code: 3624010,
    block_name: 'KOHIR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360445',
    block_code: 3625008,
    block_name: 'HUSNABAD',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12014',
    district_code: 1219,
    district_name: 'NUH MEWAT ',
    block_id: 'B-120090',
    block_code: 1219006,
    block_name: 'NUH',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40040',
    block_code: 423012,
    block_name: 'SONAI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50530',
    block_code: 516012,
    block_name: 'PATERHI BELSAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150227',
    block_code: 1507002,
    block_name: 'VIJAYAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20195',
    block_code: 219014,
    block_name: 'KAMAVARAPUKOTA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290330',
    block_code: 2906012,
    block_name: 'ANAKKAVOOR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17037',
    district_code: 1717,
    district_name: 'RATLAM',
    block_id: 'B-170219',
    block_code: 1717003,
    block_name: 'ALOT',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27004',
    district_code: 2731,
    district_name: 'BARAN',
    block_id: 'B-270044',
    block_code: 2731004,
    block_name: 'KISHANGANJ',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170091',
    block_code: 1722001,
    block_name: 'BADNAWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31336',
    district_code: 3116,
    district_name: 'GHAZIABAD',
    block_id: 'B-313380',
    block_code: 3116001,
    block_name: 'BHOJPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340087',
    block_code: 3419004,
    block_name: 'DHANWAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20122',
    block_code: 221015,
    block_name: 'MARTUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20435',
    block_code: 208031,
    block_name: 'SANTHANUTHALA PADU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340035',
    block_code: 3421010,
    block_name: 'EGARKUND',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50021',
    block_code: 505007,
    block_name: 'Kutumba',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4016',
    district_code: 422,
    district_name: 'HAILAKANDI',
    block_id: 'B-40098',
    block_code: 422004,
    block_name: 'ALGAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20015',
    block_code: 215015,
    block_name: 'MUNCHINGI PUTTU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340072',
    block_code: 3407001,
    block_name: 'GARHWA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12010',
    district_code: 1204,
    district_name: 'KAITHAL',
    block_id: 'B-120062',
    block_code: 1204006,
    block_name: 'SIWAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313830',
    block_code: 3129017,
    block_name: 'PAHALA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21002',
    district_code: 2104,
    district_name: 'EAST GARO HILLS',
    block_id: 'B-210004',
    block_code: 2104004,
    block_name: 'SAMANDA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4003',
    district_code: 405,
    district_name: 'BARPETA',
    block_id: 'B-40015',
    block_code: 405011,
    block_name: 'SARUKHETRI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370022',
    block_code: 3701008,
    block_name: 'NUBRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20281',
    block_code: 206016,
    block_name: 'MACHILIPATNAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320074',
    block_code: 3213020,
    block_name: 'RANIBUNDH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270110',
    block_code: 2729008,
    block_name: 'BHADESAR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12008',
    district_code: 1220,
    district_name: 'JHAJJAR',
    block_id: 'B-120043',
    block_code: 1220002,
    block_name: 'BERI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290042',
    block_code: 2909010,
    block_name: 'ERIYUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50394',
    block_code: 504003,
    block_name: 'CHENARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31039',
    district_code: 3139,
    district_name: 'JHANSI',
    block_id: 'B-310443',
    block_code: 3139004,
    block_name: 'GURSARAI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33010',
    district_code: 3303,
    district_name: 'DURG',
    block_id: 'B-330046',
    block_code: 3303007,
    block_name: 'PATAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20237',
    block_code: 217011,
    block_name: 'PITHAPURAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27022',
    district_code: 2709,
    district_name: 'KARAULI',
    block_id: 'B-270246',
    block_code: 2709005,
    block_name: 'TODABHIM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320256',
    block_code: 3210014,
    block_name: 'DANTAN TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240168',
    block_code: 2403008,
    block_name: 'ANANDAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50381',
    block_code: 523004,
    block_name: 'BANMANKHI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15025',
    district_code: 1524,
    district_name: 'SHIVAMOGGA',
    block_id: 'B-150179',
    block_code: 1524007,
    block_name: 'TIRTHAHALLI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360483',
    block_code: 3626023,
    block_name: 'THUNGATHURTHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140217',
    block_code: 1412013,
    block_name: 'PLANGER',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240043',
    block_code: 2409002,
    block_name: 'BELPARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360107',
    block_code: 3608003,
    block_name: 'BIBIPET',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290124',
    block_code: 2920001,
    block_name: 'MADURAI EAST',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320010',
    block_code: 3215020,
    block_name: 'BONGAON',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50232',
    block_code: 520003,
    block_name: 'BASOPATTI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313258',
    block_code: 3125017,
    block_name: 'BHADPURA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360407',
    block_code: 3623022,
    block_name: 'SHABAD',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30009',
    block_code: 310005,
    block_name: 'KHIMIYANG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50178',
    block_code: 549010,
    block_name: 'RAMGARH',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35010',
    district_code: 3506,
    district_name: 'RUDRA PRAYAG',
    block_id: 'B-350073',
    block_code: 3506002,
    block_name: 'UKHIMATH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20660',
    block_code: 211024,
    block_name: 'YERRAGUNTLA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180231',
    block_code: 1817014,
    block_name: 'GANGAKHED',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110209',
    block_code: 1117011,
    block_name: 'BARDOLI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150007',
    block_code: 1501005,
    block_name: 'JAMKHANDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313277',
    block_code: 3153005,
    block_name: 'KAPTANGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360415',
    block_code: 3624004,
    block_name: 'HATHNOORA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360438',
    block_code: 3625001,
    block_name: 'AKKANNAPET',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12014',
    district_code: 1219,
    district_name: 'NUH MEWAT ',
    block_id: 'B-120088',
    block_code: 1219011,
    block_name: 'INDRI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40039',
    block_code: 423017,
    block_name: 'SILCHAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50529',
    block_code: 516011,
    block_name: 'PATEPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150217',
    block_code: 1507001,
    block_name: 'BASAVAN BAGEWADI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20196',
    block_code: 219015,
    block_name: 'KOYYALAGUDEM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290338',
    block_code: 2906016,
    block_name: 'PERANAMALLUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17037',
    district_code: 1717,
    district_name: 'RATLAM',
    block_id: 'B-170224',
    block_code: 1717004,
    block_name: 'SAILANA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27004',
    district_code: 2731,
    district_name: 'BARAN',
    block_id: 'B-270046',
    block_code: 2731005,
    block_name: 'SHAHBAD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170101',
    block_code: 1722002,
    block_name: 'SARDARPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31336',
    district_code: 3116,
    district_name: 'GHAZIABAD',
    block_id: 'B-313382',
    block_code: 3116002,
    block_name: 'MURADNAGAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340088',
    block_code: 3419005,
    block_name: 'DUMRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20120',
    block_code: 221013,
    block_name: 'KOLLUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17052',
    district_code: 1727,
    district_name: 'VIDISHA',
    block_id: 'B-170307',
    block_code: 1727004,
    block_name: 'BASODA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34004',
    district_code: 3421,
    district_name: 'DHANBAD',
    block_id: 'B-340037',
    block_code: 3421011,
    block_name: 'KALYASOL',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4014',
    district_code: 404,
    district_name: 'GOALPARA',
    block_id: 'B-40086',
    block_code: 404004,
    block_name: 'KUSHDHOWA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4016',
    district_code: 422,
    district_name: 'HAILAKANDI',
    block_id: 'B-40100',
    block_code: 422003,
    block_name: 'KATLICHERRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20008',
    block_code: 215009,
    block_name: 'GANGAVARAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340066',
    block_code: 3407003,
    block_name: 'BHAWNATHPUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12010',
    district_code: 1204,
    district_name: 'KAITHAL',
    block_id: 'B-120057',
    block_code: 1204001,
    block_name: 'GUHLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313829',
    block_code: 3129003,
    block_name: 'MISRIKH',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21002',
    district_code: 2104,
    district_name: 'EAST GARO HILLS',
    block_id: 'B-210005',
    block_code: 2104003,
    block_name: 'SONGSAK',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4003',
    district_code: 405,
    district_name: 'BARPETA',
    block_id: 'B-40009',
    block_code: 405012,
    block_name: 'CHAKCHAKA',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370024',
    block_code: 3701009,
    block_name: 'PANAMIC',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20284',
    block_code: 206014,
    block_name: 'NAGAYALANKA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320076',
    block_code: 3213022,
    block_name: 'SARENGA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270111',
    block_code: 2729004,
    block_name: 'BHAINSRORGARH',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12008',
    district_code: 1220,
    district_name: 'JHAJJAR',
    block_id: 'B-120044',
    block_code: 1220003,
    block_name: 'JHAJJAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29005',
    district_code: 2909,
    district_name: 'DHARMAPURI',
    block_id: 'B-290044',
    block_code: 2909009,
    block_name: 'KADATHUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50393',
    block_code: 504002,
    block_name: 'BIKRAMGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313252',
    block_code: 3148009,
    block_name: 'SIDDHAUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17036',
    district_code: 1726,
    district_name: 'RAJGARH',
    block_id: 'B-170218',
    block_code: 1726001,
    block_name: 'ZIRAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2010',
    district_code: 217,
    district_name: 'KAKINADA',
    block_id: 'B-20238',
    block_code: 217012,
    block_name: 'PRATHIPADU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29011',
    district_code: 2917,
    district_name: 'KARUR',
    block_id: 'B-290107',
    block_code: 2917005,
    block_name: 'KULITHALAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320258',
    block_code: 3210029,
    block_name: 'DASPUR TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240171',
    block_code: 2403010,
    block_name: 'GHASIPURA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50382',
    block_code: 523005,
    block_name: 'BARHARA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15015',
    district_code: 1516,
    district_name: 'HASSAN',
    block_id: 'B-150101',
    block_code: 1516001,
    block_name: 'ALUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360473',
    block_code: 3626013,
    block_name: 'MOTHEY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140218',
    block_code: 1412015,
    block_name: 'QILA DARHAL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240046',
    block_code: 2409003,
    block_name: 'KHAPRAKHOL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360122',
    block_code: 3608018,
    block_name: 'RAJAMPET',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290125',
    block_code: 2920002,
    block_name: 'MADURAI WEST',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320005',
    block_code: 3215003,
    block_name: 'BARASAT TWO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50239',
    block_code: 520010,
    block_name: 'KALUAHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313264',
    block_code: 3125021,
    block_name: 'KYARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360401',
    block_code: 3623014,
    block_name: 'KOTHUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30008',
    block_code: 310002,
    block_name: 'KHAGAM MIAO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50172',
    block_code: 549004,
    block_name: 'CHAINPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35010',
    district_code: 3506,
    district_name: 'RUDRA PRAYAG',
    block_id: 'B-350072',
    block_code: 3506003,
    block_name: 'JAKHOLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20638',
    block_code: 211025,
    block_name: 'KAMALAPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180232',
    block_code: 1817015,
    block_name: 'JINTUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110212',
    block_code: 1117012,
    block_name: 'MAHUVA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15001',
    district_code: 1501,
    district_name: 'BAGALKOT',
    block_id: 'B-150008',
    block_code: 1501006,
    block_name: 'MUDHOL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313280',
    block_code: 3153006,
    block_name: 'RAMNAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360416',
    block_code: 3624005,
    block_name: 'JHARASANGAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360451',
    block_code: 3625014,
    block_name: 'MARKOOK',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12014',
    district_code: 1219,
    district_name: 'NUH MEWAT ',
    block_id: 'B-120091',
    block_code: 1219010,
    block_name: 'PINANGWAN',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40042',
    block_code: 423010,
    block_name: 'UDHARBOND',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50534',
    block_code: 516016,
    block_name: 'VAISHALI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150224',
    block_code: 1507005,
    block_name: 'SINDAGI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20190',
    block_code: 219009,
    block_name: 'GANAPAVARAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290347',
    block_code: 2906018,
    block_name: 'WEST ARNI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17037',
    district_code: 1717,
    district_name: 'RATLAM',
    block_id: 'B-170220',
    block_code: 1717005,
    block_name: 'BAJNA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27004',
    district_code: 2731,
    district_name: 'BARAN',
    block_id: 'B-270042',
    block_code: 2731006,
    block_name: 'CHHABRA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170094',
    block_code: 1722004,
    block_name: 'DHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31336',
    district_code: 3116,
    district_name: 'GHAZIABAD',
    block_id: 'B-313383',
    block_code: 3116003,
    block_name: 'RAJAPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340090',
    block_code: 3419007,
    block_name: 'GAWAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20128',
    block_code: 221021,
    block_name: 'SANTHAMAGULURU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360211',
    block_code: 3614004,
    block_name: 'CHENNUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290179',
    block_code: 2923001,
    block_name: 'MANDAPAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4014',
    district_code: 404,
    district_name: 'GOALPARA',
    block_id: 'B-40084',
    block_code: 404006,
    block_name: 'KHARMUJA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50456',
    block_code: 509016,
    block_name: 'PANAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20011',
    block_code: 215011,
    block_name: 'HUKUMPETA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340079',
    block_code: 3407006,
    block_name: 'RAMKANDA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12010',
    district_code: 1204,
    district_name: 'KAITHAL',
    block_id: 'B-120058',
    block_code: 1204002,
    block_name: 'KAITHAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313825',
    block_code: 3129010,
    block_name: 'LAHARPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320024',
    block_code: 3216008,
    block_name: 'BASANTI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4009',
    district_code: 408,
    district_name: 'DARRANG',
    block_id: 'B-40049',
    block_code: 408016,
    block_name: 'BECHIMARI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370021',
    block_code: 3701016,
    block_name: 'NEMO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20070',
    block_code: 212021,
    block_name: 'SETTUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320065',
    block_code: 3213011,
    block_name: 'INDAS',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270116',
    block_code: 2729006,
    block_name: 'KAPASAN',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12008',
    district_code: 1220,
    district_name: 'JHAJJAR',
    block_id: 'B-120046',
    block_code: 1220004,
    block_name: 'MATANHAIL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31335',
    district_code: 3164,
    district_name: 'GAUTAM BUDDHA NAGAR',
    block_id: 'B-313379',
    block_code: 3164004,
    block_name: 'JEWAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50405',
    block_code: 504014,
    block_name: 'ROHTAS',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180341',
    block_code: 1825003,
    block_name: 'KALAMB',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17015',
    district_code: 1720,
    district_name: 'DEWAS',
    block_id: 'B-170090',
    block_code: 1720001,
    block_name: 'TONK KHURD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11008',
    district_code: 1131,
    district_name: 'BOTAD',
    block_id: 'B-110070',
    block_code: 1131010,
    block_name: 'GADHADA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27022',
    district_code: 2709,
    district_name: 'KARAULI',
    block_id: 'B-270243',
    block_code: 2709003,
    block_name: 'NADOTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320261',
    block_code: 3210021,
    block_name: 'GARHBETA THREE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240170',
    block_code: 2403011,
    block_name: 'CHAMPUA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15015',
    district_code: 1516,
    district_name: 'HASSAN',
    block_id: 'B-150103',
    block_code: 1516002,
    block_name: 'ARSIKERE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360475',
    block_code: 3626015,
    block_name: 'NADIGUDEM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140221',
    block_code: 1412017,
    block_name: 'SIOT',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240052',
    block_code: 2409004,
    block_name: 'TITLAGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360118',
    block_code: 3608014,
    block_name: 'NASURULLABAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290123',
    block_code: 2920005,
    block_name: 'KOTTAMPATTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320007',
    block_code: 3215009,
    block_name: 'BARRACKPORE TWO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50249',
    block_code: 520017,
    block_name: 'RAHIKA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313263',
    block_code: 3125023,
    block_name: 'FATEHGANJ WEST',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360390',
    block_code: 3623001,
    block_name: 'ABDULLAPURMET',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30011',
    block_code: 310003,
    block_name: 'NAMPONG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50175',
    block_code: 549007,
    block_name: 'KUDRA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35010',
    district_code: 3506,
    district_name: 'RUDRA PRAYAG',
    block_id: 'B-350071',
    block_code: 3506001,
    block_name: 'AUGUSTYAMUNI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20655',
    block_code: 211026,
    block_name: 'VALLUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180235',
    block_code: 1817016,
    block_name: 'PARBHANI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110216',
    block_code: 1117013,
    block_name: 'PALSANA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360054',
    block_code: 3604003,
    block_name: 'DHARMAPURI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313282',
    block_code: 3153007,
    block_name: 'SALTAUA GOPAL PUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15024',
    district_code: 1529,
    district_name: 'RAMANAGARA',
    block_id: 'B-150169',
    block_code: 1529001,
    block_name: 'CHANNAPATNA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23011',
    district_code: 2303,
    district_name: 'ZUNHEBOTO',
    block_id: 'B-230067',
    block_code: 2303007,
    block_name: 'AKUHAITO',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12014',
    district_code: 1219,
    district_name: 'NUH MEWAT ',
    block_id: 'B-120092',
    block_code: 1219008,
    block_name: 'PUNHANA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40033',
    block_code: 423011,
    block_name: 'KATIGORA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50522',
    block_code: 516004,
    block_name: 'DESRI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150226',
    block_code: 1507012,
    block_name: 'TIKOTA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20194',
    block_code: 219013,
    block_name: 'KALIDINDI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290331',
    block_code: 2906017,
    block_name: 'ARNI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17037',
    district_code: 1717,
    district_name: 'RATLAM',
    block_id: 'B-170223',
    block_code: 1717006,
    block_name: 'RATLAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27004',
    district_code: 2731,
    district_name: 'BARAN',
    block_id: 'B-270043',
    block_code: 2731007,
    block_name: 'CHHIPABAROD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170096',
    block_code: 1722006,
    block_name: 'GANDHWANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31336',
    district_code: 3116,
    district_name: 'GHAZIABAD',
    block_id: 'B-313381',
    block_code: 3116004,
    block_name: 'LONI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340092',
    block_code: 3419008,
    block_name: 'JAMUA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20125',
    block_code: 221018,
    block_name: 'PARCHUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360220',
    block_code: 3614014,
    block_name: 'MANDAMARRI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290181',
    block_code: 2923010,
    block_name: 'NAINARKOIL',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4014',
    district_code: 404,
    district_name: 'GOALPARA',
    block_id: 'B-40082',
    block_code: 404001,
    block_name: 'BALIJANA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50451',
    block_code: 509011,
    block_name: 'MAKER',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2001',
    district_code: 215,
    district_name: 'ALLURI SITHARAMA RAJU',
    block_id: 'B-20020',
    block_code: 215019,
    block_name: 'RAMPACHODAVARAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340065',
    block_code: 3407009,
    block_name: 'BHANDARIA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12022',
    district_code: 1202,
    district_name: 'YAMUNANAGAR',
    block_id: 'B-120141',
    block_code: 1202102,
    block_name: 'RADAUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31377',
    district_code: 3129,
    district_name: 'SITAPUR',
    block_id: 'B-313820',
    block_code: 3129014,
    block_name: 'BISWAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320023',
    block_code: 3216001,
    block_name: 'BARUIPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4003',
    district_code: 405,
    district_name: 'BARPETA',
    block_id: 'B-40008',
    block_code: 405005,
    block_name: 'BARPETA',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370025',
    block_code: 3701015,
    block_name: 'RONG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20062',
    block_code: 212022,
    block_name: 'KUNDURPI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320061',
    block_code: 3213014,
    block_name: 'BISHNUPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270268',
    block_code: 2720009,
    block_name: 'BALI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17033',
    district_code: 1752,
    district_name: 'NIWARI',
    block_id: 'B-170200',
    block_code: 1752002,
    block_name: 'PRITHVIPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18014',
    district_code: 1816,
    district_name: 'JALNA',
    block_id: 'B-180139',
    block_code: 1816003,
    block_name: 'JAFRABAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50403',
    block_code: 504012,
    block_name: 'NOKHA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180347',
    block_code: 1825004,
    block_name: 'RALEGAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17015',
    district_code: 1720,
    district_name: 'DEWAS',
    block_id: 'B-170089',
    block_code: 1720002,
    block_name: 'SONKATCH',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11008',
    district_code: 1131,
    district_name: 'BOTAD',
    block_id: 'B-110071',
    block_code: 1131012,
    block_name: 'RANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31350',
    district_code: 3170,
    district_name: 'KAUSHAMBI',
    block_id: 'B-313545',
    block_code: 3170008,
    block_name: 'SIRATHU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320267',
    block_code: 3210010,
    block_name: 'KHARAGPUR TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240175',
    block_code: 2403012,
    block_name: 'JHUMPURA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15015',
    district_code: 1516,
    district_name: 'HASSAN',
    block_id: 'B-150102',
    block_code: 1516003,
    block_name: 'ARKALGUD',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360476',
    block_code: 3626016,
    block_name: 'NAGARAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140167',
    block_code: 1401037,
    block_name: 'MACHIL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240042',
    block_code: 2409007,
    block_name: 'BANGOMUNDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360243',
    block_code: 3615020,
    block_name: 'YELDURTHY',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290120',
    block_code: 2920007,
    block_name: 'ALANGANALLUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320021',
    block_code: 3215018,
    block_name: 'SANDESHKHALI TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240312',
    block_code: 2402007,
    block_name: 'SUBDEGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313269',
    block_code: 3125026,
    block_name: 'RICHHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360391',
    block_code: 3623002,
    block_name: 'AMANGAL',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30005',
    block_code: 310004,
    block_name: 'BORDUMSA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50179',
    block_code: 549011,
    block_name: 'RAMPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34014',
    district_code: 3418,
    district_name: 'KODERMA',
    block_id: 'B-340148',
    block_code: 3418001,
    block_name: 'KODERMA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20632',
    block_code: 211027,
    block_name: 'CHENNUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180238',
    block_code: 1817011,
    block_name: 'SELU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11029',
    district_code: 1117,
    district_name: 'SURAT',
    block_id: 'B-110217',
    block_code: 1117032,
    block_name: 'UMARPADA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360056',
    block_code: 3604005,
    block_name: 'IBRAHIMPATNAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313281',
    block_code: 3153008,
    block_name: 'RUDAULI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15024',
    district_code: 1529,
    district_name: 'RAMANAGARA',
    block_id: 'B-150170',
    block_code: 1529002,
    block_name: 'KANAKAPURA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23011',
    district_code: 2303,
    district_name: 'ZUNHEBOTO',
    block_id: 'B-230071',
    block_code: 2303008,
    block_name: 'SATOI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12014',
    district_code: 1219,
    district_name: 'NUH MEWAT ',
    block_id: 'B-120093',
    block_code: 1219005,
    block_name: 'TAURU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4006',
    district_code: 423,
    district_name: 'CACHAR',
    block_id: 'B-40030',
    block_code: 423019,
    block_name: 'BORJALENGA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50525',
    block_code: 516007,
    block_name: 'JANDAHA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15030',
    district_code: 1507,
    district_name: 'VIJAYAPURA',
    block_id: 'B-150221',
    block_code: 1507008,
    block_name: 'KOLHAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20198',
    block_code: 219017,
    block_name: 'LINGAPALEM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290335',
    block_code: 2906010,
    block_name: 'JAWADUMALAI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24021',
    district_code: 2431,
    district_name: 'MALKANGIRI',
    block_id: 'B-240205',
    block_code: 2431009,
    block_name: 'CHITRAKONDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27004',
    district_code: 2731,
    district_name: 'BARAN',
    block_id: 'B-270041',
    block_code: 2731002,
    block_name: 'BARAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170097',
    block_code: 1722008,
    block_name: 'KUKSHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313306',
    block_code: 3171009,
    block_name: 'NAUGARH',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340095',
    block_code: 3419010,
    block_name: 'TISRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20121',
    block_code: 221014,
    block_name: 'KORISAPADU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360209',
    block_code: 3614002,
    block_name: 'BHEEMARAM ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290177',
    block_code: 2923007,
    block_name: 'KADALADI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4014',
    district_code: 404,
    district_name: 'GOALPARA',
    block_id: 'B-40087',
    block_code: 404003,
    block_name: 'LAKHIPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50449',
    block_code: 509009,
    block_name: 'JALALPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360207',
    block_code: 3613024,
    block_name: 'RAJAPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340071',
    block_code: 3407014,
    block_name: 'DHURKI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33004',
    district_code: 3311,
    district_name: 'BASTAR',
    block_id: 'B-330020',
    block_code: 3311014,
    block_name: 'DARBHA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270019',
    block_code: 2706016,
    block_name: 'MALKHEDA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320041',
    block_code: 3216013,
    block_name: 'KULTALI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4003',
    district_code: 405,
    district_name: 'BARPETA',
    block_id: 'B-40010',
    block_code: 405008,
    block_name: 'CHENGA',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370029',
    block_code: 3701012,
    block_name: 'SKYURBACHAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20060',
    block_code: 212017,
    block_name: 'KANEKAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320059',
    block_code: 3213007,
    block_name: 'BANKURA TWO',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270118',
    block_code: 2729001,
    block_name: 'RASHMI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4005',
    district_code: 403,
    district_name: 'BONGAIGAON',
    block_id: 'B-40027',
    block_code: 403008,
    block_name: 'TAPATTARY',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18014',
    district_code: 1816,
    district_name: 'JALNA',
    block_id: 'B-180135',
    block_code: 1816005,
    block_name: 'AMBAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50400',
    block_code: 504009,
    block_name: 'KOCHAS',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180349',
    block_code: 1825006,
    block_name: 'WANI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17015',
    district_code: 1720,
    district_name: 'DEWAS',
    block_id: 'B-170086',
    block_code: 1720003,
    block_name: 'DEWAS',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11008',
    district_code: 1131,
    district_name: 'BOTAD',
    block_id: 'B-110068',
    block_code: 1131008,
    block_name: 'BARWALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31350',
    district_code: 3170,
    district_name: 'KAUSHAMBI',
    block_id: 'B-313544',
    block_code: 3170006,
    block_name: 'SARSAWAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320220',
    block_code: 3212020,
    block_name: 'RAGHUNATHGANJ TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240176',
    block_code: 2403013,
    block_name: 'JODA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15015',
    district_code: 1516,
    district_name: 'HASSAN',
    block_id: 'B-150104',
    block_code: 1516004,
    block_name: 'BELUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360470',
    block_code: 3626010,
    block_name: 'MADDIRALA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140208',
    block_code: 1412012,
    block_name: 'DHANGRI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240053',
    block_code: 2409008,
    block_name: 'TUREKELA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360227',
    block_code: 3615004,
    block_name: 'HAVELIGHANAPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290121',
    block_code: 2920009,
    block_name: 'CHELLAMPATTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320009',
    block_code: 3215012,
    block_name: 'BASIRHAT TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240298',
    block_code: 2402008,
    block_name: 'BALISANKARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313259',
    block_code: 3125020,
    block_name: 'BHOJIPURA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360409',
    block_code: 3623024,
    block_name: 'SHANKARPALLY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313838',
    block_code: 3163003,
    block_name: 'CHATARA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50171',
    block_code: 549003,
    block_name: 'BHAGWANPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34014',
    district_code: 3418,
    district_name: 'KODERMA',
    block_id: 'B-340146',
    block_code: 3418006,
    block_name: 'DOMCHANCH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20626',
    block_code: 211028,
    block_name: 'ATLUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18025',
    district_code: 1817,
    district_name: 'PARBHANI',
    block_id: 'B-180233',
    block_code: 1817012,
    block_name: 'MANWAT',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11020',
    district_code: 1129,
    district_name: 'MAHISAGAR',
    block_id: 'B-110149',
    block_code: 1129009,
    block_name: 'BALASINOR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360058',
    block_code: 3604007,
    block_name: 'JAGTIAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313283',
    block_code: 3153009,
    block_name: 'SAU GHAT',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15024',
    district_code: 1529,
    district_name: 'RAMANAGARA',
    block_id: 'B-150171',
    block_code: 1529003,
    block_name: 'MAGADI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23011',
    district_code: 2303,
    district_name: 'ZUNHEBOTO',
    block_id: 'B-230072',
    block_code: 2303003,
    block_name: 'SURUHOTO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140199',
    block_code: 1405015,
    block_name: 'LITTER',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350004',
    block_code: 3507011,
    block_name: 'DHAULADEVI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50527',
    block_code: 516009,
    block_name: 'MAHNAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15027',
    district_code: 1526,
    district_name: 'UDUPI',
    block_id: 'B-150194',
    block_code: 1526001,
    block_name: 'KARKAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20207',
    block_code: 219026,
    block_name: 'T NARASAPURAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29033',
    district_code: 2906,
    district_name: 'TIRUVANNAMALAI',
    block_id: 'B-290343',
    block_code: 2906003,
    block_name: 'THURINJAPURAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24009',
    district_code: 2407,
    district_name: 'DHENKANAL',
    block_id: 'B-240080',
    block_code: 2407002,
    block_name: 'ODAPADA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29031',
    district_code: 2933,
    district_name: 'TIRUPATTUR',
    block_id: 'B-290311',
    block_code: 2933017,
    block_name: 'JOLARPET',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170093',
    block_code: 1722009,
    block_name: 'DAHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313302',
    block_code: 3171001,
    block_name: 'CHAHNIYA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340086',
    block_code: 3419011,
    block_name: 'DEORI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20124',
    block_code: 221017,
    block_name: 'NIZAMPATNAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360213',
    block_code: 3614006,
    block_name: 'HAJIPUR ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290180',
    block_code: 2923009,
    block_name: 'MUDUKULATHUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4014',
    district_code: 404,
    district_name: 'GOALPARA',
    block_id: 'B-40089',
    block_code: 404008,
    block_name: 'RONGJULI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50447',
    block_code: 509007,
    block_name: 'GARKHA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15005',
    district_code: 1503,
    district_name: 'BENGALURU RURAL',
    block_id: 'B-150034',
    block_code: 1503002,
    block_name: 'DEVANHALLI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340074',
    block_code: 3407018,
    block_name: 'KETAR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12010',
    district_code: 1204,
    district_name: 'KAITHAL',
    block_id: 'B-120056',
    block_code: 1204008,
    block_name: 'DHAND',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31356',
    district_code: 3179,
    district_name: 'MAHOBA',
    block_id: 'B-313604',
    block_code: 3179001,
    block_name: 'PANWARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320036',
    block_code: 3216016,
    block_name: 'GOSABA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4009',
    district_code: 408,
    district_name: 'DARRANG',
    block_id: 'B-40053',
    block_code: 408014,
    block_name: 'SIPAJHAR',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370026',
    block_code: 3701014,
    block_name: 'RUPSHO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20075',
    block_code: 212003,
    block_name: 'VIDAPANAKAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320067',
    block_code: 3213013,
    block_name: 'JOYPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270115',
    block_code: 2729002,
    block_name: 'GANGRAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4005',
    district_code: 403,
    district_name: 'BONGAIGAON',
    block_id: 'B-40024',
    block_code: 403007,
    block_name: 'DANGTOL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180208',
    block_code: 1806001,
    block_name: 'NASHIK',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50408',
    block_code: 504017,
    block_name: 'SHEOSAGAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180342',
    block_code: 1825007,
    block_name: 'KELAPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17015',
    district_code: 1720,
    district_name: 'DEWAS',
    block_id: 'B-170087',
    block_code: 1720004,
    block_name: 'KANNOD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11008',
    district_code: 1131,
    district_name: 'BOTAD',
    block_id: 'B-110069',
    block_code: 1131011,
    block_name: 'BOTAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31350',
    district_code: 3170,
    district_name: 'KAUSHAMBI',
    block_id: 'B-313539',
    block_code: 3170007,
    block_name: 'KARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320222',
    block_code: 3212022,
    block_name: 'RANINAGAR TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240177',
    block_code: 2403001,
    block_name: 'KENDUJHAR SADAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15015',
    district_code: 1516,
    district_name: 'HASSAN',
    block_id: 'B-150105',
    block_code: 1516005,
    block_name: 'CHANNARAYAPATNA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360480',
    block_code: 3626020,
    block_name: 'PENPAHAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140159',
    block_code: 1401034,
    block_name: 'DRUGMULLA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240041',
    block_code: 2409009,
    block_name: 'BALANGIR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360233',
    block_code: 3615010,
    block_name: 'NARSINGI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290127',
    block_code: 2920010,
    block_name: 'SEDAPATTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320019',
    block_code: 3215007,
    block_name: 'RAJARHAT',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240305',
    block_code: 2402010,
    block_name: 'KUARMUNDA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33018',
    district_code: 3323,
    district_name: 'KONDAGAON',
    block_id: 'B-330084',
    block_code: 3323004,
    block_name: 'MAKDI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360397',
    block_code: 3623010,
    block_name: 'KADTHAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313845',
    block_code: 3163004,
    block_name: 'NAGAWA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50174',
    block_code: 549006,
    block_name: 'DURGAWATI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34014',
    district_code: 3418,
    district_name: 'KODERMA',
    block_id: 'B-340150',
    block_code: 3418002,
    block_name: 'SATGAWAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20659',
    block_code: 211029,
    block_name: 'VONTIMITTA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21009',
    district_code: 2109,
    district_name: 'SOUTH WEST KHASI HILLS',
    block_id: 'B-210033',
    block_code: 2109001,
    block_name: 'MAWKYRWAT',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11020',
    district_code: 1129,
    district_name: 'MAHISAGAR',
    block_id: 'B-110154',
    block_code: 1129011,
    block_name: 'VIRPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360059',
    block_code: 3604008,
    block_name: 'KATHLAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313273',
    block_code: 3153010,
    block_name: 'BASTI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150080',
    block_code: 1511009,
    block_name: 'ULLALA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23011',
    district_code: 2303,
    district_name: 'ZUNHEBOTO',
    block_id: 'B-230073',
    block_code: 2303005,
    block_name: 'TOKIYE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140203',
    block_code: 1405017,
    block_name: 'SHADIMARG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360170',
    block_code: 3611066,
    block_name: 'LINGAPUR ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50528',
    block_code: 516010,
    block_name: 'MAHUA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15027',
    district_code: 1526,
    district_name: 'UDUPI',
    block_id: 'B-150195',
    block_code: 1526002,
    block_name: 'KUNDAPURA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20184',
    block_code: 219003,
    block_name: 'BUTTAYAGUDEM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16011',
    district_code: 1612,
    district_name: 'PATHANAMTHITTA',
    block_id: 'B-160117',
    block_code: 1612004,
    block_name: 'MALLAPPALLY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24021',
    district_code: 2431,
    district_name: 'MALKANGIRI',
    block_id: 'B-240207',
    block_code: 2431012,
    block_name: 'KHAIRAPUT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29031',
    district_code: 2933,
    district_name: 'TIRUPATTUR',
    block_id: 'B-290312',
    block_code: 2933018,
    block_name: 'KANDHILI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170098',
    block_code: 1722011,
    block_name: 'MANAWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313305',
    block_code: 3171002,
    block_name: 'DHANAPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340091',
    block_code: 3419012,
    block_name: 'GIRIDIH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2005',
    district_code: 221,
    district_name: 'BAPATLA',
    block_id: 'B-20127',
    block_code: 221020,
    block_name: 'REPALLE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360219',
    block_code: 3614012,
    block_name: 'LUXETTIPET',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290184',
    block_code: 2923003,
    block_name: 'R.S. MANGALAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50020',
    block_code: 505006,
    block_name: 'Haspura',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50458',
    block_code: 509018,
    block_name: 'REVELGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15005',
    district_code: 1503,
    district_name: 'BENGALURU RURAL',
    block_id: 'B-150035',
    block_code: 1503003,
    block_name: 'DODBALLAPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340082',
    block_code: 3407019,
    block_name: 'SAGMA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12022',
    district_code: 1202,
    district_name: 'YAMUNANAGAR',
    block_id: 'B-120143',
    block_code: 1202096,
    block_name: 'SARASWATI NAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31356',
    district_code: 3179,
    district_name: 'MAHOBA',
    block_id: 'B-313602',
    block_code: 3179002,
    block_name: 'JAITPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320044',
    block_code: 3216023,
    block_name: 'MANDIRBAZAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4009',
    district_code: 408,
    district_name: 'DARRANG',
    block_id: 'B-40052',
    block_code: 408022,
    block_name: 'PUB MANGALDAI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370028',
    block_code: 3701013,
    block_name: 'SINGAY LALOK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20057',
    block_code: 212005,
    block_name: 'GUNTAKAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320068',
    block_code: 3213018,
    block_name: 'KHATRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270109',
    block_code: 2729003,
    block_name: 'BEGUN',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4005',
    district_code: 403,
    district_name: 'BONGAIGAON',
    block_id: 'B-40023',
    block_code: 403092,
    block_name: 'BOITAMARI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180203',
    block_code: 1806003,
    block_name: 'DINDORI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50398',
    block_code: 504007,
    block_name: 'KARAKAT',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180340',
    block_code: 1825008,
    block_name: 'GHATANJI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240159',
    block_code: 2418004,
    block_name: 'AUL',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35013',
    district_code: 3501,
    district_name: 'UTTAR KASHI',
    block_id: 'B-350094',
    block_code: 3501003,
    block_name: 'NAUGAON',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30006',
    district_code: 3002,
    district_name: 'SOUTH TRIPURA',
    block_id: 'B-300043',
    block_code: 3002005,
    block_name: 'RAJNAGAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320273',
    block_code: 3210022,
    block_name: 'SALBONI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24018',
    district_code: 2403,
    district_name: 'KENDUJHAR',
    block_id: 'B-240169',
    block_code: 2403007,
    block_name: 'BANSPAL',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15015',
    district_code: 1516,
    district_name: 'HASSAN',
    block_id: 'B-150106',
    block_code: 1516006,
    block_name: 'HASSAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360468',
    block_code: 3626008,
    block_name: 'JAJI REDDI GUDEM ARVAPALLY',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17003',
    district_code: 1746,
    district_name: 'ANUPPUR',
    block_id: 'B-170014',
    block_code: 1746004,
    block_name: 'PUSHPRAJGARH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24005',
    district_code: 2409,
    district_name: 'BOLANGIR',
    block_id: 'B-240047',
    block_code: 2409010,
    block_name: 'LOISINGA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360237',
    block_code: 3615014,
    block_name: 'REGODE',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290122',
    block_code: 2920013,
    block_name: 'KALLIKUDI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320002',
    block_code: 3215010,
    block_name: 'BADURIA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240310',
    block_code: 2402011,
    block_name: 'NUAGAON',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33018',
    district_code: 3323,
    district_name: 'KONDAGAON',
    block_id: 'B-330081',
    block_code: 3323001,
    block_name: 'BADERAJPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360398',
    block_code: 3623011,
    block_name: 'KANDUKUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31378',
    district_code: 3163,
    district_name: 'SONBHADRA',
    block_id: 'B-313840',
    block_code: 3163007,
    block_name: 'DUDDHI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50176',
    block_code: 549008,
    block_name: 'MOHANIA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34014',
    district_code: 3418,
    district_name: 'KODERMA',
    block_id: 'B-340145',
    block_code: 3418003,
    block_name: 'CHANDWARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20651',
    block_code: 211030,
    block_name: 'SIDHOUT',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21009',
    district_code: 2109,
    district_name: 'SOUTH WEST KHASI HILLS',
    block_id: 'B-210034',
    block_code: 2109002,
    block_name: 'RANIKOR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11020',
    district_code: 1129,
    district_name: 'MAHISAGAR',
    block_id: 'B-110152',
    block_code: 1129005,
    block_name: 'LUNAWADA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360062',
    block_code: 3604011,
    block_name: 'MALLAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313272',
    block_code: 3153011,
    block_name: 'BANKATI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150077',
    block_code: 1511008,
    block_name: 'MULKI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23011',
    district_code: 2303,
    district_name: 'ZUNHEBOTO',
    block_id: 'B-230074',
    block_code: 2303006,
    block_name: 'ZUNHEBOTO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140200',
    block_code: 1405016,
    block_name: 'NEWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360523',
    block_code: 3629010,
    block_name: 'NEKKONDA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50520',
    block_code: 516002,
    block_name: 'BIDUPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15027',
    district_code: 1526,
    district_name: 'UDUPI',
    block_id: 'B-150196',
    block_code: 1526003,
    block_name: 'UDUPI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20186',
    block_code: 219005,
    block_name: 'CHINTALAPUDI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16011',
    district_code: 1612,
    district_name: 'PATHANAMTHITTA',
    block_id: 'B-160121',
    block_code: 1612008,
    block_name: 'RANNI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24021',
    district_code: 2431,
    district_name: 'MALKANGIRI',
    block_id: 'B-240208',
    block_code: 2431013,
    block_name: 'KORUKONDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29031',
    district_code: 2933,
    district_name: 'TIRUPATTUR',
    block_id: 'B-290315',
    block_code: 2933016,
    block_name: 'THIRUPATHUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170095',
    block_code: 1722013,
    block_name: 'DHARAMPURI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313309',
    block_code: 3171003,
    block_name: 'SAKALDIHA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340083',
    block_code: 3419001,
    block_name: 'BAGODAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20422',
    block_code: 208016,
    block_name: 'MADDIPADU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360222',
    block_code: 3614017,
    block_name: 'TANDUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290185',
    block_code: 2923004,
    block_name: 'THIRUPPULLANI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50023',
    block_code: 505009,
    block_name: 'Nabinagar',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50450',
    block_code: 509010,
    block_name: 'LAHLADPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15005',
    district_code: 1503,
    district_name: 'BENGALURU RURAL',
    block_id: 'B-150036',
    block_code: 1503004,
    block_name: 'HOSKOTE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340078',
    block_code: 3407013,
    block_name: 'NAGAR UNTARI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12022',
    district_code: 1202,
    district_name: 'YAMUNANAGAR',
    block_id: 'B-120140',
    block_code: 1202105,
    block_name: 'PARTAPNAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31356',
    district_code: 3179,
    district_name: 'MAHOBA',
    block_id: 'B-313603',
    block_code: 3179004,
    block_name: 'KABRAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320047',
    block_code: 3216024,
    block_name: 'NAMKHANA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4009',
    district_code: 408,
    district_name: 'DARRANG',
    block_id: 'B-40051',
    block_code: 408015,
    block_name: 'PACHIM MANGALDAI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37002',
    district_code: 3701,
    district_name: 'LEH',
    block_id: 'B-370030',
    block_code: 3701011,
    block_name: 'THIKSAY',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20055',
    block_code: 212006,
    block_name: 'GOOTY',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320073',
    block_code: 3213021,
    block_name: 'RAIPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313369',
    block_code: 3121002,
    block_name: 'FIROZABAD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4005',
    district_code: 403,
    district_name: 'BONGAIGAON',
    block_id: 'B-40026',
    block_code: 403095,
    block_name: 'SRIJANGRAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180212',
    block_code: 1806004,
    block_name: 'SURGANA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50395',
    block_code: 504004,
    block_name: 'DAWATH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180348',
    block_code: 1825009,
    block_name: 'UMARKHED',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240161',
    block_code: 2418009,
    block_name: 'GARADAPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35013',
    district_code: 3501,
    district_name: 'UTTAR KASHI',
    block_id: 'B-350093',
    block_code: 3501001,
    block_name: 'MORI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30006',
    district_code: 3002,
    district_name: 'SOUTH TRIPURA',
    block_id: 'B-300040',
    block_code: 3002006,
    block_name: 'HRISHYAMUKH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320206',
    block_code: 3212006,
    block_name: 'BHARATPUR ONE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17010',
    district_code: 1747,
    district_name: 'BURHANPUR',
    block_id: 'B-170055',
    block_code: 1747008,
    block_name: 'KHAKNAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31364',
    district_code: 3126,
    district_name: 'PILIBHIT',
    block_id: 'B-313674',
    block_code: 3126001,
    block_name: 'AMARIYA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360471',
    block_code: 3626011,
    block_name: 'MATTAM PALLY',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17050',
    district_code: 1718,
    district_name: 'UJJAIN',
    block_id: 'B-170300',
    block_code: 1718001,
    block_name: 'KHACHAROD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4030',
    district_code: 409,
    district_name: 'SONITPUR',
    block_id: 'B-40193',
    block_code: 409001,
    block_name: 'DHEKIAJULI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360239',
    block_code: 3615015,
    block_name: 'SHANKARAMPET  R ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290126',
    block_code: 2920004,
    block_name: 'MELUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320015',
    block_code: 3215013,
    block_name: 'HAROA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240301',
    block_code: 2402016,
    block_name: 'BONAIGARH',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33018',
    district_code: 3323,
    district_name: 'KONDAGAON',
    block_id: 'B-330082',
    block_code: 3323002,
    block_name: 'KESHKAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360403',
    block_code: 3623016,
    block_name: 'MAHESHWARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31340',
    district_code: 3141,
    district_name: 'HAMIRPUR',
    block_id: 'B-313437',
    block_code: 3141019,
    block_name: 'KURARA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50177',
    block_code: 549009,
    block_name: 'NUAON',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34014',
    district_code: 3418,
    district_name: 'KODERMA',
    block_id: 'B-340147',
    block_code: 3418004,
    block_name: 'JAINAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20657',
    block_code: 211033,
    block_name: 'VEMPALLE',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1001',
    district_code: 102,
    district_name: 'NICOBARS',
    block_id: 'B-10003',
    block_code: 102002,
    block_name: 'NICOBAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110045',
    block_code: 1108038,
    block_name: 'SUIGAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360067',
    block_code: 3604016,
    block_name: 'RAIKAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313271',
    block_code: 3153012,
    block_name: 'BAHADURPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150074',
    block_code: 1511006,
    block_name: 'KADABA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23011',
    district_code: 2303,
    district_name: 'ZUNHEBOTO',
    block_id: 'B-230068',
    block_code: 2303001,
    block_name: 'AKULUTO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140195',
    block_code: 1405018,
    block_name: 'AWANTIPORA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360524',
    block_code: 3629012,
    block_name: 'PARVATHAGIRI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50519',
    block_code: 516001,
    block_name: 'BHAGWANPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34013',
    district_code: 3424,
    district_name: 'KHUNTI',
    block_id: 'B-340140',
    block_code: 3424003,
    block_name: 'KARRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20187',
    block_code: 219006,
    block_name: 'DENDULURU',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16011',
    district_code: 1612,
    district_name: 'PATHANAMTHITTA',
    block_id: 'B-160114',
    block_code: 1612001,
    block_name: 'ELANTHOOR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24009',
    district_code: 2407,
    district_name: 'DHENKANAL',
    block_id: 'B-240075',
    block_code: 2407001,
    block_name: 'DHENKANAL SADAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27004',
    district_code: 2731,
    district_name: 'BARAN',
    block_id: 'B-270045',
    block_code: 2731008,
    block_name: 'MANGROL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17030',
    district_code: 1732,
    district_name: 'NARMADAPURAM',
    block_id: 'B-170183',
    block_code: 1732007,
    block_name: 'BANKHEDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313307',
    block_code: 3171004,
    block_name: 'NIYAMATABAD',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340084',
    block_code: 3419002,
    block_name: 'BENGABAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20409',
    block_code: 208017,
    block_name: 'CHIMAKURTHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360215',
    block_code: 3614062,
    block_name: 'JANNARAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290178',
    block_code: 2923008,
    block_name: 'KAMUTHI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50019',
    block_code: 505005,
    block_name: 'Goh',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50454',
    block_code: 509014,
    block_name: 'MASHRAKH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360200',
    block_code: 3613010,
    block_name: 'JADCHERLA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340076',
    block_code: 3407010,
    block_name: 'MANJHIAON',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50049',
    block_code: 517013,
    block_name: 'MANSURCHAK',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270023',
    block_code: 2706010,
    block_name: 'RAMGARH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320040',
    block_code: 3216025,
    block_name: 'KULPI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4009',
    district_code: 408,
    district_name: 'DARRANG',
    block_id: 'B-40050',
    block_code: 408021,
    block_name: 'DALGAON SIALMARI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33019',
    district_code: 3308,
    district_name: 'KORBA',
    block_id: 'B-330090',
    block_code: 3308005,
    block_name: 'PODI UPARODA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20066',
    block_code: 212007,
    block_name: 'PEDDAVADUGUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320058',
    block_code: 3213006,
    block_name: 'BANKURA ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313375',
    block_code: 3121003,
    block_name: 'TUNDLA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4005',
    district_code: 403,
    district_name: 'BONGAIGAON',
    block_id: 'B-40025',
    block_code: 403093,
    block_name: 'MANIKPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180205',
    block_code: 1806005,
    block_name: 'KALWAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50401',
    block_code: 504010,
    block_name: 'NASRIGANJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180343',
    block_code: 1825010,
    block_name: 'MAHAGAON',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5002',
    district_code: 551,
    district_name: 'ARWAL',
    block_id: 'B-50013',
    block_code: 551004,
    block_name: 'Kurtha',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35013',
    district_code: 3501,
    district_name: 'UTTAR KASHI',
    block_id: 'B-350095',
    block_code: 3501002,
    block_name: 'PUROLA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30006',
    district_code: 3002,
    district_name: 'SOUTH TRIPURA',
    block_id: 'B-300039',
    block_code: 3002007,
    block_name: 'BOKAFA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320219',
    block_code: 3212019,
    block_name: 'RAGHUNATHGANJ ONE',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28006',
    district_code: 2805,
    district_name: 'SORENG',
    block_id: 'B-280030',
    block_code: 2805006,
    block_name: 'DARAMDIN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31364',
    district_code: 3126,
    district_name: 'PILIBHIT',
    block_id: 'B-313678',
    block_code: 3126003,
    block_name: 'LALAURIKHERA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360472',
    block_code: 3626012,
    block_name: 'MELLA CHERVU',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17050',
    district_code: 1718,
    district_name: 'UJJAIN',
    block_id: 'B-170301',
    block_code: 1718002,
    block_name: 'MAHIDPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4030',
    district_code: 409,
    district_name: 'SONITPUR',
    block_id: 'B-40194',
    block_code: 409002,
    block_name: 'GABHORU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360241',
    block_code: 3615018,
    block_name: 'TEKMAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290132',
    block_code: 2920006,
    block_name: 'VADIPATTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320016',
    block_code: 3215014,
    block_name: 'HASNABAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240311',
    block_code: 2402003,
    block_name: 'RAJGANGPUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33018',
    district_code: 3323,
    district_name: 'KONDAGAON',
    block_id: 'B-330083',
    block_code: 3323003,
    block_name: 'KONDAGAON',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360393',
    block_code: 3623006,
    block_name: 'FAROOQNAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270219',
    block_code: 2715001,
    block_name: 'BALESAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5014',
    district_code: 549,
    district_name: 'KAIMUR alias BHABUA',
    block_id: 'B-50173',
    block_code: 549005,
    block_name: 'CHAND',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34014',
    district_code: 3418,
    district_name: 'KODERMA',
    block_id: 'B-340149',
    block_code: 3418005,
    block_name: 'MARKACHO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20630',
    block_code: 211034,
    block_name: 'CHAKRAYAPET',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1001',
    district_code: 102,
    district_name: 'NICOBARS',
    block_id: 'B-10001',
    block_code: 102003,
    block_name: 'CAMPBELL BAY',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110043',
    block_code: 1108037,
    block_name: 'LAKHNI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360068',
    block_code: 3604017,
    block_name: 'SARANGAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313278',
    block_code: 3153013,
    block_name: 'KUDARAHA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15011',
    district_code: 1511,
    district_name: 'DAKSHINA KANNADA',
    block_id: 'B-150076',
    block_code: 1511007,
    block_name: 'MOODU BIDARE',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23011',
    district_code: 2303,
    district_name: 'ZUNHEBOTO',
    block_id: 'B-230069',
    block_code: 2303002,
    block_name: 'GHATHASHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140194',
    block_code: 1405014,
    block_name: 'ARIPAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360164',
    block_code: 3611069,
    block_name: 'CHINTALAMANEPALLY',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50524',
    block_code: 516006,
    block_name: 'HAJIPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340019',
    block_code: 3417002,
    block_name: 'PRATAPPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2008',
    district_code: 219,
    district_name: 'ELURU',
    block_id: 'B-20189',
    block_code: 219008,
    block_name: 'ELURU',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16011',
    district_code: 1612,
    district_name: 'PATHANAMTHITTA',
    block_id: 'B-160115',
    block_code: 1612002,
    block_name: 'KONNI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24009',
    district_code: 2407,
    district_name: 'DHENKANAL',
    block_id: 'B-240076',
    block_code: 2407003,
    block_name: 'GONDIA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270173',
    block_code: 2712020,
    block_name: 'MADHORAJPURA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17045',
    district_code: 1739,
    district_name: 'SHEOPUR',
    block_id: 'B-170276',
    block_code: 1739002,
    block_name: 'SHEOPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313304',
    block_code: 3171005,
    block_name: 'CHANDAULI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34008',
    district_code: 3419,
    district_name: 'GIRIDIH',
    block_id: 'B-340094',
    block_code: 3419013,
    block_name: 'SURIYA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20434',
    block_code: 208023,
    block_name: 'RACHERLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360217',
    block_code: 3614061,
    block_name: 'KASIPET',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290186',
    block_code: 2923005,
    block_name: 'THIRUVADANAI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50017',
    block_code: 505003,
    block_name: 'Daudnagar',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50457',
    block_code: 509017,
    block_name: 'PARSA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360204',
    block_code: 3613019,
    block_name: 'MIDJIL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340077',
    block_code: 3407004,
    block_name: 'MERAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50043',
    block_code: 517007,
    block_name: 'BIRPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270025',
    block_code: 2706012,
    block_name: 'THANAGAZI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320039',
    block_code: 3216026,
    block_name: 'KAK DWIP',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24024',
    district_code: 2422,
    district_name: 'NAYAGARH',
    block_id: 'B-240253',
    block_code: 2422004,
    block_name: 'NUAGAON',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33019',
    district_code: 3308,
    district_name: 'KORBA',
    block_id: 'B-330088',
    block_code: 3308001,
    block_name: 'KORBA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20076',
    block_code: 212008,
    block_name: 'YADIKI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32004',
    district_code: 3213,
    district_name: 'BANKURA',
    block_id: 'B-320066',
    block_code: 3213005,
    block_name: 'INDPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313370',
    block_code: 3121006,
    block_name: 'JASRANA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4025',
    district_code: 429,
    district_name: 'MAJULI',
    block_id: 'B-40158',
    block_code: 429008,
    block_name: 'MAJULI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180200',
    block_code: 1806006,
    block_name: 'BAGLAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50399',
    block_code: 504008,
    block_name: 'KARGAHAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180346',
    block_code: 1825011,
    block_name: 'PUSAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5002',
    district_code: 551,
    district_name: 'ARWAL',
    block_id: 'B-50011',
    block_code: 551002,
    block_name: 'Kaler',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35013',
    district_code: 3501,
    district_name: 'UTTAR KASHI',
    block_id: 'B-350091',
    block_code: 3501005,
    block_name: 'CHINYALISAUR',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30006',
    district_code: 3002,
    district_name: 'SOUTH TRIPURA',
    block_id: 'B-300044',
    block_code: 3002009,
    block_name: 'RUPAICHARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320221',
    block_code: 3212021,
    block_name: 'RANINAGAR ONE',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28006',
    district_code: 2805,
    district_name: 'SORENG',
    block_id: 'B-280033',
    block_code: 2805002,
    block_name: 'SORENG',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31364',
    district_code: 3126,
    district_name: 'PILIBHIT',
    block_id: 'B-313675',
    block_code: 3126004,
    block_name: 'BARKHERA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360481',
    block_code: 3626021,
    block_name: 'SURYAPET',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17050',
    district_code: 1718,
    district_name: 'UJJAIN',
    block_id: 'B-170299',
    block_code: 1718003,
    block_name: 'GHATIYA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4030',
    district_code: 409,
    district_name: 'SONITPUR',
    block_id: 'B-40190',
    block_code: 409003,
    block_name: 'BALIPARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360113',
    block_code: 3608009,
    block_name: 'KAMAREDDY',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290131',
    block_code: 2920008,
    block_name: 'USILAMPATTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320017',
    block_code: 3215015,
    block_name: 'HINGALGANJ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240313',
    block_code: 2402005,
    block_name: 'SUNDARGARH',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33018',
    district_code: 3323,
    district_name: 'KONDAGAON',
    block_id: 'B-330085',
    block_code: 3323005,
    block_name: 'PHARASGAON',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360400',
    block_code: 3623013,
    block_name: 'KONDURG',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270223',
    block_code: 2715003,
    block_name: 'BHOPALGARH',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4001',
    district_code: 434,
    district_name: 'BAJALI',
    block_id: 'B-40002',
    block_code: 434001,
    block_name: 'BHAWANIPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20653',
    block_code: 211035,
    block_name: 'SRI AVADUTHA KASINAYANA',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1001',
    district_code: 102,
    district_name: 'NICOBARS',
    block_id: 'B-10002',
    block_code: 102001,
    block_name: 'NANCOWRY',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110047',
    block_code: 1108015,
    block_name: 'VADGAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360069',
    block_code: 3604018,
    block_name: 'VELGATOOR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290068',
    block_code: 2910019,
    block_name: 'BHAVANISAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360426',
    block_code: 3624015,
    block_name: 'NAGALGIDDA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23011',
    district_code: 2303,
    district_name: 'ZUNHEBOTO',
    block_id: 'B-230070',
    block_code: 2303004,
    block_name: 'SATAKHA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140198',
    block_code: 1405004,
    block_name: 'KAKAPORA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15007',
    district_code: 1508,
    district_name: 'CHAMARAJA NAGARA',
    block_id: 'B-150049',
    block_code: 1508003,
    block_name: 'KOLLEGALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50531',
    block_code: 516013,
    block_name: 'RAGHOPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340015',
    block_code: 3417003,
    block_name: 'KUNDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170161',
    block_code: 1724009,
    block_name: 'ZIRANYA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180175',
    block_code: 1827004,
    block_name: 'RAMTEK',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24009',
    district_code: 2407,
    district_name: 'DHENKANAL',
    block_id: 'B-240078',
    block_code: 2407004,
    block_name: 'KAMAKHYANAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270161',
    block_code: 2712016,
    block_name: 'ANDHI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17045',
    district_code: 1739,
    district_name: 'SHEOPUR',
    block_id: 'B-170275',
    block_code: 1739003,
    block_name: 'KARAHAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313303',
    block_code: 3171007,
    block_name: 'CHAKIYA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290144',
    block_code: 2908001,
    block_name: 'ELACIPALAYAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20417',
    block_code: 208025,
    block_name: 'KOMAROLU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360214',
    block_code: 3614007,
    block_name: 'JAIPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290182',
    block_code: 2923011,
    block_name: 'PARAMAKUDI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5003',
    district_code: 505,
    district_name: 'AURANAGABAD',
    block_id: 'B-50018',
    block_code: 505004,
    block_name: 'Deo',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50444',
    block_code: 509004,
    block_name: 'DARIAPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360206',
    block_code: 3613023,
    block_name: 'NAWABPET',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340075',
    block_code: 3407002,
    block_name: 'KHARAUNDHI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50052',
    block_code: 517016,
    block_name: 'SAHEBPUR KAMAL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270026',
    block_code: 2706013,
    block_name: 'TIJARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320048',
    block_code: 3216027,
    block_name: 'PATHAR PRATIMA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24024',
    district_code: 2422,
    district_name: 'NAYAGARH',
    block_id: 'B-240254',
    block_code: 2422005,
    block_name: 'ODAGAON',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33019',
    district_code: 3308,
    district_name: 'KORBA',
    block_id: 'B-330086',
    block_code: 3308002,
    block_name: 'KARTALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20065',
    block_code: 212010,
    block_name: 'PEDDAPAPPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17021',
    district_code: 1723,
    district_name: 'INDORE',
    block_id: 'B-170123',
    block_code: 1723001,
    block_name: 'DEPALPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313374',
    block_code: 3121007,
    block_name: 'SHIKOHABAD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4025',
    district_code: 429,
    district_name: 'MAJULI',
    block_id: 'B-40159',
    block_code: 429007,
    block_name: 'UJANI MAJULI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180206',
    block_code: 1806007,
    block_name: 'MALEGAON',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50396',
    block_code: 504005,
    block_name: 'DEHRI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180339',
    block_code: 1825012,
    block_name: 'DIGRAS',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5002',
    district_code: 551,
    district_name: 'ARWAL',
    block_id: 'B-50010',
    block_code: 551001,
    block_name: 'Arwal',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35013',
    district_code: 3501,
    district_name: 'UTTAR KASHI',
    block_id: 'B-350090',
    block_code: 3501006,
    block_name: 'BHATWARI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30006',
    district_code: 3002,
    district_name: 'SOUTH TRIPURA',
    block_id: 'B-300045',
    block_code: 3002010,
    block_name: 'SATCHAND',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320262',
    block_code: 3210020,
    block_name: 'GARHBETA TWO',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28006',
    district_code: 2805,
    district_name: 'SORENG',
    block_id: 'B-280028',
    block_code: 2805023,
    block_name: 'BAIGUNEY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31364',
    district_code: 3126,
    district_name: 'PILIBHIT',
    block_id: 'B-313676',
    block_code: 3126005,
    block_name: 'BILSANDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360466',
    block_code: 3626006,
    block_name: 'GARIDE PALLY',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17050',
    district_code: 1718,
    district_name: 'UJJAIN',
    block_id: 'B-170302',
    block_code: 1718004,
    block_name: 'TARANA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4030',
    district_code: 409,
    district_name: 'SONITPUR',
    block_id: 'B-40192',
    block_code: 409008,
    block_name: 'BORCHALA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360105',
    block_code: 3608001,
    block_name: 'BANSWADA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290129',
    block_code: 2920003,
    block_name: 'THIRUPPARANKUNDRAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320022',
    block_code: 3215019,
    block_name: 'SWARUPNAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240299',
    block_code: 2402006,
    block_name: 'BARGAON',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12015',
    district_code: 1221,
    district_name: 'PALWAL',
    block_id: 'B-120095',
    block_code: 1221003,
    block_name: 'HASSANPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360396',
    block_code: 3623005,
    block_name: 'JILLED CHOWDERGUDEM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270224',
    block_code: 2715004,
    block_name: 'BILARA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4001',
    district_code: 434,
    district_name: 'BAJALI',
    block_id: 'B-40001',
    block_code: 434002,
    block_name: 'BAJALI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20643',
    block_code: 211006,
    block_name: 'MYDUKUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12012',
    district_code: 1203,
    district_name: 'KURUKSHETRA',
    block_id: 'B-120077',
    block_code: 1203002,
    block_name: 'SHAHBAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110039',
    block_code: 1108016,
    block_name: 'DEESA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360055',
    block_code: 3604004,
    block_name: 'GOLLAPALLI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29007',
    district_code: 2910,
    district_name: 'ERODE',
    block_id: 'B-290077',
    block_code: 2910020,
    block_name: 'TALAVADI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360425',
    block_code: 3624014,
    block_name: 'MUNIPALLY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360449',
    block_code: 3625012,
    block_name: 'KONDAPAK',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140202',
    block_code: 1405001,
    block_name: 'PULWAMA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15007',
    district_code: 1508,
    district_name: 'CHAMARAJA NAGARA',
    block_id: 'B-150048',
    block_code: 1508005,
    block_name: 'HANOORU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50526',
    block_code: 516008,
    block_name: 'LALGANJ',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340010',
    block_code: 3417005,
    block_name: 'CHATRA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360095',
    block_code: 3607003,
    block_name: 'GADWAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180169',
    block_code: 1827012,
    block_name: 'KATOL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24009',
    district_code: 2407,
    district_name: 'DHENKANAL',
    block_id: 'B-240079',
    block_code: 2407005,
    block_name: 'KANKADA HAD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270169',
    block_code: 2712017,
    block_name: 'JOBNER',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20016',
    district_code: 2008,
    district_name: 'UKHRUL',
    block_id: 'B-200070',
    block_code: 2008002,
    block_name: 'UKHRUL T D BLOCK',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313308',
    block_code: 3171008,
    block_name: 'SAHABGANJ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290148',
    block_code: 2908005,
    block_name: 'MALLASAMUDRAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20408',
    block_code: 208026,
    block_name: 'CHANDRA SEKHARA PURAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340061',
    block_code: 3410001,
    block_name: 'PATAMDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290183',
    block_code: 2923002,
    block_name: 'RAMANATHAPURAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50073',
    block_code: 503003,
    block_name: 'Barhara',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50459',
    block_code: 509019,
    block_name: 'SONEPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360194',
    block_code: 3613002,
    block_name: 'BALANAGAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340081',
    block_code: 3407005,
    block_name: 'RANKA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50044',
    block_code: 517008,
    block_name: 'CHERIA BARIARPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270027',
    block_code: 2706014,
    block_name: 'UMREN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320035',
    block_code: 3216028,
    block_name: 'FALTA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24024',
    district_code: 2422,
    district_name: 'NAYAGARH',
    block_id: 'B-240251',
    block_code: 2422006,
    block_name: 'KHANDAPARA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33019',
    district_code: 3308,
    district_name: 'KORBA',
    block_id: 'B-330087',
    block_code: 3308003,
    block_name: 'KATGHORA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20064',
    block_code: 212012,
    block_name: 'PAMIDI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17021',
    district_code: 1723,
    district_name: 'INDORE',
    block_id: 'B-170124',
    block_code: 1723003,
    block_name: 'INDORE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180148',
    block_code: 1814003,
    block_name: 'HATKANANGALE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20303',
    block_code: 213015,
    block_name: 'HOLAGUNDA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180207',
    block_code: 1806009,
    block_name: 'NANDGAON',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50402',
    block_code: 504011,
    block_name: 'NAUHATTA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180338',
    block_code: 1825013,
    block_name: 'DARWHA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240162',
    block_code: 2418001,
    block_name: 'KENDRAPADA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35013',
    district_code: 3501,
    district_name: 'UTTAR KASHI',
    block_id: 'B-350092',
    block_code: 3501004,
    block_name: 'DUNDA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30006',
    district_code: 3002,
    district_name: 'SOUTH TRIPURA',
    block_id: 'B-300041',
    block_code: 3002012,
    block_name: 'JOLAIBARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320209',
    block_code: 3212009,
    block_name: 'DOMKAL',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28006',
    district_code: 2805,
    district_name: 'SORENG',
    block_id: 'B-280029',
    block_code: 2805019,
    block_name: 'CHUMBONG CHAKUNG',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3008',
    district_code: 323,
    district_name: 'LEPARADA',
    block_id: 'B-30038',
    block_code: 323002,
    block_name: 'BASAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360477',
    block_code: 3626017,
    block_name: 'NEREDUCHERLA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17050',
    district_code: 1718,
    district_name: 'UJJAIN',
    block_id: 'B-170303',
    block_code: 1718005,
    block_name: 'UJJAIN',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4030',
    district_code: 409,
    district_name: 'SONITPUR',
    block_id: 'B-40191',
    block_code: 409009,
    block_name: 'BIHAGURI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360108',
    block_code: 3608004,
    block_name: 'BICHKUNDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290130',
    block_code: 2920012,
    block_name: 'T.KALLUPATTY',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320012',
    block_code: 3215022,
    block_name: 'GAIGHATA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240314',
    block_code: 2402009,
    block_name: 'TANGARPALI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12015',
    district_code: 1221,
    district_name: 'PALWAL',
    block_id: 'B-120098',
    block_code: 1221001,
    block_name: 'PALWAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36026',
    district_code: 3623,
    district_name: 'RANGAREDDY',
    block_id: 'B-360399',
    block_code: 3623012,
    block_name: 'KESHAMPETA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270231',
    block_code: 2715005,
    block_name: 'LUNI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26005',
    district_code: 2618,
    district_name: 'FATEHGARH SAHIB',
    block_id: 'B-260029',
    block_code: 2618003,
    block_name: 'SIRHIND',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20628',
    block_code: 211008,
    block_name: 'B KODUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12012',
    district_code: 1203,
    district_name: 'KURUKSHETRA',
    block_id: 'B-120078',
    block_code: 1203003,
    block_name: 'THANESAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110040',
    block_code: 1108018,
    block_name: 'DEODAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360066',
    block_code: 3604015,
    block_name: 'PEGADAPALLI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3001',
    district_code: 317,
    district_name: 'ANJAW',
    block_id: 'B-30002',
    block_code: 317002,
    block_name: 'HAWAI WALONG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360417',
    block_code: 3624006,
    block_name: 'JINNARAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360452',
    block_code: 3625015,
    block_name: 'MIRDODDI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140201',
    block_code: 1405002,
    block_name: 'PAMPORE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360169',
    block_code: 3611067,
    block_name: 'KOUTHALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50523',
    block_code: 516005,
    block_name: 'GORAUL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340013',
    block_code: 3417006,
    block_name: 'ITKHORI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360096',
    block_code: 3607004,
    block_name: 'GHATTU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180173',
    block_code: 1827013,
    block_name: 'NARKHED',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24009',
    district_code: 2407,
    district_name: 'DHENKANAL',
    block_id: 'B-240074',
    block_code: 2407006,
    block_name: 'BHUBAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270174',
    block_code: 2712021,
    block_name: 'MAUZAMABAD',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20016',
    district_code: 2008,
    district_name: 'UKHRUL',
    block_id: 'B-200069',
    block_code: 2008006,
    block_name: 'LUNCHONG MAIPHAI T D BLOCK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180275',
    block_code: 1804001,
    block_name: 'RATNAGIRI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290149',
    block_code: 2908006,
    block_name: 'MOHANUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20410',
    block_code: 208022,
    block_name: 'CUMBUM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340057',
    block_code: 3410003,
    block_name: 'GHATSHILA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29019',
    district_code: 2923,
    district_name: 'RAMANATHAPURAM',
    block_id: 'B-290176',
    block_code: 2923006,
    block_name: 'BOGALUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50081',
    block_code: 503011,
    block_name: 'Sandesh',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50460',
    block_code: 509020,
    block_name: 'TARAIYA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360199',
    block_code: 3613009,
    block_name: 'HANWADA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340068',
    block_code: 3407007,
    block_name: 'CHINIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50046',
    block_code: 517010,
    block_name: 'DANDARI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3004',
    district_code: 307,
    district_name: 'EAST SIANG',
    block_id: 'B-30022',
    block_code: 307001,
    block_name: 'PASIGHAT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320049',
    block_code: 3216029,
    block_name: 'SAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24024',
    district_code: 2422,
    district_name: 'NAYAGARH',
    block_id: 'B-240250',
    block_code: 2422007,
    block_name: 'GANIA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33019',
    district_code: 3308,
    district_name: 'KORBA',
    block_id: 'B-330089',
    block_code: 3308004,
    block_name: 'PALI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20074',
    block_code: 212004,
    block_name: 'VAJRAKARUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17021',
    district_code: 1723,
    district_name: 'INDORE',
    block_id: 'B-170125',
    block_code: 1723004,
    block_name: 'MHOW',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180151',
    block_code: 1814002,
    block_name: 'PANHALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20305',
    block_code: 213010,
    block_name: 'KODUMUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180209',
    block_code: 1806011,
    block_name: 'NIPHAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50406',
    block_code: 504015,
    block_name: 'SANJHAULI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180345',
    block_code: 1825014,
    block_name: 'NER',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240160',
    block_code: 2418002,
    block_name: 'DERABISH',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23006',
    district_code: 2307,
    district_name: 'MON',
    block_id: 'B-230031',
    block_code: 2307007,
    block_name: 'ABOI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30006',
    district_code: 3002,
    district_name: 'SOUTH TRIPURA',
    block_id: 'B-300042',
    block_code: 3002013,
    block_name: 'POANGBARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320265',
    block_code: 3210023,
    block_name: 'KESHPUR',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28006',
    district_code: 2805,
    district_name: 'SORENG',
    block_id: 'B-280031',
    block_code: 2805021,
    block_name: 'KALUK',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3008',
    district_code: 323,
    district_name: 'LEPARADA',
    block_id: 'B-30039',
    block_code: 323013,
    block_name: 'DARING',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36029',
    district_code: 3626,
    district_name: 'SURYAPET',
    block_id: 'B-360482',
    block_code: 3626022,
    block_name: 'THIRUMALAGIRI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17050',
    district_code: 1718,
    district_name: 'UJJAIN',
    block_id: 'B-170298',
    block_code: 1718006,
    block_name: 'BADNAGAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4030',
    district_code: 409,
    district_name: 'SONITPUR',
    block_id: 'B-40196',
    block_code: 409010,
    block_name: 'RANGAPARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360109',
    block_code: 3608005,
    block_name: 'BIRKOOR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29013',
    district_code: 2920,
    district_name: 'MADURAI',
    block_id: 'B-290128',
    block_code: 2920011,
    block_name: 'THIRUMANGALAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320003',
    block_code: 3215021,
    block_name: 'BAGDAH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240300',
    block_code: 2402012,
    block_name: 'BISRA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12015',
    district_code: 1221,
    district_name: 'PALWAL',
    block_id: 'B-120097',
    block_code: 1221002,
    block_name: 'HODAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29001',
    district_code: 2931,
    district_name: 'ARIYALUR',
    block_id: 'B-290001',
    block_code: 2931008,
    block_name: 'ANDIMADAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270232',
    block_code: 2715006,
    block_name: 'MANDOR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26005',
    district_code: 2618,
    district_name: 'FATEHGARH SAHIB',
    block_id: 'B-260025',
    block_code: 2618001,
    block_name: 'AMLOH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20650',
    block_code: 211004,
    block_name: 'RAJUPALEM',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12012',
    district_code: 1203,
    district_name: 'KURUKSHETRA',
    block_id: 'B-120075',
    block_code: 1203091,
    block_name: 'PEHOWA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11005',
    district_code: 1108,
    district_name: 'BANAS KANTHA',
    block_id: 'B-110038',
    block_code: 1108024,
    block_name: 'DANTIVADA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360064',
    block_code: 3604013,
    block_name: 'MEDIPALLI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3001',
    district_code: 317,
    district_name: 'ANJAW',
    block_id: 'B-30003',
    block_code: 317001,
    block_name: 'HAYULIANG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360433',
    block_code: 3624022,
    block_name: 'SADASIVPET',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360457',
    block_code: 3625020,
    block_name: 'SIDDIPET  RURAL ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140204',
    block_code: 1405003,
    block_name: 'TRAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360162',
    block_code: 3611001,
    block_name: 'ASIFABAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50521',
    block_code: 516003,
    block_name: 'CHEHRA KALAN',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340021',
    block_code: 3417010,
    block_name: 'TANDWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360098',
    block_code: 3607006,
    block_name: 'ITIKYAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180165',
    block_code: 1827008,
    block_name: 'BHIWAPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24009',
    district_code: 2407,
    district_name: 'DHENKANAL',
    block_id: 'B-240077',
    block_code: 2407015,
    block_name: 'HINDOL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270170',
    block_code: 2712018,
    block_name: 'KISHANGARH RENWAL',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20016',
    district_code: 2008,
    district_name: 'UKHRUL',
    block_id: 'B-200068',
    block_code: 2008007,
    block_name: 'JESSAMI T D BLOCK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180270',
    block_code: 1804002,
    block_name: 'GUHAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290150',
    block_code: 2908008,
    block_name: 'NAMAGIRIPET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20441',
    block_code: 208027,
    block_name: 'VELIGANDLA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340062',
    block_code: 3410004,
    block_name: 'POTKA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33020',
    district_code: 3306,
    district_name: 'KOREA',
    block_id: 'B-330092',
    block_code: 3306003,
    block_name: 'KHADGAWANA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50082',
    block_code: 503012,
    block_name: 'Shahpur',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50442',
    block_code: 509002,
    block_name: 'BANIAPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15005',
    district_code: 1503,
    district_name: 'BENGALURU RURAL',
    block_id: 'B-150037',
    block_code: 1503007,
    block_name: 'NELAMANGALA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340070',
    block_code: 3407008,
    block_name: 'DANDAI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50041',
    block_code: 517005,
    block_name: 'BEGUSARAI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3004',
    district_code: 307,
    district_name: 'EAST SIANG',
    block_id: 'B-30021',
    block_code: 307007,
    block_name: 'MEBO',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320029',
    block_code: 3216006,
    block_name: 'BUDGE BUDGE ONE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24024',
    district_code: 2422,
    district_name: 'NAYAGARH',
    block_id: 'B-240255',
    block_code: 2422008,
    block_name: 'RANAPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24001',
    district_code: 2421,
    district_name: 'ANGUL',
    block_id: 'B-240005',
    block_code: 2421002,
    block_name: 'KANIHA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20073',
    block_code: 212015,
    block_name: 'URAVAKONDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17021',
    district_code: 1723,
    district_name: 'INDORE',
    block_id: 'B-170126',
    block_code: 1723002,
    block_name: 'SAWER',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180154',
    block_code: 1814004,
    block_name: 'SHIROL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20295',
    block_code: 213016,
    block_name: 'ALUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180211',
    block_code: 1806012,
    block_name: 'SINNAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5029',
    district_code: 504,
    district_name: 'ROHTAS',
    block_id: 'B-50392',
    block_code: 504001,
    block_name: 'AKORHI GOLA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180336',
    block_code: 1825015,
    block_name: 'ARNI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240165',
    block_code: 2418003,
    block_name: 'PATTAMUNDAI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23006',
    district_code: 2307,
    district_name: 'MON',
    block_id: 'B-230034',
    block_code: 2307002,
    block_name: 'MON',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30006',
    district_code: 3002,
    district_name: 'SOUTH TRIPURA',
    block_id: 'B-300038',
    block_code: 3002014,
    block_name: 'BHARAT CHANDRA NAGAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320268',
    block_code: 3210024,
    block_name: 'MIDNAPORE',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28006',
    district_code: 2805,
    district_name: 'SORENG',
    block_id: 'B-280032',
    block_code: 2805022,
    block_name: 'MANGALBAREY',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3008',
    district_code: 323,
    district_name: 'LEPARADA',
    block_id: 'B-30040',
    block_code: 323011,
    block_name: 'TIRBIN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290237',
    block_code: 2913002,
    block_name: 'BUDALUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24008',
    district_code: 2416,
    district_name: 'DEOGARH',
    block_id: 'B-240073',
    block_code: 2416001,
    block_name: 'TILEIBANI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4030',
    district_code: 409,
    district_name: 'SONITPUR',
    block_id: 'B-40195',
    block_code: 409004,
    block_name: 'NADUAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360111',
    block_code: 3608007,
    block_name: 'GANDHARI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30098',
    block_code: 305001,
    block_name: 'DAPORIJO',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320001',
    block_code: 3215001,
    block_name: 'AMDANGA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240308',
    block_code: 2402013,
    block_name: 'LATHIKATA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12015',
    district_code: 1221,
    district_name: 'PALWAL',
    block_id: 'B-120096',
    block_code: 1221004,
    block_name: 'HATHIN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270218',
    block_code: 2715017,
    block_name: 'AAU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270233',
    block_code: 2715007,
    block_name: 'OSIAN',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26005',
    district_code: 2618,
    district_name: 'FATEHGARH SAHIB',
    block_id: 'B-260026',
    block_code: 2618002,
    block_name: 'BASSI PATHANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20646',
    block_code: 211032,
    block_name: 'PENDLIMARRI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12012',
    district_code: 1203,
    district_name: 'KURUKSHETRA',
    block_id: 'B-120074',
    block_code: 1203001,
    block_name: 'LADWA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11020',
    district_code: 1129,
    district_name: 'MAHISAGAR',
    block_id: 'B-110153',
    block_code: 1129006,
    block_name: 'SANTRAMPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360065',
    block_code: 3604014,
    block_name: 'METPALLI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3001',
    district_code: 317,
    district_name: 'ANJAW',
    block_id: 'B-30001',
    block_code: 317003,
    block_name: 'CHAGLAGAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360434',
    block_code: 3624023,
    block_name: 'SANGAREDDY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360460',
    block_code: 3625022,
    block_name: 'WARGAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140196',
    block_code: 1405013,
    block_name: 'DADSARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360517',
    block_code: 3629002,
    block_name: 'CHENNARAOPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50533',
    block_code: 516015,
    block_name: 'SAHDAI BUZURG',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340011',
    block_code: 3417007,
    block_name: 'GIDDHOR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360100',
    block_code: 3607008,
    block_name: 'MALDAKAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180176',
    block_code: 1827002,
    block_name: 'SAVNER',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240023',
    block_code: 2414001,
    block_name: 'BARGARH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270180',
    block_code: 2712022,
    block_name: 'TUNGA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20016',
    district_code: 2008,
    district_name: 'UKHRUL',
    block_id: 'B-200067',
    block_code: 2008001,
    block_name: 'CHINGAI T D BLOCK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180269',
    block_code: 1804003,
    block_name: 'DAPOLI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290154',
    block_code: 2908009,
    block_name: 'PUDUCHATRAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20415',
    block_code: 208020,
    block_name: 'HANUMANTHUNI PADU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340060',
    block_code: 3410005,
    block_name: 'MUSABANI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33020',
    district_code: 3306,
    district_name: 'KOREA',
    block_id: 'B-330091',
    block_code: 3306001,
    block_name: 'BAIKUNTHPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26019',
    district_code: 2608,
    district_name: 'RUPNAGAR',
    block_id: 'B-260125',
    block_code: 2608003,
    block_name: 'CHAMKAUR SAHIB',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50452',
    block_code: 509012,
    block_name: 'MANJHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360202',
    block_code: 3613016,
    block_name: 'MAHABUBNAGAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340073',
    block_code: 3407011,
    block_name: 'KANDI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50050',
    block_code: 517014,
    block_name: 'MATIHANI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3024',
    district_code: 302,
    district_name: 'WEST KAMENG',
    block_id: 'B-30107',
    block_code: 302001,
    block_name: 'KALAKTANG',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320032',
    block_code: 3216010,
    block_name: 'CANNING TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24024',
    district_code: 2422,
    district_name: 'NAYAGARH',
    block_id: 'B-240252',
    block_code: 2422014,
    block_name: 'NAYAGARH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24001',
    district_code: 2421,
    district_name: 'ANGUL',
    block_id: 'B-240002',
    block_code: 2421003,
    block_name: 'ATHMALLIK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20049',
    block_code: 212016,
    block_name: 'BELUGUPPA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26022',
    district_code: 2614,
    district_name: 'SHAHID BHAGAT SINGH NAGAR',
    block_id: 'B-260142',
    block_code: 2614003,
    block_name: 'BALACHAUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180149',
    block_code: 1814005,
    block_name: 'KAGAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20313',
    block_code: 213008,
    block_name: 'ORVAKAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180204',
    block_code: 1806013,
    block_name: 'IGATPURI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15010',
    district_code: 1510,
    district_name: 'CHITRADURGA',
    block_id: 'B-150066',
    block_code: 1510001,
    block_name: 'CHALLAKERE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180350',
    block_code: 1825017,
    block_name: 'YAVATMAL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240166',
    block_code: 2418005,
    block_name: 'RAJKANIKA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23006',
    district_code: 2307,
    district_name: 'MON',
    block_id: 'B-230035',
    block_code: 2307003,
    block_name: 'PHOMCHING',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320271',
    block_code: 3210016,
    block_name: 'PINGLA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320264',
    block_code: 3210011,
    block_name: 'KESHIARY',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33006',
    district_code: 3317,
    district_name: 'BIJAPUR',
    block_id: 'B-330031',
    block_code: 3317004,
    block_name: 'USOOR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31364',
    district_code: 3126,
    district_name: 'PILIBHIT',
    block_id: 'B-313677',
    block_code: 3126006,
    block_name: 'BISALPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290248',
    block_code: 2913005,
    block_name: 'THIRUVONAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24008',
    district_code: 2416,
    district_name: 'DEOGARH',
    block_id: 'B-240071',
    block_code: 2416002,
    block_name: 'BARKOTE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24025',
    district_code: 2428,
    district_name: 'NUAPADA',
    block_id: 'B-240256',
    block_code: 2428004,
    block_name: 'BODEN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360240',
    block_code: 3615017,
    block_name: 'SHIVAMPET',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30099',
    block_code: 305002,
    block_name: 'DUMPORIJO',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32001',
    district_code: 3215,
    district_name: '24 PARGANAS NORTH',
    block_id: 'B-320011',
    block_code: 3215004,
    block_name: 'DEGANGA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240307',
    block_code: 2402014,
    block_name: 'LAHUNIPARA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12015',
    district_code: 1221,
    district_name: 'PALWAL',
    block_id: 'B-120099',
    block_code: 1221005,
    block_name: 'PRITHALA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270225',
    block_code: 2715018,
    block_name: 'CHAMU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270234',
    block_code: 2715008,
    block_name: 'PHALODI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26005',
    district_code: 2618,
    district_name: 'FATEHGARH SAHIB',
    block_id: 'B-260027',
    block_code: 2618004,
    block_name: 'KHAMANO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20648',
    block_code: 211015,
    block_name: 'PRODDATUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12012',
    district_code: 1203,
    district_name: 'KURUKSHETRA',
    block_id: 'B-120072',
    block_code: 1203092,
    block_name: 'BABAIN',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11020',
    district_code: 1129,
    district_name: 'MAHISAGAR',
    block_id: 'B-110151',
    block_code: 1129014,
    block_name: 'KHANPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340098',
    block_code: 3415040,
    block_name: 'GODDA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3001',
    district_code: 317,
    district_name: 'ANJAW',
    block_id: 'B-30004',
    block_code: 317004,
    block_name: 'MANCHAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360422',
    block_code: 3624011,
    block_name: 'KONDAPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360441',
    block_code: 3625004,
    block_name: 'CHINNAKODUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14013',
    district_code: 1405,
    district_name: 'PULWAMA',
    block_id: 'B-140197',
    block_code: 1405012,
    block_name: 'ICHEGOZA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360518',
    block_code: 3629005,
    block_name: 'DUGGONDI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5038',
    district_code: 516,
    district_name: 'VAISHALI',
    block_id: 'B-50532',
    block_code: 516014,
    block_name: 'RAJA PAKAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340016',
    block_code: 3417004,
    block_name: 'LAWALONG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360104',
    block_code: 3607012,
    block_name: 'WADDEPALLE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180172',
    block_code: 1827010,
    block_name: 'NAGPUR RURAL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240024',
    block_code: 2414002,
    block_name: 'BARPALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31354',
    district_code: 3132,
    district_name: 'LUCKNOW',
    block_id: 'B-313584',
    block_code: 3132004,
    block_name: 'KAKORI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170102',
    block_code: 1722003,
    block_name: 'TIRLA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180273',
    block_code: 1804004,
    block_name: 'MANDANGAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290152',
    block_code: 2908011,
    block_name: 'PALLIPALAYAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20407',
    block_code: 208021,
    block_name: 'BESTAVARIPETA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340056',
    block_code: 3410006,
    block_name: 'DUMARIA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33020',
    district_code: 3306,
    district_name: 'KOREA',
    block_id: 'B-330093',
    block_code: 3306002,
    block_name: 'SONHAT',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26019',
    district_code: 2608,
    district_name: 'RUPNAGAR',
    block_id: 'B-260126',
    block_code: 2608007,
    block_name: 'MORINDA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50455',
    block_code: 509015,
    block_name: 'NAGRA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360196',
    block_code: 3613004,
    block_name: 'CHINNACHINTAKUNTA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340080',
    block_code: 3407012,
    block_name: 'RAMNA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50040',
    block_code: 517004,
    block_name: 'BARAUNI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3024',
    district_code: 302,
    district_name: 'WEST KAMENG',
    block_id: 'B-30106',
    block_code: 302002,
    block_name: 'DIRANG',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320034',
    block_code: 3216018,
    block_name: 'DIAMOND HARBOUR TWO',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4003',
    district_code: 405,
    district_name: 'BARPETA',
    block_id: 'B-40014',
    block_code: 405001,
    block_name: 'RUPSHI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24001',
    district_code: 2421,
    district_name: 'ANGUL',
    block_id: 'B-240004',
    block_code: 2421005,
    block_name: 'CHHENDIPADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20056',
    block_code: 212019,
    block_name: 'GUMMAGATTA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26022',
    district_code: 2614,
    district_name: 'SHAHID BHAGAT SINGH NAGAR',
    block_id: 'B-260144',
    block_code: 2614005,
    block_name: 'NAWANSHAHR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180146',
    block_code: 1814006,
    block_name: 'GADHINGLAJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20304',
    block_code: 213009,
    block_name: 'KALLUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18022',
    district_code: 1806,
    district_name: 'NASHIK',
    block_id: 'B-180202',
    block_code: 1806014,
    block_name: 'DEOLA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15010',
    district_code: 1510,
    district_name: 'CHITRADURGA',
    block_id: 'B-150067',
    block_code: 1510002,
    block_name: 'CHITRADURGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310195',
    block_code: 3109012,
    block_name: 'ALLAHPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240167',
    block_code: 2418006,
    block_name: 'RAJNAGAR',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23006',
    district_code: 2307,
    district_name: 'MON',
    block_id: 'B-230037',
    block_code: 2307004,
    block_name: 'TOBU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320259',
    block_code: 3210018,
    block_name: 'DEBRA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320270',
    block_code: 3210012,
    block_name: 'NARAYANGARH',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33006',
    district_code: 3317,
    district_name: 'BIJAPUR',
    block_id: 'B-330028',
    block_code: 3317001,
    block_name: 'BHAIRAMGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31364',
    district_code: 3126,
    district_name: 'PILIBHIT',
    block_id: 'B-313680',
    block_code: 3126007,
    block_name: 'PURANPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290239',
    block_code: 2913012,
    block_name: 'MADUKKUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24008',
    district_code: 2416,
    district_name: 'DEOGARH',
    block_id: 'B-240072',
    block_code: 2416003,
    block_name: 'REAMAL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24025',
    district_code: 2428,
    district_name: 'NUAPADA',
    block_id: 'B-240260',
    block_code: 2428005,
    block_name: 'SINAPALI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360112',
    block_code: 3608008,
    block_name: 'JUKKAL',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30105',
    block_code: 305003,
    block_name: 'TALIHA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12017',
    district_code: 1206,
    district_name: 'PANIPAT',
    block_id: 'B-120106',
    block_code: 1206002,
    block_name: 'MADLAUDA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4010',
    district_code: 411,
    district_name: 'DHEMAJI',
    block_id: 'B-40058',
    block_code: 411004,
    block_name: 'SISSIBORGAON',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12015',
    district_code: 1221,
    district_name: 'PALWAL',
    block_id: 'B-120094',
    block_code: 1221006,
    block_name: 'BADOLI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270227',
    block_code: 2715019,
    block_name: 'DHAWA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270237',
    block_code: 2715009,
    block_name: 'SHERGARH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26005',
    district_code: 2618,
    district_name: 'FATEHGARH SAHIB',
    block_id: 'B-260028',
    block_code: 2618005,
    block_name: 'KHERA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20654',
    block_code: 211022,
    block_name: 'THONDUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12012',
    district_code: 1203,
    district_name: 'KURUKSHETRA',
    block_id: 'B-120073',
    block_code: 1203093,
    block_name: 'ISMAILABAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11020',
    district_code: 1129,
    district_name: 'MAHISAGAR',
    block_id: 'B-110150',
    block_code: 1129013,
    block_name: 'KADANA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340099',
    block_code: 3415042,
    block_name: 'MAHAGAMA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313211',
    block_code: 3146009,
    block_name: 'PRAYAGPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360428',
    block_code: 3624017,
    block_name: 'NYALKAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360443',
    block_code: 3625006,
    block_name: 'DUBBAK',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17024',
    district_code: 1744,
    district_name: 'KATNI',
    block_id: 'B-170143',
    block_code: 1744002,
    block_name: 'KATNI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360165',
    block_code: 3611004,
    block_name: 'DAHEGAON',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340018',
    block_code: 3417008,
    block_name: 'PATHALGADA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360102',
    block_code: 3607010,
    block_name: 'RAJOLI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180171',
    block_code: 1827005,
    block_name: 'MOUDA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240026',
    block_code: 2414003,
    block_name: 'BHEDEN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31354',
    district_code: 3132,
    district_name: 'LUCKNOW',
    block_id: 'B-313582',
    block_code: 3132005,
    block_name: 'CHINHAT',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170099',
    block_code: 1722005,
    block_name: 'NALCHHA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180271',
    block_code: 1804005,
    block_name: 'KHED',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290156',
    block_code: 2908013,
    block_name: 'SENDAMANGALAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20424',
    block_code: 208018,
    block_name: 'MARRIPUDI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340055',
    block_code: 3410007,
    block_name: 'DHALBHUMGARH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17044',
    district_code: 1719,
    district_name: 'SHAJAPUR',
    block_id: 'B-170273',
    block_code: 1719005,
    block_name: 'SHAJAPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26019',
    district_code: 2608,
    district_name: 'RUPNAGAR',
    block_id: 'B-260124',
    block_code: 2608001,
    block_name: 'ANANDPUR SAHIB',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50445',
    block_code: 509005,
    block_name: 'DIGHWARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360198',
    block_code: 3613008,
    block_name: 'GANDEED',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340063',
    block_code: 3407015,
    block_name: 'BARDIHA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50042',
    block_code: 517006,
    block_name: 'BHAGWANPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3024',
    district_code: 302,
    district_name: 'WEST KAMENG',
    block_id: 'B-30108',
    block_code: 302003,
    block_name: 'NAFRA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320037',
    block_code: 3216011,
    block_name: 'JAYNAGAR ONE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24024',
    district_code: 2422,
    district_name: 'NAYAGARH',
    block_id: 'B-240248',
    block_code: 2422010,
    block_name: 'BHAPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24001',
    district_code: 2421,
    district_name: 'ANGUL',
    block_id: 'B-240006',
    block_code: 2421006,
    block_name: 'KISHORENAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20051',
    block_code: 212020,
    block_name: 'BRAHMASAMUDRAM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26022',
    district_code: 2614,
    district_name: 'SHAHID BHAGAT SINGH NAGAR',
    block_id: 'B-260145',
    block_code: 2614002,
    block_name: 'SAROYA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180145',
    block_code: 1814007,
    block_name: 'CHANDGAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20294',
    block_code: 213014,
    block_name: 'ADONI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313859',
    block_code: 3150029,
    block_name: 'MOTIGARPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15010',
    district_code: 1510,
    district_name: 'CHITRADURGA',
    block_id: 'B-150068',
    block_code: 1510003,
    block_name: 'HIRIYUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18036',
    district_code: 1825,
    district_name: 'YAVATMAL',
    block_id: 'B-180337',
    block_code: 1825002,
    block_name: 'BABULGAON',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240164',
    block_code: 2418007,
    block_name: 'MARSAGHAI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23006',
    district_code: 2307,
    district_name: 'MON',
    block_id: 'B-230036',
    block_code: 2307005,
    block_name: 'TIZIT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320263',
    block_code: 3210027,
    block_name: 'GHATAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32020',
    district_code: 3210,
    district_name: 'PASCHIM MEDINIPUR',
    block_id: 'B-320269',
    block_code: 3210015,
    block_name: 'MOHANPUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33006',
    district_code: 3317,
    district_name: 'BIJAPUR',
    block_id: 'B-330029',
    block_code: 3317002,
    block_name: 'BHOPAL PATNAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180278',
    block_code: 1812005,
    block_name: 'JATH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290245',
    block_code: 2913001,
    block_name: 'THANJAVUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50473',
    block_code: 514002,
    block_name: 'BAJPATTI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50156',
    block_code: 550005,
    block_name: 'JAMUI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360115',
    block_code: 3608011,
    block_name: 'MACHAREDDY',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30100',
    block_code: 305005,
    block_name: 'GIBA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12017',
    district_code: 1206,
    district_name: 'PANIPAT',
    block_id: 'B-120104',
    block_code: 1206093,
    block_name: 'BAPOLI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40120',
    block_code: 407003,
    block_name: 'CHAYGAON',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24010',
    district_code: 2424,
    district_name: 'GAJAPATI',
    block_id: 'B-240082',
    block_code: 2424001,
    block_name: 'GOSANI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270228',
    block_code: 2715020,
    block_name: 'GHANTIYALI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270220',
    block_code: 2715002,
    block_name: 'BAP',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20629',
    block_code: 211007,
    block_name: 'BRAHMAMGARIMATHAM',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12012',
    district_code: 1203,
    district_name: 'KURUKSHETRA',
    block_id: 'B-120076',
    block_code: 1203094,
    block_name: 'PIPLI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170170',
    block_code: 1735003,
    block_name: 'NIWAS',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340104',
    block_code: 3415043,
    block_name: 'THAKURGANGTI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180188',
    block_code: 1819016,
    block_name: 'MAHUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360429',
    block_code: 3624018,
    block_name: 'PATANCHERU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360447',
    block_code: 3625010,
    block_name: 'KOHEDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17046',
    district_code: 1705,
    district_name: 'SHIVPURI',
    block_id: 'B-170284',
    block_code: 1705001,
    block_name: 'POHRI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360520',
    block_code: 3629007,
    block_name: 'KHANAPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340012',
    block_code: 3417001,
    block_name: 'HUNTERGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360103',
    block_code: 3607011,
    block_name: 'UNDAVELLY',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180174',
    block_code: 1827003,
    block_name: 'PARSEONI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240022',
    block_code: 2414004,
    block_name: 'ATTABIRA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29031',
    district_code: 2933,
    district_name: 'TIRUPATTUR',
    block_id: 'B-290310',
    block_code: 2933020,
    block_name: 'ALANGAYAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170092',
    block_code: 1722007,
    block_name: 'BAGH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180272',
    block_code: 1804008,
    block_name: 'LANJA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290158',
    block_code: 2908015,
    block_name: 'VENNANDUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20414',
    block_code: 208024,
    block_name: 'GIDDALURU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340054',
    block_code: 3410008,
    block_name: 'CHAKULIA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17044',
    district_code: 1719,
    district_name: 'SHAJAPUR',
    block_id: 'B-170274',
    block_code: 1719007,
    block_name: 'SHUJALPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26019',
    district_code: 2608,
    district_name: 'RUPNAGAR',
    block_id: 'B-260127',
    block_code: 2608002,
    block_name: 'NURPUR BEDI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50441',
    block_code: 509001,
    block_name: 'AMNOUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360205',
    block_code: 3613020,
    block_name: 'MOOSAPET',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340067',
    block_code: 3407016,
    block_name: 'BISHUNPURA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50038',
    block_code: 517002,
    block_name: 'BAKHRI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3024',
    district_code: 302,
    district_name: 'WEST KAMENG',
    block_id: 'B-30110',
    block_code: 302004,
    block_name: 'THRIZINO',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320046',
    block_code: 3216020,
    block_name: 'MATHURAPUR TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24024',
    district_code: 2422,
    district_name: 'NAYAGARH',
    block_id: 'B-240249',
    block_code: 2422003,
    block_name: 'DASPALLA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24001',
    district_code: 2421,
    district_name: 'ANGUL',
    block_id: 'B-240003',
    block_code: 2421008,
    block_name: 'BANARPAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20048',
    block_code: 212024,
    block_name: 'ATMAKUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26022',
    district_code: 2614,
    district_name: 'SHAHID BHAGAT SINGH NAGAR',
    block_id: 'B-260143',
    block_code: 2614004,
    block_name: 'BANGA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180144',
    block_code: 1814009,
    block_name: 'BHUDARGAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20315',
    block_code: 213013,
    block_name: 'PEDDAKADABUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18014',
    district_code: 1816,
    district_name: 'JALNA',
    block_id: 'B-180137',
    block_code: 1816002,
    block_name: 'BHOKARDAN',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15010',
    district_code: 1510,
    district_name: 'CHITRADURGA',
    block_id: 'B-150069',
    block_code: 1510004,
    block_name: 'HOLALKERE',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320229',
    block_code: 3201003,
    block_name: 'HANSKHALI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24017',
    district_code: 2418,
    district_name: 'KENDRAPARA',
    block_id: 'B-240163',
    block_code: 2418008,
    block_name: 'MAHAKALAPADA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23006',
    district_code: 2307,
    district_name: 'MON',
    block_id: 'B-230038',
    block_code: 2307006,
    block_name: 'WAKCHING',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320203',
    block_code: 3212003,
    block_name: 'BERHAMPORE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170022',
    block_code: 1738001,
    block_name: 'KATANGI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33006',
    district_code: 3317,
    district_name: 'BIJAPUR',
    block_id: 'B-330030',
    block_code: 3317003,
    block_name: 'BIJAPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180282',
    block_code: 1812001,
    block_name: 'MIRAJ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290246',
    block_code: 2913003,
    block_name: 'THIRUVAIYARU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50326',
    block_code: 512017,
    block_name: 'SIKTA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50155',
    block_code: 550004,
    block_name: 'ISLAMNAGAR ALIGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360119',
    block_code: 3608015,
    block_name: 'NIZAMSAGAR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30104',
    block_code: 305006,
    block_name: 'SIYUM',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12017',
    district_code: 1206,
    district_name: 'PANIPAT',
    block_id: 'B-120109',
    block_code: 1206094,
    block_name: 'SANOLI KHURD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40115',
    block_code: 407014,
    block_name: 'BIHDIA JAJIKONA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24010',
    district_code: 2424,
    district_name: 'GAJAPATI',
    block_id: 'B-240083',
    block_code: 2424002,
    block_name: 'GUMMA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270229',
    block_code: 2715021,
    block_name: 'KERU',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30007',
    block_code: 310008,
    block_name: 'DIYUN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20631',
    block_code: 211014,
    block_name: 'CHAPADU',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140226',
    block_code: 1416011,
    block_name: 'GANDHRI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170169',
    block_code: 1735002,
    block_name: 'NARAYANGANJ',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340096',
    block_code: 3415046,
    block_name: 'BASANTRAY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313214',
    block_code: 3146013,
    block_name: 'TEJWAPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360430',
    block_code: 3624019,
    block_name: 'PULKAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360442',
    block_code: 3625005,
    block_name: 'DOULTABAD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17046',
    district_code: 1705,
    district_name: 'SHIVPURI',
    block_id: 'B-170285',
    block_code: 1705002,
    block_name: 'SHIVPURI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360522',
    block_code: 3629009,
    block_name: 'NARSAMPET',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340020',
    block_code: 3417009,
    block_name: 'SIMARIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360099',
    block_code: 3607007,
    block_name: 'KALOOR THIMMANDODDI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180168',
    block_code: 1827006,
    block_name: 'KAMPTEE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240021',
    block_code: 2414005,
    block_name: 'AMBABHONA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270172',
    block_code: 2712001,
    block_name: 'KOTPUTLI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170100',
    block_code: 1722010,
    block_name: 'NISARPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180274',
    block_code: 1804009,
    block_name: 'RAJAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313178',
    block_code: 3157005,
    block_name: 'HARAIYA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20416',
    block_code: 208019,
    block_name: 'KANIGIRI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340053',
    block_code: 3410010,
    block_name: 'BORAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17044',
    district_code: 1719,
    district_name: 'SHAJAPUR',
    block_id: 'B-170271',
    block_code: 1719008,
    block_name: 'KALAPIPAL',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26019',
    district_code: 2608,
    district_name: 'RUPNAGAR',
    block_id: 'B-260128',
    block_code: 2608004,
    block_name: 'RUPNAGAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50446',
    block_code: 509006,
    block_name: 'EKMA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360193',
    block_code: 3613001,
    block_name: 'ADDAKAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340069',
    block_code: 3407017,
    block_name: 'DANDA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50268',
    block_code: 515009,
    block_name: 'KURHANI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3004',
    district_code: 307,
    district_name: 'EAST SIANG',
    block_id: 'B-30023',
    block_code: 307008,
    block_name: 'RUKSIN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320027',
    block_code: 3216004,
    block_name: 'BISHNUPUR ONE',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150188',
    block_code: 1525009,
    block_name: 'TUMKUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240243',
    block_code: 2430006,
    block_name: 'NANDAHANDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20061',
    block_code: 212014,
    block_name: 'KUDAIR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26022',
    district_code: 2614,
    district_name: 'SHAHID BHAGAT SINGH NAGAR',
    block_id: 'B-260141',
    block_code: 2614001,
    block_name: 'AUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180152',
    block_code: 1814010,
    block_name: 'RADHANAGARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20314',
    block_code: 213022,
    block_name: 'PATTIKONDA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18014',
    district_code: 1816,
    district_name: 'JALNA',
    block_id: 'B-180142',
    block_code: 1816004,
    block_name: 'PARTUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15010',
    district_code: 1510,
    district_name: 'CHITRADURGA',
    block_id: 'B-150070',
    block_code: 1510005,
    block_name: 'HOSDURGA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320230',
    block_code: 3201004,
    block_name: 'HARINGHATA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5002',
    district_code: 551,
    district_name: 'ARWAL',
    block_id: 'B-50014',
    block_code: 551005,
    block_name: 'Sonbhadra Banshi',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23006',
    district_code: 2307,
    district_name: 'MON',
    block_id: 'B-230032',
    block_code: 2307008,
    block_name: 'ANJANGYANG',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320208',
    block_code: 3212008,
    block_name: 'BURWAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170023',
    block_code: 1738002,
    block_name: 'KHAIRLANJI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17010',
    district_code: 1747,
    district_name: 'BURHANPUR',
    block_id: 'B-170054',
    block_code: 1747009,
    block_name: 'BURHANPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180285',
    block_code: 1812002,
    block_name: 'TASGAON',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290238',
    block_code: 2913006,
    block_name: 'KUMBAKONAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50327',
    block_code: 512018,
    block_name: 'THAKRAHAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50158',
    block_code: 550007,
    block_name: 'KHAIRA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360121',
    block_code: 3608017,
    block_name: 'PITLAM',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30102',
    block_code: 305004,
    block_name: 'NACHO',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12017',
    district_code: 1206,
    district_name: 'PANIPAT',
    block_id: 'B-120107',
    block_code: 1206003,
    block_name: 'PANIPAT',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40125',
    block_code: 407006,
    block_name: 'RANGIA-PART',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240181',
    block_code: 2423001,
    block_name: 'BALIANTA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270221',
    block_code: 2715011,
    block_name: 'BAPIDI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30119',
    block_code: 310011,
    block_name: 'KANTANG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20656',
    block_code: 211023,
    block_name: 'VEERAPANAYANI PALLE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140229',
    block_code: 1416008,
    block_name: 'KHARI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170165',
    block_code: 1735004,
    block_name: 'MANDLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360060',
    block_code: 3604009,
    block_name: 'KODIMIAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180192',
    block_code: 1819001,
    block_name: 'NANDED',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360436',
    block_code: 3624025,
    block_name: 'VATPALLY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360440',
    block_code: 3625003,
    block_name: 'CHERIYAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17046',
    district_code: 1705,
    district_name: 'SHIVPURI',
    block_id: 'B-170282',
    block_code: 1705003,
    block_name: 'NARWAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360166',
    block_code: 3611005,
    block_name: 'JAINOOR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340014',
    block_code: 3417011,
    block_name: 'KANHACHATTI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360093',
    block_code: 3607001,
    block_name: 'ALAMPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180170',
    block_code: 1827007,
    block_name: 'KUHI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240025',
    block_code: 2414006,
    block_name: 'BHATLI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270181',
    block_code: 2712002,
    block_name: 'VIRATNAGAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17016',
    district_code: 1722,
    district_name: 'DHAR',
    block_id: 'B-170103',
    block_code: 1722012,
    block_name: 'UMARBAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31327',
    district_code: 3171,
    district_name: 'CHANDAULI',
    block_id: 'B-313301',
    block_code: 3171006,
    block_name: 'BARHANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313177',
    block_code: 3157006,
    block_name: 'BILARIYAGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20428',
    block_code: 208037,
    block_name: 'PAMUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360216',
    block_code: 3614009,
    block_name: 'KANNEPALLY ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240155',
    block_code: 2408016,
    block_name: 'PHULBANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313463',
    block_code: 3130027,
    block_name: 'SURSA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24029',
    district_code: 2427,
    district_name: 'SONEPUR',
    block_id: 'B-240294',
    block_code: 2427003,
    block_name: 'DUNGURIPALI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360197',
    block_code: 3613006,
    block_name: 'DEVARAKADARA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34007',
    district_code: 3407,
    district_name: 'GARHWA',
    block_id: 'B-340064',
    block_code: 3407020,
    block_name: 'BARGARH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50267',
    block_code: 515008,
    block_name: 'KATRA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3017',
    district_code: 326,
    district_name: 'SHI YOMI',
    block_id: 'B-30068',
    block_code: 326005,
    block_name: 'MECHUKA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320026',
    block_code: 3216003,
    block_name: 'BHANGORE TWO',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150186',
    block_code: 1525007,
    block_name: 'SIRA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24001',
    district_code: 2421,
    district_name: 'ANGUL',
    block_id: 'B-240008',
    block_code: 2421001,
    block_name: 'TALCHER',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20054',
    block_code: 212013,
    block_name: 'GARLADINNE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270083',
    block_code: 2724012,
    block_name: 'BIJOLIYA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180153',
    block_code: 1814012,
    block_name: 'SHAHUWADI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20311',
    block_code: 213003,
    block_name: 'MANTRALAYAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18014',
    district_code: 1816,
    district_name: 'JALNA',
    block_id: 'B-180136',
    block_code: 1816006,
    block_name: 'BADNAPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15010',
    district_code: 1510,
    district_name: 'CHITRADURGA',
    block_id: 'B-150071',
    block_code: 1510006,
    block_name: 'MOLAKALMURU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320231',
    block_code: 3201005,
    block_name: 'KALIGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5002',
    district_code: 551,
    district_name: 'ARWAL',
    block_id: 'B-50012',
    block_code: 551003,
    block_name: 'Karpi',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23006',
    district_code: 2307,
    district_name: 'MON',
    block_id: 'B-230033',
    block_code: 2307001,
    block_name: 'CHEN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320210',
    block_code: 3212010,
    block_name: 'FARAKKA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170025',
    block_code: 1738003,
    block_name: 'LALBARRA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20006',
    district_code: 2010,
    district_name: 'JIRIBAM',
    block_id: 'B-200028',
    block_code: 2010009,
    block_name: 'BOROBEKRA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180277',
    block_code: 1812004,
    block_name: 'ATPADI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290241',
    block_code: 2913009,
    block_name: 'PAPANASAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50312',
    block_code: 512003,
    block_name: 'BETTIAH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50161',
    block_code: 550010,
    block_name: 'SONO',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360124',
    block_code: 3608020,
    block_name: 'SADASIVANAGAR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30096',
    block_code: 305007,
    block_name: 'BARIRIJO',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12017',
    district_code: 1206,
    district_name: 'PANIPAT',
    block_id: 'B-120108',
    block_code: 1206004,
    block_name: 'SAMALKHA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40126',
    block_code: 407002,
    block_name: 'RANI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240182',
    block_code: 2423002,
    block_name: 'BALIPATNA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270222',
    block_code: 2715010,
    block_name: 'BAWARI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30121',
    block_code: 316013,
    block_name: 'PANIASANG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2026',
    district_code: 211,
    district_name: 'Y S R',
    block_id: 'B-20641',
    block_code: 211019,
    block_name: 'LINGALA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140230',
    block_code: 1416009,
    block_name: 'RAJGARH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170162',
    block_code: 1735005,
    block_name: 'BICHHIYA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36005',
    district_code: 3604,
    district_name: 'JAGITIAL',
    block_id: 'B-360061',
    block_code: 3604010,
    block_name: 'KORUTLA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180183',
    block_code: 1819002,
    block_name: 'HADGAON',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340007',
    block_code: 3420007,
    block_name: 'KASMAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360459',
    block_code: 3625021,
    block_name: 'THOGUTA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17046',
    district_code: 1705,
    district_name: 'SHIVPURI',
    block_id: 'B-170279',
    block_code: 1705004,
    block_name: 'KARERA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360163',
    block_code: 3611002,
    block_name: 'BEJJUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34002',
    district_code: 3417,
    district_name: 'CHATRA',
    block_id: 'B-340017',
    block_code: 3417012,
    block_name: 'MAYURHAND',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36008',
    district_code: 3607,
    district_name: 'JOGULAMBA',
    block_id: 'B-360094',
    block_code: 3607002,
    block_name: 'DHARUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180177',
    block_code: 1827009,
    block_name: 'UMRED',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240027',
    block_code: 2414007,
    block_name: 'BIJEPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270179',
    block_code: 2712003,
    block_name: 'SHAHPURA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17030',
    district_code: 1732,
    district_name: 'NARMADAPURAM',
    block_id: 'B-170184',
    block_code: 1732002,
    block_name: 'KESLA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180268',
    block_code: 1804006,
    block_name: 'CHIPLUN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313176',
    block_code: 3157007,
    block_name: 'AZMATGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20436',
    block_code: 208038,
    block_name: 'SINGARAYAKONDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360208',
    block_code: 3614001,
    block_name: 'BELLAMPALLY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240148',
    block_code: 2408017,
    block_name: 'CHAKAPAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313454',
    block_code: 3130034,
    block_name: 'HARPALPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24029',
    district_code: 2427,
    district_name: 'SONEPUR',
    block_id: 'B-240295',
    block_code: 2427004,
    block_name: 'SONEPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360195',
    block_code: 3613003,
    block_name: 'BHOOTHPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290095',
    block_code: 2928005,
    block_name: 'KURUNTHANCODE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50265',
    block_code: 515006,
    block_name: 'GAIGHAT',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3017',
    district_code: 326,
    district_name: 'SHI YOMI',
    block_id: 'B-30069',
    block_code: 326010,
    block_name: 'MONIGONG',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320042',
    block_code: 3216021,
    block_name: 'MAGRAHAT ONE',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150187',
    block_code: 1525008,
    block_name: 'TIPTUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24001',
    district_code: 2421,
    district_name: 'ANGUL',
    block_id: 'B-240001',
    block_code: 2421004,
    block_name: 'ANGUL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20071',
    block_code: 212011,
    block_name: 'SINGANAMALA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270136',
    block_code: 2711003,
    block_name: 'SIKRAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31371',
    district_code: 3174,
    district_name: 'SANT KABEER NAGAR',
    block_id: 'B-313766',
    block_code: 3174001,
    block_name: 'HAISAR BAZAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20306',
    block_code: 213002,
    block_name: 'KOSIGI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18014',
    district_code: 1816,
    district_name: 'JALNA',
    block_id: 'B-180141',
    block_code: 1816008,
    block_name: 'MANTHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290163',
    block_code: 2919001,
    block_name: 'ANNAVASAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320235',
    block_code: 3201008,
    block_name: 'KRISHNAGANJ',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34017',
    district_code: 3414,
    district_name: 'PAKUR',
    block_id: 'B-340168',
    block_code: 3414002,
    block_name: 'HIRANPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320211',
    block_code: 3212011,
    block_name: 'HARIHARPARA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170028',
    block_code: 1738004,
    block_name: 'WARASEONI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20006',
    district_code: 2010,
    district_name: 'JIRIBAM',
    block_id: 'B-200029',
    block_code: 2010007,
    block_name: 'JIRIBAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180284',
    block_code: 1812008,
    block_name: 'SHIRALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290242',
    block_code: 2913011,
    block_name: 'PATTUKKOTTAI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50482',
    block_code: 514011,
    block_name: 'PARSAUNI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50160',
    block_code: 550009,
    block_name: 'SIKANDRA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360126',
    block_code: 3608022,
    block_name: 'YELLAREDDY',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30116',
    block_code: 305012,
    block_name: 'TAKSING',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12017',
    district_code: 1206,
    district_name: 'PANIPAT',
    block_id: 'B-120105',
    block_code: 1206005,
    block_name: 'ISRANA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4010',
    district_code: 411,
    district_name: 'DHEMAJI',
    block_id: 'B-40055',
    block_code: 411001,
    block_name: 'DHEMAJI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240185',
    block_code: 2423003,
    block_name: 'BHUBANESWAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29001',
    district_code: 2931,
    district_name: 'ARIYALUR',
    block_id: 'B-290006',
    block_code: 2931009,
    block_name: 'T.PALUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30122',
    block_code: 316014,
    block_name: 'PHASSANG',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15020',
    district_code: 1520,
    district_name: 'KOPPAL',
    block_id: 'B-150139',
    block_code: 1520001,
    block_name: 'GANGAVATHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140233',
    block_code: 1416006,
    block_name: 'SANGALDAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170168',
    block_code: 1735006,
    block_name: 'NAINPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340102',
    block_code: 3415045,
    block_name: 'PORAIYAHAT',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180186',
    block_code: 1819003,
    block_name: 'KINWAT',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340006',
    block_code: 3420008,
    block_name: 'JARIDIH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360446',
    block_code: 3625009,
    block_name: 'JAGDEVPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17046',
    district_code: 1705,
    district_name: 'SHIVPURI',
    block_id: 'B-170281',
    block_code: 1705005,
    block_name: 'KOLARAS',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360173',
    block_code: 3611013,
    block_name: 'SIRPUR  T ',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34013',
    district_code: 3424,
    district_name: 'KHUNTI',
    block_id: 'B-340139',
    block_code: 3424002,
    block_name: 'ARKI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230057',
    block_code: 2306006,
    block_name: 'SANGSANGYU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180166',
    block_code: 1827011,
    block_name: 'HINGNA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240028',
    block_code: 2414008,
    block_name: 'GAISILET',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270165',
    block_code: 2712004,
    block_name: 'GOVINDGARH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17030',
    district_code: 1732,
    district_name: 'NARMADAPURAM',
    block_id: 'B-170188',
    block_code: 1732001,
    block_name: 'SEONI MALWA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18028',
    district_code: 1804,
    district_name: 'RATNAGIRI',
    block_id: 'B-180276',
    block_code: 1804007,
    block_name: 'SANGAMESHWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313193',
    block_code: 3157008,
    block_name: 'TAHBARPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20418',
    block_code: 208011,
    block_name: 'KONAKANAMITTLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360210',
    block_code: 3614003,
    block_name: 'BHEEMINI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240149',
    block_code: 2408018,
    block_name: 'DARINGIBADI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313458',
    block_code: 3130035,
    block_name: 'MALLAWAN',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24029',
    district_code: 2427,
    district_name: 'SONEPUR',
    block_id: 'B-240296',
    block_code: 2427005,
    block_name: 'TARBHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36014',
    district_code: 3613,
    district_name: 'MAHABUBNAGAR',
    block_id: 'B-360201',
    block_code: 3613011,
    block_name: 'KOILKONDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290099',
    block_code: 2928006,
    block_name: 'THIRUVATTAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50260',
    block_code: 515001,
    block_name: 'AURAI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270018',
    block_code: 2706006,
    block_name: 'LAXMANGARH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320051',
    block_code: 3216014,
    block_name: 'THAKURPUKUR MAHESTALA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110051',
    block_code: 1116001,
    block_name: 'BHARUCH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240240',
    block_code: 2430004,
    block_name: 'JHARIGAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20067',
    block_code: 212028,
    block_name: 'PUTLUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270129',
    block_code: 2711004,
    block_name: 'DAUSA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313371',
    block_code: 3121005,
    block_name: 'KHERGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20307',
    block_code: 213001,
    block_name: 'KOWTHALAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313850',
    block_code: 3150012,
    block_name: 'DHANPATGANJ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290165',
    block_code: 2919002,
    block_name: 'ARIMALAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320238',
    block_code: 3201011,
    block_name: 'NABADWIP',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34017',
    district_code: 3414,
    district_name: 'PAKUR',
    block_id: 'B-340167',
    block_code: 3414004,
    block_name: 'AMRAPARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320212',
    block_code: 3212012,
    block_name: 'JALANGI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170020',
    block_code: 1738005,
    block_name: 'BALAGHAT',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12013',
    district_code: 1212,
    district_name: 'MAHENDRAGARH',
    block_id: 'B-120082',
    block_code: 1212005,
    block_name: 'NANGAL CHAUDHRY',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180283',
    block_code: 1812009,
    block_name: 'PALUS',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290243',
    block_code: 2913013,
    block_name: 'PERAVURANI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50313',
    block_code: 512004,
    block_name: 'BHITAHA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50153',
    block_code: 550002,
    block_name: 'CHAKAI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360106',
    block_code: 3608002,
    block_name: 'BHIKNUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30097',
    block_code: 305008,
    block_name: 'CHETAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40124',
    block_code: 407001,
    block_name: 'RAMPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50243',
    block_code: 520014,
    block_name: 'LAUKAHA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240188',
    block_code: 2423004,
    block_name: 'JATNI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270230',
    block_code: 2715012,
    block_name: 'LOHAWAT',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30123',
    block_code: 316015,
    block_name: 'POLOSANG',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15020',
    district_code: 1520,
    district_name: 'KOPPAL',
    block_id: 'B-150145',
    block_code: 1520004,
    block_name: 'YELBURGA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140234',
    block_code: 1416010,
    block_name: 'UKHRAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290031',
    block_code: 2903007,
    block_name: 'KEERAPALAYAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340097',
    block_code: 3415037,
    block_name: 'BOARIJORE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180179',
    block_code: 1819004,
    block_name: 'BHOKAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340005',
    block_code: 3420005,
    block_name: 'GOMIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360450',
    block_code: 3625013,
    block_name: 'MADDUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17046',
    district_code: 1705,
    district_name: 'SHIVPURI',
    block_id: 'B-170278',
    block_code: 1705006,
    block_name: 'BADARWAS',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360171',
    block_code: 3611065,
    block_name: 'PENCHICALPET',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34013',
    district_code: 3424,
    district_name: 'KHUNTI',
    block_id: 'B-340144',
    block_code: 3424005,
    block_name: 'TORPA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230052',
    block_code: 2306002,
    block_name: 'CHESSORE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18019',
    district_code: 1827,
    district_name: 'NAGPUR',
    block_id: 'B-180167',
    block_code: 1827014,
    block_name: 'KALAMESHWAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240030',
    block_code: 2414009,
    block_name: 'PADAMPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270164',
    block_code: 2712006,
    block_name: 'DUDU',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240278',
    block_code: 2429007,
    block_name: 'KOLNARA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17002',
    district_code: 1749,
    district_name: 'ALIRAJPUR',
    block_id: 'B-170008',
    block_code: 1749004,
    block_name: 'KATHIWADA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313185',
    block_code: 3157009,
    block_name: 'MIRZAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20437',
    block_code: 208015,
    block_name: 'TALLUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360212',
    block_code: 3614005,
    block_name: 'DANDEPALLY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240152',
    block_code: 2408019,
    block_name: 'K.NUAGAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313459',
    block_code: 3130036,
    block_name: 'PIHANI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24029',
    district_code: 2427,
    district_name: 'SONEPUR',
    block_id: 'B-240297',
    block_code: 2427006,
    block_name: 'ULLUNDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290018',
    block_code: 2911008,
    block_name: 'KINATHUKADAVU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290094',
    block_code: 2928007,
    block_name: 'KILLIYOOR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50261',
    block_code: 515002,
    block_name: 'BANDRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270021',
    block_code: 2706008,
    block_name: 'NEEMRANA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320050',
    block_code: 3216015,
    block_name: 'SONARPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110050',
    block_code: 1116002,
    block_name: 'ANKLESVAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240239',
    block_code: 2430001,
    block_name: 'DABUGAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20077',
    block_code: 212029,
    block_name: 'YELLANUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270130',
    block_code: 2711005,
    block_name: 'LALSOT',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180150',
    block_code: 1814001,
    block_name: 'KARVIR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20312',
    block_code: 213004,
    block_name: 'NANDAVARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313856',
    block_code: 3150013,
    block_name: 'KUREBHAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290169',
    block_code: 2919003,
    block_name: 'KUNNANDARKOIL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320239',
    block_code: 3201012,
    block_name: 'NAKASHIPARA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34017',
    district_code: 3414,
    district_name: 'PAKUR',
    block_id: 'B-340170',
    block_code: 3414005,
    block_name: 'MAHESHPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320213',
    block_code: 3212013,
    block_name: 'KANDI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170024',
    block_code: 1738006,
    block_name: 'KIRNAPUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12013',
    district_code: 1212,
    district_name: 'MAHENDRAGARH',
    block_id: 'B-120081',
    block_code: 1212002,
    block_name: 'MAHENDRAGARH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180279',
    block_code: 1812010,
    block_name: 'KADEGAON',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290249',
    block_code: 2913008,
    block_name: 'TIRUPPANANDAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50481',
    block_code: 514010,
    block_name: 'PARIHAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50157',
    block_code: 550006,
    block_name: 'JHAJHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360116',
    block_code: 3608012,
    block_name: 'MADNUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30103',
    block_code: 305009,
    block_name: 'PAYENG',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40117',
    block_code: 407009,
    block_name: 'BONGAON',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40119',
    block_code: 407011,
    block_name: 'CHAYANI BARDUAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240183',
    block_code: 2423005,
    block_name: 'BANAPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270235',
    block_code: 2715013,
    block_name: 'PIPAD SHAHAR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30013',
    block_code: 310009,
    block_name: 'YATDAM',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15020',
    district_code: 1520,
    district_name: 'KOPPAL',
    block_id: 'B-150142',
    block_code: 1520002,
    block_name: 'KOPPAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140227',
    block_code: 1416001,
    block_name: 'GOOL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290027',
    block_code: 2903002,
    block_name: 'ANNAGRAMAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340101',
    block_code: 3415039,
    block_name: 'PATHERGAMA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180180',
    block_code: 1819005,
    block_name: 'BILOLI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340002',
    block_code: 3420002,
    block_name: 'CHANDANKIYARI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360439',
    block_code: 3625002,
    block_name: 'BEJJANKI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17046',
    district_code: 1705,
    district_name: 'SHIVPURI',
    block_id: 'B-170283',
    block_code: 1705007,
    block_name: 'PICHHORE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360174',
    block_code: 3611012,
    block_name: 'SIRPUR U',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13005',
    district_code: 1305,
    district_name: 'KINNAUR',
    block_id: 'B-130036',
    block_code: 1305003,
    block_name: 'POOH',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230053',
    block_code: 2306003,
    block_name: 'LONGKHIM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170159',
    block_code: 1724002,
    block_name: 'MAHESHWAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240031',
    block_code: 2414010,
    block_name: 'PAIKMAL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270176',
    block_code: 2712007,
    block_name: 'PHAGI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24027',
    district_code: 2429,
    district_name: 'RAYAGADA',
    block_id: 'B-240281',
    block_code: 2429010,
    block_name: 'RAMANAGUDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17002',
    district_code: 1749,
    district_name: 'ALIRAJPUR',
    block_id: 'B-170009',
    block_code: 1749005,
    block_name: 'SONDWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313186',
    block_code: 3157010,
    block_name: 'MOHAMMADPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20429',
    block_code: 208006,
    block_name: 'PEDA ARAVEEDU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360218',
    block_code: 3614011,
    block_name: 'KOTAPALLY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240158',
    block_code: 2408020,
    block_name: 'TUMUDIBANDH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313453',
    block_code: 3130037,
    block_name: 'HARIYAWAN',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24029',
    district_code: 2427,
    district_name: 'SONEPUR',
    block_id: 'B-240292',
    block_code: 2427001,
    block_name: 'BINKA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290024',
    block_code: 2911018,
    block_name: 'SULTANPET',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290096',
    block_code: 2928009,
    block_name: 'MELPURAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50274',
    block_code: 515015,
    block_name: 'SAKRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270024',
    block_code: 2706011,
    block_name: 'RENI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320025',
    block_code: 3216002,
    block_name: 'BHANGORE ONE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110052',
    block_code: 1116003,
    block_name: 'HANSOT',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240241',
    block_code: 2430002,
    block_name: 'KOSAGUMUDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20063',
    block_code: 212027,
    block_name: 'NARPALA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270127',
    block_code: 2711001,
    block_name: 'BANDIKUI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180143',
    block_code: 1814008,
    block_name: 'AJRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20297',
    block_code: 213005,
    block_name: 'C BELAGAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313858',
    block_code: 3150020,
    block_name: 'LAMBHUA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290175',
    block_code: 2919007,
    block_name: 'VIRALIMALAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320242',
    block_code: 3201015,
    block_name: 'SANTIPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34017',
    district_code: 3414,
    district_name: 'PAKUR',
    block_id: 'B-340172',
    block_code: 3414006,
    block_name: 'PAKURIA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320214',
    block_code: 3212014,
    block_name: 'KHARGRAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170019',
    block_code: 1738007,
    block_name: 'BAIHAR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12013',
    district_code: 1212,
    district_name: 'MAHENDRAGARH',
    block_id: 'B-120083',
    block_code: 1212004,
    block_name: 'NARNAUL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31364',
    district_code: 3126,
    district_name: 'PILIBHIT',
    block_id: 'B-313679',
    block_code: 3126002,
    block_name: 'MARORI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290236',
    block_code: 2913010,
    block_name: 'AMMAPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50478',
    block_code: 514007,
    block_name: 'DUMRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5012',
    district_code: 550,
    district_name: 'JAMUI',
    block_id: 'B-50152',
    block_code: 550001,
    block_name: 'BARHAT',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360117',
    block_code: 3608013,
    block_name: 'NAGIREDDYPET',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3023',
    district_code: 305,
    district_name: 'UPPER SUBANSIRI',
    block_id: 'B-30101',
    block_code: 305011,
    block_name: 'LIME KING',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40127',
    block_code: 407012,
    block_name: 'SUALKUCHI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240309',
    block_code: 2402001,
    block_name: 'LEPHRIPARA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240184',
    block_code: 2423006,
    block_name: 'BEGUNIA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270236',
    block_code: 2715014,
    block_name: 'SEKHALA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30012',
    block_code: 310006,
    block_name: 'VIJAY NAGAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15020',
    district_code: 1520,
    district_name: 'KOPPAL',
    block_id: 'B-150144',
    block_code: 1520003,
    block_name: 'KUSHTAGI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140231',
    block_code: 1416002,
    block_name: 'RAMBAN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290035',
    block_code: 2903008,
    block_name: 'MELBHUVANAGIRI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340100',
    block_code: 3415041,
    block_name: 'MEHARMA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180181',
    block_code: 1819006,
    block_name: 'DEGLUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340009',
    block_code: 3420006,
    block_name: 'PETERWAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36028',
    district_code: 3625,
    district_name: 'SIDDIPET',
    block_id: 'B-360454',
    block_code: 3625017,
    block_name: 'NANGANOOR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4026',
    district_code: 412,
    district_name: 'MORIGAON',
    block_id: 'B-40160',
    block_code: 412094,
    block_name: 'BHURBANDHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360168',
    block_code: 3611068,
    block_name: 'KERAMERI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13005',
    district_code: 1305,
    district_name: 'KINNAUR',
    block_id: 'B-130034',
    block_code: 1305001,
    block_name: 'KALPA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230055',
    block_code: 2306004,
    block_name: 'NOKSEN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170157',
    block_code: 1724003,
    block_name: 'KASRAWAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240032',
    block_code: 2414011,
    block_name: 'SOHELLA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270178',
    block_code: 2712008,
    block_name: 'SANGANER',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4028',
    district_code: 406,
    district_name: 'NALBARI',
    block_id: 'B-40178',
    block_code: 406007,
    block_name: 'BARIGOG BANBHAG',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17002',
    district_code: 1749,
    district_name: 'ALIRAJPUR',
    block_id: 'B-170010',
    block_code: 1749006,
    block_name: 'UDAIGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313191',
    block_code: 3157011,
    block_name: 'RANI KI SARAI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20439',
    block_code: 208010,
    block_name: 'TARLUPADU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360221',
    block_code: 3614016,
    block_name: 'NENNEL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240147',
    block_code: 2408021,
    block_name: 'BALIGUDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31332',
    district_code: 3134,
    district_name: 'FARRUKHABAD',
    block_id: 'B-313348',
    block_code: 3134001,
    block_name: 'KAIMGANJ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24029',
    district_code: 2427,
    district_name: 'SONEPUR',
    block_id: 'B-240293',
    block_code: 2427002,
    block_name: 'BIRAMAHARAJPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270192',
    block_code: 2718008,
    block_name: 'CHITALWANA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313667',
    block_code: 3114005,
    block_name: 'CHARTHAWAL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240284',
    block_code: 2401001,
    block_name: 'DHANKAUDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270012',
    block_code: 2706001,
    block_name: 'BANSUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320028',
    block_code: 3216005,
    block_name: 'BISHNUPUR TWO',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110056',
    block_code: 1116004,
    block_name: 'VAGRA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240238',
    block_code: 2430003,
    block_name: 'CHANDAHANDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20047',
    block_code: 212025,
    block_name: 'ANANTAPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270132',
    block_code: 2711002,
    block_name: 'MAHWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313368',
    block_code: 3121004,
    block_name: 'EKA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20301',
    block_code: 213006,
    block_name: 'GUDUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313855',
    block_code: 3150030,
    block_name: 'KARAUNDIKALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290174',
    block_code: 2919013,
    block_name: 'THIRUVARANKULAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320227',
    block_code: 3201001,
    block_name: 'CHAKDAHA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34017',
    district_code: 3414,
    district_name: 'PAKUR',
    block_id: 'B-340171',
    block_code: 3414001,
    block_name: 'PAKUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320215',
    block_code: 3212015,
    block_name: 'LALGOLA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170027',
    block_code: 1738008,
    block_name: 'PARASWADA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12013',
    district_code: 1212,
    district_name: 'MAHENDRAGARH',
    block_id: 'B-120080',
    block_code: 1212001,
    block_name: 'KANINA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180286',
    block_code: 1812007,
    block_name: 'WALWA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290244',
    block_code: 2913014,
    block_name: 'SETHUBAVACHATRAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50483',
    block_code: 514012,
    block_name: 'PUPRI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24025',
    district_code: 2428,
    district_name: 'NUAPADA',
    block_id: 'B-240258',
    block_code: 2428002,
    block_name: 'KOMNA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360230',
    block_code: 3615007,
    block_name: 'MANOHARABAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313649',
    block_code: 3162002,
    block_name: 'KON',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4019',
    district_code: 407,
    district_name: 'KAMRUP',
    block_id: 'B-40114',
    block_code: 407013,
    block_name: 'BEZERA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240303',
    block_code: 2402002,
    block_name: 'HEMGIR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240186',
    block_code: 2423007,
    block_name: 'BOLAGARH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27021',
    district_code: 2715,
    district_name: 'JODHPUR',
    block_id: 'B-270226',
    block_code: 2715015,
    block_name: 'DECHU',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3007',
    district_code: 316,
    district_name: 'KURUNG KUMEY',
    block_id: 'B-30035',
    block_code: 316012,
    block_name: 'PARSI PARLO',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23001',
    district_code: 2308,
    district_name: 'DIMAPUR',
    block_id: 'B-230001',
    block_code: 2308006,
    block_name: 'AGHUNAQA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140232',
    block_code: 1416003,
    block_name: 'RAMSOO',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290038',
    block_code: 2903009,
    block_name: 'PARANGIPETTAI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34009',
    district_code: 3415,
    district_name: 'GODDA',
    block_id: 'B-340103',
    block_code: 3415044,
    block_name: 'SUNDERPAHARI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180185',
    block_code: 1819008,
    block_name: 'KANDHAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360423',
    block_code: 3624012,
    block_name: 'MANOOR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31347',
    district_code: 3136,
    district_name: 'KANPUR DEHAT',
    block_id: 'B-313515',
    block_code: 3136007,
    block_name: 'MAITHA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4026',
    district_code: 412,
    district_name: 'MORIGAON',
    block_id: 'B-40161',
    block_code: 412095,
    block_name: 'KAPILI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360519',
    block_code: 3629006,
    block_name: 'GEESUGONDA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13005',
    district_code: 1305,
    district_name: 'KINNAUR',
    block_id: 'B-130035',
    block_code: 1305002,
    block_name: 'NICHAR',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23009',
    district_code: 2306,
    district_name: 'TUENSANG',
    block_id: 'B-230054',
    block_code: 2306005,
    block_name: 'NOKLAK',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17026',
    district_code: 1724,
    district_name: 'KHARGONE',
    block_id: 'B-170160',
    block_code: 1724004,
    block_name: 'SEGAON',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24003',
    district_code: 2414,
    district_name: 'BARGARH',
    block_id: 'B-240029',
    block_code: 2414012,
    block_name: 'JHARBANDH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27016',
    district_code: 2712,
    district_name: 'JAIPUR',
    block_id: 'B-270168',
    block_code: 2712009,
    block_name: 'JHOTWARA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4028',
    district_code: 406,
    district_name: 'NALBARI',
    block_id: 'B-40181',
    block_code: 406010,
    block_name: 'MADHUPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17002',
    district_code: 1749,
    district_name: 'ALIRAJPUR',
    block_id: 'B-170006',
    block_code: 1749002,
    block_name: 'BHABRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313188',
    block_code: 3157012,
    block_name: 'PALHANI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2018',
    district_code: 208,
    district_name: 'PRAKASAM',
    block_id: 'B-20427',
    block_code: 208032,
    block_name: 'ONGOLE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36015',
    district_code: 3614,
    district_name: 'MANCHERIAL',
    block_id: 'B-360223',
    block_code: 3614018,
    block_name: 'VEMANPALLY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24016',
    district_code: 2408,
    district_name: 'KANDHAMAL',
    block_id: 'B-240156',
    block_code: 2408022,
    block_name: 'RAIKIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313452',
    block_code: 3130025,
    block_name: 'BILGRAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50448',
    block_code: 509008,
    block_name: 'ISHUPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313105',
    block_code: 3120004,
    block_name: 'BICHPURI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313672',
    block_code: 3114006,
    block_name: 'PURKAJI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240288',
    block_code: 2401002,
    block_name: 'MANESWAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27002',
    district_code: 2706,
    district_name: 'ALWAR',
    block_id: 'B-270013',
    block_code: 2706002,
    block_name: 'BEHROR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32002',
    district_code: 3216,
    district_name: '24 PARGANAS SOUTH',
    block_id: 'B-320030',
    block_code: 3216007,
    block_name: 'BUDGE BUDGE TWO',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110049',
    block_code: 1116006,
    block_name: 'AMOD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240242',
    block_code: 2430005,
    block_name: 'NABARANGPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20052',
    block_code: 212026,
    block_name: 'BUKKARAYASAMUDRAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31319',
    district_code: 3165,
    district_name: 'BAGHPAT',
    block_id: 'B-313201',
    block_code: 3165020,
    block_name: 'PILANA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18015',
    district_code: 1814,
    district_name: 'KOLHAPUR',
    block_id: 'B-180147',
    block_code: 1814011,
    block_name: 'GAGANBAWADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20299',
    block_code: 213018,
    block_name: 'DEVANAKONDA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18014',
    district_code: 1816,
    district_name: 'JALNA',
    block_id: 'B-180138',
    block_code: 1816007,
    block_name: 'GHANSAVANGI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310199',
    block_code: 3109002,
    block_name: 'KIRATPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32018',
    district_code: 3201,
    district_name: 'NADIA',
    block_id: 'B-320243',
    block_code: 3201016,
    block_name: 'TEHATTA ONE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34017',
    district_code: 3414,
    district_name: 'PAKUR',
    block_id: 'B-340169',
    block_code: 3414003,
    block_name: 'LITTIPARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32017',
    district_code: 3212,
    district_name: 'MURSHIDABAD',
    block_id: 'B-320217',
    block_code: 3212017,
    block_name: 'NABAGRAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17005',
    district_code: 1738,
    district_name: 'BALAGHAT',
    block_id: 'B-170026',
    block_code: 1738010,
    block_name: 'LANJI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12013',
    district_code: 1212,
    district_name: 'MAHENDRAGARH',
    block_id: 'B-120079',
    block_code: 1212003,
    block_name: 'ATELI NANGAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180280',
    block_code: 1812006,
    block_name: 'KAVATHE MAHANKAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290240',
    block_code: 2913004,
    block_name: 'ORATHANADU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50486',
    block_code: 514015,
    block_name: 'SONBARSA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24025',
    district_code: 2428,
    district_name: 'NUAPADA',
    block_id: 'B-240257',
    block_code: 2428003,
    block_name: 'KHARIAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360110',
    block_code: 3608006,
    block_name: 'DOMAKONDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313651',
    block_code: 3162003,
    block_name: 'MAJHAWA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4010',
    district_code: 411,
    district_name: 'DHEMAJI',
    block_id: 'B-40056',
    block_code: 411005,
    block_name: 'MACHKHOWA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240306',
    block_code: 2402004,
    block_name: 'KUTRA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240190',
    block_code: 2423009,
    block_name: 'TANGI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240189',
    block_code: 2423010,
    block_name: 'KHORDHA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3002',
    district_code: 310,
    district_name: 'CHANGLANG',
    block_id: 'B-30010',
    block_code: 310007,
    block_name: 'MANMAO',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23001',
    district_code: 2308,
    district_name: 'DIMAPUR',
    block_id: 'B-230002',
    block_code: 2308005,
    block_name: 'CHUMUKEDIMA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140224',
    block_code: 1416004,
    block_name: 'BANIHAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290029',
    block_code: 2903011,
    block_name: 'KAMMAPURAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31353',
    district_code: 3140,
    district_name: 'LALITPUR',
    block_id: 'B-313577',
    block_code: 3140002,
    block_name: 'JAKHAURA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180187',
    block_code: 1819010,
    block_name: 'LOHA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180178',
    block_code: 1819011,
    block_name: 'ARDHAPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140102',
    block_code: 1413004,
    block_name: 'DANSAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29014',
    district_code: 2936,
    district_name: 'MAYILADUTHURAI',
    block_id: 'B-290133',
    block_code: 2936011,
    block_name: 'KOLLIDAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360525',
    block_code: 3629013,
    block_name: 'RAIPARTHY',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150199',
    block_code: 1527012,
    block_name: 'DHAANDELI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313554',
    block_code: 3128007,
    block_name: 'MOHAMMADI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4002',
    district_code: 424,
    district_name: 'BAKSA',
    block_id: 'B-40004',
    block_code: 424001,
    block_name: 'BASKA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27023',
    district_code: 2730,
    district_name: 'KOTA',
    block_id: 'B-270247',
    block_code: 2730003,
    block_name: 'ITAWA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4004',
    district_code: 433,
    district_name: 'BISWANATH',
    block_id: 'B-40016',
    block_code: 433013,
    block_name: 'BAGHMARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20533',
    block_code: 225023,
    block_name: 'PARIGI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17002',
    district_code: 1749,
    district_name: 'ALIRAJPUR',
    block_id: 'B-170005',
    block_code: 1749001,
    block_name: 'ALIRAJPUR',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22002',
    district_code: 2206,
    district_name: 'CHAMPHAI',
    block_id: 'B-220006',
    block_code: 2206003,
    block_name: 'KHAWBUNG',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130063',
    block_code: 1309004,
    block_name: 'JUBBAL KOTKHAI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110186',
    block_code: 1120003,
    block_name: 'SIDHPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50357',
    block_code: 513014,
    block_name: 'DHAKA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313461',
    block_code: 3130028,
    block_name: 'SANDILA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30007',
    district_code: 3005,
    district_name: 'UNAKOTI',
    block_id: 'B-300046',
    block_code: 3005004,
    block_name: 'CHANDIPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313101',
    block_code: 3120002,
    block_name: 'ACHHNERA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240215',
    block_code: 2404047,
    block_name: 'BARIPADA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313665',
    block_code: 3114008,
    block_name: 'BAGHARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320198',
    block_code: 3209008,
    block_name: 'OLD MALDA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140031',
    block_code: 1402002,
    block_name: 'BONIYAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110054',
    block_code: 1116007,
    block_name: 'JHAGADIA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15021',
    district_code: 1521,
    district_name: 'MANDYA',
    block_id: 'B-150147',
    block_code: 1521002,
    block_name: 'MADDUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360048',
    block_code: 3630017,
    block_name: 'NADIKUDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270318',
    block_code: 2701001,
    block_name: 'ANUPGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313787',
    block_code: 3127019,
    block_name: 'KHUTAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20309',
    block_code: 213007,
    block_name: 'KURNOOL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310201',
    block_code: 3109003,
    block_name: 'MOHAMMEDPUR DEOMAL',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15016',
    district_code: 1517,
    district_name: 'HAVERI',
    block_id: 'B-150114',
    block_code: 1517008,
    block_name: 'RATTIHALLI',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22006',
    district_code: 2208,
    district_name: 'LAWNGTLAI',
    block_id: 'B-220011',
    block_code: 2208004,
    block_name: 'BUNGTLANG S',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150059',
    block_code: 1509002,
    block_name: 'KADUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12013',
    district_code: 1212,
    district_name: 'MAHENDRAGARH',
    block_id: 'B-120084',
    block_code: 1212006,
    block_name: 'NIZAMPUR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130020',
    block_code: 1304002,
    block_name: 'BHAWARNA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313167',
    block_code: 3149019,
    block_name: 'MAWAI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50472',
    block_code: 514001,
    block_name: 'BAIRGANIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50319',
    block_code: 512010,
    block_name: 'MAINATANR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36009',
    district_code: 3608,
    district_name: 'KAMAREDDY',
    block_id: 'B-360125',
    block_code: 3608021,
    block_name: 'TADWAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313653',
    block_code: 3162005,
    block_name: 'PAHARI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13002',
    district_code: 1302,
    district_name: 'CHAMBA',
    block_id: 'B-130005',
    block_code: 1302001,
    block_name: 'BHARMOUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290282',
    block_code: 2927003,
    block_name: 'SRIVAIKUNDAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24010',
    district_code: 2424,
    district_name: 'GAJAPATI',
    block_id: 'B-240084',
    block_code: 2424003,
    block_name: 'KASINAGAR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35009',
    district_code: 3511,
    district_name: 'PITHORAGARH',
    block_id: 'B-350068',
    block_code: 3511008,
    block_name: 'MUNAKOT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29015',
    district_code: 2914,
    district_name: 'NAGAPATTINAM',
    block_id: 'B-290140',
    block_code: 2914001,
    block_name: 'NAGAPATTINAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320171',
    block_code: 3207003,
    block_name: 'MAYNAGURI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27030',
    district_code: 2719,
    district_name: 'SIROHI',
    block_id: 'B-270314',
    block_code: 2719003,
    block_name: 'PINDWARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20401',
    block_code: 214011,
    block_name: 'PARVATHIPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180182',
    block_code: 1819013,
    block_name: 'DHARMABAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140112',
    block_code: 1413008,
    block_name: 'R S PURA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29014',
    district_code: 2936,
    district_name: 'MAYILADUTHURAI',
    block_id: 'B-290134',
    block_code: 2936008,
    block_name: 'KUTHALAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360167',
    block_code: 3611006,
    block_name: 'KAGAZNAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20211',
    block_code: 207009,
    block_name: 'DUGGIRALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313552',
    block_code: 3128011,
    block_name: 'LAKHIMPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4002',
    district_code: 424,
    district_name: 'BAKSA',
    block_id: 'B-40003',
    block_code: 424002,
    block_name: 'BARAMA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27023',
    district_code: 2730,
    district_name: 'KOTA',
    block_id: 'B-270250',
    block_code: 2730004,
    block_name: 'SANGOD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4004',
    district_code: 433,
    district_name: 'BISWANATH',
    block_id: 'B-40019',
    block_code: 433007,
    block_name: 'CHAIDUAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20527',
    block_code: 225017,
    block_name: 'MADAKASIRA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17002',
    district_code: 1749,
    district_name: 'ALIRAJPUR',
    block_id: 'B-170007',
    block_code: 1749003,
    block_name: 'JOBAT',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22002',
    district_code: 2206,
    district_name: 'CHAMPHAI',
    block_id: 'B-220005',
    block_code: 2206004,
    block_name: 'CHAMPHAI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130060',
    block_code: 1309001,
    block_name: 'BASANTPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110180',
    block_code: 1120004,
    block_name: 'PATAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50369',
    block_code: 513016,
    block_name: 'PATAHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313462',
    block_code: 3130029,
    block_name: 'SHAHABAD',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30007',
    district_code: 3005,
    district_name: 'UNAKOTI',
    block_id: 'B-300048',
    block_code: 3005002,
    block_name: 'KUMARGHAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313102',
    block_code: 3120003,
    block_name: 'AKOLA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240216',
    block_code: 2404048,
    block_name: 'BETNOTI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313673',
    block_code: 3114011,
    block_name: 'SHAHPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320190',
    block_code: 3209009,
    block_name: 'GAZOLE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140029',
    block_code: 1402003,
    block_name: 'BARAMULLA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11033',
    district_code: 1118,
    district_name: 'VALSAD',
    block_id: 'B-110247',
    block_code: 1118001,
    block_name: 'VALSAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20498',
    block_code: 201014,
    block_name: 'NARASANNAPETA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360040',
    block_code: 3630018,
    block_name: 'ATMAKUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270321',
    block_code: 2701003,
    block_name: 'KARANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313784',
    block_code: 3127020,
    block_name: 'KALAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20296',
    block_code: 213017,
    block_name: 'ASPARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310200',
    block_code: 3109005,
    block_name: 'KOTWALI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360080',
    block_code: 3605012,
    block_name: 'THARIGOPPULA',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22006',
    district_code: 2208,
    district_name: 'LAWNGTLAI',
    block_id: 'B-220014',
    block_code: 2208003,
    block_name: 'SANGAU',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150061',
    block_code: 1509003,
    block_name: 'KOPPA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12013',
    district_code: 1212,
    district_name: 'MAHENDRAGARH',
    block_id: 'B-120086',
    block_code: 1212008,
    block_name: 'SIHMA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130021',
    block_code: 1304003,
    block_name: 'DEHRA GOPIPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313168',
    block_code: 3149004,
    block_name: 'MAYA BAZAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50317',
    block_code: 512008,
    block_name: 'LAURIYA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50310',
    block_code: 512001,
    block_name: 'BAGAHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36016',
    district_code: 3615,
    district_name: 'MEDAK',
    block_id: 'B-360228',
    block_code: 3615005,
    block_name: 'KOWDIPALLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313656',
    block_code: 3162010,
    block_name: 'SHIKHAR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13002',
    district_code: 1302,
    district_name: 'CHAMBA',
    block_id: 'B-130008',
    block_code: 1302004,
    block_name: 'MEHLA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290284',
    block_code: 2927005,
    block_name: 'TIRUCHENDUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24010',
    district_code: 2424,
    district_name: 'GAJAPATI',
    block_id: 'B-240087',
    block_code: 2424006,
    block_name: 'RAYAGADA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35009',
    district_code: 3511,
    district_name: 'PITHORAGARH',
    block_id: 'B-350069',
    block_code: 3511001,
    block_name: 'MUNSYARI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290354',
    block_code: 2915007,
    block_name: 'NEEDAMANGALAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320166',
    block_code: 3207004,
    block_name: 'DHUPGURI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27030',
    district_code: 2719,
    district_name: 'SIROHI',
    block_id: 'B-270313',
    block_code: 2719004,
    block_name: 'ABU ROAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20402',
    block_code: 214012,
    block_name: 'SALUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180193',
    block_code: 1819014,
    block_name: 'UMRI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170237',
    block_code: 1710007,
    block_name: 'JAISINAGAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180253',
    block_code: 1803001,
    block_name: 'ALIBAG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360527',
    block_code: 3629016,
    block_name: 'WARDHANNA PET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20216',
    block_code: 207006,
    block_name: 'MEDIKONDURU',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3021',
    district_code: 315,
    district_name: 'UPPER DIBANG VALLEY',
    block_id: 'B-30087',
    block_code: 315002,
    block_name: 'ANELIH-ARZU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4002',
    district_code: 424,
    district_name: 'BAKSA',
    block_id: 'B-40005',
    block_code: 424008,
    block_name: 'DHAMDHAMA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27023',
    district_code: 2730,
    district_name: 'KOTA',
    block_id: 'B-270248',
    block_code: 2730005,
    block_name: 'KHAIRABAD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4004',
    district_code: 433,
    district_name: 'BISWANATH',
    block_id: 'B-40021',
    block_code: 433012,
    block_name: 'SAKOMATHA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20526',
    block_code: 225016,
    block_name: 'LEPAKSHI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40156',
    block_code: 410002,
    block_name: 'NOWBOICHA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320087',
    block_code: 3203009,
    block_name: 'MOHAMMAD BAZAR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130061',
    block_code: 1309002,
    block_name: 'CHAUHARA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110179',
    block_code: 1120005,
    block_name: 'HARIJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50363',
    block_code: 513019,
    block_name: 'MADHUBAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31346',
    district_code: 3168,
    district_name: 'KANNAUJ',
    block_id: 'B-313506',
    block_code: 3168001,
    block_name: 'JALALABAD',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30007',
    district_code: 3005,
    district_name: 'UNAKOTI',
    block_id: 'B-300049',
    block_code: 3005003,
    block_name: 'PECHARTHAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313606',
    block_code: 3123007,
    block_name: 'BEWAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240218',
    block_code: 2404050,
    block_name: 'BISOI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313670',
    block_code: 3114012,
    block_name: 'MORNA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320199',
    block_code: 3209005,
    block_name: 'RATUA ONE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140047',
    block_code: 1402010,
    block_name: 'SINGHPORA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11033',
    district_code: 1118,
    district_name: 'VALSAD',
    block_id: 'B-110245',
    block_code: 1118002,
    block_name: 'PARDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20485',
    block_code: 201012,
    block_name: 'GARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360042',
    block_code: 3630019,
    block_name: 'DAMERA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270322',
    block_code: 2701004,
    block_name: 'PADAMPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31362',
    district_code: 3110,
    district_name: 'MORADABAD',
    block_id: 'B-313661',
    block_code: 3110016,
    block_name: 'DINGARPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20308',
    block_code: 213019,
    block_name: 'KRISHNAGIRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310194',
    block_code: 3109006,
    block_name: 'AFZALGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360071',
    block_code: 3605002,
    block_name: 'CHILPUR',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210008',
    block_code: 2102002,
    block_name: 'KHADARSHNONG-LAITKROH',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150062',
    block_code: 1509004,
    block_name: 'MUDIGERE',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12013',
    district_code: 1212,
    district_name: 'MAHENDRAGARH',
    block_id: 'B-120085',
    block_code: 1212007,
    block_name: 'SATNALI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130022',
    block_code: 1304004,
    block_name: 'DHARAMSHALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313169',
    block_code: 3149006,
    block_name: 'MILKIPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50484',
    block_code: 514013,
    block_name: 'RIGA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50477',
    block_code: 514006,
    block_name: 'CHARAUT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31316',
    district_code: 3169,
    district_name: 'AURAIYA',
    block_id: 'B-313162',
    block_code: 3169004,
    block_name: 'SAHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313652',
    block_code: 3162011,
    block_name: 'NARAINPUR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13002',
    district_code: 1302,
    district_name: 'CHAMBA',
    block_id: 'B-130006',
    block_code: 1302002,
    block_name: 'BHATTIYAT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290281',
    block_code: 2927007,
    block_name: 'SATTANKULAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24010',
    district_code: 2424,
    district_name: 'GAJAPATI',
    block_id: 'B-240088',
    block_code: 2424007,
    block_name: 'R.UDAYAGIRI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35009',
    district_code: 3511,
    district_name: 'PITHORAGARH',
    block_id: 'B-350064',
    block_code: 3511002,
    block_name: 'DHARCHULA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290355',
    block_code: 2915009,
    block_name: 'THIRUTHURAIPOONDI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320170',
    block_code: 3207006,
    block_name: 'MATIALI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27030',
    district_code: 2719,
    district_name: 'SIROHI',
    block_id: 'B-270315',
    block_code: 2719005,
    block_name: 'REODAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20396',
    block_code: 214006,
    block_name: 'KOMARADA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180184',
    block_code: 1819015,
    block_name: 'HIMAYATNAGAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170240',
    block_code: 1710003,
    block_name: 'MALTHONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180267',
    block_code: 1803002,
    block_name: 'URAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360175',
    block_code: 3611064,
    block_name: 'TIRYANI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20223',
    block_code: 207004,
    block_name: 'TADIKONDA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3021',
    district_code: 315,
    district_name: 'UPPER DIBANG VALLEY',
    block_id: 'B-30089',
    block_code: 315003,
    block_name: 'ETALIN-MALINYE',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4002',
    district_code: 424,
    district_name: 'BAKSA',
    block_id: 'B-40007',
    block_code: 424005,
    block_name: 'JALAH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313699',
    block_code: 3145013,
    block_name: 'BAHRIA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4004',
    district_code: 433,
    district_name: 'BISWANATH',
    block_id: 'B-40022',
    block_code: 433011,
    block_name: 'SOOTEA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20532',
    block_code: 225022,
    block_name: 'OBULADEVARECHERUVU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40154',
    block_code: 410003,
    block_name: 'LAKHIMPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320096',
    block_code: 3203010,
    block_name: 'SAINTHIA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130066',
    block_code: 1309005,
    block_name: 'MASHOBRA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110182',
    block_code: 1120006,
    block_name: 'SAMI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50364',
    block_code: 513020,
    block_name: 'MEHSI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31346',
    district_code: 3168,
    district_name: 'KANNAUJ',
    block_id: 'B-313510',
    block_code: 3168002,
    block_name: 'UMARDA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30007',
    district_code: 3005,
    district_name: 'UNAKOTI',
    block_id: 'B-300047',
    block_code: 3005001,
    block_name: 'GOURNAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313610',
    block_code: 3123009,
    block_name: 'KISHNI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240221',
    block_code: 2404051,
    block_name: 'JOSHIPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290101',
    block_code: 2928004,
    block_name: 'THUCKALAY',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320200',
    block_code: 3209006,
    block_name: 'RATUA TWO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140036',
    block_code: 1402011,
    block_name: 'KUNZER',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11033',
    district_code: 1118,
    district_name: 'VALSAD',
    block_id: 'B-110246',
    block_code: 1118003,
    block_name: 'UMBERGAON',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20484',
    block_code: 201001,
    block_name: 'GANGUVARISIGADAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360049',
    block_code: 3630011,
    block_name: 'PARKAL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270093',
    block_code: 2724008,
    block_name: 'SUWANA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313782',
    block_code: 3127022,
    block_name: 'JAITPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20317',
    block_code: 213020,
    block_name: 'VELDURTHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310203',
    block_code: 3109007,
    block_name: 'NEHTAUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15016',
    district_code: 1517,
    district_name: 'HAVERI',
    block_id: 'B-150110',
    block_code: 1517002,
    block_name: 'HANAGAL',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210013',
    block_code: 2102003,
    block_name: 'MAWRYNGKNENG',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150063',
    block_code: 1509005,
    block_name: 'NARASIMHARAJAPURA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140064',
    block_code: 1404020,
    block_name: 'PAKHERPORA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130028',
    block_code: 1304010,
    block_name: 'NAGROTA SURIAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313171',
    block_code: 3149020,
    block_name: 'RUDAULI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50475',
    block_code: 514004,
    block_name: 'BELSAND',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50485',
    block_code: 514014,
    block_name: 'RUNISAIDPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31316',
    district_code: 3169,
    district_name: 'AURAIYA',
    block_id: 'B-313157',
    block_code: 3169005,
    block_name: 'AJITMAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313645',
    block_code: 3162001,
    block_name: 'CHHANVEY',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13002',
    district_code: 1302,
    district_name: 'CHAMBA',
    block_id: 'B-130009',
    block_code: 1302005,
    block_name: 'PANGI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290278',
    block_code: 2927008,
    block_name: 'KOVILPATTI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24010',
    district_code: 2424,
    district_name: 'GAJAPATI',
    block_id: 'B-240085',
    block_code: 2424004,
    block_name: 'MOHONA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35009',
    district_code: 3511,
    district_name: 'PITHORAGARH',
    block_id: 'B-350063',
    block_code: 3511003,
    block_name: 'BERINAG',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290056',
    block_code: 2922005,
    block_name: 'NATHAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320172',
    block_code: 3207007,
    block_name: 'NAGRAKATA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31381',
    district_code: 3161,
    district_name: 'VARANASI',
    block_id: 'B-313880',
    block_code: 3161026,
    block_name: 'CHOLAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20391',
    block_code: 214001,
    block_name: 'BALIJIPETA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313209',
    block_code: 3146001,
    block_name: 'MIHINPURWA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170235',
    block_code: 1710001,
    block_name: 'BINA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180260',
    block_code: 1803003,
    block_name: 'PANVEL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360172',
    block_code: 3611011,
    block_name: 'REBBENA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20215',
    block_code: 207003,
    block_name: 'MANGALAGIRI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3005',
    district_code: 322,
    district_name: 'KAMLE',
    block_id: 'B-30025',
    block_code: 322010,
    block_name: 'TAMEN RAGA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50491',
    block_code: 510003,
    block_name: 'BASANTPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313231',
    block_code: 3159018,
    block_name: 'SIAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50308',
    block_code: 508013,
    block_name: 'SIRDALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20529',
    block_code: 225019,
    block_name: 'NALLACHERUVU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40153',
    block_code: 410007,
    block_name: 'KARUNABARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320080',
    block_code: 3203011,
    block_name: 'BOLPUR-SRINIKETAN',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130068',
    block_code: 1309007,
    block_name: 'NARKANDA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110178',
    block_code: 1120007,
    block_name: 'CHANASMA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50354',
    block_code: 513022,
    block_name: 'BANKATWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31346',
    district_code: 3168,
    district_name: 'KANNAUJ',
    block_id: 'B-313508',
    block_code: 3168003,
    block_name: 'SAURIKH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32003',
    district_code: 3220,
    district_name: 'ALIPURUDUAR',
    block_id: 'B-320054',
    block_code: 3220008,
    block_name: 'FALAKATA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18031',
    district_code: 1805,
    district_name: 'SINDHUDURG',
    block_id: 'B-180303',
    block_code: 1805006,
    block_name: 'SAWANTWADI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240220',
    block_code: 2404052,
    block_name: 'JAMDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290097',
    block_code: 2928008,
    block_name: 'MUNCHIRAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320192',
    block_code: 3209001,
    block_name: 'HARISHCHANDRAPUR ONE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140035',
    block_code: 1402032,
    block_name: 'KANDI RAFIABAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11033',
    district_code: 1118,
    district_name: 'VALSAD',
    block_id: 'B-110243',
    block_code: 1118008,
    block_name: 'DHARAMPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20500',
    block_code: 201017,
    block_name: 'PATHAPATNAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360050',
    block_code: 3630015,
    block_name: 'SHAYAMPET',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270087',
    block_code: 2724009,
    block_name: 'KOTRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313779',
    block_code: 3127015,
    block_name: 'BANDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20302',
    block_code: 213025,
    block_name: 'HALAHARVI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310196',
    block_code: 3109009,
    block_name: 'BUDHANPUR SEOHARA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15016',
    district_code: 1517,
    district_name: 'HAVERI',
    block_id: 'B-150113',
    block_code: 1517005,
    block_name: 'RANEBENNUR',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210015',
    block_code: 2102004,
    block_name: 'MYLLIEM',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150064',
    block_code: 1509006,
    block_name: 'SRINGERI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140059',
    block_code: 1404019,
    block_name: 'CHARISHARIEF',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130030',
    block_code: 1304012,
    block_name: 'PANCHRUKHI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320311',
    block_code: 3211012,
    block_name: 'NANDAKUMAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50322',
    block_code: 512013,
    block_name: 'NAUTAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50311',
    block_code: 512002,
    block_name: 'BAIRIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313723',
    block_code: 3133024,
    block_name: 'CHHATOH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313650',
    block_code: 3162006,
    block_name: 'LALGANJ',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13002',
    district_code: 1302,
    district_name: 'CHAMBA',
    block_id: 'B-130007',
    block_code: 1302003,
    block_name: 'CHAMBA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290279',
    block_code: 2927010,
    block_name: 'OTTAPIDARAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24010',
    district_code: 2424,
    district_name: 'GAJAPATI',
    block_id: 'B-240086',
    block_code: 2424005,
    block_name: 'NUAGADA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35009',
    district_code: 3511,
    district_name: 'PITHORAGARH',
    block_id: 'B-350065',
    block_code: 3511004,
    block_name: 'DIDIHAT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290350',
    block_code: 2915008,
    block_name: 'KOTTUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320291',
    block_code: 3202003,
    block_name: 'MEMARI TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31381',
    district_code: 3161,
    district_name: 'VARANASI',
    block_id: 'B-313879',
    block_code: 3161027,
    block_name: 'CHIRAIGAON',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20398',
    block_code: 214008,
    block_name: 'MAKKUVA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313210',
    block_code: 3146002,
    block_name: 'NAWABGANJ',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170239',
    block_code: 1710002,
    block_name: 'KHURAI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180254',
    block_code: 1803004,
    block_name: 'KARJAT',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36012',
    district_code: 3611,
    district_name: 'KOMARAM BHEEM',
    block_id: 'B-360176',
    block_code: 3611063,
    block_name: 'WANKIDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20217',
    block_code: 207008,
    block_name: 'PEDAKAKANI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3021',
    district_code: 315,
    district_name: 'UPPER DIBANG VALLEY',
    block_id: 'B-30088',
    block_code: 315001,
    block_name: 'ANINI-MIPI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50493',
    block_code: 510005,
    block_name: 'DARAULI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313226',
    block_code: 3159019,
    block_name: 'NAGRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50253',
    block_code: 526003,
    block_name: 'DHARHARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20513',
    block_code: 225003,
    block_name: 'AMARAPURAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40157',
    block_code: 410008,
    block_name: 'TELAHI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320084',
    block_code: 3203012,
    block_name: 'LABPUR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130067',
    block_code: 1309006,
    block_name: 'NANKHARI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11004',
    district_code: 1127,
    district_name: 'ARAVALLI',
    block_id: 'B-110030',
    block_code: 1127006,
    block_name: 'BHILODA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50362',
    block_code: 513024,
    block_name: 'KOTWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31346',
    district_code: 3168,
    district_name: 'KANNAUJ',
    block_id: 'B-313509',
    block_code: 3168006,
    block_name: 'TALGRAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32003',
    district_code: 3220,
    district_name: 'ALIPURUDUAR',
    block_id: 'B-320055',
    block_code: 3220010,
    block_name: 'KALCHINI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18031',
    district_code: 1805,
    district_name: 'SINDHUDURG',
    block_id: 'B-180298',
    block_code: 1805003,
    block_name: 'DEVGAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240223',
    block_code: 2404053,
    block_name: 'KARANJIA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290093',
    block_code: 2928001,
    block_name: 'AGASTHEESWARAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320187',
    block_code: 3209003,
    block_name: 'CHANCHAL ONE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17035',
    district_code: 1730,
    district_name: 'RAISEN',
    block_id: 'B-170210',
    block_code: 1730001,
    block_name: 'SANCHI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11033',
    district_code: 1118,
    district_name: 'VALSAD',
    block_id: 'B-110244',
    block_code: 1118009,
    block_name: 'KAPRADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20508',
    block_code: 201011,
    block_name: 'SRIKAKULAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290380',
    block_code: 2924005,
    block_name: 'NARIKUDI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270085',
    block_code: 2724010,
    block_name: 'JAHAZPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313780',
    block_code: 3127016,
    block_name: 'BHAWAL KHERA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20316',
    block_code: 213021,
    block_name: 'TUGGALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310198',
    block_code: 3109010,
    block_name: 'JALILPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360072',
    block_code: 3605003,
    block_name: 'DEVARUPPULA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210012',
    block_code: 2102005,
    block_name: 'MAWPHLANG',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150065',
    block_code: 1509007,
    block_name: 'TARIKERE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140055',
    block_code: 1404003,
    block_name: 'BEERWAH',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130031',
    block_code: 1304013,
    block_name: 'PRAGPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320305',
    block_code: 3211014,
    block_name: 'HALDIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50323',
    block_code: 512014,
    block_name: 'PIPRASI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50476',
    block_code: 514005,
    block_name: 'BOKHARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313722',
    block_code: 3133001,
    block_name: 'BACHHRAWAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313647',
    block_code: 3162007,
    block_name: 'HALLIA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13002',
    district_code: 1302,
    district_name: 'CHAMBA',
    block_id: 'B-130010',
    block_code: 1302006,
    block_name: 'SALOONI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290286',
    block_code: 2927011,
    block_name: 'VILATHIKULAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24019',
    district_code: 2423,
    district_name: 'KHORDHA',
    block_id: 'B-240187',
    block_code: 2423008,
    block_name: 'CHILIKA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35009',
    district_code: 3511,
    district_name: 'PITHORAGARH',
    block_id: 'B-350066',
    block_code: 3511006,
    block_name: 'GANGOLIHAT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290352',
    block_code: 2915010,
    block_name: 'MUTHUPETTAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320296',
    block_code: 3202006,
    block_name: 'RAINA TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31381',
    district_code: 3161,
    district_name: 'VARANASI',
    block_id: 'B-313881',
    block_code: 3161028,
    block_name: 'HARAHUA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20399',
    block_code: 214009,
    block_name: 'PACHIPENTA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313202',
    block_code: 3146003,
    block_name: 'BALAHA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170234',
    block_code: 1710004,
    block_name: 'BANDA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180255',
    block_code: 1803005,
    block_name: 'KHALAPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360526',
    block_code: 3629014,
    block_name: 'SANGEM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20219',
    block_code: 207005,
    block_name: 'PHIRANGIPURAM',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3005',
    district_code: 322,
    district_name: 'KAMLE',
    block_id: 'B-30024',
    block_code: 322001,
    block_name: 'PUCHI GEKU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50499',
    block_code: 510011,
    block_name: 'LAKRI NABIGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313229',
    block_code: 3159020,
    block_name: 'RASRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50309',
    block_code: 508014,
    block_name: 'WARISALIGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20521',
    block_code: 225011,
    block_name: 'GUDIBANDA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4034',
    district_code: 427,
    district_name: 'UDALGURI',
    block_id: 'B-40210',
    block_code: 427002,
    block_name: 'BHERGAON',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320092',
    block_code: 3203013,
    block_name: 'NANOOR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130069',
    block_code: 1309008,
    block_name: 'RAMPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110183',
    block_code: 1120001,
    block_name: 'SANTALPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50370',
    block_code: 513025,
    block_name: 'PHENHARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31346',
    district_code: 3168,
    district_name: 'KANNAUJ',
    block_id: 'B-313505',
    block_code: 3168007,
    block_name: 'HASERAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32003',
    district_code: 3220,
    district_name: 'ALIPURUDUAR',
    block_id: 'B-320056',
    block_code: 3220013,
    block_name: 'KUMARGRAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18031',
    district_code: 1805,
    district_name: 'SINDHUDURG',
    block_id: 'B-180302',
    block_code: 1805002,
    block_name: 'MALWAN',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240222',
    block_code: 2404054,
    block_name: 'KAPTIPADA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290100',
    block_code: 2928002,
    block_name: 'THOVALAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320196',
    block_code: 3209015,
    block_name: 'KALIACHAK TWO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140033',
    block_code: 1402028,
    block_name: 'HARDE ABOORA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110053',
    block_code: 1116005,
    block_name: 'JAMBUSAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20496',
    block_code: 201018,
    block_name: 'MELIAPUTTI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290388',
    block_code: 2924008,
    block_name: 'WATRAP',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270126',
    block_code: 2711007,
    block_name: 'BAIJUPADA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313781',
    block_code: 3127017,
    block_name: 'DADROL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20310',
    block_code: 213023,
    block_name: 'MADDIKERA (EAST)',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31017',
    district_code: 3109,
    district_name: 'BIJNOR',
    block_id: 'B-310204',
    block_code: 3109011,
    block_name: 'NOORPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360075',
    block_code: 3605007,
    block_name: 'KODAKANDLA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210009',
    block_code: 2102006,
    block_name: 'MAWKYNREW',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150153',
    block_code: 1522001,
    block_name: 'HEGGADADEVANKOTE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140058',
    block_code: 1404006,
    block_name: 'CHADOORA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130032',
    block_code: 1304014,
    block_name: 'RAIT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320299',
    block_code: 3211017,
    block_name: 'CHANDIPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50480',
    block_code: 514009,
    block_name: 'NANPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50325',
    block_code: 512016,
    block_name: 'SIDHAW',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313725',
    block_code: 3133023,
    block_name: 'DEEH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313655',
    block_code: 3162009,
    block_name: 'RAJGARH',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13002',
    district_code: 1302,
    district_name: 'CHAMBA',
    block_id: 'B-130011',
    block_code: 1302007,
    block_name: 'TISSA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290283',
    block_code: 2927001,
    block_name: 'THOOTHUKUDI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35009',
    district_code: 3511,
    district_name: 'PITHORAGARH',
    block_id: 'B-350070',
    block_code: 3511007,
    block_name: 'PITHORAGARH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290061',
    block_code: 2922004,
    block_name: 'SHANARPATTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320293',
    block_code: 3202031,
    block_name: 'PURBASTHALI ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31381',
    district_code: 3161,
    district_name: 'VARANASI',
    block_id: 'B-313884',
    block_code: 3161029,
    block_name: 'SEVAPURI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20395',
    block_code: 214005,
    block_name: 'JIYYAMMAVALASA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313205',
    block_code: 3146015,
    block_name: 'HUZOORPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170244',
    block_code: 1710005,
    block_name: 'SHAHGARH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180261',
    block_code: 1803006,
    block_name: 'PEN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36032',
    district_code: 3629,
    district_name: 'WARANGAL',
    block_id: 'B-360521',
    block_code: 3629008,
    block_name: 'NALLA BELLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20225',
    block_code: 207001,
    block_name: 'THULLUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3005',
    district_code: 322,
    district_name: 'KAMLE',
    block_id: 'B-30126',
    block_code: 322011,
    block_name: 'GEPEN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50496',
    block_code: 510008,
    block_name: 'GUTHANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313220',
    block_code: 3159021,
    block_name: 'CHILKAHAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5034',
    district_code: 543,
    district_name: 'SHEOHAR',
    block_id: 'B-50469',
    block_code: 543003,
    block_name: 'PURNAHIYA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20524',
    block_code: 225014,
    block_name: 'KANAGANAPALLE',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4034',
    district_code: 427,
    district_name: 'UDALGURI',
    block_id: 'B-40214',
    block_code: 427004,
    block_name: 'ROWTA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320081',
    block_code: 3203014,
    block_name: 'DUBRAJPUR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130070',
    block_code: 1309009,
    block_name: 'ROHRU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110181',
    block_code: 1120002,
    block_name: 'RADHANPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50366',
    block_code: 513023,
    block_name: 'NARKATIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31346',
    district_code: 3168,
    district_name: 'KANNAUJ',
    block_id: 'B-313507',
    block_code: 3168004,
    block_name: 'KANNAUJ',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32003',
    district_code: 3220,
    district_name: 'ALIPURUDUAR',
    block_id: 'B-320057',
    block_code: 3220009,
    block_name: 'MADARIHAT-BIRPARA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18031',
    district_code: 1805,
    district_name: 'SINDHUDURG',
    block_id: 'B-180304',
    block_code: 1805004,
    block_name: 'VAIBHAVVADI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240225',
    block_code: 2404055,
    block_name: 'KULIANA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29010',
    district_code: 2928,
    district_name: 'KANNIYAKUMARI',
    block_id: 'B-290098',
    block_code: 2928003,
    block_name: 'RAJAKKAMANGALAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320193',
    block_code: 3209002,
    block_name: 'HARISHCHANDRAPUR TWO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140039',
    block_code: 1402027,
    block_name: 'NARWAH',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110057',
    block_code: 1116011,
    block_name: 'VALIA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20491',
    block_code: 201020,
    block_name: 'KOTABOMMILI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290386',
    block_code: 2924010,
    block_name: 'VEMBAKOTTAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31319',
    district_code: 3165,
    district_name: 'BAGHPAT',
    block_id: 'B-313196',
    block_code: 3165011,
    block_name: 'BAGHPAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313786',
    block_code: 3127021,
    block_name: 'KHUDAGANJ KATRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20298',
    block_code: 213024,
    block_name: 'CHIPPAGIRI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290172',
    block_code: 2919005,
    block_name: 'PUDUKKOTTAI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15016',
    district_code: 1517,
    district_name: 'HAVERI',
    block_id: 'B-150109',
    block_code: 1517001,
    block_name: 'BYADGI',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210017',
    block_code: 2102007,
    block_name: 'SHELLA BHOLAGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150154',
    block_code: 1522002,
    block_name: 'HUNSUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140056',
    block_code: 1404007,
    block_name: 'B.K.PORA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130033',
    block_code: 1304015,
    block_name: 'SULAH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320320',
    block_code: 3211013,
    block_name: 'SUTAHATA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50315',
    block_code: 512006,
    block_name: 'GAUNAHA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26014',
    district_code: 2617,
    district_name: 'MANSA',
    block_id: 'B-260096',
    block_code: 2617002,
    block_name: 'JHUNIR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160092',
    block_code: 1605007,
    block_name: 'NILAMBUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313646',
    block_code: 3162004,
    block_name: 'CITY NAGAR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350020',
    block_code: 3504001,
    block_name: 'KARNAPRAYAG',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32007',
    district_code: 3219,
    district_name: 'DARJEELING GTA ',
    block_id: 'B-320114',
    block_code: 3219007,
    block_name: 'MIRIK',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35009',
    district_code: 3511,
    district_name: 'PITHORAGARH',
    block_id: 'B-350067',
    block_code: 3511005,
    block_name: 'KANALICHINA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290063',
    block_code: 2922012,
    block_name: 'VADAMADURAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320277',
    block_code: 3202001,
    block_name: 'BURDWAN ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31381',
    district_code: 3161,
    district_name: 'VARANASI',
    block_id: 'B-313877',
    block_code: 3161030,
    block_name: 'ARAJILINE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20397',
    block_code: 214007,
    block_name: 'KURUPAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313206',
    block_code: 3146017,
    block_name: 'JARWAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170241',
    block_code: 1710006,
    block_name: 'RAHATGARH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180265',
    block_code: 1803007,
    block_name: 'SUDHAGAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313399',
    block_code: 3160014,
    block_name: 'ZAMANIA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20221',
    block_code: 207014,
    block_name: 'PRATHIPADU',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3005',
    district_code: 322,
    district_name: 'KAMLE',
    block_id: 'B-30127',
    block_code: 322012,
    block_name: 'KAMPORIJO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50505',
    block_code: 510017,
    block_name: 'SISWAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313227',
    block_code: 3159022,
    block_name: 'NAVANAGAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50307',
    block_code: 508012,
    block_name: 'ROH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20534',
    block_code: 225024,
    block_name: 'PENUKONDA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4034',
    district_code: 427,
    district_name: 'UDALGURI',
    block_id: 'B-40211',
    block_code: 427005,
    block_name: 'KALAIGAON',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320082',
    block_code: 3203015,
    block_name: 'ILLAMBAZAR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130071',
    block_code: 1309010,
    block_name: 'THEOG',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11010',
    district_code: 1119,
    district_name: 'DANG',
    block_id: 'B-110078',
    block_code: 1119003,
    block_name: 'AHWA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4020',
    district_code: 426,
    district_name: 'KAMRUP-METRO',
    block_id: 'B-40128',
    block_code: 426002,
    block_name: 'CHANDRAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31346',
    district_code: 3168,
    district_name: 'KANNAUJ',
    block_id: 'B-313503',
    block_code: 3168005,
    block_name: 'CHHIBRAMAU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32003',
    district_code: 3220,
    district_name: 'ALIPURUDUAR',
    block_id: 'B-320052',
    block_code: 3220011,
    block_name: 'ALIPURDUAR ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313114',
    block_code: 3120010,
    block_name: 'SAIYAN',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240224',
    block_code: 2404057,
    block_name: 'KHUNTA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3016',
    district_code: 312,
    district_name: 'PAPUM PARE',
    block_id: 'B-30067',
    block_code: 312002,
    block_name: 'SAGALEE',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320194',
    block_code: 3209014,
    block_name: 'KALIACHAK ONE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140040',
    block_code: 1402030,
    block_name: 'NOORKHA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11006',
    district_code: 1116,
    district_name: 'BHARUCH',
    block_id: 'B-110055',
    block_code: 1116012,
    block_name: 'NETRANG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20509',
    block_code: 201019,
    block_name: 'TEKKALI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270006',
    block_code: 2721007,
    block_name: 'KISHANGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31319',
    district_code: 3165,
    district_name: 'BAGHPAT',
    block_id: 'B-313198',
    block_code: 3165016,
    block_name: 'BINOLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313789',
    block_code: 3127024,
    block_name: 'MIRZAPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360092',
    block_code: 3606017,
    block_name: 'TEKUMATLA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290164',
    block_code: 2919008,
    block_name: 'ARANTANGI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15016',
    district_code: 1517,
    district_name: 'HAVERI',
    block_id: 'B-150111',
    block_code: 1517003,
    block_name: 'HAVERI',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210016',
    block_code: 2102008,
    block_name: 'PYNURSLA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150155',
    block_code: 1522003,
    block_name: 'KRISHNARAJANAGARA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140062',
    block_code: 1404008,
    block_name: 'NAGAM',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130018',
    block_code: 1304001,
    block_name: 'BAIJNATH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320302',
    block_code: 3211022,
    block_name: 'DESHAPRAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50488',
    block_code: 514017,
    block_name: 'SURSAND',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26014',
    district_code: 2617,
    district_name: 'MANSA',
    block_id: 'B-260094',
    block_code: 2617005,
    block_name: 'BHIKHI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160093',
    block_code: 1605008,
    block_name: 'PERINTHALMANNA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31316',
    district_code: 3169,
    district_name: 'AURAIYA',
    block_id: 'B-313161',
    block_code: 3169001,
    block_name: 'ERWA KATRA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350015',
    block_code: 3504003,
    block_name: 'DASHOLI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32007',
    district_code: 3219,
    district_name: 'DARJEELING GTA ',
    block_id: 'B-320111',
    block_code: 3219001,
    block_name: 'DARJEELING PULBAZAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17053',
    district_code: 1753,
    district_name: 'MAIHAR',
    block_id: 'B-170249',
    block_code: 1753007,
    block_name: 'RAMNAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290054',
    block_code: 2922013,
    block_name: 'GUZILIAMPARAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320292',
    block_code: 3202028,
    block_name: 'MONGALKOTE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31381',
    district_code: 3161,
    district_name: 'VARANASI',
    block_id: 'B-313882',
    block_code: 3161031,
    block_name: 'KASHI VIDYAPEETH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20400',
    block_code: 214010,
    block_name: 'PALAKONDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313208',
    block_code: 3146012,
    block_name: 'MAHASI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170243',
    block_code: 1710008,
    block_name: 'SAGAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180263',
    block_code: 1803008,
    block_name: 'ROHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313388',
    block_code: 3160001,
    block_name: 'JAKHANIA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20220',
    block_code: 207017,
    block_name: 'PONNUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3005',
    district_code: 322,
    district_name: 'KAMLE',
    block_id: 'B-30128',
    block_code: 322013,
    block_name: 'PERSIN DOLLUNGMUKH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50503',
    block_code: 510015,
    block_name: 'PACHRUKHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313228',
    block_code: 3159023,
    block_name: 'PANDAH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5034',
    district_code: 543,
    district_name: 'SHEOHAR',
    block_id: 'B-50470',
    block_code: 543004,
    block_name: 'SHEOHAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20512',
    block_code: 225002,
    block_name: 'AMADAGUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40155',
    block_code: 410004,
    block_name: 'NARAYANPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320093',
    block_code: 3203016,
    block_name: 'RAJNAGAR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130062',
    block_code: 1309003,
    block_name: 'CHOPAL',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110184',
    block_code: 1120008,
    block_name: 'SARASVATI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50223',
    block_code: 522007,
    block_name: 'KISHANGANJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180244',
    block_code: 1810002,
    block_name: 'HAVELI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32003',
    district_code: 3220,
    district_name: 'ALIPURUDUAR',
    block_id: 'B-320053',
    block_code: 3220012,
    block_name: 'ALIPURDUAR TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18031',
    district_code: 1805,
    district_name: 'SINDHUDURG',
    block_id: 'B-180300',
    block_code: 1805005,
    block_name: 'KANKAVLI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240227',
    block_code: 2404058,
    block_name: 'MORADA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3016',
    district_code: 312,
    district_name: 'PAPUM PARE',
    block_id: 'B-30066',
    block_code: 312003,
    block_name: 'MENGIO',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320195',
    block_code: 3209016,
    block_name: 'KALIACHAK THREE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14006',
    district_code: 1420,
    district_name: 'GANDERBAL',
    block_id: 'B-140094',
    block_code: 1420007,
    block_name: 'SHERPATHRI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11033',
    district_code: 1118,
    district_name: 'VALSAD',
    block_id: 'B-110248',
    block_code: 1118010,
    block_name: 'VAPI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20506',
    block_code: 201009,
    block_name: 'SARUBUJJILI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270004',
    block_code: 2721003,
    block_name: 'JAWAJA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31319',
    district_code: 3165,
    district_name: 'BAGHPAT',
    block_id: 'B-313197',
    block_code: 3165013,
    block_name: 'BAROUT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313790',
    block_code: 3127027,
    block_name: 'NIGOHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360091',
    block_code: 3606015,
    block_name: 'REGONDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290170',
    block_code: 2919012,
    block_name: 'MANAMELKUDI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15016',
    district_code: 1517,
    district_name: 'HAVERI',
    block_id: 'B-150112',
    block_code: 1517004,
    block_name: 'HIREKERUR',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210014',
    block_code: 2102009,
    block_name: 'MAWSYNRAM',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150058',
    block_code: 1509001,
    block_name: 'CHICKMAGALUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140063',
    block_code: 1404002,
    block_name: 'NARBAL',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130023',
    block_code: 1304005,
    block_name: 'FATEHPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320308',
    block_code: 3211007,
    block_name: 'KOLAGHAT',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50320',
    block_code: 512011,
    block_name: 'MAJHAULIA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26014',
    district_code: 2617,
    district_name: 'MANSA',
    block_id: 'B-260095',
    block_code: 2617001,
    block_name: 'BUDHLADA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160095',
    block_code: 1605010,
    block_name: 'PONNANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31316',
    district_code: 3169,
    district_name: 'AURAIYA',
    block_id: 'B-313156',
    block_code: 3169003,
    block_name: 'ACHCHALDA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350018',
    block_code: 3504004,
    block_name: 'GHAT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32007',
    district_code: 3219,
    district_name: 'DARJEELING GTA ',
    block_id: 'B-320112',
    block_code: 3219003,
    block_name: 'JOREBUNGLOW SUKHIA POKHARI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17053',
    district_code: 1753,
    district_name: 'MAIHAR',
    block_id: 'B-170245',
    block_code: 1753006,
    block_name: 'AMARPATAN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290053',
    block_code: 2922001,
    block_name: 'DINDIGUL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320169',
    block_code: 3207005,
    block_name: 'MAL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270077',
    block_code: 2707007,
    block_name: 'SEWER',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20393',
    block_code: 214003,
    block_name: 'GARUGUBILLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313207',
    block_code: 3146016,
    block_name: 'KAISARGANJ',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170242',
    block_code: 1710009,
    block_name: 'REHLI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180257',
    block_code: 1803009,
    block_name: 'MANGAON',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313386',
    block_code: 3160005,
    block_name: 'DEVKALI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20213',
    block_code: 207016,
    block_name: 'KAKUMANU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313556',
    block_code: 3128002,
    block_name: 'NIGHASAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50507',
    block_code: 510019,
    block_name: 'ZIRADEI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313224',
    block_code: 3159024,
    block_name: 'MANIAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50255',
    block_code: 526005,
    block_name: 'KHARAGPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20538',
    block_code: 225028,
    block_name: 'ROLLA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4034',
    district_code: 427,
    district_name: 'UDALGURI',
    block_id: 'B-40213',
    block_code: 427003,
    block_name: 'MAZBAT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320083',
    block_code: 3203019,
    block_name: 'KHOYRASOL',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130065',
    block_code: 1309011,
    block_name: 'KUPVI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11010',
    district_code: 1119,
    district_name: 'DANG',
    block_id: 'B-110079',
    block_code: 1119004,
    block_name: 'SUBIR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50229',
    block_code: 522013,
    block_name: 'SINGHESHWAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180247',
    block_code: 1810003,
    block_name: 'KHED',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17042',
    district_code: 1737,
    district_name: 'SEONI',
    block_id: 'B-170264',
    block_code: 1737001,
    block_name: 'LAKHNADON',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320107',
    block_code: 3208007,
    block_name: 'SITAI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240228',
    block_code: 2404060,
    block_name: 'RAIRANGPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3016',
    district_code: 312,
    district_name: 'PAPUM PARE',
    block_id: 'B-30062',
    block_code: 312004,
    block_name: 'BALIJAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320188',
    block_code: 3209004,
    block_name: 'CHANCHAL TWO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14006',
    district_code: 1420,
    district_name: 'GANDERBAL',
    block_id: 'B-140093',
    block_code: 1420006,
    block_name: 'SAFAPORA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150180',
    block_code: 1525001,
    block_name: 'CHIKNAYAKANHALLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20482',
    block_code: 201006,
    block_name: 'BURJA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270005',
    block_code: 2721004,
    block_name: 'KEKRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31319',
    district_code: 3165,
    district_name: 'BAGHPAT',
    block_id: 'B-313199',
    block_code: 3165015,
    block_name: 'CHHPAROLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313792',
    block_code: 3127028,
    block_name: 'SINDHAULI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360082',
    block_code: 3606001,
    block_name: 'BHUPALPALLE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313254',
    block_code: 3148003,
    block_name: 'SURATGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15016',
    district_code: 1517,
    district_name: 'HAVERI',
    block_id: 'B-150115',
    block_code: 1517006,
    block_name: 'SAVANUR',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210010',
    block_code: 2102011,
    block_name: 'MAWLAI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150157',
    block_code: 1522005,
    block_name: 'NANJANGUD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140061',
    block_code: 1404005,
    block_name: 'KHAN-SAHIB',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130024',
    block_code: 1304006,
    block_name: 'INDORA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320319',
    block_code: 3211008,
    block_name: 'SHAHID MATANGINI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50318',
    block_code: 512009,
    block_name: 'MADHUBANI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26014',
    district_code: 2617,
    district_name: 'MANSA',
    block_id: 'B-260097',
    block_code: 2617003,
    block_name: 'MANSA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160087',
    block_code: 1605002,
    block_name: 'KALIKAVU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313654',
    block_code: 3162008,
    block_name: 'PATEHRA KALA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350021',
    block_code: 3504005,
    block_name: 'NARAYANBAGAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32007',
    district_code: 3219,
    district_name: 'DARJEELING GTA ',
    block_id: 'B-320115',
    block_code: 3219008,
    block_name: 'RANGLI RANGLIOT',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17053',
    district_code: 1753,
    district_name: 'MAIHAR',
    block_id: 'B-170246',
    block_code: 1753008,
    block_name: 'MAIHAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290057',
    block_code: 2922006,
    block_name: 'NILAKOTTAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320279',
    block_code: 3202012,
    block_name: 'GALSI ONE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270078',
    block_code: 2707012,
    block_name: 'UCHAIN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20404',
    block_code: 214014,
    block_name: 'SEETHANAGARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31353',
    district_code: 3140,
    district_name: 'LALITPUR',
    block_id: 'B-313576',
    block_code: 3140004,
    block_name: 'BIRDHA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170236',
    block_code: 1710010,
    block_name: 'DEORI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180256',
    block_code: 1803010,
    block_name: 'MAHAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313398',
    block_code: 3160006,
    block_name: 'VIRNO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20222',
    block_code: 207002,
    block_name: 'TADEPALLE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313549',
    block_code: 3128014,
    block_name: 'DHAUREHRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50495',
    block_code: 510007,
    block_name: 'GORIAKOTHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313219',
    block_code: 3159025,
    block_name: 'BERUARBARI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50304',
    block_code: 508009,
    block_name: 'NAWADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20536',
    block_code: 225026,
    block_name: 'RAMAGIRI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40151',
    block_code: 410005,
    block_name: 'DHAKUAKHANA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320088',
    block_code: 3203003,
    block_name: 'MURARAI ONE',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130064',
    block_code: 1309013,
    block_name: 'KOTKHAI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11010',
    district_code: 1119,
    district_name: 'DANG',
    block_id: 'B-110080',
    block_code: 1119005,
    block_name: 'VAGHAI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50224',
    block_code: 522008,
    block_name: 'KUMARKHAND',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180240',
    block_code: 1810004,
    block_name: 'AMBEGAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17042',
    district_code: 1737,
    district_name: 'SEONI',
    block_id: 'B-170259',
    block_code: 1737002,
    block_name: 'CHHAPARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320103',
    block_code: 3208008,
    block_name: 'HALDIBARI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240230',
    block_code: 2404062,
    block_name: 'RASGOVINDPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3016',
    district_code: 312,
    district_name: 'PAPUM PARE',
    block_id: 'B-30065',
    block_code: 312001,
    block_name: 'KIMIN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320186',
    block_code: 3209010,
    block_name: 'BAMONGOLA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14006',
    district_code: 1420,
    district_name: 'GANDERBAL',
    block_id: 'B-140090',
    block_code: 1420005,
    block_name: 'GUND',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150181',
    block_code: 1525002,
    block_name: 'GUBBI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20492',
    block_code: 201007,
    block_name: 'KOTTURU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270011',
    block_code: 2721008,
    block_name: 'SRINAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31319',
    district_code: 3165,
    district_name: 'BAGHPAT',
    block_id: 'B-313200',
    block_code: 3165019,
    block_name: 'KHEKARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313149',
    block_code: 3181012,
    block_name: 'TILOI 1',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360090',
    block_code: 3606014,
    block_name: 'PALIMELA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313244',
    block_code: 3148005,
    block_name: 'DEWA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15016',
    district_code: 1517,
    district_name: 'HAVERI',
    block_id: 'B-150116',
    block_code: 1517007,
    block_name: 'SHIGGAON',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210011',
    block_code: 2102010,
    block_name: 'MAWPAT',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150156',
    block_code: 1522004,
    block_name: 'MYSORE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140060',
    block_code: 1404004,
    block_name: 'KHAG',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130025',
    block_code: 1304007,
    block_name: 'KANGRA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320310',
    block_code: 3211010,
    block_name: 'MOYNA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50321',
    block_code: 512012,
    block_name: 'NARKATIAGANJ',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26014',
    district_code: 2617,
    district_name: 'MANSA',
    block_id: 'B-260098',
    block_code: 2617004,
    block_name: 'SARDULGARH',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160088',
    block_code: 1605003,
    block_name: 'KONDOTTY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31361',
    district_code: 3162,
    district_name: 'MIRZAPUR',
    block_id: 'B-313648',
    block_code: 3162012,
    block_name: 'JAMALPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350016',
    block_code: 3504008,
    block_name: 'DEWAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32007',
    district_code: 3219,
    district_name: 'DARJEELING GTA ',
    block_id: 'B-320113',
    block_code: 3219006,
    block_name: 'KURSEONG',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290051',
    block_code: 2922002,
    block_name: 'ATHOOR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290059',
    block_code: 2922008,
    block_name: 'PALANI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320280',
    block_code: 3202011,
    block_name: 'GALSI TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180063',
    block_code: 1822001,
    block_name: 'BULDANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20405',
    block_code: 214015,
    block_name: 'VEERAGHATTAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31353',
    district_code: 3140,
    district_name: 'LALITPUR',
    block_id: 'B-313579',
    block_code: 3140005,
    block_name: 'MEHRAUNI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17039',
    district_code: 1710,
    district_name: 'SAGAR',
    block_id: 'B-170238',
    block_code: 1710011,
    block_name: 'KESLI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180262',
    block_code: 1803011,
    block_name: 'POLADPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313392',
    block_code: 3160007,
    block_name: 'MARDAH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20218',
    block_code: 207015,
    block_name: 'PEDANANDIPADU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313546',
    block_code: 3128006,
    block_name: 'BANKEYGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50506',
    block_code: 510018,
    block_name: 'SIWAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313217',
    block_code: 3159026,
    block_name: 'BANSDIH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50296',
    block_code: 508001,
    block_name: 'AKBARPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20540',
    block_code: 225030,
    block_name: 'TADIMARRI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4034',
    district_code: 427,
    district_name: 'UDALGURI',
    block_id: 'B-40215',
    block_code: 427001,
    block_name: 'UDALGURI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320089',
    block_code: 3203004,
    block_name: 'MURARAI TWO',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13009',
    district_code: 1309,
    district_name: 'SHIMLA',
    block_id: 'B-130072',
    block_code: 1309012,
    block_name: 'TUTU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11004',
    district_code: 1127,
    district_name: 'ARAVALLI',
    block_id: 'B-110029',
    block_code: 1127010,
    block_name: 'BAYAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50218',
    block_code: 522002,
    block_name: 'BIHARIGANJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180246',
    block_code: 1810005,
    block_name: 'JUNNAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17042',
    district_code: 1737,
    district_name: 'SEONI',
    block_id: 'B-170262',
    block_code: 1737005,
    block_name: 'KEOLARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320106',
    block_code: 3208009,
    block_name: 'MEKLIGANJ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240234',
    block_code: 2404065,
    block_name: 'SULIAPADA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3016',
    district_code: 312,
    district_name: 'PAPUM PARE',
    block_id: 'B-30063',
    block_code: 312006,
    block_name: 'BORUM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320191',
    block_code: 3209011,
    block_name: 'HABIBPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140038',
    block_code: 1402038,
    block_name: 'NADIHAL',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150182',
    block_code: 1525003,
    block_name: 'KORATAGERE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20486',
    block_code: 201008,
    block_name: 'HIRAMANDALAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270002',
    block_code: 2721001,
    block_name: 'ARAI',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1003',
    district_code: 101,
    district_name: 'SOUTH ANDAMAN',
    block_id: 'B-10009',
    block_code: 101001,
    block_name: 'PROTHRAPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16003',
    district_code: 1609,
    district_name: 'IDUKKI',
    block_id: 'B-160027',
    block_code: 1609001,
    block_name: 'ADIMALI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360083',
    block_code: 3606002,
    block_name: 'CHITYAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313242',
    block_code: 3148006,
    block_name: 'BANKI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360074',
    block_code: 3605006,
    block_name: 'JANGAON',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21004',
    district_code: 2102,
    district_name: 'EAST KHASI HILLS',
    block_id: 'B-210018',
    block_code: 2102012,
    block_name: 'SOHIONG',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150160',
    block_code: 1522008,
    block_name: 'SARAGURU',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140057',
    block_code: 1404001,
    block_name: 'BUDGAM',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130027',
    block_code: 1304009,
    block_name: 'NAGROTA BAGWAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320309',
    block_code: 3211011,
    block_name: 'MAHISHADAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50324',
    block_code: 512015,
    block_name: 'RAMNAGAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11003',
    district_code: 1122,
    district_name: 'ANAND',
    block_id: 'B-110028',
    block_code: 1122001,
    block_name: 'UMRETH',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160089',
    block_code: 1605004,
    block_name: 'KUTTIPPURAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320156',
    block_code: 3205001,
    block_name: 'DOMJUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350019',
    block_code: 3504002,
    block_name: 'JOSHIMATH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24004',
    district_code: 2417,
    district_name: 'BHADRAK',
    block_id: 'B-240034',
    block_code: 2417001,
    block_name: 'BHADRAK',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270345',
    block_code: 2726004,
    block_name: 'MAVLI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290356',
    block_code: 2915004,
    block_name: 'THIRUVARUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320274',
    block_code: 3202009,
    block_name: 'AUSGRAM ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180071',
    block_code: 1822002,
    block_name: 'MOTALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20394',
    block_code: 214004,
    block_name: 'GUMMALAKSHMIPURAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31353',
    district_code: 3140,
    district_name: 'LALITPUR',
    block_id: 'B-313578',
    block_code: 3140006,
    block_name: 'MADAWARA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50331',
    block_code: 501004,
    block_name: 'BELCHHI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180259',
    block_code: 1803014,
    block_name: 'MURUD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313387',
    block_code: 3160008,
    block_name: 'GHAZIPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11011',
    district_code: 1128,
    district_name: 'DEVBHUMI DWARKA',
    block_id: 'B-110082',
    block_code: 1128005,
    block_name: 'KALYANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313558',
    block_code: 3128009,
    block_name: 'PASGAWAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50489',
    block_code: 510001,
    block_name: 'ANDAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313230',
    block_code: 3159027,
    block_name: 'REOTI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50251',
    block_code: 526001,
    block_name: 'ASARGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20537',
    block_code: 225027,
    block_name: 'RODDAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40152',
    block_code: 410009,
    block_name: 'GHILAMARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320090',
    block_code: 3203001,
    block_name: 'NALHATI ONE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340179',
    block_code: 3405004,
    block_name: 'LESLIGANJ',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11004',
    district_code: 1127,
    district_name: 'ARAVALLI',
    block_id: 'B-110031',
    block_code: 1127013,
    block_name: 'DHANSURA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50226',
    block_code: 522010,
    block_name: 'MURLIGANJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180251',
    block_code: 1810006,
    block_name: 'SHIRUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17042',
    district_code: 1737,
    district_name: 'SEONI',
    block_id: 'B-170265',
    block_code: 1737006,
    block_name: 'SEONI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320108',
    block_code: 3208012,
    block_name: 'SITALKUCHI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240236',
    block_code: 2404067,
    block_name: 'TIRING',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3016',
    district_code: 312,
    district_name: 'PAPUM PARE',
    block_id: 'B-30064',
    block_code: 312005,
    block_name: 'DOIMUKH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320189',
    block_code: 3209012,
    block_name: 'ENGLISH BAZAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140037',
    block_code: 1402037,
    block_name: 'LALPORA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150183',
    block_code: 1525004,
    block_name: 'KUNIGAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20497',
    block_code: 201022,
    block_name: 'NANDIGAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270010',
    block_code: 2721010,
    block_name: 'SAWAR',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1003',
    district_code: 101,
    district_name: 'SOUTH ANDAMAN',
    block_id: 'B-10008',
    block_code: 101003,
    block_name: 'LITTLE ANDAMAN',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16003',
    district_code: 1609,
    district_name: 'IDUKKI',
    block_id: 'B-160030',
    block_code: 1609004,
    block_name: 'ELAMDESAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360084',
    block_code: 3606004,
    block_name: 'GHANPUR  MULUG ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313247',
    block_code: 3148007,
    block_name: 'HARAKH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360076',
    block_code: 3605008,
    block_name: 'LINGALAGHANPUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33016',
    district_code: 3302,
    district_name: 'KAWARDHA',
    block_id: 'B-330076',
    block_code: 3302001,
    block_name: 'KAWARDHA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150161',
    block_code: 1522007,
    block_name: 'TIRUMAKUDAL NARSIPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140065',
    block_code: 1404021,
    block_name: 'PARNEWA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130029',
    block_code: 1304011,
    block_name: 'NURPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320300',
    block_code: 3211023,
    block_name: 'CONTAI ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50487',
    block_code: 514016,
    block_name: 'SUPPI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11003',
    district_code: 1122,
    district_name: 'ANAND',
    block_id: 'B-110021',
    block_code: 1122002,
    block_name: 'ANAND',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160090',
    block_code: 1605005,
    block_name: 'MALAPPURAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320157',
    block_code: 3205002,
    block_name: 'JAGATBALLAVPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350017',
    block_code: 3504006,
    block_name: 'GAIRSAIN',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24004',
    district_code: 2417,
    district_name: 'BHADRAK',
    block_id: 'B-240035',
    block_code: 2417003,
    block_name: 'BHANDARIPOKHARI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270344',
    block_code: 2726006,
    block_name: 'LASADIYA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290351',
    block_code: 2915006,
    block_name: 'MANNARGUDI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320278',
    block_code: 3202034,
    block_name: 'BURDWAN TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180069',
    block_code: 1822003,
    block_name: 'MALKAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20392',
    block_code: 214002,
    block_name: 'BHAMINI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313204',
    block_code: 3146014,
    block_name: 'FAKHARPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50347',
    block_code: 501020,
    block_name: 'PATNA RURAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180266',
    block_code: 1803015,
    block_name: 'TALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313389',
    block_code: 3160009,
    block_name: 'KARANDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20224',
    block_code: 207011,
    block_name: 'TENALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313547',
    block_code: 3128010,
    block_name: 'BEHJAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4017',
    district_code: 431,
    district_name: 'HOJAI',
    block_id: 'B-40104',
    block_code: 431093,
    block_name: 'DHALPUKHURI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313222',
    block_code: 3159028,
    block_name: 'GARWAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50299',
    block_code: 508004,
    block_name: 'KASHI CHAK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20531',
    block_code: 225021,
    block_name: 'NAMBULAPULIKUNTA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15008',
    district_code: 1528,
    district_name: 'CHIKKABALLAPURA',
    block_id: 'B-150051',
    block_code: 1528001,
    block_name: 'BAGEPALLI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320091',
    block_code: 3203002,
    block_name: 'NALHATI TWO',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340174',
    block_code: 3405002,
    block_name: 'CHAINPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11004',
    district_code: 1127,
    district_name: 'ARAVALLI',
    block_id: 'B-110032',
    block_code: 1127009,
    block_name: 'MALPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50222',
    block_code: 522006,
    block_name: 'GWALPARA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180243',
    block_code: 1810007,
    block_name: 'DAUND',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17042',
    district_code: 1737,
    district_name: 'SEONI',
    block_id: 'B-170263',
    block_code: 1737007,
    block_name: 'KURAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320101',
    block_code: 3208005,
    block_name: 'DINHATA ONE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240235',
    block_code: 2404068,
    block_name: 'THAKURMUNDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313671',
    block_code: 3114007,
    block_name: 'MUZAFFARNAGAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17035',
    district_code: 1730,
    district_name: 'RAISEN',
    block_id: 'B-170208',
    block_code: 1730002,
    block_name: 'GAIRATGANJ',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4013',
    district_code: 420,
    district_name: 'DIMA HASAO NORTH CACHAR HILLS ',
    block_id: 'B-40077',
    block_code: 420002,
    block_name: 'DIYUNGBRA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150184',
    block_code: 1525005,
    block_name: 'MADHUGIRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20504',
    block_code: 201021,
    block_name: 'SANTHABOMMALI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270009',
    block_code: 2721009,
    block_name: 'SARWAD',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1003',
    district_code: 101,
    district_name: 'SOUTH ANDAMAN',
    block_id: 'B-10007',
    block_code: 101002,
    block_name: 'FERRARGUNJ',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16003',
    district_code: 1609,
    district_name: 'IDUKKI',
    block_id: 'B-160033',
    block_code: 1609007,
    block_name: 'NEDUMKANDAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360085',
    block_code: 3606007,
    block_name: 'KATARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313248',
    block_code: 3148008,
    block_name: 'MASAULI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360077',
    block_code: 3605009,
    block_name: 'NARMETTA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33016',
    district_code: 3302,
    district_name: 'KAWARDHA',
    block_id: 'B-330075',
    block_code: 3302002,
    block_name: 'BODLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360332',
    block_code: 3619013,
    block_name: 'NARSAPUR G',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140066',
    block_code: 1404022,
    block_name: 'RATSUN',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130026',
    block_code: 1304008,
    block_name: 'LAMBAGRAON',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320301',
    block_code: 3211024,
    block_name: 'CONTAI THREE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50479',
    block_code: 514008,
    block_name: 'MAJORGANJ',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11003',
    district_code: 1122,
    district_name: 'ANAND',
    block_id: 'B-110025',
    block_code: 1122003,
    block_name: 'PETLAD',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160091',
    block_code: 1605006,
    block_name: 'MANKADA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32011',
    district_code: 3205,
    district_name: 'HOWRAH',
    block_id: 'B-320155',
    block_code: 3205003,
    block_name: 'BALLY-JAGACHA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350023',
    block_code: 3504007,
    block_name: 'THARALI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24004',
    district_code: 2417,
    district_name: 'BHADRAK',
    block_id: 'B-240033',
    block_code: 2417004,
    block_name: 'BASUDEVPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270337',
    block_code: 2726003,
    block_name: 'GOGUNDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29015',
    district_code: 2914,
    district_name: 'NAGAPATTINAM',
    block_id: 'B-290138',
    block_code: 2914002,
    block_name: 'KEELAIYUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320295',
    block_code: 3202005,
    block_name: 'RAINA ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180072',
    block_code: 1822004,
    block_name: 'NANDURA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2017',
    district_code: 214,
    district_name: 'PARVATHIPURAM MANYAM',
    block_id: 'B-20403',
    block_code: 214013,
    block_name: 'SEETHAMPETA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31325',
    district_code: 3153,
    district_name: 'BASTI',
    block_id: 'B-313274',
    block_code: 3153014,
    block_name: 'DUBAULIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50341',
    block_code: 501014,
    block_name: 'MANER',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180264',
    block_code: 1803013,
    block_name: 'SHRIWARDHAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313390',
    block_code: 3160010,
    block_name: 'KASIMABAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11011',
    district_code: 1128,
    district_name: 'DEVBHUMI DWARKA',
    block_id: 'B-110081',
    block_code: 1128004,
    block_name: 'BHANVAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313559',
    block_code: 3128012,
    block_name: 'PHOOLBEHAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4017',
    district_code: 431,
    district_name: 'HOJAI',
    block_id: 'B-40105',
    block_code: 431008,
    block_name: 'JUGIJAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313232',
    block_code: 3159029,
    block_name: 'SOHANV',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50259',
    block_code: 526009,
    block_name: 'TETIHA BAMBOR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20518',
    block_code: 225008,
    block_name: 'DHARMAVARAM',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15008',
    district_code: 1528,
    district_name: 'CHIKKABALLAPURA',
    block_id: 'B-150053',
    block_code: 1528003,
    block_name: 'CHINTAMANI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320097',
    block_code: 3203017,
    block_name: 'SURI ONE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340191',
    block_code: 3405003,
    block_name: 'SATBARWA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11004',
    district_code: 1127,
    district_name: 'ARAVALLI',
    block_id: 'B-110033',
    block_code: 1127007,
    block_name: 'MEGHRAJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50225',
    block_code: 522009,
    block_name: 'MADHEPURA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180245',
    block_code: 1810008,
    block_name: 'INDAPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17042',
    district_code: 1737,
    district_name: 'SEONI',
    block_id: 'B-170258',
    block_code: 1737008,
    block_name: 'BARGHAT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320102',
    block_code: 3208006,
    block_name: 'DINHATA TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240237',
    block_code: 2404069,
    block_name: 'UDALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313666',
    block_code: 3114010,
    block_name: 'BUDHANA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17035',
    district_code: 1730,
    district_name: 'RAISEN',
    block_id: 'B-170206',
    block_code: 1730005,
    block_name: 'BADI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4013',
    district_code: 420,
    district_name: 'DIMA HASAO NORTH CACHAR HILLS ',
    block_id: 'B-40080',
    block_code: 420003,
    block_name: 'JATINGA VALLEY',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150185',
    block_code: 1525006,
    block_name: 'PAVAGADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20510',
    block_code: 201023,
    block_name: 'VAJRAPUKOTTURU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31349',
    district_code: 3180,
    district_name: 'KASGANJ',
    block_id: 'B-313537',
    block_code: 3180001,
    block_name: 'SORON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17049',
    district_code: 1707,
    district_name: 'TIKAMGARH',
    block_id: 'B-170296',
    block_code: 1707004,
    block_name: 'PALERA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313140',
    block_code: 3181009,
    block_name: 'BHETUA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360086',
    block_code: 3606008,
    block_name: 'MAHADEVPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313255',
    block_code: 3148010,
    block_name: 'TRIVEDIGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360078',
    block_code: 3605010,
    block_name: 'PALAKURTHI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33016',
    district_code: 3302,
    district_name: 'KAWARDHA',
    block_id: 'B-330077',
    block_code: 3302004,
    block_name: 'PANDARIYA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360334',
    block_code: 3619016,
    block_name: 'PEMBI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140067',
    block_code: 1404023,
    block_name: 'S K PORA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130093',
    block_code: 1304021,
    block_name: 'PALAMPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320303',
    block_code: 3211027,
    block_name: 'EGRA ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50316',
    block_code: 512007,
    block_name: 'JOGAPATTI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11003',
    district_code: 1122,
    district_name: 'ANAND',
    block_id: 'B-110026',
    block_code: 1122004,
    block_name: 'SOJITRA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160098',
    block_code: 1605012,
    block_name: 'TIRUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35003',
    district_code: 3504,
    district_name: 'CHAMOLI',
    block_id: 'B-350022',
    block_code: 3504009,
    block_name: 'POKHARI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24004',
    district_code: 2417,
    district_name: 'BHADRAK',
    block_id: 'B-240037',
    block_code: 2417005,
    block_name: 'CHANDABALI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270349',
    block_code: 2726008,
    block_name: 'SALUMBAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29015',
    district_code: 2914,
    district_name: 'NAGAPATTINAM',
    block_id: 'B-290142',
    block_code: 2914004,
    block_name: 'THIRUMARUGAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320287',
    block_code: 3202027,
    block_name: 'KETUGRAM TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180073',
    block_code: 1822006,
    block_name: 'SANGRAMPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11024',
    district_code: 1114,
    district_name: 'PANCH MAHALS',
    block_id: 'B-110172',
    block_code: 1114001,
    block_name: 'GODHRA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180191',
    block_code: 1819012,
    block_name: 'NAIGAONKH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50350',
    block_code: 501023,
    block_name: 'SAMPATCHAK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18027',
    district_code: 1803,
    district_name: 'RAIGAD',
    block_id: 'B-180258',
    block_code: 1803012,
    block_name: 'MHASLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313393',
    block_code: 3160012,
    block_name: 'MOHAMMADABAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11011',
    district_code: 1128,
    district_name: 'DEVBHUMI DWARKA',
    block_id: 'B-110083',
    block_code: 1128007,
    block_name: 'KHAMBHALIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313555',
    block_code: 3128013,
    block_name: 'NAKAHA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4017',
    district_code: 431,
    district_name: 'HOJAI',
    block_id: 'B-40106',
    block_code: 431099,
    block_name: 'LUMDING',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313223',
    block_code: 3159030,
    block_name: 'HANUMANGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50252',
    block_code: 526002,
    block_name: 'BARIARPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20542',
    block_code: 225032,
    block_name: 'TANAKAL',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15008',
    district_code: 1528,
    district_name: 'CHIKKABALLAPURA',
    block_id: 'B-150054',
    block_code: 1528004,
    block_name: 'GAURIBIDANUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320098',
    block_code: 3203018,
    block_name: 'SURI TWO',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340187',
    block_code: 3405005,
    block_name: 'PANKI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11004',
    district_code: 1127,
    district_name: 'ARAVALLI',
    block_id: 'B-110034',
    block_code: 1127008,
    block_name: 'MODASA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50219',
    block_code: 522003,
    block_name: 'CHAUSA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180241',
    block_code: 1810009,
    block_name: 'BARAMATI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17042',
    district_code: 1737,
    district_name: 'SEONI',
    block_id: 'B-170260',
    block_code: 1737004,
    block_name: 'DHANAURA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320099',
    block_code: 3208001,
    block_name: 'COOCH BEHAR ONE',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4008',
    district_code: 425,
    district_name: 'CHIRANG',
    block_id: 'B-40048',
    block_code: 425006,
    block_name: 'SIDLI-CHIRANG',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313668',
    block_code: 3114013,
    block_name: 'JANSATH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17035',
    district_code: 1730,
    district_name: 'RAISEN',
    block_id: 'B-170211',
    block_code: 1730006,
    block_name: 'SILWANI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4013',
    district_code: 420,
    district_name: 'DIMA HASAO NORTH CACHAR HILLS ',
    block_id: 'B-40079',
    block_code: 420004,
    block_name: 'HARANGAJAO',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15026',
    district_code: 1525,
    district_name: 'TUMAKURU',
    block_id: 'B-150189',
    block_code: 1525010,
    block_name: 'TURUVEKERE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20495',
    block_code: 201025,
    block_name: 'MANDASA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31349',
    district_code: 3180,
    district_name: 'KASGANJ',
    block_id: 'B-313532',
    block_code: 3180005,
    block_name: 'GANJ DUNDWARA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17049',
    district_code: 1707,
    district_name: 'TIKAMGARH',
    block_id: 'B-170295',
    block_code: 1707003,
    block_name: 'JATARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313139',
    block_code: 3181010,
    block_name: 'BHADAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360087',
    block_code: 3606009,
    block_name: 'MALHARRAO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313243',
    block_code: 3148012,
    block_name: 'DARIYABAD',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360079',
    block_code: 3605011,
    block_name: 'RAGHUNATHPALLE',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33016',
    district_code: 3302,
    district_name: 'KAWARDHA',
    block_id: 'B-330078',
    block_code: 3302003,
    block_name: 'S LOHARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360336',
    block_code: 3619018,
    block_name: 'SOAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140068',
    block_code: 1404024,
    block_name: 'SOIBUGH',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13004',
    district_code: 1304,
    district_name: 'KANGRA',
    block_id: 'B-130019',
    block_code: 1304016,
    block_name: 'BAROH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320304',
    block_code: 3211028,
    block_name: 'EGRA TWO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5025',
    district_code: 512,
    district_name: 'PASHCHIM CHAMPARAN',
    block_id: 'B-50314',
    block_code: 512005,
    block_name: 'CHANPATIA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11003',
    district_code: 1122,
    district_name: 'ANAND',
    block_id: 'B-110023',
    block_code: 1122005,
    block_name: 'BORSAD',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160094',
    block_code: 1605009,
    block_name: 'PERUMPADAPPU',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15018',
    district_code: 1518,
    district_name: 'KODAGU',
    block_id: 'B-150128',
    block_code: 1518004,
    block_name: 'KUSHALANAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24004',
    district_code: 2417,
    district_name: 'BHADRAK',
    block_id: 'B-240039',
    block_code: 2417006,
    block_name: 'TIHIDI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270350',
    block_code: 2726009,
    block_name: 'SARADA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290062',
    block_code: 2922010,
    block_name: 'THOPPAMPATTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320286',
    block_code: 3202026,
    block_name: 'KETUGRAM ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180074',
    block_code: 1822007,
    block_name: 'SHEGAON',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11024',
    district_code: 1114,
    district_name: 'PANCH MAHALS',
    block_id: 'B-110175',
    block_code: 1114002,
    block_name: 'KALOL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180190',
    block_code: 1819007,
    block_name: 'MUKHED',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50345',
    block_code: 501018,
    block_name: 'PALIGANJ',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22005',
    district_code: 2205,
    district_name: 'KOLASIB',
    block_id: 'B-220010',
    block_code: 2205001,
    block_name: 'THINGDAWL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313384',
    block_code: 3160016,
    block_name: 'BHADAURA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11011',
    district_code: 1128,
    district_name: 'DEVBHUMI DWARKA',
    block_id: 'B-110084',
    block_code: 1128006,
    block_name: 'OKHAMANDAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313560',
    block_code: 3128003,
    block_name: 'RAMIA BEHAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4017',
    district_code: 431,
    district_name: 'HOJAI',
    block_id: 'B-40107',
    block_code: 431009,
    block_name: 'ODALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313221',
    block_code: 3159031,
    block_name: 'DUBHAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50256',
    block_code: 526006,
    block_name: 'MUNGER',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20541',
    block_code: 225031,
    block_name: 'TALUPULA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20453',
    block_code: 209036,
    block_name: 'GUDLURU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320086',
    block_code: 3203006,
    block_name: 'MAYURESWAR TWO',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340180',
    block_code: 3405006,
    block_name: 'MANATU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11025',
    district_code: 1120,
    district_name: 'PATAN',
    block_id: 'B-110185',
    block_code: 1120009,
    block_name: 'SHANKHESHWAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50217',
    block_code: 522001,
    block_name: 'ALAMNAGAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180242',
    block_code: 1810011,
    block_name: 'BHOR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33025',
    district_code: 3318,
    district_name: 'NARAYANPUR',
    block_id: 'B-330108',
    block_code: 3318003,
    block_name: 'ORCHHA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320110',
    block_code: 3208004,
    block_name: 'TUFANGANJ TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240229',
    block_code: 2404061,
    block_name: 'RARUAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31363',
    district_code: 3114,
    district_name: 'MUZAFFARNAGAR',
    block_id: 'B-313669',
    block_code: 3114014,
    block_name: 'KHATAULI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17035',
    district_code: 1730,
    district_name: 'RAISEN',
    block_id: 'B-170212',
    block_code: 1730007,
    block_name: 'UDAIPURA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4013',
    district_code: 420,
    district_name: 'DIMA HASAO NORTH CACHAR HILLS ',
    block_id: 'B-40078',
    block_code: 420001,
    block_name: 'DIYUNG VALLEY',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29017',
    district_code: 2918,
    district_name: 'PERAMBALUR',
    block_id: 'B-290162',
    block_code: 2918006,
    block_name: 'VEPPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20505',
    block_code: 201016,
    block_name: 'SARAVAKOTA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290387',
    block_code: 2924002,
    block_name: 'VIRUDHUNAGAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17049',
    district_code: 1707,
    district_name: 'TIKAMGARH',
    block_id: 'B-170294',
    block_code: 1707005,
    block_name: 'BALDEOGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313145',
    block_code: 3181011,
    block_name: 'SANGRAMPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360089',
    block_code: 3606013,
    block_name: 'MUTHARAM  MAHADEVPUR ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313241',
    block_code: 3148013,
    block_name: 'BANI KODAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360081',
    block_code: 3605013,
    block_name: 'ZAFFERGADH',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12020',
    district_code: 1216,
    district_name: 'SIRSA',
    block_id: 'B-120126',
    block_code: 1216002,
    block_name: 'ODHAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360325',
    block_code: 3619058,
    block_name: 'KHANAPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140069',
    block_code: 1404018,
    block_name: 'SUKHNAG HARD PANZOO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313173',
    block_code: 3149009,
    block_name: 'TARUN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320306',
    block_code: 3211020,
    block_name: 'KHEJURI ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5035',
    district_code: 514,
    district_name: 'SITAMARHI',
    block_id: 'B-50474',
    block_code: 514003,
    block_name: 'BATHNAHA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11003',
    district_code: 1122,
    district_name: 'ANAND',
    block_id: 'B-110022',
    block_code: 1122006,
    block_name: 'ANKLAV',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160099',
    block_code: 1605014,
    block_name: 'VENGARA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15018',
    district_code: 1518,
    district_name: 'KODAGU',
    block_id: 'B-150130',
    block_code: 1518005,
    block_name: 'PONNAMPET',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24004',
    district_code: 2417,
    district_name: 'BHADRAK',
    block_id: 'B-240038',
    block_code: 2417007,
    block_name: 'DHAMANAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270339',
    block_code: 2726010,
    block_name: 'JHADOL',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3015',
    district_code: 325,
    district_name: 'PAKKE KESANG',
    block_id: 'B-30060',
    block_code: 325004,
    block_name: 'PAKKE-KESSANG',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320294',
    block_code: 3202032,
    block_name: 'PURBASTHALI TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180067',
    block_code: 1822008,
    block_name: 'KHAMGAON',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11024',
    district_code: 1114,
    district_name: 'PANCH MAHALS',
    block_id: 'B-110173',
    block_code: 1114003,
    block_name: 'HALOL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18020',
    district_code: 1819,
    district_name: 'NANDED',
    block_id: 'B-180189',
    block_code: 1819009,
    block_name: 'MUDKHED',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50329',
    block_code: 501002,
    block_name: 'BAKHTIARPUR',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22005',
    district_code: 2205,
    district_name: 'KOLASIB',
    block_id: 'B-220009',
    block_code: 2205002,
    block_name: 'BILKHAWTHLIR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313397',
    block_code: 3160011,
    block_name: 'VARACHAWAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20214',
    block_code: 207010,
    block_name: 'KOLLIPARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313553',
    block_code: 3128008,
    block_name: 'MITAULI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4017',
    district_code: 431,
    district_name: 'HOJAI',
    block_id: 'B-40103',
    block_code: 431094,
    block_name: 'BINNAKANDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313218',
    block_code: 3159032,
    block_name: 'BELHARI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50300',
    block_code: 508005,
    block_name: 'KAWAKOL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20535',
    block_code: 225025,
    block_name: 'PUTTAPARTHI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20480',
    block_code: 209034,
    block_name: 'VOLETIVARI PALEM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320095',
    block_code: 3203008,
    block_name: 'RAMPURHAT TWO',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340188',
    block_code: 3405007,
    block_name: 'PATAN',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10001',
    district_code: 1001,
    district_name: 'NORTH GOA',
    block_id: 'B-100005',
    block_code: 1001001,
    block_name: 'TISWADI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50228',
    block_code: 522012,
    block_name: 'SHANKARPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180252',
    block_code: 1810012,
    block_name: 'VELHE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17042',
    district_code: 1737,
    district_name: 'SEONI',
    block_id: 'B-170261',
    block_code: 1737003,
    block_name: 'KAHNAPAS-GHANSAUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320105',
    block_code: 3208011,
    block_name: 'MATHA BHANGA TWO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50411',
    block_code: 521001,
    block_name: 'BANMA ITAHRI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180128',
    block_code: 1808001,
    block_name: 'JALGAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17004',
    district_code: 1748,
    district_name: 'ASHOK NAGAR',
    block_id: 'B-170017',
    block_code: 1748001,
    block_name: 'ISAGARH',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4013',
    district_code: 420,
    district_name: 'DIMA HASAO NORTH CACHAR HILLS ',
    block_id: 'B-40081',
    block_code: 420005,
    block_name: 'NEW SANGBAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310218',
    block_code: 3124018,
    block_name: 'USAWAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20501',
    block_code: 201013,
    block_name: 'POLAKI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290379',
    block_code: 2924003,
    block_name: 'KARIAPATTI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17049',
    district_code: 1707,
    district_name: 'TIKAMGARH',
    block_id: 'B-170297',
    block_code: 1707006,
    block_name: 'TIKAMGARH',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21011',
    district_code: 2108,
    district_name: 'WEST JAINTIA HILLS',
    block_id: 'B-210042',
    block_code: 2108003,
    block_name: 'AMLAREM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36007',
    district_code: 3606,
    district_name: 'JAYASHANKAR',
    block_id: 'B-360088',
    block_code: 3606011,
    block_name: 'MOGULLAPALLE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31323',
    district_code: 3148,
    district_name: 'BARABANKI',
    block_id: 'B-313250',
    block_code: 3148014,
    block_name: 'PUREDALAI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360070',
    block_code: 3605001,
    block_name: 'BACHANNAPETA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12020',
    district_code: 1216,
    district_name: 'SIRSA',
    block_id: 'B-120122',
    block_code: 1216003,
    block_name: 'BARAGUDHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360330',
    block_code: 3619011,
    block_name: 'MAMDA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140070',
    block_code: 1404025,
    block_name: 'SURASYAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313170',
    block_code: 3149003,
    block_name: 'PURA BAZAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320314',
    block_code: 3211006,
    block_name: 'PANSKURA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29024',
    district_code: 2913,
    district_name: 'THANJAVUR',
    block_id: 'B-290247',
    block_code: 2913007,
    block_name: 'THIRUVIDAIMARUDUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11003',
    district_code: 1122,
    district_name: 'ANAND',
    block_id: 'B-110027',
    block_code: 1122008,
    block_name: 'TARAPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160100',
    block_code: 1605015,
    block_name: 'WANDOOR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15018',
    district_code: 1518,
    district_name: 'KODAGU',
    block_id: 'B-150129',
    block_code: 1518001,
    block_name: 'MADIKERI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5013',
    district_code: 506,
    district_name: 'JEHANABAD',
    block_id: 'B-50163',
    block_code: 506002,
    block_name: 'HULASGANJ',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270353',
    block_code: 2726116,
    block_name: 'VALLABHNAGAR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3015',
    district_code: 325,
    district_name: 'PAKKE KESANG',
    block_id: 'B-30061',
    block_code: 325009,
    block_name: 'SEIJOSA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320282',
    block_code: 3202029,
    block_name: 'KALNA ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180064',
    block_code: 1822009,
    block_name: 'CHIKHLI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11024',
    district_code: 1114,
    district_name: 'PANCH MAHALS',
    block_id: 'B-110177',
    block_code: 1114004,
    block_name: 'SHEHERA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313213',
    block_code: 3146004,
    block_name: 'SHIVPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50332',
    block_code: 501005,
    block_name: 'BIHTA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32008',
    district_code: 3217,
    district_name: 'DINAJPUR DAKSHIN',
    block_id: 'B-320118',
    block_code: 3217005,
    block_name: 'GANGARAMPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313391',
    block_code: 3160002,
    block_name: 'MANIHARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20210',
    block_code: 207012,
    block_name: 'CHEBROLE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313550',
    block_code: 3128015,
    block_name: 'ISANAGAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4002',
    district_code: 424,
    district_name: 'BAKSA',
    block_id: 'B-40006',
    block_code: 424007,
    block_name: 'GOBARDHANA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313216',
    block_code: 3159033,
    block_name: 'BAIRIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50305',
    block_code: 508010,
    block_name: 'PAKRIBARAWAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20522',
    block_code: 225012,
    block_name: 'HINDUPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20472',
    block_code: 209032,
    block_name: 'SYDAPURAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320085',
    block_code: 3203005,
    block_name: 'MAYURESWAR ONE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340175',
    block_code: 3405008,
    block_name: 'CHHATARPUR',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10001',
    district_code: 1001,
    district_name: 'NORTH GOA',
    block_id: 'B-100001',
    block_code: 1001002,
    block_name: 'BARDEZ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50220',
    block_code: 522004,
    block_name: 'GAMHARIA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180249',
    block_code: 1810013,
    block_name: 'MULSHI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33025',
    district_code: 3318,
    district_name: 'NARAYANPUR',
    block_id: 'B-330107',
    block_code: 3318004,
    block_name: 'NARAYANPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320104',
    block_code: 3208010,
    block_name: 'MATHABHANGA ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50417',
    block_code: 521007,
    block_name: 'SATAR KATAIYA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180125',
    block_code: 1808002,
    block_name: 'CHOPDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17004',
    district_code: 1748,
    district_name: 'ASHOK NAGAR',
    block_id: 'B-170016',
    block_code: 1748002,
    block_name: 'CHANDERI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26020',
    district_code: 2610,
    district_name: 'SANGRUR',
    block_id: 'B-260133',
    block_code: 2610007,
    block_name: 'LEHRAGAGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310212',
    block_code: 3124017,
    block_name: 'MION',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20502',
    block_code: 201005,
    block_name: 'PONDURU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290385',
    block_code: 2924004,
    block_name: 'TIRUCHULI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350054',
    block_code: 3505001,
    block_name: 'KOT',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21011',
    district_code: 2108,
    district_name: 'WEST JAINTIA HILLS',
    block_id: 'B-210044',
    block_code: 2108004,
    block_name: 'THADLASKEIN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313857',
    block_code: 3150015,
    block_name: 'KURWAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290171',
    block_code: 2919004,
    block_name: 'PONNAMARAVATHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36006',
    district_code: 3605,
    district_name: 'JANGAON',
    block_id: 'B-360073',
    block_code: 3605004,
    block_name: 'GHANPUR STATION',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12020',
    district_code: 1216,
    district_name: 'SIRSA',
    block_id: 'B-120125',
    block_code: 1216005,
    block_name: 'NATHUSARI CHOPTA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360327',
    block_code: 3619008,
    block_name: 'KUNTALA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14004',
    district_code: 1404,
    district_name: 'BUDGAM',
    block_id: 'B-140071',
    block_code: 1404026,
    block_name: 'WATERHAIL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290304',
    block_code: 2926002,
    block_name: 'MANUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320315',
    block_code: 3211025,
    block_name: 'PATASHPUR ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31372',
    district_code: 3173,
    district_name: 'SANT RAVIDAS NAGAR',
    block_id: 'B-313778',
    block_code: 3173001,
    block_name: 'SURIYAVAN',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11003',
    district_code: 1122,
    district_name: 'ANAND',
    block_id: 'B-110024',
    block_code: 1122007,
    block_name: 'KHAMBHAT',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160086',
    block_code: 1605001,
    block_name: 'AREACODE',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15018',
    district_code: 1518,
    district_name: 'KODAGU',
    block_id: 'B-150131',
    block_code: 1518002,
    block_name: 'SOMVARPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5013',
    district_code: 506,
    district_name: 'JEHANABAD',
    block_id: 'B-50167',
    block_code: 506006,
    block_name: 'MODANGANJ',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27013',
    district_code: 2708,
    district_name: 'DHOLPUR',
    block_id: 'B-270142',
    block_code: 2708006,
    block_name: 'SARMATHURA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27013',
    district_code: 2708,
    district_name: 'DHOLPUR',
    block_id: 'B-270139',
    block_code: 2708003,
    block_name: 'DHOLPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320283',
    block_code: 3202030,
    block_name: 'KALNA TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180070',
    block_code: 1822010,
    block_name: 'MEHKAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11024',
    district_code: 1114,
    district_name: 'PANCH MAHALS',
    block_id: 'B-110174',
    block_code: 1114011,
    block_name: 'JAMBUGHODA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313212',
    block_code: 3146005,
    block_name: 'RISIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50346',
    block_code: 501019,
    block_name: 'PANDARAK',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32008',
    district_code: 3217,
    district_name: 'DINAJPUR DAKSHIN',
    block_id: 'B-320116',
    block_code: 3217001,
    block_name: 'BALURGHAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313385',
    block_code: 3160013,
    block_name: 'BHANWARKOL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20226',
    block_code: 207013,
    block_name: 'VATTICHERUKURU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18002',
    district_code: 1823,
    district_name: 'AKOLA',
    block_id: 'B-180015',
    block_code: 1823001,
    block_name: 'AKOLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50504',
    block_code: 510016,
    block_name: 'RAGHUNATHPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31321',
    district_code: 3159,
    district_name: 'BALLIA',
    block_id: 'B-313225',
    block_code: 3159034,
    block_name: 'MURLICHHAPRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5034',
    district_code: 543,
    district_name: 'SHEOHAR',
    block_id: 'B-50467',
    block_code: 543001,
    block_name: 'DUMRI KATSARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20516',
    block_code: 225006,
    block_name: 'CHENNEKOTHAPALLE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20475',
    block_code: 209037,
    block_name: 'ULAVAPADU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32005',
    district_code: 3203,
    district_name: 'BIRBHUM',
    block_id: 'B-320094',
    block_code: 3203007,
    block_name: 'RAMPURHAT ONE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340177',
    block_code: 3405009,
    block_name: 'HARIHARGANJ',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10001',
    district_code: 1001,
    district_name: 'NORTH GOA',
    block_id: 'B-100003',
    block_code: 1001003,
    block_name: 'PERNEM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50221',
    block_code: 522005,
    block_name: 'GHAILARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313447',
    block_code: 3130022,
    block_name: 'AHRORI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14019',
    district_code: 1403,
    district_name: 'SRINAGAR',
    block_id: 'B-140265',
    block_code: 1403010,
    block_name: 'HARWAN RURAL AREA DARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320109',
    block_code: 3208003,
    block_name: 'TUFANGANJ ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50418',
    block_code: 521008,
    block_name: 'SAUR BAZAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180134',
    block_code: 1808003,
    block_name: 'YAWAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17004',
    district_code: 1748,
    district_name: 'ASHOK NAGAR',
    block_id: 'B-170015',
    block_code: 1748005,
    block_name: 'ASHOKNAGAR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26020',
    district_code: 2610,
    district_name: 'SANGRUR',
    block_id: 'B-260134',
    block_code: 2610005,
    block_name: 'SANGRUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29017',
    district_code: 2918,
    district_name: 'PERAMBALUR',
    block_id: 'B-290160',
    block_code: 2918001,
    block_name: 'PERAMBALUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20507',
    block_code: 201026,
    block_name: 'SOMPETA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290383',
    block_code: 2924009,
    block_name: 'SIVAKASI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350052',
    block_code: 3505002,
    block_name: 'KALJIKHAL',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21011',
    district_code: 2108,
    district_name: 'WEST JAINTIA HILLS',
    block_id: 'B-210043',
    block_code: 2108005,
    block_name: 'LASKEIN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313851',
    block_code: 3150018,
    block_name: 'DOSTPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290173',
    block_code: 2919006,
    block_name: 'THIRUMAYAM',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190001',
    block_code: 1901005,
    block_name: 'AGATTI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12020',
    district_code: 1216,
    district_name: 'SIRSA',
    block_id: 'B-120123',
    block_code: 1216001,
    block_name: 'DABWALI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360320',
    block_code: 3619001,
    block_name: 'BASAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50386',
    block_code: 523009,
    block_name: 'JALALGARH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290302',
    block_code: 2926007,
    block_name: 'CHERANMAHADEVI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320318',
    block_code: 3211030,
    block_name: 'RAMNAGAR TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31372',
    district_code: 3173,
    district_name: 'SANT RAVIDAS NAGAR',
    block_id: 'B-313775',
    block_code: 3173002,
    block_name: 'BHADOHI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17022',
    district_code: 1733,
    district_name: 'JABALPUR',
    block_id: 'B-170133',
    block_code: 1733001,
    block_name: 'SIHORA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160096',
    block_code: 1605011,
    block_name: 'THANUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15018',
    district_code: 1518,
    district_name: 'KODAGU',
    block_id: 'B-150132',
    block_code: 1518003,
    block_name: 'VIRAJPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5013',
    district_code: 506,
    district_name: 'JEHANABAD',
    block_id: 'B-50166',
    block_code: 506005,
    block_name: 'MAKHDUMPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270343',
    block_code: 2726108,
    block_name: 'KURABAD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270335',
    block_code: 2726005,
    block_name: 'BHINDAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320284',
    block_code: 3202024,
    block_name: 'KATWA ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180068',
    block_code: 1822011,
    block_name: 'LONAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11024',
    district_code: 1114,
    district_name: 'PANCH MAHALS',
    block_id: 'B-110171',
    block_code: 1114015,
    block_name: 'GHOGHAMBA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313203',
    block_code: 3146007,
    block_name: 'CHITAURA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50340',
    block_code: 501013,
    block_name: 'KHUSRUPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32008',
    district_code: 3217,
    district_name: 'DINAJPUR DAKSHIN',
    block_id: 'B-320120',
    block_code: 3217002,
    block_name: 'HILI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313394',
    block_code: 3160015,
    block_name: 'REVATIPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2009',
    district_code: 207,
    district_name: 'GUNTUR',
    block_id: 'B-20212',
    block_code: 207007,
    block_name: 'GUNTUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18002',
    district_code: 1823,
    district_name: 'AKOLA',
    block_id: 'B-180016',
    block_code: 1823002,
    block_name: 'AKOT',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50492',
    block_code: 510004,
    block_name: 'BHAGWANPUR HAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313700',
    block_code: 3145031,
    block_name: 'BHAGWATPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50301',
    block_code: 508006,
    block_name: 'MESKAUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20517',
    block_code: 225007,
    block_name: 'CHILAMATHUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20463',
    block_code: 209035,
    block_name: 'LINGASAMUDRAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170039',
    block_code: 1731002,
    block_name: 'BHAINSDEHI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340178',
    block_code: 3405010,
    block_name: 'HUSSAINABAD',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10001',
    district_code: 1001,
    district_name: 'NORTH GOA',
    block_id: 'B-100002',
    block_code: 1001004,
    block_name: 'BICHOLIM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5019',
    district_code: 522,
    district_name: 'MADHEPURA',
    block_id: 'B-50227',
    block_code: 522011,
    block_name: 'PURAINI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313456',
    block_code: 3130032,
    block_name: 'KOTHWAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14019',
    district_code: 1403,
    district_name: 'SRINAGAR',
    block_id: 'B-140266',
    block_code: 1403011,
    block_name: 'KHANMOH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32006',
    district_code: 3208,
    district_name: 'COOCHBEHAR',
    block_id: 'B-320100',
    block_code: 3208002,
    block_name: 'COOCH BEHAR TWO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50412',
    block_code: 521002,
    block_name: 'KAHARA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180133',
    block_code: 1808004,
    block_name: 'RAVER',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17004',
    district_code: 1748,
    district_name: 'ASHOK NAGAR',
    block_id: 'B-170018',
    block_code: 1748007,
    block_name: 'MUNGAOLI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26020',
    district_code: 2610,
    district_name: 'SANGRUR',
    block_id: 'B-260130',
    block_code: 2610004,
    block_name: 'BHAWANIGARH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29017',
    district_code: 2918,
    district_name: 'PERAMBALUR',
    block_id: 'B-290161',
    block_code: 2918002,
    block_name: 'VEPPANTHATTAI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20488',
    block_code: 201015,
    block_name: 'JALUMURU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270007',
    block_code: 2721005,
    block_name: 'MASUDA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350056',
    block_code: 3505004,
    block_name: 'PABAU',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17009',
    district_code: 1728,
    district_name: 'BHOPAL',
    block_id: 'B-170052',
    block_code: 1728001,
    block_name: 'BERASIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313847',
    block_code: 3150019,
    block_name: 'AKHAND NAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290166',
    block_code: 2919009,
    block_name: 'AVUDAYARKOIL',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190002',
    block_code: 1901006,
    block_name: 'AMINI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12020',
    district_code: 1216,
    district_name: 'SIRSA',
    block_id: 'B-120128',
    block_code: 1216004,
    block_name: 'SIRSA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360328',
    block_code: 3619009,
    block_name: 'LAXMANCHANDA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50379',
    block_code: 523002,
    block_name: 'BAISA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290307',
    block_code: 2926008,
    block_name: 'PAPPAKUDI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320307',
    block_code: 3211021,
    block_name: 'KHEJURI TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31372',
    district_code: 3173,
    district_name: 'SANT RAVIDAS NAGAR',
    block_id: 'B-313774',
    block_code: 3173003,
    block_name: 'AURAI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360264',
    block_code: 3617007,
    block_name: 'KODAIR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16009',
    district_code: 1605,
    district_name: 'MALAPPURAM',
    block_id: 'B-160097',
    block_code: 1605013,
    block_name: 'THIRURANGADI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290205',
    block_code: 2907003,
    block_name: 'PANAMARATHUPATTI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5013',
    district_code: 506,
    district_name: 'JEHANABAD',
    block_id: 'B-50164',
    block_code: 506003,
    block_name: 'JEHANABAD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270340',
    block_code: 2726112,
    block_name: 'JHALLARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270342',
    block_code: 2726007,
    block_name: 'KOTRA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320285',
    block_code: 3202025,
    block_name: 'KATWA TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31381',
    district_code: 3161,
    district_name: 'VARANASI',
    block_id: 'B-313878',
    block_code: 3161024,
    block_name: 'BARAGAON',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11024',
    district_code: 1114,
    district_name: 'PANCH MAHALS',
    block_id: 'B-110176',
    block_code: 1114012,
    block_name: 'MORVA HADAF',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31320',
    district_code: 3146,
    district_name: 'BAHRAICH',
    block_id: 'B-313215',
    block_code: 3146010,
    block_name: 'VISHESHWARGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50339',
    block_code: 501012,
    block_name: 'GHOSWARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32008',
    district_code: 3217,
    district_name: 'DINAJPUR DAKSHIN',
    block_id: 'B-320122',
    block_code: 3217008,
    block_name: 'KUSHMANDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31337',
    district_code: 3160,
    district_name: 'GHAZIPUR',
    block_id: 'B-313396',
    block_code: 3160004,
    block_name: 'SAIDPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150206',
    block_code: 1527008,
    block_name: 'SIDDAPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18002',
    district_code: 1823,
    district_name: 'AKOLA',
    block_id: 'B-180019',
    block_code: 1823003,
    block_name: 'MURTIJAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50502',
    block_code: 510014,
    block_name: 'NAUTAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313709',
    block_code: 3145027,
    block_name: 'KORAON',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24021',
    district_code: 2431,
    district_name: 'MALKANGIRI',
    block_id: 'B-240210',
    block_code: 2431008,
    block_name: 'MATHILI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20511',
    block_code: 225001,
    block_name: 'AGALI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110085',
    block_code: 1123001,
    block_name: 'DAHOD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170037',
    block_code: 1731003,
    block_name: 'ATHNER',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340173',
    block_code: 3405012,
    block_name: 'BISHRAMPUR',
  },
  {
    state_id: 'S-08',
    state_code: 10,
    state_name: 'GOA',
    district_id: 'D-10001',
    district_code: 1001,
    district_name: 'NORTH GOA',
    block_id: 'B-100004',
    block_code: 1001005,
    block_name: 'SATTARI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50373',
    block_code: 513001,
    block_name: 'RAXAUL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313455',
    block_code: 3130033,
    block_name: 'KACHHAUNA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14019',
    district_code: 1403,
    district_name: 'SRINAGAR',
    block_id: 'B-140267',
    block_code: 1403012,
    block_name: 'QAMARWARI',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28001',
    district_code: 2802,
    district_name: 'GANGTOK',
    block_id: 'B-280002',
    block_code: 2802007,
    block_name: 'KHAMDONG',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26006',
    district_code: 2622,
    district_name: 'FAZILKA',
    block_id: 'B-260033',
    block_code: 2622004,
    block_name: 'JALALABAD',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180122',
    block_code: 1808006,
    block_name: 'BHUSAWAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17035',
    district_code: 1730,
    district_name: 'RAISEN',
    block_id: 'B-170209',
    block_code: 1730004,
    block_name: 'OBEDULLAHGANJ',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26020',
    district_code: 2610,
    district_name: 'SANGRUR',
    block_id: 'B-260131',
    block_code: 2610003,
    block_name: 'DHURI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29017',
    district_code: 2918,
    district_name: 'PERAMBALUR',
    block_id: 'B-290159',
    block_code: 2918005,
    block_name: 'ALATHUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20490',
    block_code: 201028,
    block_name: 'KAVITI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313481',
    block_code: 3138001,
    block_name: 'RAMPURA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350062',
    block_code: 3505009,
    block_name: 'ZAHRIKHAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17009',
    district_code: 1728,
    district_name: 'BHOPAL',
    block_id: 'B-170053',
    block_code: 1728002,
    block_name: 'PHANDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313848',
    block_code: 3150024,
    block_name: 'BALDIRAI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290167',
    block_code: 2919010,
    block_name: 'GANDARVAKOTTAI',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190006',
    block_code: 1901007,
    block_name: 'KADMAT',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12020',
    district_code: 1216,
    district_name: 'SIRSA',
    block_id: 'B-120127',
    block_code: 1216006,
    block_name: 'RANIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360322',
    block_code: 3619060,
    block_name: 'DASTURABAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50385',
    block_code: 523008,
    block_name: 'DHAMDAHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290303',
    block_code: 2926011,
    block_name: 'KALAKADU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320298',
    block_code: 3211019,
    block_name: 'BHAGWANPUR TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31372',
    district_code: 3173,
    district_name: 'SANT RAVIDAS NAGAR',
    block_id: 'B-313777',
    block_code: 3173004,
    block_name: 'GYANPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360265',
    block_code: 3617008,
    block_name: 'KOLLAPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17022',
    district_code: 1733,
    district_name: 'JABALPUR',
    block_id: 'B-170132',
    block_code: 1733004,
    block_name: 'SHAHPURA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290211',
    block_code: 2907005,
    block_name: 'VALAPADY',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5013',
    district_code: 506,
    district_name: 'JEHANABAD',
    block_id: 'B-50168',
    block_code: 506007,
    block_name: 'RATNI FARIDPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310135',
    block_code: 3175004,
    block_name: 'GAISRI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270341',
    block_code: 2726011,
    block_name: 'KHERWARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320290',
    block_code: 3202002,
    block_name: 'MEMARI ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31381',
    district_code: 3161,
    district_name: 'VARANASI',
    block_id: 'B-313883',
    block_code: 3161025,
    block_name: 'PINDRA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35004',
    district_code: 3510,
    district_name: 'CHAMPAWAT',
    block_id: 'B-350024',
    block_code: 3510004,
    block_name: 'BARAKOT',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33024',
    district_code: 3324,
    district_name: 'MUNGELI',
    block_id: 'B-330104',
    block_code: 3324001,
    block_name: 'LORMI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50330',
    block_code: 501003,
    block_name: 'BARH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32008',
    district_code: 3217,
    district_name: 'DINAJPUR DAKSHIN',
    block_id: 'B-320123',
    block_code: 3217004,
    block_name: 'TAPAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140075',
    block_code: 1409009,
    block_name: 'BHALESSA-GANDOH',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150197',
    block_code: 1527001,
    block_name: 'ANKOLA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18002',
    district_code: 1823,
    district_name: 'AKOLA',
    block_id: 'B-180018',
    block_code: 1823004,
    block_name: 'BARSHITAKLI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50498',
    block_code: 510010,
    block_name: 'HUSSAINGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313713',
    block_code: 3145014,
    block_name: 'PHULPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24021',
    district_code: 2431,
    district_name: 'MALKANGIRI',
    block_id: 'B-240206',
    block_code: 2431010,
    block_name: 'KALIMELA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20539',
    block_code: 225029,
    block_name: 'SOMANDEPALLE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110088',
    block_code: 1123002,
    block_name: 'FATEPURA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170041',
    block_code: 1731004,
    block_name: 'CHICHOLI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340176',
    block_code: 3405013,
    block_name: 'HAIDERNAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360178',
    block_code: 3612002,
    block_name: 'CHINNAGUDUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50372',
    block_code: 513002,
    block_name: 'RAMGARHWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31346',
    district_code: 3168,
    district_name: 'KANNAUJ',
    block_id: 'B-313504',
    block_code: 3168008,
    block_name: 'GUGURAPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14019',
    district_code: 1403,
    district_name: 'SRINAGAR',
    block_id: 'B-140268',
    block_code: 1403001,
    block_name: 'SRINAGAR',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28001',
    district_code: 2802,
    district_name: 'GANGTOK',
    block_id: 'B-280004',
    block_code: 2802008,
    block_name: 'RAKDONG TINTEK',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26006',
    district_code: 2622,
    district_name: 'FAZILKA',
    block_id: 'B-260034',
    block_code: 2622005,
    block_name: 'KHUIAN SARWAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180129',
    block_code: 1808007,
    block_name: 'JAMNER',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160068',
    block_code: 1610006,
    block_name: 'MADAPPALLY',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26020',
    district_code: 2610,
    district_name: 'SANGRUR',
    block_id: 'B-260132',
    block_code: 2610014,
    block_name: 'DIRBA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27032',
    district_code: 2722,
    district_name: 'TONK',
    block_id: 'B-270329',
    block_code: 2722003,
    block_name: 'NEWAI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20494',
    block_code: 201030,
    block_name: 'L N PETA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313477',
    block_code: 3138002,
    block_name: 'KUTHAUND',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350051',
    block_code: 3505010,
    block_name: 'EKESHWAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4032',
    district_code: 435,
    district_name: 'TAMULPUR',
    block_id: 'B-40202',
    block_code: 435003,
    block_name: 'TAMULPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313852',
    block_code: 3150026,
    block_name: 'DUBEPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29018',
    district_code: 2919,
    district_name: 'PUDUKKOTTAI',
    block_id: 'B-290168',
    block_code: 2919011,
    block_name: 'KARAMBAKKUDI',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190005',
    block_code: 1901009,
    block_name: 'CHETLAT',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12020',
    district_code: 1216,
    district_name: 'SIRSA',
    block_id: 'B-120124',
    block_code: 1216007,
    block_name: 'ELLENABAD',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150158',
    block_code: 1522006,
    block_name: 'PIRIYAPATNA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50389',
    block_code: 523012,
    block_name: 'PURNIA EAST',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290309',
    block_code: 2926012,
    block_name: 'VALLIYOOR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320316',
    block_code: 3211026,
    block_name: 'PATASHPUR TWO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31372',
    district_code: 3173,
    district_name: 'SANT RAVIDAS NAGAR',
    block_id: 'B-313776',
    block_code: 3173005,
    block_name: 'DEEGH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360266',
    block_code: 3617009,
    block_name: 'LINGAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17022',
    district_code: 1733,
    district_name: 'JABALPUR',
    block_id: 'B-170130',
    block_code: 1733005,
    block_name: 'PANAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290199',
    block_code: 2907011,
    block_name: 'KOLATHUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5013',
    district_code: 506,
    district_name: 'JEHANABAD',
    block_id: 'B-50162',
    block_code: 506001,
    block_name: 'GHOSHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310137',
    block_code: 3175005,
    block_name: 'PACHPEDWA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270348',
    block_code: 2726109,
    block_name: 'RISHABHADEV',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320275',
    block_code: 3202010,
    block_name: 'AUSGRAM TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180066',
    block_code: 1822005,
    block_name: 'JALGAON JAMOD',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35004',
    district_code: 3510,
    district_name: 'CHAMPAWAT',
    block_id: 'B-350026',
    block_code: 3510002,
    block_name: 'LOHAGHAT',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33024',
    district_code: 3324,
    district_name: 'MUNGELI',
    block_id: 'B-330105',
    block_code: 3324002,
    block_name: 'MUNGELI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50348',
    block_code: 501021,
    block_name: 'PHULWARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32008',
    district_code: 3217,
    district_name: 'DINAJPUR DAKSHIN',
    block_id: 'B-320117',
    block_code: 3217006,
    block_name: 'BANSHIHARI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140083',
    block_code: 1409023,
    block_name: 'JAKYAS',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150198',
    block_code: 1527002,
    block_name: 'BHATKAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18002',
    district_code: 1823,
    district_name: 'AKOLA',
    block_id: 'B-180020',
    block_code: 1823011,
    block_name: 'PATUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50490',
    block_code: 510002,
    block_name: 'BARHARIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313717',
    block_code: 3145021,
    block_name: 'SHANKARGARH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24021',
    district_code: 2431,
    district_name: 'MALKANGIRI',
    block_id: 'B-240209',
    block_code: 2431011,
    block_name: 'MALKANGIRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20520',
    block_code: 225010,
    block_name: 'GORANTLA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110090',
    block_code: 1123003,
    block_name: 'JHALOD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170038',
    block_code: 1731005,
    block_name: 'BETUL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340184',
    block_code: 3405015,
    block_name: 'NAWDIHA BAZAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360179',
    block_code: 3612003,
    block_name: 'DANTHALAPALLE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50375',
    block_code: 513003,
    block_name: 'SUGAULI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18035',
    district_code: 1832,
    district_name: 'WASHIM',
    block_id: 'B-180335',
    block_code: 1832001,
    block_name: 'WASHIM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4033',
    district_code: 418,
    district_name: 'TINSUKIA',
    block_id: 'B-40206',
    block_code: 418001,
    block_name: 'KAKOPATHAR',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28001',
    district_code: 2802,
    district_name: 'GANGTOK',
    block_id: 'B-280005',
    block_code: 2802006,
    block_name: 'RANKA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26017',
    district_code: 2623,
    district_name: 'PATHANKOT',
    block_id: 'B-260110',
    block_code: 2623001,
    block_name: 'GHAROTA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180131',
    block_code: 1808008,
    block_name: 'PACHORA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140045',
    block_code: 1402039,
    block_name: 'SANGRAMA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26020',
    district_code: 2610,
    district_name: 'SANGRUR',
    block_id: 'B-260135',
    block_code: 2610011,
    block_name: 'SHERPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27032',
    district_code: 2722,
    district_name: 'TONK',
    block_id: 'B-270327',
    block_code: 2722006,
    block_name: 'DEOLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20499',
    block_code: 201024,
    block_name: 'PALASA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313480',
    block_code: 3138005,
    block_name: 'NADIGAON',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350059',
    block_code: 3505011,
    block_name: 'RIKHNIKHAL',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4032',
    district_code: 435,
    district_name: 'TAMULPUR',
    block_id: 'B-40201',
    block_code: 435004,
    block_name: 'NAGRIJULI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313849',
    block_code: 3150027,
    block_name: 'BHADAIYA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290231',
    block_code: 2934003,
    block_name: 'MELANEELITHANALLUR',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190003',
    block_code: 1901002,
    block_name: 'ANDROTT',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140250',
    block_code: 1418006,
    block_name: 'PURMANDAL BARI BRAHNA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150060',
    block_code: 1509009,
    block_name: 'KALASA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5028',
    district_code: 523,
    district_name: 'PURNIA',
    block_id: 'B-50378',
    block_code: 523001,
    block_name: 'AMOUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313165',
    block_code: 3149007,
    block_name: 'HARINGTANGANJ',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320317',
    block_code: 3211029,
    block_name: 'RAMNAGAR ONE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31372',
    district_code: 3173,
    district_name: 'SANT RAVIDAS NAGAR',
    block_id: 'B-313773',
    block_code: 3173060,
    block_name: 'ABHOLI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360267',
    block_code: 3617010,
    block_name: 'NAGARKURNOOL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17022',
    district_code: 1733,
    district_name: 'JABALPUR',
    block_id: 'B-170127',
    block_code: 1733006,
    block_name: 'JABALPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290203',
    block_code: 2907012,
    block_name: 'NANGAVALLI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5013',
    district_code: 506,
    district_name: 'JEHANABAD',
    block_id: 'B-50165',
    block_code: 506004,
    block_name: 'KAKO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310139',
    block_code: 3175006,
    block_name: 'SHRIDUTTGANJ',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270347',
    block_code: 2726111,
    block_name: 'PHALASIA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320165',
    block_code: 3207008,
    block_name: 'BANARHAT',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180065',
    block_code: 1822013,
    block_name: 'DEULGAON RAJA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35004',
    district_code: 3510,
    district_name: 'CHAMPAWAT',
    block_id: 'B-350027',
    block_code: 3510003,
    block_name: 'PATI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33024',
    district_code: 3324,
    district_name: 'MUNGELI',
    block_id: 'B-330106',
    block_code: 3324003,
    block_name: 'PATHARIYA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50336',
    block_code: 501008,
    block_name: 'DHANARUA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32008',
    district_code: 3217,
    district_name: 'DINAJPUR DAKSHIN',
    block_id: 'B-320121',
    block_code: 3217003,
    block_name: 'KUMARGANJ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140077',
    block_code: 1409022,
    block_name: 'CHANGA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150200',
    block_code: 1527003,
    block_name: 'HALIYAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18002',
    district_code: 1823,
    district_name: 'AKOLA',
    block_id: 'B-180021',
    block_code: 1823014,
    block_name: 'TELHARA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50500',
    block_code: 510012,
    block_name: 'MAHARAJGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313720',
    block_code: 3145025,
    block_name: 'URUWAN',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24021',
    district_code: 2431,
    district_name: 'MALKANGIRI',
    block_id: 'B-240211',
    block_code: 2431014,
    block_name: 'PODIA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20528',
    block_code: 225018,
    block_name: 'MUDIGUBBA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110089',
    block_code: 1123004,
    block_name: 'GARBADA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170045',
    block_code: 1731007,
    block_name: 'SHAHPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340185',
    block_code: 3405017,
    block_name: 'PADWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360180',
    block_code: 3612004,
    block_name: 'DORNAKAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50367',
    block_code: 513004,
    block_name: 'PAHARPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18035',
    district_code: 1832,
    district_name: 'WASHIM',
    block_id: 'B-180331',
    block_code: 1832002,
    block_name: 'MALEGAON',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4033',
    district_code: 418,
    district_name: 'TINSUKIA',
    block_id: 'B-40204',
    block_code: 418002,
    block_name: 'HAPJAN',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28001',
    district_code: 2802,
    district_name: 'GANGTOK',
    block_id: 'B-280001',
    block_code: 2802001,
    block_name: 'GANGTOK NANDOK',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26017',
    district_code: 2623,
    district_name: 'PATHANKOT',
    block_id: 'B-260108',
    block_code: 2623002,
    block_name: 'BAMIAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180124',
    block_code: 1808009,
    block_name: 'CHALISGAON',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140046',
    block_code: 1402034,
    block_name: 'SHERABAD KHORE',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26020',
    district_code: 2610,
    district_name: 'SANGRUR',
    block_id: 'B-260129',
    block_code: 2610013,
    block_name: 'ANDANA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3011',
    district_code: 314,
    district_name: 'LOWER DIBANG VALLEY',
    block_id: 'B-30049',
    block_code: 314001,
    block_name: 'ROING',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20489',
    block_code: 201027,
    block_name: 'KANCHILI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313473',
    block_code: 3138007,
    block_name: 'DAKORE',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350055',
    block_code: 3505013,
    block_name: 'NAINIDANDA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4032',
    district_code: 435,
    district_name: 'TAMULPUR',
    block_id: 'B-40200',
    block_code: 435006,
    block_name: 'GORESWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313860',
    block_code: 3150028,
    block_name: 'P.P.KAMAICHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290233',
    block_code: 2934017,
    block_name: 'SHENCOTTAI',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190007',
    block_code: 1901003,
    block_name: 'KALPENI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140251',
    block_code: 1418007,
    block_name: 'RAJPURA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15022',
    district_code: 1522,
    district_name: 'MYSURU',
    block_id: 'B-150159',
    block_code: 1522009,
    block_name: 'SALIGRAMA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29002',
    district_code: 2937,
    district_name: 'CHENGALPATTU',
    block_id: 'B-290007',
    block_code: 2937010,
    block_name: 'ACHARAPAKKAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290305',
    block_code: 2926010,
    block_name: 'NANGUNERI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320313',
    block_code: 3211016,
    block_name: 'NANDIGRAM TWO',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160017',
    block_code: 1608005,
    block_name: 'KOTHAMANGALAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360262',
    block_code: 3617005,
    block_name: 'CHARAKONDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17022',
    district_code: 1733,
    district_name: 'JABALPUR',
    block_id: 'B-170128',
    block_code: 1733007,
    block_name: 'KUNDAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290202',
    block_code: 2907013,
    block_name: 'MECHERI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24004',
    district_code: 2417,
    district_name: 'BHADRAK',
    block_id: 'B-240036',
    block_code: 2417002,
    block_name: 'BONTH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29015',
    district_code: 2914,
    district_name: 'NAGAPATTINAM',
    block_id: 'B-290139',
    block_code: 2914003,
    block_name: 'KILVELUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270352',
    block_code: 2726113,
    block_name: 'SEMAARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320168',
    block_code: 3207009,
    block_name: 'KRANTI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18007',
    district_code: 1822,
    district_name: 'BULDHANA',
    block_id: 'B-180075',
    block_code: 1822012,
    block_name: 'SINDKHED RAJA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35004',
    district_code: 3510,
    district_name: 'CHAMPAWAT',
    block_id: 'B-350025',
    block_code: 3510001,
    block_name: 'CHAMPAWAT',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140105',
    block_code: 1413013,
    block_name: 'MAIRA MANDRIAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50333',
    block_code: 501006,
    block_name: 'BIKRAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32008',
    district_code: 3217,
    district_name: 'DINAJPUR DAKSHIN',
    block_id: 'B-320119',
    block_code: 3217007,
    block_name: 'HARIRAMPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17014',
    district_code: 1704,
    district_name: 'DATIA',
    block_id: 'B-170084',
    block_code: 1704001,
    block_name: 'SEONDHA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150201',
    block_code: 1527004,
    block_name: 'HONAVAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18002',
    district_code: 1823,
    district_name: 'AKOLA',
    block_id: 'B-180017',
    block_code: 1823015,
    block_name: 'BALAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50494',
    block_code: 510006,
    block_name: 'DARAUNDHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313711',
    block_code: 3145011,
    block_name: 'MAUAIMA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24009',
    district_code: 2407,
    district_name: 'DHENKANAL',
    block_id: 'B-240081',
    block_code: 2407007,
    block_name: 'PARAJANG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20519',
    block_code: 225009,
    block_name: 'GANDLAPENTA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110091',
    block_code: 1123005,
    block_name: 'LIMKHEDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170036',
    block_code: 1731008,
    block_name: 'AMLA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340183',
    block_code: 3405018,
    block_name: 'NAWA BAZAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360183',
    block_code: 3612007,
    block_name: 'GUDUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50352',
    block_code: 513005,
    block_name: 'ARERAJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18035',
    district_code: 1832,
    district_name: 'WASHIM',
    block_id: 'B-180334',
    block_code: 1832003,
    block_name: 'RISOD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4033',
    district_code: 418,
    district_name: 'TINSUKIA',
    block_id: 'B-40205',
    block_code: 418006,
    block_name: 'ITAKHULI',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28001',
    district_code: 2802,
    district_name: 'GANGTOK',
    block_id: 'B-280003',
    block_code: 2802009,
    block_name: 'MARTAM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26017',
    district_code: 2623,
    district_name: 'PATHANKOT',
    block_id: 'B-260109',
    block_code: 2623003,
    block_name: 'DHAR KALAN',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180121',
    block_code: 1808010,
    block_name: 'BHADGAON',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140050',
    block_code: 1402036,
    block_name: 'TUJJAR SHAREF',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26020',
    district_code: 2610,
    district_name: 'SANGRUR',
    block_id: 'B-260136',
    block_code: 2610006,
    block_name: 'SUNAM',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3011',
    district_code: 314,
    district_name: 'LOWER DIBANG VALLEY',
    block_id: 'B-30048',
    block_code: 314002,
    block_name: 'HUNLI-KRONLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20487',
    block_code: 201029,
    block_name: 'ICHAPURAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313479',
    block_code: 3138008,
    block_name: 'MAHEVA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350058',
    block_code: 3505014,
    block_name: 'POKHRA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26007',
    district_code: 2603,
    district_name: 'FIROZEPUR',
    block_id: 'B-260040',
    block_code: 2603002,
    block_name: 'ZIRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31335',
    district_code: 3164,
    district_name: 'GAUTAM BUDDHA NAGAR',
    block_id: 'B-313377',
    block_code: 3164003,
    block_name: 'DADRI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290232',
    block_code: 2934005,
    block_name: 'SANKARANKOIL',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190008',
    block_code: 1901004,
    block_name: 'KAVARATTI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140252',
    block_code: 1418008,
    block_name: 'RAMGARH',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15009',
    district_code: 1509,
    district_name: 'CHIKKAMAGALURU',
    block_id: 'B-150057',
    block_code: 1509008,
    block_name: 'AJJAMPURA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29002',
    district_code: 2937,
    district_name: 'CHENGALPATTU',
    block_id: 'B-290008',
    block_code: 2937013,
    block_name: 'CHITHAMUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290308',
    block_code: 2926013,
    block_name: 'RADHAPURAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320297',
    block_code: 3211018,
    block_name: 'BHAGWANPUR ONE',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160019',
    block_code: 1608007,
    block_name: 'MUVATTUPUZHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360268',
    block_code: 3617011,
    block_name: 'PADARA',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28005',
    district_code: 2806,
    district_name: 'PAKYONG',
    block_id: 'B-280023',
    block_code: 2806003,
    block_name: 'DUGA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290200',
    block_code: 2907019,
    block_name: 'KONGANAPURAM',
  },
  {
    state_id: 'S-23',
    state_code: 25,
    state_name: 'PUDUCHERRY',
    district_id: 'D-25001',
    district_code: 2502,
    district_name: 'KARAIKAL',
    block_id: 'B-250001',
    block_code: 2502001,
    block_name: 'KARAIKAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29015',
    district_code: 2914,
    district_name: 'NAGAPATTINAM',
    block_id: 'B-290143',
    block_code: 2914006,
    block_name: 'VEDARANYAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270338',
    block_code: 2726114,
    block_name: 'JAISAMAND',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33013',
    district_code: 3314,
    district_name: 'JANJGIR-CHAMPA',
    block_id: 'B-330058',
    block_code: 3314001,
    block_name: 'NAWAGARH',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22011',
    district_code: 2207,
    district_name: 'SERCHHIP',
    block_id: 'B-220025',
    block_code: 2207003,
    block_name: 'EAST LUNGDAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360314',
    block_code: 3633005,
    block_name: 'MAGANOOR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140106',
    block_code: 1413019,
    block_name: 'MANDAL PHALLAIN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50349',
    block_code: 501022,
    block_name: 'PUNPUN',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33012',
    district_code: 3328,
    district_name: 'GAURELLA PENDRA MARWAHI',
    block_id: 'B-330054',
    block_code: 3328002,
    block_name: 'PENDRA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17014',
    district_code: 1704,
    district_name: 'DATIA',
    block_id: 'B-170083',
    block_code: 1704002,
    block_name: 'DATIA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150203',
    block_code: 1527005,
    block_name: 'KARWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313548',
    block_code: 3128005,
    block_name: 'BIJUA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50501',
    block_code: 510013,
    block_name: 'MAIRWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313715',
    block_code: 3145029,
    block_name: 'SAHSON',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20011',
    district_code: 2015,
    district_name: 'PHERZAWL',
    block_id: 'B-200051',
    block_code: 2015008,
    block_name: 'VANGAI RANGE T D BLOCK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20530',
    block_code: 225020,
    block_name: 'NALLAMADA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110087',
    block_code: 1123006,
    block_name: 'DHANPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170043',
    block_code: 1731009,
    block_name: 'MULTAI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340189',
    block_code: 3405019,
    block_name: 'PIPRA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360184',
    block_code: 3612008,
    block_name: 'KESAMUDRAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50355',
    block_code: 513018,
    block_name: 'CHAKIA-PIPRA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18035',
    district_code: 1832,
    district_name: 'WASHIM',
    block_id: 'B-180332',
    block_code: 1832005,
    block_name: 'MANGRULPIR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4033',
    district_code: 418,
    district_name: 'TINSUKIA',
    block_id: 'B-40209',
    block_code: 418007,
    block_name: 'SAIKHOWA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4008',
    district_code: 425,
    district_name: 'CHIRANG',
    block_id: 'B-40047',
    block_code: 425094,
    block_name: 'BOROBAZAR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26017',
    district_code: 2623,
    district_name: 'PATHANKOT',
    block_id: 'B-260111',
    block_code: 2623004,
    block_name: 'NAROT JAIMAL SINGH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180127',
    block_code: 1808012,
    block_name: 'ERANDOL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140034',
    block_code: 1402029,
    block_name: 'KAHIPORA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160134',
    block_code: 1607002,
    block_name: 'CHALAKKUDY',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3011',
    district_code: 314,
    district_name: 'LOWER DIBANG VALLEY',
    block_id: 'B-30047',
    block_code: 314003,
    block_name: 'DAMBUK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20503',
    block_code: 201003,
    block_name: 'RANASTALAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313475',
    block_code: 3138009,
    block_name: 'KADAURA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350053',
    block_code: 3505015,
    block_name: 'KHIRSU',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26007',
    district_code: 2603,
    district_name: 'FIROZEPUR',
    block_id: 'B-260037',
    block_code: 2603005,
    block_name: 'GURU HAR SAHAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313854',
    block_code: 3150022,
    block_name: 'KADIPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290235',
    block_code: 2934019,
    block_name: 'VASUDEVANALLUR',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190009',
    block_code: 1901008,
    block_name: 'KILTAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140254',
    block_code: 1418009,
    block_name: 'SUMB',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360333',
    block_code: 3619015,
    block_name: 'NIRMAL RURAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29002',
    district_code: 2937,
    district_name: 'CHENGALPATTU',
    block_id: 'B-290009',
    block_code: 2937007,
    block_name: 'KATTANKOLATHUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313163',
    block_code: 3149005,
    block_name: 'AMANIGANJ',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320312',
    block_code: 3211015,
    block_name: 'NANDIGRAM ONE',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160018',
    block_code: 1608006,
    block_name: 'MULANTHURUTHY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360258',
    block_code: 3617001,
    block_name: 'ACHAMPETA',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28005',
    district_code: 2806,
    district_name: 'PAKYONG',
    block_id: 'B-280024',
    block_code: 2806002,
    block_name: 'PAKYONG',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290207',
    block_code: 2907001,
    block_name: 'SALEM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240304',
    block_code: 2402015,
    block_name: 'KOIDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290357',
    block_code: 2915001,
    block_name: 'VALANGAIMAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270346',
    block_code: 2726115,
    block_name: 'NAYAGAON',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33013',
    district_code: 3314,
    district_name: 'JANJGIR-CHAMPA',
    block_id: 'B-330055',
    block_code: 3314005,
    block_name: 'AKALTARA',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22011',
    district_code: 2207,
    district_name: 'SERCHHIP',
    block_id: 'B-220026',
    block_code: 2207001,
    block_name: 'SERCHHIP',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360316',
    block_code: 3633007,
    block_name: 'MARIKAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140101',
    block_code: 1413017,
    block_name: 'CHOWKI CHOURA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50344',
    block_code: 501017,
    block_name: 'NAUBATPUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33012',
    district_code: 3328,
    district_name: 'GAURELLA PENDRA MARWAHI',
    block_id: 'B-330053',
    block_code: 3328001,
    block_name: 'MARWAHI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17014',
    district_code: 1704,
    district_name: 'DATIA',
    block_id: 'B-170082',
    block_code: 1704003,
    block_name: 'BHANDER',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150204',
    block_code: 1527006,
    block_name: 'KUMTA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313551',
    block_code: 3128004,
    block_name: 'KUMBHIGOLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5036',
    district_code: 510,
    district_name: 'SIWAN',
    block_id: 'B-50497',
    block_code: 510009,
    block_name: 'HASANPURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313706',
    block_code: 3145023,
    block_name: 'KARCHHANA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33008',
    district_code: 3312,
    district_name: 'DANTEWADA',
    block_id: 'B-330036',
    block_code: 3312006,
    block_name: 'DANTEWADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20515',
    block_code: 225005,
    block_name: 'BUKKAPATNAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110086',
    block_code: 1123007,
    block_name: 'DEVGAD BARIYA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17032',
    district_code: 1741,
    district_name: 'NEEMUCH',
    block_id: 'B-170196',
    block_code: 1741001,
    block_name: 'JAWAD',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340192',
    block_code: 3405020,
    block_name: 'TARHASI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360188',
    block_code: 3612012,
    block_name: 'MARIPEDA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50374',
    block_code: 513027,
    block_name: 'SANGRAMPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18035',
    district_code: 1832,
    district_name: 'WASHIM',
    block_id: 'B-180333',
    block_code: 1832007,
    block_name: 'MANORA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4033',
    district_code: 418,
    district_name: 'TINSUKIA',
    block_id: 'B-40203',
    block_code: 418005,
    block_name: 'GUIJAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50416',
    block_code: 521006,
    block_name: 'SALKHUA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26017',
    district_code: 2623,
    district_name: 'PATHANKOT',
    block_id: 'B-260112',
    block_code: 2623005,
    block_name: 'PATHANKOT',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180120',
    block_code: 1808013,
    block_name: 'AMALNER',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140041',
    block_code: 1402033,
    block_name: 'PARANPEELA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160136',
    block_code: 1607004,
    block_name: 'CHERPU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27032',
    district_code: 2722,
    district_name: 'TONK',
    block_id: 'B-270328',
    block_code: 2722001,
    block_name: 'MAALPURA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20481',
    block_code: 201010,
    block_name: 'AMADALAVALASA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290378',
    block_code: 2924001,
    block_name: 'ARUPUKOTTAI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350048',
    block_code: 3505016,
    block_name: 'BIRONKHAL',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26007',
    district_code: 2603,
    district_name: 'FIROZEPUR',
    block_id: 'B-260036',
    block_code: 2603004,
    block_name: 'GHALL KHURD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31379',
    district_code: 3150,
    district_name: 'SULTANPUR',
    block_id: 'B-313853',
    block_code: 3150025,
    block_name: 'JAISINGHPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290229',
    block_code: 2934015,
    block_name: 'KEELAPAVOOR',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190010',
    block_code: 1901001,
    block_name: 'MINICOY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140247',
    block_code: 1418001,
    block_name: 'GHAGWAL',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23003',
    district_code: 2301,
    district_name: 'KOHIMA',
    block_id: 'B-230012',
    block_code: 2301006,
    block_name: 'BOTSA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29002',
    district_code: 2937,
    district_name: 'CHENGALPATTU',
    block_id: 'B-290010',
    block_code: 2937012,
    block_name: 'LATHUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290306',
    block_code: 2926001,
    block_name: 'PALAYAMKOTTAI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32022',
    district_code: 3211,
    district_name: 'PURBA MEDINIPUR',
    block_id: 'B-320321',
    block_code: 3211009,
    block_name: 'TAMLUK',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160020',
    block_code: 1608008,
    block_name: 'PALLURUTHY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360273',
    block_code: 3617016,
    block_name: 'THIMMAJIPETA',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28005',
    district_code: 2806,
    district_name: 'PAKYONG',
    block_id: 'B-280026',
    block_code: 2806005,
    block_name: 'REGU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290213',
    block_code: 2907006,
    block_name: 'YERCAUD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24030',
    district_code: 2402,
    district_name: 'SUNDARGARH',
    block_id: 'B-240302',
    block_code: 2402017,
    block_name: 'GURUNDIA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290353',
    block_code: 2915002,
    block_name: 'NANNILAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310140',
    block_code: 3175003,
    block_name: 'TULSIPUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33013',
    district_code: 3314,
    district_name: 'JANJGIR-CHAMPA',
    block_id: 'B-330059',
    block_code: 3314007,
    block_name: 'PAMGARH',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33023',
    district_code: 3330,
    district_name: 'MOHLA MANPUR AMBAGARH CHOUKI',
    block_id: 'B-330101',
    block_code: 3330007,
    block_name: 'A. CHOWKI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360311',
    block_code: 3633003,
    block_name: 'KOSGI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140108',
    block_code: 1413014,
    block_name: 'MATHWAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50337',
    block_code: 501010,
    block_name: 'DULHIN BAZAR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20005',
    district_code: 2007,
    district_name: 'IMPHAL WEST',
    block_id: 'B-200024',
    block_code: 2007009,
    block_name: 'HIYANGTHANG C D BLOCK IMPHAL WEST II',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140086',
    block_code: 1409027,
    block_name: 'KHELLANI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150205',
    block_code: 1527007,
    block_name: 'MUNDGOD',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30002',
    district_code: 3008,
    district_name: 'GOMATI',
    block_id: 'B-300010',
    block_code: 3008004,
    block_name: 'KAKRABAN',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33015',
    district_code: 3310,
    district_name: 'KANKER',
    block_id: 'B-330074',
    block_code: 3310013,
    block_name: 'NARHARPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313719',
    block_code: 3145030,
    block_name: 'SRINGVERPUR DHAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33008',
    district_code: 3312,
    district_name: 'DANTEWADA',
    block_id: 'B-330037',
    block_code: 3312005,
    block_name: 'GEEDAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20514',
    block_code: 225004,
    block_name: 'BATHALAPALLE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20471',
    block_code: 209001,
    block_name: 'SEETHARAMAPURAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33014',
    district_code: 3307,
    district_name: 'JASHPUR',
    block_id: 'B-330067',
    block_code: 3307014,
    block_name: 'PHARSABAHAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340186',
    block_code: 3405011,
    block_name: 'PANDU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360192',
    block_code: 3612016,
    block_name: 'THORRUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33033',
    district_code: 3305,
    district_name: 'SURGUJA',
    block_id: 'B-330144',
    block_code: 3305008,
    block_name: 'MAINPAT',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18035',
    district_code: 1832,
    district_name: 'WASHIM',
    block_id: 'B-180330',
    block_code: 1832008,
    block_name: 'KARANJA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4033',
    district_code: 418,
    district_name: 'TINSUKIA',
    block_id: 'B-40207',
    block_code: 418003,
    block_name: 'MARGHERITA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50419',
    block_code: 521009,
    block_name: 'SIMRI BAKHTIARPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26017',
    district_code: 2623,
    district_name: 'PATHANKOT',
    block_id: 'B-260113',
    block_code: 2623006,
    block_name: 'SUJANPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180126',
    block_code: 1808015,
    block_name: 'DHARANGAON',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140053',
    block_code: 1402035,
    block_name: 'WAILOO',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160138',
    block_code: 1607006,
    block_name: 'IRINJALAKKUDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27032',
    district_code: 2722,
    district_name: 'TONK',
    block_id: 'B-270333',
    block_code: 2722002,
    block_name: 'UNIYARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20493',
    block_code: 201002,
    block_name: 'LAVERU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290381',
    block_code: 2924006,
    block_name: 'RAJAPALAYAM',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350050',
    block_code: 3505017,
    block_name: 'DWARIKHAL',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26007',
    district_code: 2603,
    district_name: 'FIROZEPUR',
    block_id: 'B-260039',
    block_code: 2603010,
    block_name: 'MAMDOT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290228',
    block_code: 2934016,
    block_name: 'KADAYANALLUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27015',
    district_code: 2702,
    district_name: 'HANUMANGARH',
    block_id: 'B-270153',
    block_code: 2702001,
    block_name: 'BHADRA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140249',
    block_code: 1418002,
    block_name: 'PURMANDAL',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23003',
    district_code: 2301,
    district_name: 'KOHIMA',
    block_id: 'B-230016',
    block_code: 2301003,
    block_name: 'KOHIMA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29002',
    district_code: 2937,
    district_name: 'CHENGALPATTU',
    block_id: 'B-290014',
    block_code: 2937006,
    block_name: 'THIRUPORUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29030',
    district_code: 2926,
    district_name: 'TIRUNELVELI',
    block_id: 'B-290301',
    block_code: 2926006,
    block_name: 'AMBASAMUDRAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33007',
    district_code: 3301,
    district_name: 'BILASPUR',
    block_id: 'B-330032',
    block_code: 3301014,
    block_name: 'BELHA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160025',
    block_code: 1608013,
    block_name: 'VAZHAKKULAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360261',
    block_code: 3617004,
    block_name: 'BIJINAPALLE',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28005',
    district_code: 2806,
    district_name: 'PAKYONG',
    block_id: 'B-280027',
    block_code: 2806004,
    block_name: 'RHENOCK',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270037',
    block_code: 2728007,
    block_name: 'SAJJANGARH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50231',
    block_code: 520002,
    block_name: 'BABUBARHI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290348',
    block_code: 2915003,
    block_name: 'KODAVASAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310141',
    block_code: 3175007,
    block_name: 'UTRAULA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33013',
    district_code: 3314,
    district_name: 'JANJGIR-CHAMPA',
    block_id: 'B-330056',
    block_code: 3314002,
    block_name: 'BAHMINDIH',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33023',
    district_code: 3330,
    district_name: 'MOHLA MANPUR AMBAGARH CHOUKI',
    block_id: 'B-330102',
    block_code: 3330009,
    block_name: 'MANPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360317',
    block_code: 3633008,
    block_name: 'NARAYANPET',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140109',
    block_code: 1413020,
    block_name: 'MIRAN SAHIB',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50335',
    block_code: 501007,
    block_name: 'DANIAWAN',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20005',
    district_code: 2007,
    district_name: 'IMPHAL WEST',
    block_id: 'B-200027',
    block_code: 2007008,
    block_name: 'PATSOI C D BLOCK',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4018',
    district_code: 415,
    district_name: 'JORHAT',
    block_id: 'B-40111',
    block_code: 415001,
    block_name: 'KALIAPANI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150207',
    block_code: 1527009,
    block_name: 'SIRSI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30002',
    district_code: 3008,
    district_name: 'GOMATI',
    block_id: 'B-300014',
    block_code: 3008005,
    block_name: 'OMPI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33015',
    district_code: 3310,
    district_name: 'KANKER',
    block_id: 'B-330072',
    block_code: 3310014,
    block_name: 'KANKER',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33008',
    district_code: 3312,
    district_name: 'DANTEWADA',
    block_id: 'B-330039',
    block_code: 3312008,
    block_name: 'KUWAKONDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17048',
    district_code: 1750,
    district_name: 'SINGROLI',
    block_id: 'B-170291',
    block_code: 1750003,
    block_name: 'CHITRANGI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20523',
    block_code: 225013,
    block_name: 'KADIRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20474',
    block_code: 209010,
    block_name: 'UDAYAGIRI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33014',
    district_code: 3307,
    district_name: 'JASHPUR',
    block_id: 'B-330063',
    block_code: 3307010,
    block_name: 'KANSABEL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340182',
    block_code: 3405016,
    block_name: 'MOHAMADGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360177',
    block_code: 3612069,
    block_name: 'BAYYARAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33003',
    district_code: 3327,
    district_name: 'BALRAMPUR',
    block_id: 'B-330012',
    block_code: 3327002,
    block_name: 'KUSMI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313457',
    block_code: 3130038,
    block_name: 'MADHOGANJ',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4033',
    district_code: 418,
    district_name: 'TINSUKIA',
    block_id: 'B-40208',
    block_code: 418004,
    block_name: 'SADIYA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50415',
    block_code: 521005,
    block_name: 'PATARGHAT',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26006',
    district_code: 2622,
    district_name: 'FAZILKA',
    block_id: 'B-260030',
    block_code: 2622001,
    block_name: 'ABOHAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180130',
    block_code: 1808016,
    block_name: 'MUKTAINAGAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140030',
    block_code: 1402040,
    block_name: 'BIJHAMA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160139',
    block_code: 1607007,
    block_name: 'KODAKARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27032',
    district_code: 2722,
    district_name: 'TONK',
    block_id: 'B-270331',
    block_code: 2722005,
    block_name: 'TODARAYSINGH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2020',
    district_code: 201,
    district_name: 'SRIKAKULAM',
    block_id: 'B-20483',
    block_code: 201004,
    block_name: 'ETCHERLA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290384',
    block_code: 2924007,
    block_name: 'SRIVILLIPUTHUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350060',
    block_code: 3505005,
    block_name: 'THALISAIN',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26007',
    district_code: 2603,
    district_name: 'FIROZEPUR',
    block_id: 'B-260038',
    block_code: 2603011,
    block_name: 'MAKHU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290226',
    block_code: 2934014,
    block_name: 'ALANKULAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27015',
    district_code: 2702,
    district_name: 'HANUMANGARH',
    block_id: 'B-270154',
    block_code: 2702002,
    block_name: 'HANUMANGARH',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140255',
    block_code: 1418004,
    block_name: 'VIJAYPUR',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23003',
    district_code: 2301,
    district_name: 'KOHIMA',
    block_id: 'B-230015',
    block_code: 2301002,
    block_name: 'JAKHAMA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29002',
    district_code: 2937,
    district_name: 'CHENGALPATTU',
    block_id: 'B-290013',
    block_code: 2937008,
    block_name: 'THIRUKAZHUKUNDRAM',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3009',
    district_code: 309,
    district_name: 'LOHIT',
    block_id: 'B-30041',
    block_code: 309001,
    block_name: 'TEZU',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33007',
    district_code: 3301,
    district_name: 'BILASPUR',
    block_id: 'B-330035',
    block_code: 3301015,
    block_name: 'TAKHATPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160021',
    block_code: 1608009,
    block_name: 'PAMPAKKUDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360271',
    block_code: 3617014,
    block_name: 'TADOOR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33029',
    district_code: 3333,
    district_name: 'SAKTI',
    block_id: 'B-330125',
    block_code: 3333004,
    block_name: 'JAIJAIPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270030',
    block_code: 2728006,
    block_name: 'BAGIDORA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50248',
    block_code: 520020,
    block_name: 'PHULPARAS',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290058',
    block_code: 2922009,
    block_name: 'ODDANCHATRAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310133',
    block_code: 3175010,
    block_name: 'BALRAMPUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33013',
    district_code: 3314,
    district_name: 'JANJGIR-CHAMPA',
    block_id: 'B-330057',
    block_code: 3314006,
    block_name: 'BALAUDA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33023',
    district_code: 3330,
    district_name: 'MOHLA MANPUR AMBAGARH CHOUKI',
    block_id: 'B-330103',
    block_code: 3330008,
    block_name: 'MOHLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360319',
    block_code: 3633010,
    block_name: 'UTKOOR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140110',
    block_code: 1413021,
    block_name: 'NAGROTA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50338',
    block_code: 501011,
    block_name: 'FATWAH',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20005',
    district_code: 2007,
    district_name: 'IMPHAL WEST',
    block_id: 'B-200025',
    block_code: 2007006,
    block_name: 'IMPHAL WEST I HAORANGSABAL',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4018',
    district_code: 415,
    district_name: 'JORHAT',
    block_id: 'B-40109',
    block_code: 415003,
    block_name: 'JORHAT CENTRAL',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150208',
    block_code: 1527011,
    block_name: 'YELLAPUR',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30002',
    district_code: 3008,
    district_name: 'GOMATI',
    block_id: 'B-300011',
    block_code: 3008006,
    block_name: 'KARBOOK',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200009',
    block_code: 2003014,
    block_name: 'KANGVAI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33008',
    district_code: 3312,
    district_name: 'DANTEWADA',
    block_id: 'B-330038',
    block_code: 3312007,
    block_name: 'KATEKALYAN',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260089',
    block_code: 2604002,
    block_name: 'SIDHWAN BET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2021',
    district_code: 225,
    district_name: 'SRI SATHYA SAI',
    block_id: 'B-20525',
    block_code: 225015,
    block_name: 'KOTHACHERUVU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20476',
    block_code: 209002,
    block_name: 'VARIKUNTAPADU',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33014',
    district_code: 3307,
    district_name: 'JASHPUR',
    block_id: 'B-330064',
    block_code: 3307011,
    block_name: 'KUNKURI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340181',
    block_code: 3405014,
    block_name: 'MEDININAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360181',
    block_code: 3612005,
    block_name: 'GANGARAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33003',
    district_code: 3327,
    district_name: 'BALRAMPUR',
    block_id: 'B-330013',
    block_code: 3327003,
    block_name: 'RAJPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313449',
    block_code: 3130024,
    block_name: 'BEHADAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50110',
    block_code: 519015,
    block_name: 'KUSHESHWAR ASTHAN EAST',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50420',
    block_code: 521010,
    block_name: 'SONBARSA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26006',
    district_code: 2622,
    district_name: 'FAZILKA',
    block_id: 'B-260031',
    block_code: 2622002,
    block_name: 'ARNIWALA SHIEKH SUBHAN',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160066',
    block_code: 1610004,
    block_name: 'KANJIRAPPALLY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140032',
    block_code: 1402031,
    block_name: 'CHANDIL WANGAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160140',
    block_code: 1607008,
    block_name: 'MALA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27032',
    district_code: 2722,
    district_name: 'TONK',
    block_id: 'B-270332',
    block_code: 2722004,
    block_name: 'TONK',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15021',
    district_code: 1521,
    district_name: 'MANDYA',
    block_id: 'B-150148',
    block_code: 1521003,
    block_name: 'MALVALLI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29037',
    district_code: 2924,
    district_name: 'VIRUDHUNAGAR',
    block_id: 'B-290382',
    block_code: 2924011,
    block_name: 'SATTUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350061',
    block_code: 3505012,
    block_name: 'YAMKESHWAR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26007',
    district_code: 2603,
    district_name: 'FIROZEPUR',
    block_id: 'B-260035',
    block_code: 2603003,
    block_name: 'FIROZPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29023',
    district_code: 2934,
    district_name: 'TENKASI',
    block_id: 'B-290230',
    block_code: 2934004,
    block_name: 'KURUVIKULAM',
  },
  {
    state_id: 'S-17',
    state_code: 19,
    state_name: 'LAKSHADWEEP',
    district_id: 'D-19001',
    district_code: 1901,
    district_name: 'LAKSHADWEEP DISTRICT',
    block_id: 'B-190004',
    block_code: 1901010,
    block_name: 'BITRA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140253',
    block_code: 1418003,
    block_name: 'SAMBA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23003',
    district_code: 2301,
    district_name: 'KOHIMA',
    block_id: 'B-230018',
    block_code: 2301004,
    block_name: 'TSEMINYU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29002',
    district_code: 2937,
    district_name: 'CHENGALPATTU',
    block_id: 'B-290012',
    block_code: 2937009,
    block_name: 'ST.THOMAS MOUNT',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3009',
    district_code: 309,
    district_name: 'LOHIT',
    block_id: 'B-30042',
    block_code: 309003,
    block_name: 'WAKRO',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33007',
    district_code: 3301,
    district_name: 'BILASPUR',
    block_id: 'B-330033',
    block_code: 3301019,
    block_name: 'KOTA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160022',
    block_code: 1608010,
    block_name: 'PARAKKADAVU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360259',
    block_code: 3617002,
    block_name: 'AMRABAD',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33029',
    district_code: 3333,
    district_name: 'SAKTI',
    block_id: 'B-330126',
    block_code: 3333008,
    block_name: 'MALKHARAUDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270031',
    block_code: 2728004,
    block_name: 'BANSWARA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50242',
    block_code: 520013,
    block_name: 'LAKHNAUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290064',
    block_code: 2922011,
    block_name: 'VEDASANDUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310138',
    block_code: 3175009,
    block_name: 'REHERA BAZAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17013',
    district_code: 1711,
    district_name: 'DAMOH',
    block_id: 'B-170080',
    block_code: 1711004,
    block_name: 'PATHARIYA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290028',
    block_code: 2903001,
    block_name: 'CUDDALORE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360313',
    block_code: 3633004,
    block_name: 'MADDUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140111',
    block_code: 1413022,
    block_name: 'PARGWAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50343',
    block_code: 501016,
    block_name: 'MOKAMEH',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20005',
    district_code: 2007,
    district_name: 'IMPHAL WEST',
    block_id: 'B-200026',
    block_code: 2007007,
    block_name: 'IMPHAL WEST II WANGOI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4018',
    district_code: 415,
    district_name: 'JORHAT',
    block_id: 'B-40112',
    block_code: 415004,
    block_name: 'NORTH WEST JORHAT',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15028',
    district_code: 1527,
    district_name: 'UTTARA KANNADA',
    block_id: 'B-150202',
    block_code: 1527010,
    block_name: 'JOIDA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30002',
    district_code: 3008,
    district_name: 'GOMATI',
    block_id: 'B-300015',
    block_code: 3008007,
    block_name: 'SILACHARI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200012',
    block_code: 2003004,
    block_name: 'LANVA',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28004',
    district_code: 2803,
    district_name: 'NAMCHI',
    block_id: 'B-280022',
    block_code: 2803003,
    block_name: 'YANGANG',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260090',
    block_code: 2604003,
    block_name: 'SUDHAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170044',
    block_code: 1731010,
    block_name: 'PRABHAT PATTAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20461',
    block_code: 209003,
    block_name: 'KONDAPURAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33014',
    district_code: 3307,
    district_name: 'JASHPUR',
    block_id: 'B-330062',
    block_code: 3307012,
    block_name: 'JASHPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340190',
    block_code: 3405022,
    block_name: 'RAMGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360185',
    block_code: 3612009,
    block_name: 'KOTHAGUDA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33003',
    district_code: 3327,
    district_name: 'BALRAMPUR',
    block_id: 'B-330014',
    block_code: 3327004,
    block_name: 'RAMCHANDRAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313464',
    block_code: 3130031,
    block_name: 'TADIYAWAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50099',
    block_code: 519004,
    block_name: 'BENIPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50414',
    block_code: 521004,
    block_name: 'NAUHATTA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26006',
    district_code: 2622,
    district_name: 'FAZILKA',
    block_id: 'B-260032',
    block_code: 2622003,
    block_name: 'FAZILLKA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160064',
    block_code: 1610002,
    block_name: 'ETTUMANOOR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14006',
    district_code: 1420,
    district_name: 'GANDERBAL',
    block_id: 'B-140091',
    block_code: 1420004,
    block_name: 'KANGAN',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160141',
    block_code: 1607009,
    block_name: 'MATHILAKAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27032',
    district_code: 2722,
    district_name: 'TONK',
    block_id: 'B-270330',
    block_code: 2722007,
    block_name: 'PEEPLU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360043',
    block_code: 3630002,
    block_name: 'DHARMASAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270008',
    block_code: 2721006,
    block_name: 'PEESANGAN',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350057',
    block_code: 3505003,
    block_name: 'PAURI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130046',
    block_code: 1308001,
    block_name: 'BALH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27015',
    district_code: 2702,
    district_name: 'HANUMANGARH',
    block_id: 'B-270157',
    block_code: 2702007,
    block_name: 'RAWATSAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14017',
    district_code: 1418,
    district_name: 'SAMBA',
    block_id: 'B-140248',
    block_code: 1418005,
    block_name: 'NUD',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23003',
    district_code: 2301,
    district_name: 'KOHIMA',
    block_id: 'B-230013',
    block_code: 2301001,
    block_name: 'CHIEPHOBOZOU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31368',
    district_code: 3111,
    district_name: 'RAMPUR',
    block_id: 'B-313744',
    block_code: 3111001,
    block_name: 'SUAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313166',
    block_code: 3149002,
    block_name: 'MASODHA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33007',
    district_code: 3301,
    district_name: 'BILASPUR',
    block_id: 'B-330034',
    block_code: 3301023,
    block_name: 'MASTURI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160023',
    block_code: 1608011,
    block_name: 'PARAVOOR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360272',
    block_code: 3617015,
    block_name: 'TELKAPALLE',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33029',
    district_code: 3333,
    district_name: 'SAKTI',
    block_id: 'B-330127',
    block_code: 3333003,
    block_name: 'SAKTI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270036',
    block_code: 2728008,
    block_name: 'KUSHALGARH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50234',
    block_code: 520005,
    block_name: 'BISFI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290055',
    block_code: 2922014,
    block_name: 'KODAIKANAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310136',
    block_code: 3175011,
    block_name: 'HARYA SATGHARWA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17013',
    district_code: 1711,
    district_name: 'DAMOH',
    block_id: 'B-170077',
    block_code: 1711001,
    block_name: 'HATTA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290037',
    block_code: 2903003,
    block_name: 'PANRUTI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360318',
    block_code: 3633009,
    block_name: 'NARVA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140113',
    block_code: 1413023,
    block_name: 'SAMWAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50328',
    block_code: 501001,
    block_name: 'ATHMALGOLA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33012',
    district_code: 3328,
    district_name: 'GAURELLA PENDRA MARWAHI',
    block_id: 'B-330052',
    block_code: 3328003,
    block_name: 'GAURELLA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4018',
    district_code: 415,
    district_name: 'JORHAT',
    block_id: 'B-40108',
    block_code: 415005,
    block_name: 'JORHAT',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340108',
    block_code: 3403001,
    block_name: 'BISHUNPUR',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30002',
    district_code: 3008,
    district_name: 'GOMATI',
    block_id: 'B-300009',
    block_code: 3008001,
    block_name: 'AMARPUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200008',
    block_code: 2003003,
    block_name: 'HENGLEP',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28004',
    district_code: 2803,
    district_name: 'NAMCHI',
    block_id: 'B-280015',
    block_code: 2803001,
    block_name: 'NAMCHI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260078',
    block_code: 2604008,
    block_name: 'DEHLON',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23004',
    district_code: 2310,
    district_name: 'LONGLENG',
    block_id: 'B-230020',
    block_code: 2310003,
    block_name: 'SAKSHI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20455',
    block_code: 209004,
    block_name: 'JALADANKI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33014',
    district_code: 3307,
    district_name: 'JASHPUR',
    block_id: 'B-330061',
    block_code: 3307013,
    block_name: 'DULDULA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34018',
    district_code: 3405,
    district_name: 'PALAMU',
    block_id: 'B-340193',
    block_code: 3405021,
    block_name: 'UNTARI ROAD',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360191',
    block_code: 3612015,
    block_name: 'PEDDAVANGARA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33003',
    district_code: 3327,
    district_name: 'BALRAMPUR',
    block_id: 'B-330015',
    block_code: 3327005,
    block_name: 'SHANKARGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313465',
    block_code: 3130030,
    block_name: 'TONDARPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50106',
    block_code: 519011,
    block_name: 'JALE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5030',
    district_code: 521,
    district_name: 'SAHARSA',
    block_id: 'B-50413',
    block_code: 521003,
    block_name: 'MAHISHI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270190',
    block_code: 2718009,
    block_name: 'BAGODA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160065',
    block_code: 1610003,
    block_name: 'KADUTHURUTHY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140044',
    block_code: 1402004,
    block_name: 'ROHAMA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160142',
    block_code: 1607010,
    block_name: 'MULLASSERY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310206',
    block_code: 3124004,
    block_name: 'ASAFPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360044',
    block_code: 3630003,
    block_name: 'ELKATHURTHI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270003',
    block_code: 2721002,
    block_name: 'BHINAY',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35008',
    district_code: 3505,
    district_name: 'PAURI GARHWAL',
    block_id: 'B-350049',
    block_code: 3505008,
    block_name: 'DUGADDA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130048',
    block_code: 1308002,
    block_name: 'CHAUNTRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27015',
    district_code: 2702,
    district_name: 'HANUMANGARH',
    block_id: 'B-270155',
    block_code: 2702003,
    block_name: 'NOHAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240122',
    block_code: 2420005,
    block_name: 'DANAGADI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23003',
    district_code: 2301,
    district_name: 'KOHIMA',
    block_id: 'B-230017',
    block_code: 2301005,
    block_name: 'SECHU ZUBZA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31368',
    district_code: 3111,
    district_name: 'RAMPUR',
    block_id: 'B-313743',
    block_code: 3111005,
    block_name: 'SHAHABAD',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160001',
    block_code: 1611001,
    block_name: 'AMBALAPPUZHA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33011',
    district_code: 3320,
    district_name: 'GARIYABAND',
    block_id: 'B-330049',
    block_code: 3320003,
    block_name: 'FINGESHWAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160024',
    block_code: 1608012,
    block_name: 'VADAVUKOD',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360270',
    block_code: 3617013,
    block_name: 'PENTLAVELLI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33029',
    district_code: 3333,
    district_name: 'SAKTI',
    block_id: 'B-330124',
    block_code: 3333009,
    block_name: 'DABHARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270035',
    block_code: 2728001,
    block_name: 'GHATOL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50240',
    block_code: 520011,
    block_name: 'KHAJAULI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290052',
    block_code: 2922007,
    block_name: 'BATLAGUNDU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31012',
    district_code: 3175,
    district_name: 'BALRAMPUR',
    block_id: 'B-310134',
    block_code: 3175008,
    block_name: 'GAINDAS BUJURG',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17013',
    district_code: 1711,
    district_name: 'DAMOH',
    block_id: 'B-170079',
    block_code: 1711002,
    block_name: 'PATERA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290033',
    block_code: 2903004,
    block_name: 'KURINJIPADI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360309',
    block_code: 3633001,
    block_name: 'DAMARAGIDDA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140103',
    block_code: 1413018,
    block_name: 'KHARAH BALLI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50342',
    block_code: 501015,
    block_name: 'MASAURHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140026',
    block_code: 1419019,
    block_name: 'NOWGAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4018',
    district_code: 415,
    district_name: 'JORHAT',
    block_id: 'B-40110',
    block_code: 415002,
    block_name: 'JORHAT EAST',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340111',
    block_code: 3403002,
    block_name: 'GHAGHRA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30002',
    district_code: 3008,
    district_name: 'GOMATI',
    block_id: 'B-300012',
    block_code: 3008002,
    block_name: 'KILLA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200015',
    block_code: 2003005,
    block_name: 'SAMULAMLAN',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28004',
    district_code: 2803,
    district_name: 'NAMCHI',
    block_id: 'B-280021',
    block_code: 2803004,
    block_name: 'TEMI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260080',
    block_code: 2604001,
    block_name: 'JAGRAON',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23004',
    district_code: 2310,
    district_name: 'LONGLENG',
    block_id: 'B-230019',
    block_code: 2310001,
    block_name: 'LONGLENG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20459',
    block_code: 209005,
    block_name: 'KAVALI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33014',
    district_code: 3307,
    district_name: 'JASHPUR',
    block_id: 'B-330065',
    block_code: 3307016,
    block_name: 'MANORA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180045',
    block_code: 1818012,
    block_name: 'AMBAJOGAI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360187',
    block_code: 3612011,
    block_name: 'MAHABUBABAD',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33003',
    district_code: 3327,
    district_name: 'BALRAMPUR',
    block_id: 'B-330016',
    block_code: 3327006,
    block_name: 'WADRAFNAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31332',
    district_code: 3134,
    district_name: 'FARRUKHABAD',
    block_id: 'B-313350',
    block_code: 3134006,
    block_name: 'MOHAMDABAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50102',
    block_code: 519007,
    block_name: 'GHANSHYAMPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240212',
    block_code: 2404044,
    block_name: 'BADASAHI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270197',
    block_code: 2718010,
    block_name: 'SARNAU',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160067',
    block_code: 1610005,
    block_name: 'LALAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140054',
    block_code: 1402007,
    block_name: 'ZAINGEER',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160143',
    block_code: 1607011,
    block_name: 'OLLUKKARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310210',
    block_code: 3124005,
    block_name: 'ISLAMNAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360045',
    block_code: 3630005,
    block_name: 'HASANPARTHY',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27001',
    district_code: 2721,
    district_name: 'AJMER',
    block_id: 'B-270001',
    block_code: 2721011,
    block_name: 'AJMER RURAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313783',
    block_code: 3127023,
    block_name: 'JALALABAD',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130052',
    block_code: 1308004,
    block_name: 'DRANG',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27015',
    district_code: 2702,
    district_name: 'HANUMANGARH',
    block_id: 'B-270158',
    block_code: 2702004,
    block_name: 'SANGARIYA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240123',
    block_code: 2420006,
    block_name: 'DASARATHAPUR',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23003',
    district_code: 2301,
    district_name: 'KOHIMA',
    block_id: 'B-230014',
    block_code: 2301007,
    block_name: 'CHUNLIKHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31368',
    district_code: 3111,
    district_name: 'RAMPUR',
    block_id: 'B-313741',
    block_code: 3111006,
    block_name: 'MILAK',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160005',
    block_code: 1611005,
    block_name: 'CHENGANNUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33011',
    district_code: 3320,
    district_name: 'GARIYABAND',
    block_id: 'B-330050',
    block_code: 3320004,
    block_name: 'GARIYABAND',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300057',
    block_code: 3001001,
    block_name: 'MOHANPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360274',
    block_code: 3617017,
    block_name: 'UPPUNUNTHALA',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28005',
    district_code: 2806,
    district_name: 'PAKYONG',
    block_id: 'B-280025',
    block_code: 2806010,
    block_name: 'PARAKHA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270028',
    block_code: 2728005,
    block_name: 'ANANDPURI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5020',
    district_code: 520,
    district_name: 'MADHUBANI',
    block_id: 'B-50246',
    block_code: 520018,
    block_name: 'MADHWAPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29015',
    district_code: 2914,
    district_name: 'NAGAPATTINAM',
    block_id: 'B-290141',
    block_code: 2914005,
    block_name: 'THALAINAYAR',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22001',
    district_code: 2201,
    district_name: 'AIZAWL',
    block_id: 'B-220004',
    block_code: 2201002,
    block_name: 'TLANGNUAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17013',
    district_code: 1711,
    district_name: 'DAMOH',
    block_id: 'B-170075',
    block_code: 1711003,
    block_name: 'BATIYAGARH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290030',
    block_code: 2903005,
    block_name: 'KATTUMANNAR KOIL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360310',
    block_code: 3633002,
    block_name: 'DHANWADA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140097',
    block_code: 1413015,
    block_name: 'ARNIA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5026',
    district_code: 501,
    district_name: 'PATNA',
    block_id: 'B-50334',
    block_code: 501009,
    block_name: 'DANAPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140017',
    block_code: 1419016,
    block_name: 'ALOOSA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4018',
    district_code: 415,
    district_name: 'JORHAT',
    block_id: 'B-40113',
    block_code: 415006,
    block_name: 'TITABOR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340109',
    block_code: 3403003,
    block_name: 'CHAINPUR',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30002',
    district_code: 3008,
    district_name: 'GOMATI',
    block_id: 'B-300013',
    block_code: 3008003,
    block_name: 'MATABARI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200014',
    block_code: 2003010,
    block_name: 'SAIKOT',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28004',
    district_code: 2803,
    district_name: 'NAMCHI',
    block_id: 'B-280020',
    block_code: 2803019,
    block_name: 'SUM BUK',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260082',
    block_code: 2604004,
    block_name: 'LUDHIANA 1',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23004',
    district_code: 2310,
    district_name: 'LONGLENG',
    block_id: 'B-230021',
    block_code: 2310002,
    block_name: 'TAMLU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20448',
    block_code: 209006,
    block_name: 'BOGOLE',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33014',
    district_code: 3307,
    district_name: 'JASHPUR',
    block_id: 'B-330060',
    block_code: 3307009,
    block_name: 'BAGICHA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18023',
    district_code: 1820,
    district_name: 'OSMANABAD',
    block_id: 'B-180218',
    block_code: 1820035,
    block_name: 'OMERGA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360189',
    block_code: 3612013,
    block_name: 'NARSIMHULAPET',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33003',
    district_code: 3327,
    district_name: 'BALRAMPUR',
    block_id: 'B-330011',
    block_code: 3327001,
    block_name: 'BALRAMPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180248',
    block_code: 1810014,
    block_name: 'MAWAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50100',
    block_code: 519005,
    block_name: 'BIRAUL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240217',
    block_code: 2404049,
    block_name: 'BIJATALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290025',
    block_code: 2911017,
    block_name: 'SULUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160070',
    block_code: 1610008,
    block_name: 'PAMPADY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140052',
    block_code: 1402008,
    block_name: 'WAGOORA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160144',
    block_code: 1607012,
    block_name: 'PAZHAYANNUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31018',
    district_code: 3124,
    district_name: 'BUDAUN',
    block_id: 'B-310219',
    block_code: 3124007,
    block_name: 'WAZIRGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15021',
    district_code: 1521,
    district_name: 'MANDYA',
    block_id: 'B-150146',
    block_code: 1521001,
    block_name: 'KRISHNARAJPET',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313478',
    block_code: 3138003,
    block_name: 'MADHOGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313793',
    block_code: 3127025,
    block_name: 'TILHAR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130053',
    block_code: 1308005,
    block_name: 'GOHAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27015',
    district_code: 2702,
    district_name: 'HANUMANGARH',
    block_id: 'B-270159',
    block_code: 2702006,
    block_name: 'TIBI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240127',
    block_code: 2420009,
    block_name: 'RASULPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360329',
    block_code: 3619010,
    block_name: 'LOKESWARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31368',
    district_code: 3111,
    district_name: 'RAMPUR',
    block_id: 'B-313739',
    block_code: 3111007,
    block_name: 'BILASPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160008',
    block_code: 1611008,
    block_name: 'MAVELIKKARA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33011',
    district_code: 3320,
    district_name: 'GARIYABAND',
    block_id: 'B-330051',
    block_code: 3320005,
    block_name: 'MAINPUR',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300053',
    block_code: 3001002,
    block_name: 'HEZAMARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360275',
    block_code: 3617018,
    block_name: 'URKONDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17022',
    district_code: 1733,
    district_name: 'JABALPUR',
    block_id: 'B-170131',
    block_code: 1733003,
    block_name: 'PATAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270034',
    block_code: 2728003,
    block_name: 'GARHI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29034',
    district_code: 2915,
    district_name: 'TIRUVARUR',
    block_id: 'B-290349',
    block_code: 2915005,
    block_name: 'KORADACHERI',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22001',
    district_code: 2201,
    district_name: 'AIZAWL',
    block_id: 'B-220003',
    block_code: 2201003,
    block_name: 'THINGSULTHLIAH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17013',
    district_code: 1711,
    district_name: 'DAMOH',
    block_id: 'B-170076',
    block_code: 1711005,
    block_name: 'DAMOH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290040',
    block_code: 2903010,
    block_name: 'VRIDHACHALAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360312',
    block_code: 3633011,
    block_name: 'KRISHNA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140099',
    block_code: 1413016,
    block_name: 'BHALWAL BRAHMANA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18024',
    district_code: 1835,
    district_name: 'PALGHAR',
    block_id: 'B-180230',
    block_code: 1835008,
    block_name: 'WADA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140018',
    block_code: 1419017,
    block_name: 'ARIN',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340110',
    block_code: 3403004,
    block_name: 'DUMRI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30002',
    district_code: 3008,
    district_name: 'GOMATI',
    block_id: 'B-300016',
    block_code: 3008008,
    block_name: 'TEPANIA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200016',
    block_code: 2003011,
    block_name: 'SANGAIKOT',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28004',
    district_code: 2803,
    district_name: 'NAMCHI',
    block_id: 'B-280016',
    block_code: 2803007,
    block_name: 'NAMTHANG',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260084',
    block_code: 2604006,
    block_name: 'MACHHIWARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27011',
    district_code: 2704,
    district_name: 'CHURU',
    block_id: 'B-270125',
    block_code: 2704001,
    block_name: 'TARANAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20456',
    block_code: 209007,
    block_name: 'KALIGIRI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170042',
    block_code: 1731006,
    block_name: 'GHORA DONGRI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180050',
    block_code: 1818005,
    block_name: 'KAIJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360182',
    block_code: 3612006,
    block_name: 'GARLA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17040',
    district_code: 1712,
    district_name: 'SATNA',
    block_id: 'B-170251',
    block_code: 1712002,
    block_name: 'SOHAWAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18026',
    district_code: 1810,
    district_name: 'PUNE',
    block_id: 'B-180250',
    block_code: 1810010,
    block_name: 'PURANDHAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50105',
    block_code: 519010,
    block_name: 'HAYAGHAT',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240226',
    block_code: 2404056,
    block_name: 'KUSUMI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290017',
    block_code: 2911001,
    block_name: 'KARAMADAI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160071',
    block_code: 1610009,
    block_name: 'UZHAVOOR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140043',
    block_code: 1402005,
    block_name: 'RAFIABAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313423',
    block_code: 3154005,
    block_name: 'CHARGANWA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15021',
    district_code: 1521,
    district_name: 'MANDYA',
    block_id: 'B-150149',
    block_code: 1521004,
    block_name: 'MANDYA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313474',
    block_code: 3138004,
    block_name: 'JALAUN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313791',
    block_code: 3127026,
    block_name: 'POWAYAN',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130054',
    block_code: 1308006,
    block_name: 'GOPALPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27015',
    district_code: 2702,
    district_name: 'HANUMANGARH',
    block_id: 'B-270156',
    block_code: 2702008,
    block_name: 'PILIBANGAN.',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50147',
    block_code: 511010,
    block_name: 'PACH DEURI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360323',
    block_code: 3619004,
    block_name: 'DILAWARPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31368',
    district_code: 3111,
    district_name: 'RAMPUR',
    block_id: 'B-313742',
    block_code: 3111003,
    block_name: 'SAIDNAGAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160002',
    block_code: 1611002,
    block_name: 'ARYAD',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160003',
    block_code: 1611003,
    block_name: 'BHARANIKKAVU',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300054',
    block_code: 3001009,
    block_name: 'JIRANIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360276',
    block_code: 3617019,
    block_name: 'VANGOOR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12004',
    district_code: 1209,
    district_name: 'FARIDABAD',
    block_id: 'B-120019',
    block_code: 1209001,
    block_name: 'FARIDABAD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27003',
    district_code: 2728,
    district_name: 'BANSWARA',
    block_id: 'B-270033',
    block_code: 2728011,
    block_name: 'GAANGDTALAI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29006',
    district_code: 2922,
    district_name: 'DINDIGUL',
    block_id: 'B-290060',
    block_code: 2922003,
    block_name: 'REDDIARCHATRAM',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22001',
    district_code: 2201,
    district_name: 'AIZAWL',
    block_id: 'B-220001',
    block_code: 2201001,
    block_name: 'AIBAWK',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17013',
    district_code: 1711,
    district_name: 'DAMOH',
    block_id: 'B-170078',
    block_code: 1711006,
    block_name: 'JABERA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313625',
    block_code: 3156001,
    block_name: 'DOHRI GHAT',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36021',
    district_code: 3633,
    district_name: 'NARAYANPET',
    block_id: 'B-360315',
    block_code: 3633006,
    block_name: 'MAKTHAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140115',
    block_code: 1413024,
    block_name: 'SUCHETGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313134',
    block_code: 3178002,
    block_name: 'KATEHARI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140019',
    block_code: 1419018,
    block_name: 'BAKTOOR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340115',
    block_code: 3403005,
    block_name: 'RAIDIH',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21003',
    district_code: 2101,
    district_name: 'EAST JAINTIA HILLS',
    block_id: 'B-210006',
    block_code: 2101008,
    block_name: 'KHLIEHRIAT',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200010',
    block_code: 2003012,
    block_name: 'LAMKA',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28004',
    district_code: 2803,
    district_name: 'NAMCHI',
    block_id: 'B-280018',
    block_code: 2803017,
    block_name: 'RAVONGLA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260079',
    block_code: 2604009,
    block_name: 'DORAHA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27011',
    district_code: 2704,
    district_name: 'CHURU',
    block_id: 'B-270121',
    block_code: 2704002,
    block_name: 'RAJGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20479',
    block_code: 209008,
    block_name: 'VINJAMUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17032',
    district_code: 1741,
    district_name: 'NEEMUCH',
    block_id: 'B-170198',
    block_code: 1741002,
    block_name: 'NEEMUCH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180053',
    block_code: 1818006,
    block_name: 'PATODA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360186',
    block_code: 3612010,
    block_name: 'KURAVI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17040',
    district_code: 1712,
    district_name: 'SATNA',
    block_id: 'B-170247',
    block_code: 1712001,
    block_name: 'MAJHGAWAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20322',
    block_code: 226028,
    block_name: 'BANDI ATMAKUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50097',
    block_code: 519002,
    block_name: 'BAHADURPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240219',
    block_code: 2404059,
    block_name: 'GOPABANDHUNAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290020',
    block_code: 2911003,
    block_name: 'P.N.PALAYAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160073',
    block_code: 1610011,
    block_name: 'VAZHOOR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140048',
    block_code: 1402006,
    block_name: 'SOPORE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31315',
    district_code: 3167,
    district_name: 'AMROHA',
    block_id: 'B-313154',
    block_code: 3167001,
    block_name: 'HASANPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15021',
    district_code: 1521,
    district_name: 'MANDYA',
    block_id: 'B-150150',
    block_code: 1521005,
    block_name: 'NAGAMANGALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31349',
    district_code: 3180,
    district_name: 'KASGANJ',
    block_id: 'B-313533',
    block_code: 3180002,
    block_name: 'KASGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31362',
    district_code: 3110,
    district_name: 'MORADABAD',
    block_id: 'B-313660',
    block_code: 3110002,
    block_name: 'DILARI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130056',
    block_code: 1308008,
    block_name: 'MANDI SADAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18033',
    district_code: 1802,
    district_name: 'THANE',
    block_id: 'B-180317',
    block_code: 1802015,
    block_name: 'AMBERNATH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240119',
    block_code: 2420001,
    block_name: 'BADCHANA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360337',
    block_code: 3619019,
    block_name: 'TANUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31368',
    district_code: 3111,
    district_name: 'RAMPUR',
    block_id: 'B-313740',
    block_code: 3111004,
    block_name: 'CHAMRAWA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160006',
    block_code: 1611006,
    block_name: 'HARIPPAD',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160004',
    block_code: 1611004,
    block_name: 'CHAMPAKKULAM',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300052',
    block_code: 3001010,
    block_name: 'DUKLI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360260',
    block_code: 3617003,
    block_name: 'BALMOOR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12004',
    district_code: 1209,
    district_name: 'FARIDABAD',
    block_id: 'B-120018',
    block_code: 1209002,
    block_name: 'BALLABGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313261',
    block_code: 3125024,
    block_name: 'BITHIRI CHAINPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27013',
    district_code: 2708,
    district_name: 'DHOLPUR',
    block_id: 'B-270141',
    block_code: 2708005,
    block_name: 'SAIPAU',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22001',
    district_code: 2201,
    district_name: 'AIZAWL',
    block_id: 'B-220002',
    block_code: 2201005,
    block_name: 'DARLAWN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17013',
    district_code: 1711,
    district_name: 'DAMOH',
    block_id: 'B-170081',
    block_code: 1711007,
    block_name: 'TENDUKHEDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313626',
    block_code: 3156002,
    block_name: 'FATEHPUR MADAUN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290329',
    block_code: 2902001,
    block_name: 'VILLIVAKKAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140098',
    block_code: 1413002,
    block_name: 'BHALWAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18024',
    district_code: 1835,
    district_name: 'PALGHAR',
    block_id: 'B-180229',
    block_code: 1835014,
    block_name: 'VIKRAMGAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140021',
    block_code: 1419013,
    block_name: 'BANKOOT',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340112',
    block_code: 3403006,
    block_name: 'GUMLA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21003',
    district_code: 2101,
    district_name: 'EAST JAINTIA HILLS',
    block_id: 'B-210007',
    block_code: 2101007,
    block_name: 'SAIPUNG',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200019',
    block_code: 2003009,
    block_name: 'TUIBOUNG',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28004',
    district_code: 2803,
    district_name: 'NAMCHI',
    block_id: 'B-280019',
    block_code: 2803020,
    block_name: 'SIKKIP',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260086',
    block_code: 2604010,
    block_name: 'PAKHOWAL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27011',
    district_code: 2704,
    district_name: 'CHURU',
    block_id: 'B-270120',
    block_code: 2704004,
    block_name: 'CHURU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20452',
    block_code: 209009,
    block_name: 'DUTTALUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17032',
    district_code: 1741,
    district_name: 'NEEMUCH',
    block_id: 'B-170197',
    block_code: 1741003,
    block_name: 'MANASA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180046',
    block_code: 1818007,
    block_name: 'ASHTI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36013',
    district_code: 3612,
    district_name: 'MAHABUBABAD',
    block_id: 'B-360190',
    block_code: 3612014,
    block_name: 'NELLIKUDUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17040',
    district_code: 1712,
    district_name: 'SATNA',
    block_id: 'B-170248',
    block_code: 1712003,
    block_name: 'NAGOD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20323',
    block_code: 226004,
    block_name: 'BETHAMCHERLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50096',
    block_code: 519001,
    block_name: 'ALINAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240233',
    block_code: 2404063,
    block_name: 'SUKRULI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290023',
    block_code: 2911004,
    block_name: 'S S KULAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160063',
    block_code: 1610001,
    block_name: 'ERATTUPETTAH',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140042',
    block_code: 1402009,
    block_name: 'PATTAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31315',
    district_code: 3167,
    district_name: 'AMROHA',
    block_id: 'B-313150',
    block_code: 3167002,
    block_name: 'AMROHA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15021',
    district_code: 1521,
    district_name: 'MANDYA',
    block_id: 'B-150151',
    block_code: 1521006,
    block_name: 'PANDAVAPURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31349',
    district_code: 3180,
    district_name: 'KASGANJ',
    block_id: 'B-313531',
    block_code: 3180003,
    block_name: 'AMANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31362',
    district_code: 3110,
    district_name: 'MORADABAD',
    block_id: 'B-313659',
    block_code: 3110004,
    block_name: 'CHHAJLET',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130058',
    block_code: 1308009,
    block_name: 'SERAJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18033',
    district_code: 1802,
    district_name: 'THANE',
    block_id: 'B-180318',
    block_code: 1802009,
    block_name: 'BHIWANDI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240121',
    block_code: 2420003,
    block_name: 'BINJHARPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360321',
    block_code: 3619002,
    block_name: 'BHAINSA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20010',
    district_code: 2016,
    district_name: 'NONEY',
    block_id: 'B-200048',
    block_code: 2016004,
    block_name: 'NUNGBA T D BLOCK',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160007',
    block_code: 1611007,
    block_name: 'KANJIKKUZHY',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160011',
    block_code: 1611011,
    block_name: 'THAIKKATTUSSERY',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300056',
    block_code: 3001008,
    block_name: 'MANDWI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360269',
    block_code: 3617012,
    block_name: 'PEDDAKOTHAPALLE',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12004',
    district_code: 1209,
    district_name: 'FARIDABAD',
    block_id: 'B-120020',
    block_code: 1209003,
    block_name: 'TIGAON',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313265',
    block_code: 3125025,
    block_name: 'MAJHGAWAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270351',
    block_code: 2726110,
    block_name: 'SAYRA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320288',
    block_code: 3202007,
    block_name: 'KHANDAGHOSH',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140225',
    block_code: 1416005,
    block_name: 'BATOTE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313627',
    block_code: 3156003,
    block_name: 'GHOSI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290319',
    block_code: 2902003,
    block_name: 'MINJUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140104',
    block_code: 1413005,
    block_name: 'KHOUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18024',
    district_code: 1835,
    district_name: 'PALGHAR',
    block_id: 'B-180226',
    block_code: 1835003,
    block_name: 'PALGHAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140024',
    block_code: 1419003,
    block_name: 'HAJIN',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340116',
    block_code: 3403007,
    block_name: 'SISAI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17008',
    district_code: 1702,
    district_name: 'BHIND',
    block_id: 'B-170046',
    block_code: 1702001,
    block_name: 'ATER',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200017',
    block_code: 2003006,
    block_name: 'SINGNGAT',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28004',
    district_code: 2803,
    district_name: 'NAMCHI',
    block_id: 'B-280017',
    block_code: 2803016,
    block_name: 'POKLOK NANUGAON',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260081',
    block_code: 2604011,
    block_name: 'KHANNA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27011',
    district_code: 2704,
    district_name: 'CHURU',
    block_id: 'B-270122',
    block_code: 2704005,
    block_name: 'RATANGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20446',
    block_code: 209013,
    block_name: 'ANUMASAMUDRAMPETA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20008',
    district_code: 2014,
    district_name: 'KAMJONG',
    block_id: 'B-200032',
    block_code: 2014004,
    block_name: 'KAMJONG T D BLOCK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180055',
    block_code: 1818009,
    block_name: 'WADWANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313595',
    block_code: 3152001,
    block_name: 'NAUTANWA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17040',
    district_code: 1712,
    district_name: 'SATNA',
    block_id: 'B-170252',
    block_code: 1712004,
    block_name: 'UNCHAHARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20336',
    block_code: 226017,
    block_name: 'NANDYAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50098',
    block_code: 519003,
    block_name: 'BAHERI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240231',
    block_code: 2404064,
    block_name: 'SAMAKHUNTA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270198',
    block_code: 2718001,
    block_name: 'SAYLA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160069',
    block_code: 1610007,
    block_name: 'PALLAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14006',
    district_code: 1420,
    district_name: 'GANDERBAL',
    block_id: 'B-140095',
    block_code: 1420003,
    block_name: 'WAKURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313419',
    block_code: 3154095,
    block_name: 'BHAROHIYA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15021',
    district_code: 1521,
    district_name: 'MANDYA',
    block_id: 'B-150152',
    block_code: 1521007,
    block_name: 'SHRIRANGAPATTANA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31349',
    district_code: 3180,
    district_name: 'KASGANJ',
    block_id: 'B-313535',
    block_code: 3180004,
    block_name: 'SAHAWAR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3014',
    district_code: 319,
    district_name: 'NAMSAI',
    block_id: 'B-30058',
    block_code: 319002,
    block_name: 'LEKANG',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130055',
    block_code: 1308007,
    block_name: 'KARSOG',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18033',
    district_code: 1802,
    district_name: 'THANE',
    block_id: 'B-180321',
    block_code: 1802010,
    block_name: 'SHAHAPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240125',
    block_code: 2420007,
    block_name: 'JAJPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360324',
    block_code: 3619059,
    block_name: 'KADDAM  PEDDUR ',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20010',
    district_code: 2016,
    district_name: 'NONEY',
    block_id: 'B-200046',
    block_code: 2016005,
    block_name: 'KHOUPUM T D BLOCK',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160009',
    block_code: 1611009,
    block_name: 'MUTHUKULAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33011',
    district_code: 3320,
    district_name: 'GARIYABAND',
    block_id: 'B-330047',
    block_code: 3320001,
    block_name: 'CHHURRA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300050',
    block_code: 3001018,
    block_name: 'BAMUTIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360277',
    block_code: 3617020,
    block_name: 'VELDANDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17043',
    district_code: 1714,
    district_name: 'SHAHDOL',
    block_id: 'B-170268',
    block_code: 1714004,
    block_name: 'GOHPARU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313268',
    block_code: 3125028,
    block_name: 'RAMNAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27013',
    district_code: 2708,
    district_name: 'DHOLPUR',
    block_id: 'B-270138',
    block_code: 2708001,
    block_name: 'BASERI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320276',
    block_code: 3202008,
    block_name: 'BHATAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14015',
    district_code: 1416,
    district_name: 'RAMBAN',
    block_id: 'B-140228',
    block_code: 1416007,
    block_name: 'GUNDI DHARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313624',
    block_code: 3156004,
    block_name: 'BADRAON',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290325',
    block_code: 2902004,
    block_name: 'SHOLAVARAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140107',
    block_code: 1413006,
    block_name: 'MARH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18024',
    district_code: 1835,
    district_name: 'PALGHAR',
    block_id: 'B-180223',
    block_code: 1835004,
    block_name: 'DAHANU',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140027',
    block_code: 1419004,
    block_name: 'SUMBAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340106',
    block_code: 3403009,
    block_name: 'BASIA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17008',
    district_code: 1702,
    district_name: 'BHIND',
    block_id: 'B-170047',
    block_code: 1702002,
    block_name: 'BHIND',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200011',
    block_code: 2003001,
    block_name: 'LAMKA SOUTH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17048',
    district_code: 1750,
    district_name: 'SINGROLI',
    block_id: 'B-170293',
    block_code: 1750001,
    block_name: 'WAIDHAN',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260088',
    block_code: 2604007,
    block_name: 'SAMRALA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27011',
    district_code: 2704,
    district_name: 'CHURU',
    block_id: 'B-270124',
    block_code: 2704006,
    block_name: 'SUJANGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20457',
    block_code: 209022,
    block_name: 'KALUVOYA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20008',
    district_code: 2014,
    district_name: 'KAMJONG',
    block_id: 'B-200034',
    block_code: 2014003,
    block_name: 'PHUNGYAR T D BLOCK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180048',
    block_code: 1818010,
    block_name: 'DHARUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313592',
    block_code: 3152002,
    block_name: 'LAKSHMIPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17040',
    district_code: 1712,
    district_name: 'SATNA',
    block_id: 'B-170250',
    block_code: 1712005,
    block_name: 'RAMPUR BAGHELAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20343',
    block_code: 226024,
    block_name: 'SANJAMALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50112',
    block_code: 519017,
    block_name: 'SINGHWARA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240232',
    block_code: 2404066,
    block_name: 'SARASKANA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270189',
    block_code: 2718002,
    block_name: 'AHORE',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16007',
    district_code: 1610,
    district_name: 'KOTTAYAM',
    block_id: 'B-160072',
    block_code: 1610010,
    block_name: 'VAIKKOM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140049',
    block_code: 1402012,
    block_name: 'TANGMARG',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160137',
    block_code: 1607005,
    block_name: 'CHOVANNUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360041',
    block_code: 3630001,
    block_name: 'BHEEMADEVARAPALLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31349',
    district_code: 3180,
    district_name: 'KASGANJ',
    block_id: 'B-313534',
    block_code: 3180006,
    block_name: 'PATIYALI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3014',
    district_code: 319,
    district_name: 'NAMSAI',
    block_id: 'B-30057',
    block_code: 319001,
    block_name: 'CHOWKHAM',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130059',
    block_code: 1308010,
    block_name: 'SUNDERNAGAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18033',
    district_code: 1802,
    district_name: 'THANE',
    block_id: 'B-180320',
    block_code: 1802011,
    block_name: 'MURBAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240126',
    block_code: 2420008,
    block_name: 'KOREI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360326',
    block_code: 3619007,
    block_name: 'KUBEER',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20010',
    district_code: 2016,
    district_name: 'NONEY',
    block_id: 'B-200045',
    block_code: 2016001,
    block_name: 'HAOCHONG T D BLOCK',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160010',
    block_code: 1611010,
    block_name: 'PATTANAKKAD',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33011',
    district_code: 3320,
    district_name: 'GARIYABAND',
    block_id: 'B-330048',
    block_code: 3320002,
    block_name: 'DEOBHOG',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300051',
    block_code: 3001019,
    block_name: 'BELBARI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36019',
    district_code: 3617,
    district_name: 'NAGARKURNOOL',
    block_id: 'B-360263',
    block_code: 3617006,
    block_name: 'KALWAKURTHY',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17043',
    district_code: 1714,
    district_name: 'SHAHDOL',
    block_id: 'B-170267',
    block_code: 1714005,
    block_name: 'BURHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313270',
    block_code: 3125029,
    block_name: 'SHERGARH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27013',
    district_code: 2708,
    district_name: 'DHOLPUR',
    block_id: 'B-270137',
    block_code: 2708002,
    block_name: 'BARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320289',
    block_code: 3202033,
    block_name: 'MANTESWAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40066',
    block_code: 401012,
    block_name: 'JAMADARHAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313628',
    block_code: 3156005,
    block_name: 'KOPAGANJ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290324',
    block_code: 2902009,
    block_name: 'R.K.PET',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140114',
    block_code: 1413009,
    block_name: 'SATWARI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33021',
    district_code: 3315,
    district_name: 'MAHASAMUND',
    block_id: 'B-330096',
    block_code: 3315002,
    block_name: 'MAHASAMUND',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140023',
    block_code: 1419002,
    block_name: 'GUREZ',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11026',
    district_code: 1121,
    district_name: 'PORBANDAR',
    block_id: 'B-110189',
    block_code: 1121004,
    block_name: 'RANAVAV',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17008',
    district_code: 1702,
    district_name: 'BHIND',
    block_id: 'B-170050',
    block_code: 1702003,
    block_name: 'MEHGAON',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200018',
    block_code: 2003015,
    block_name: 'SUANGDOH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17048',
    district_code: 1750,
    district_name: 'SINGROLI',
    block_id: 'B-170292',
    block_code: 1750002,
    block_name: 'DEOSAR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260083',
    block_code: 2604005,
    block_name: 'LUDHIANA 2',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270303',
    block_code: 2713003,
    block_name: 'DHOND',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20469',
    block_code: 209023,
    block_name: 'RAPUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20008',
    district_code: 2014,
    district_name: 'KAMJONG',
    block_id: 'B-200033',
    block_code: 2014005,
    block_name: 'KASOM KHULLEN T D BLOCK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18023',
    district_code: 1820,
    district_name: 'OSMANABAD',
    block_id: 'B-180217',
    block_code: 1820032,
    block_name: 'LOHARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313596',
    block_code: 3152003,
    block_name: 'NICHLAUL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240060',
    block_code: 2406042,
    block_name: 'BANKI- DAMPARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20325',
    block_code: 226006,
    block_name: 'DHONE ALIAS DRONACHALAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50111',
    block_code: 519016,
    block_name: 'MANIGACHHI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240213',
    block_code: 2404045,
    block_name: 'BAHALDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270191',
    block_code: 2718004,
    block_name: 'BHINMAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180132',
    block_code: 1808011,
    block_name: 'PAROLA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14006',
    district_code: 1420,
    district_name: 'GANDERBAL',
    block_id: 'B-140089',
    block_code: 1420001,
    block_name: 'GANDERBAL',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22004',
    district_code: 2210,
    district_name: 'KHAWZAWL',
    block_id: 'B-220008',
    block_code: 2210001,
    block_name: 'KHAWZAWL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360046',
    block_code: 3630006,
    block_name: 'INAVOLE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31349',
    district_code: 3180,
    district_name: 'KASGANJ',
    block_id: 'B-313536',
    block_code: 3180007,
    block_name: 'SIDHPURA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3014',
    district_code: 319,
    district_name: 'NAMSAI',
    block_id: 'B-30059',
    block_code: 319003,
    block_name: 'NAMSAI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130051',
    block_code: 1308003,
    block_name: 'DHARAMPUR MANDI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18033',
    district_code: 1802,
    district_name: 'THANE',
    block_id: 'B-180319',
    block_code: 1802012,
    block_name: 'KALYAN',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240128',
    block_code: 2420010,
    block_name: 'SUKINDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360331',
    block_code: 3619012,
    block_name: 'MUDHOLE',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20010',
    district_code: 2016,
    district_name: 'NONEY',
    block_id: 'B-200047',
    block_code: 2016006,
    block_name: 'LONGMAI NONEY TD BLOCK',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16001',
    district_code: 1611,
    district_name: 'ALAPPUZHA',
    block_id: 'B-160012',
    block_code: 1611012,
    block_name: 'VELIYANAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240266',
    block_code: 2413010,
    block_name: 'KANAS',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300058',
    block_code: 3001020,
    block_name: 'OLD AGARTALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313737',
    block_code: 3133002,
    block_name: 'SHIVGARH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17022',
    district_code: 1733,
    district_name: 'JABALPUR',
    block_id: 'B-170129',
    block_code: 1733002,
    block_name: 'MAJHOULI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313256',
    block_code: 3125031,
    block_name: 'AALAMPUR JAFARABAD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27013',
    district_code: 2708,
    district_name: 'DHOLPUR',
    block_id: 'B-270140',
    block_code: 2708004,
    block_name: 'RAJAKHERA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32021',
    district_code: 3202,
    district_name: 'PURBA BARDHAMAN',
    block_id: 'B-320281',
    block_code: 3202004,
    block_name: 'JAMALPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40064',
    block_code: 401003,
    block_name: 'GAURIPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313630',
    block_code: 3156006,
    block_name: 'PARDAHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290318',
    block_code: 2902012,
    block_name: 'KADAMBATHUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140100',
    block_code: 1413003,
    block_name: 'BISHNAH',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33021',
    district_code: 3315,
    district_name: 'MAHASAMUND',
    block_id: 'B-330098',
    block_code: 3315004,
    block_name: 'SARAIPALI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140028',
    block_code: 1419005,
    block_name: 'TULAIL',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11026',
    district_code: 1121,
    district_name: 'PORBANDAR',
    block_id: 'B-110187',
    block_code: 1121005,
    block_name: 'KUTIYANA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17008',
    district_code: 1702,
    district_name: 'BHIND',
    block_id: 'B-170048',
    block_code: 1702004,
    block_name: 'GOHAD',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20003',
    district_code: 2003,
    district_name: 'CHURACHANDPUR',
    block_id: 'B-200013',
    block_code: 2003013,
    block_name: 'MUALNUAM',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20011',
    district_code: 2015,
    district_name: 'PHERZAWL',
    block_id: 'B-200050',
    block_code: 2015007,
    block_name: 'TIPAIMUKH T D BLOCK',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260085',
    block_code: 2604013,
    block_name: 'MALOUD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270212',
    block_code: 2705011,
    block_name: 'MANDAWA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20462',
    block_code: 209026,
    block_name: 'KOVUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20008',
    district_code: 2014,
    district_name: 'KAMJONG',
    block_id: 'B-200035',
    block_code: 2014001,
    block_name: 'SAHAMPHUNG TD BLOCK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18023',
    district_code: 1820,
    district_name: 'OSMANABAD',
    block_id: 'B-180220',
    block_code: 1820033,
    block_name: 'PARANDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313600',
    block_code: 3152005,
    block_name: 'SISWA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240069',
    block_code: 2406005,
    block_name: 'TANGI CHOUDWAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20330',
    block_code: 226011,
    block_name: 'KOILAKUNTLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50108',
    block_code: 519013,
    block_name: 'KIRATPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24022',
    district_code: 2404,
    district_name: 'MAYURBHANJ',
    block_id: 'B-240214',
    block_code: 2404046,
    block_name: 'BANGRIPOSI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270194',
    block_code: 2718005,
    block_name: 'JASWANTPURA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18013',
    district_code: 1808,
    district_name: 'JALGAON',
    block_id: 'B-180123',
    block_code: 1808014,
    block_name: 'BODWAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14006',
    district_code: 1420,
    district_name: 'GANDERBAL',
    block_id: 'B-140092',
    block_code: 1420002,
    block_name: 'LAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160145',
    block_code: 1607013,
    block_name: 'PUZHAKKAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360047',
    block_code: 3630007,
    block_name: 'KAMALAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31344',
    district_code: 3138,
    district_name: 'JALAUN',
    block_id: 'B-313476',
    block_code: 3138006,
    block_name: 'KONCH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31362',
    district_code: 3110,
    district_name: 'MORADABAD',
    block_id: 'B-313657',
    block_code: 3110013,
    block_name: 'BHAGATPUR TANDA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130057',
    block_code: 1308012,
    block_name: 'NIHARI',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22006',
    district_code: 2208,
    district_name: 'LAWNGTLAI',
    block_id: 'B-220013',
    block_code: 2208001,
    block_name: 'LAWNGTLAI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50146',
    block_code: 511009,
    block_name: 'MANJHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36022',
    district_code: 3619,
    district_name: 'NIRMAL',
    block_id: 'B-360335',
    block_code: 3619017,
    block_name: 'SARANGAPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4012',
    district_code: 417,
    district_name: 'DIBRUGARH',
    block_id: 'B-40074',
    block_code: 417011,
    block_name: 'PANITOLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313164',
    block_code: 3149008,
    block_name: 'BIKAPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240267',
    block_code: 2413001,
    block_name: 'KRUSHNAPRASAD',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30008',
    district_code: 3001,
    district_name: 'WEST TRIPURA',
    block_id: 'B-300055',
    block_code: 3001017,
    block_name: 'LEFUNGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313727',
    block_code: 3133007,
    block_name: 'HARCHANDPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17043',
    district_code: 1714,
    district_name: 'SHAHDOL',
    block_id: 'B-170266',
    block_code: 1714001,
    block_name: 'BEOHARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31324',
    district_code: 3125,
    district_name: 'BAREILLY',
    block_id: 'B-313260',
    block_code: 3125018,
    block_name: 'BHUTA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270336',
    block_code: 2726001,
    block_name: 'GIRWA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320173',
    block_code: 3207001,
    block_name: 'RAJGANJ',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40068',
    block_code: 401011,
    block_name: 'NAYERALGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313632',
    block_code: 3156007,
    block_name: 'RATANPURA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290316',
    block_code: 2902013,
    block_name: 'ELLAPURAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14007',
    district_code: 1413,
    district_name: 'JAMMU',
    block_id: 'B-140096',
    block_code: 1413012,
    block_name: 'AKHNOOR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33021',
    district_code: 3315,
    district_name: 'MAHASAMUND',
    block_id: 'B-330095',
    block_code: 3315005,
    block_name: 'BASNA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14002',
    district_code: 1419,
    district_name: 'BANDIPORA',
    block_id: 'B-140020',
    block_code: 1419001,
    block_name: 'BANDIPORA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11026',
    district_code: 1121,
    district_name: 'PORBANDAR',
    block_id: 'B-110188',
    block_code: 1121006,
    block_name: 'PORBANDAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17008',
    district_code: 1702,
    district_name: 'BHIND',
    block_id: 'B-170049',
    block_code: 1702006,
    block_name: 'LAHAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4035',
    district_code: 430,
    district_name: 'WEST KARBI ANGLONG',
    block_id: 'B-40216',
    block_code: 430005,
    block_name: 'AMRI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20011',
    district_code: 2015,
    district_name: 'PHERZAWL',
    block_id: 'B-200049',
    block_code: 2015002,
    block_name: 'THANLON T D BLOCK',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26012',
    district_code: 2604,
    district_name: 'LUDHIANA',
    block_id: 'B-260087',
    block_code: 2604012,
    block_name: 'RAIKOT',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270214',
    block_code: 2705009,
    block_name: 'PILANI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20454',
    block_code: 209027,
    block_name: 'INDUKURPET',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33014',
    district_code: 3307,
    district_name: 'JASHPUR',
    block_id: 'B-330066',
    block_code: 3307015,
    block_name: 'PATTHALGAON',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18023',
    district_code: 1820,
    district_name: 'OSMANABAD',
    block_id: 'B-180216',
    block_code: 1820034,
    block_name: 'KALAMB',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313590',
    block_code: 3152011,
    block_name: 'DHANI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240068',
    block_code: 2406006,
    block_name: 'SALEPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20334',
    block_code: 226015,
    block_name: 'MIDTHUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50113',
    block_code: 519018,
    block_name: 'TARDIH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50443',
    block_code: 509003,
    block_name: 'CHAPRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270196',
    block_code: 2718006,
    block_name: 'SANCHORE',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32016',
    district_code: 3209,
    district_name: 'MALDAH',
    block_id: 'B-320197',
    block_code: 3209007,
    block_name: 'MANIKCHAK',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14003',
    district_code: 1402,
    district_name: 'BARAMULLA',
    block_id: 'B-140051',
    block_code: 1402001,
    block_name: 'URI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160146',
    block_code: 1607014,
    block_name: 'THALIKKULAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36003',
    district_code: 3630,
    district_name: 'HANAMKONDA',
    block_id: 'B-360051',
    block_code: 3630010,
    block_name: 'VELAIR',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30005',
    district_code: 3007,
    district_name: 'SEPAHIJALA',
    block_id: 'B-300032',
    block_code: 3007002,
    block_name: 'BOXANAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31362',
    district_code: 3110,
    district_name: 'MORADABAD',
    block_id: 'B-313663',
    block_code: 3110015,
    block_name: 'MUNDA PANDEY',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130050',
    block_code: 1308014,
    block_name: 'DHANOTU',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22006',
    district_code: 2208,
    district_name: 'LAWNGTLAI',
    block_id: 'B-220012',
    block_code: 2208002,
    block_name: 'CHAWNGTE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50143',
    block_code: 511006,
    block_name: 'HATHUA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29002',
    district_code: 2937,
    district_name: 'CHENGALPATTU',
    block_id: 'B-290011',
    block_code: 2937011,
    block_name: 'MADURANTHAKAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4012',
    district_code: 417,
    district_name: 'DIBRUGARH',
    block_id: 'B-40071',
    block_code: 417013,
    block_name: 'JOYPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31317',
    district_code: 3149,
    district_name: 'AYODHYA',
    block_id: 'B-313172',
    block_code: 3149001,
    block_name: 'SOHAWAL',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24026',
    district_code: 2413,
    district_name: 'PURI',
    block_id: 'B-240262',
    block_code: 2413002,
    block_name: 'BRAHMAGIRI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17047',
    district_code: 1715,
    district_name: 'SIDHI',
    block_id: 'B-170290',
    block_code: 1715003,
    block_name: 'SIHAWAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313721',
    block_code: 3133008,
    block_name: 'AMAWAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17043',
    district_code: 1714,
    district_name: 'SHAHDOL',
    block_id: 'B-170269',
    block_code: 1714002,
    block_name: 'JAISINGHNAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29021',
    district_code: 2907,
    district_name: 'SALEM',
    block_id: 'B-290194',
    block_code: 2907008,
    block_name: 'ATTUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27033',
    district_code: 2726,
    district_name: 'UDAIPUR',
    block_id: 'B-270334',
    block_code: 2726002,
    block_name: 'BARGAON',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32012',
    district_code: 3207,
    district_name: 'JALPAIGURI',
    block_id: 'B-320167',
    block_code: 3207002,
    block_name: 'JALPAIGURI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40061',
    block_code: 401014,
    block_name: 'BIRSING JARUA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313629',
    block_code: 3156008,
    block_name: 'MOHAMMADABAD GOHANA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290326',
    block_code: 2902007,
    block_name: 'TIRUTTANI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290328',
    block_code: 2902010,
    block_name: 'TIRUVALLUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33021',
    district_code: 3315,
    district_name: 'MAHASAMUND',
    block_id: 'B-330097',
    block_code: 3315006,
    block_name: 'PITHORA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240194',
    block_code: 2411009,
    block_name: 'DASAMANTAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20618',
    block_code: 205002,
    block_name: 'PENTAPADU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34013',
    district_code: 3424,
    district_name: 'KHUNTI',
    block_id: 'B-340143',
    block_code: 3424006,
    block_name: 'RANIA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4035',
    district_code: 430,
    district_name: 'WEST KARBI ANGLONG',
    block_id: 'B-40217',
    block_code: 430008,
    block_name: 'CHINTHONG',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33032',
    district_code: 3326,
    district_name: 'SURAJPUR',
    block_id: 'B-330137',
    block_code: 3326004,
    block_name: 'PREMNAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20024',
    block_code: 216001,
    block_name: 'ANAKAPALLE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20473',
    block_code: 209028,
    block_name: 'THOTAPALLIGUDUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40150',
    block_code: 410010,
    block_name: 'BOGINADI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20080',
    block_code: 224003,
    block_name: 'CHITVEL',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11022',
    district_code: 1124,
    district_name: 'NARMADA',
    block_id: 'B-110164',
    block_code: 1124001,
    block_name: 'TILAKWADA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240067',
    block_code: 2406007,
    block_name: 'NISCHINTA KOILI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20340',
    block_code: 226021,
    block_name: 'PANYAM',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35012',
    district_code: 3509,
    district_name: 'UDAM SINGH NAGAR',
    block_id: 'B-350089',
    block_code: 3509006,
    block_name: 'SITARGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5032',
    district_code: 509,
    district_name: 'SARAN',
    block_id: 'B-50453',
    block_code: 509013,
    block_name: 'MARHAURA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270195',
    block_code: 2718007,
    block_name: 'RANIWARA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3020',
    district_code: 311,
    district_name: 'TIRAP',
    block_id: 'B-30085',
    block_code: 311004,
    block_name: 'LAZU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360005',
    block_code: 3601006,
    block_name: 'BOATH',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160147',
    block_code: 1607015,
    block_name: 'VELLANGALLUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15004',
    district_code: 1502,
    district_name: 'BENGALURU',
    block_id: 'B-150031',
    block_code: 1502002,
    block_name: 'BANGALORE NORTH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31362',
    district_code: 3110,
    district_name: 'MORADABAD',
    block_id: 'B-313664',
    block_code: 3110001,
    block_name: 'THAKURDWARA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130047',
    block_code: 1308011,
    block_name: 'BALI CHOWKI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23008',
    district_code: 2302,
    district_name: 'PHEK',
    block_id: 'B-230050',
    block_code: 2302008,
    block_name: 'WEZIHO',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4012',
    district_code: 417,
    district_name: 'DIBRUGARH',
    block_id: 'B-40072',
    block_code: 417014,
    block_name: 'KHOWANG',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18029',
    district_code: 1812,
    district_name: 'SANGLI',
    block_id: 'B-180281',
    block_code: 1812003,
    block_name: 'KHANAPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17047',
    district_code: 1715,
    district_name: 'SIDHI',
    block_id: 'B-170287',
    block_code: 1715006,
    block_name: 'MAJHAULI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313736',
    block_code: 3133009,
    block_name: 'SATAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17043',
    district_code: 1714,
    district_name: 'SHAHDOL',
    block_id: 'B-170270',
    block_code: 1714003,
    block_name: 'SOHAGPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15012',
    district_code: 1512,
    district_name: 'DAVANAGERE',
    block_id: 'B-150081',
    block_code: 1512001,
    block_name: 'CHANNAGIRI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110198',
    block_code: 1102001,
    block_name: 'RAJKOT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313412',
    block_code: 3147018,
    block_name: 'PARASPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40059',
    block_code: 401002,
    block_name: 'AGOMONI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290032',
    block_code: 2903006,
    block_name: 'KUMARATCHI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4015',
    district_code: 414,
    district_name: 'GOLAGHAT',
    block_id: 'B-40097',
    block_code: 414007,
    block_name: 'MORONGI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290321',
    block_code: 2902014,
    block_name: 'POONAMALLEE',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200040',
    block_code: 2011003,
    block_name: 'KANGPOKPI T D BLOCK',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240195',
    block_code: 2411014,
    block_name: 'JEYPORE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20610',
    block_code: 205009,
    block_name: 'BHIMAVARAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34013',
    district_code: 3424,
    district_name: 'KHUNTI',
    block_id: 'B-340141',
    block_code: 3424001,
    block_name: 'KHUNTI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4035',
    district_code: 430,
    district_name: 'WEST KARBI ANGLONG',
    block_id: 'B-40218',
    block_code: 430006,
    block_name: 'RONGKHANG',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33032',
    district_code: 3326,
    district_name: 'SURAJPUR',
    block_id: 'B-330138',
    block_code: 3326005,
    block_name: 'RAMANUJNAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20030',
    block_code: 216009,
    block_name: 'KASIMKOTA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20466',
    block_code: 209029,
    block_name: 'MUTHUKUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4024',
    district_code: 410,
    district_name: 'LAKHIMPUR',
    block_id: 'B-40149',
    block_code: 410011,
    block_name: 'BIHPURIA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20100',
    block_code: 224023,
    block_name: 'RAMAPURAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11022',
    district_code: 1124,
    district_name: 'NARMADA',
    block_id: 'B-110162',
    block_code: 1124002,
    block_name: 'NANDOD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240064',
    block_code: 2406008,
    block_name: 'MAHANGA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20329',
    block_code: 226010,
    block_name: 'JUPADU BUNGALOW',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35012',
    district_code: 3509,
    district_name: 'UDAM SINGH NAGAR',
    block_id: 'B-350087',
    block_code: 3509007,
    block_name: 'KHATIMA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5001',
    district_code: 541,
    district_name: 'ARARIA',
    block_id: 'B-50002',
    block_code: 541001,
    block_name: 'Bhargama',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290015',
    block_code: 2911006,
    block_name: 'ANAIMALAI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3020',
    district_code: 311,
    district_name: 'TIRAP',
    block_id: 'B-30084',
    block_code: 311002,
    block_name: 'KHONSA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360002',
    block_code: 3601003,
    block_name: 'BAZARHATNOOR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160148',
    block_code: 1607016,
    block_name: 'WADAKKANCHERY',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15004',
    district_code: 1502,
    district_name: 'BENGALURU',
    block_id: 'B-150030',
    block_code: 1502004,
    block_name: 'BANGALORE EAST',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31362',
    district_code: 3110,
    district_name: 'MORADABAD',
    block_id: 'B-313658',
    block_code: 3110018,
    block_name: 'BILARI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13008',
    district_code: 1308,
    district_name: 'MANDI',
    block_id: 'B-130049',
    block_code: 1308013,
    block_name: 'CHURAG',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230029',
    block_code: 2305009,
    block_name: 'TSURANGKONG',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4012',
    district_code: 417,
    district_name: 'DIBRUGARH',
    block_id: 'B-40076',
    block_code: 417009,
    block_name: 'TINGKHONG',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17003',
    district_code: 1746,
    district_name: 'ANUPPUR',
    block_id: 'B-170012',
    block_code: 1746003,
    block_name: 'JAITHARI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17047',
    district_code: 1715,
    district_name: 'SIDHI',
    block_id: 'B-170286',
    block_code: 1715007,
    block_name: 'KUSMI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313732',
    block_code: 3133010,
    block_name: 'RAHI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50029',
    block_code: 545004,
    block_name: 'BAUSI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360129',
    block_code: 3609003,
    block_name: 'ELLANDAKUNTA ',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110195',
    block_code: 1102002,
    block_name: 'KOTDA SANGANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313410',
    block_code: 3147022,
    block_name: 'NAWABGANJ',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40060',
    block_code: 401004,
    block_name: 'BILASIPARA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290036',
    block_code: 2903012,
    block_name: 'NALLUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4022',
    district_code: 421,
    district_name: 'KARIMGANJ',
    block_id: 'B-40142',
    block_code: 421001,
    block_name: 'RAMKRISHNA NAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290082',
    block_code: 2938019,
    block_name: 'RISHIVANDIYAM',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200042',
    block_code: 2011004,
    block_name: 'SAIKUL T D BLOCK',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240197',
    block_code: 2411015,
    block_name: 'KOTPAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20620',
    block_code: 205012,
    block_name: 'PENUMANTRA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34013',
    district_code: 3424,
    district_name: 'KHUNTI',
    block_id: 'B-340142',
    block_code: 3424004,
    block_name: 'MURHU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4035',
    district_code: 430,
    district_name: 'WEST KARBI ANGLONG',
    block_id: 'B-40219',
    block_code: 430007,
    block_name: 'SOCHENG',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12021',
    district_code: 1207,
    district_name: 'SONIPAT',
    block_id: 'B-120133',
    block_code: 1207005,
    block_name: 'MUNDLANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20025',
    block_code: 216003,
    block_name: 'BUTCHAYYAPETA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20477',
    block_code: 209030,
    block_name: 'VENKATACHALAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4034',
    district_code: 427,
    district_name: 'UDALGURI',
    block_id: 'B-40212',
    block_code: 427006,
    block_name: 'KHOIRABARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20107',
    block_code: 224029,
    block_name: 'VEERABALLI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11022',
    district_code: 1124,
    district_name: 'NARMADA',
    block_id: 'B-110160',
    block_code: 1124003,
    block_name: 'DEDIYAPADA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240057',
    block_code: 2406036,
    block_name: 'ATHAGAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20337',
    block_code: 226018,
    block_name: 'OWK',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360256',
    block_code: 3632008,
    block_name: 'VENKATAPURAM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26016',
    district_code: 2616,
    district_name: 'MUKTSAR',
    block_id: 'B-260107',
    block_code: 2616001,
    block_name: 'MUKTSAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290016',
    block_code: 2911013,
    block_name: 'ANNUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27009',
    district_code: 2723,
    district_name: 'BUNDI',
    block_id: 'B-270105',
    block_code: 2723003,
    block_name: 'KESHORAI PATAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360007',
    block_code: 3601008,
    block_name: 'GUDIHATNUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17018',
    district_code: 1706,
    district_name: 'GUNA',
    block_id: 'B-170113',
    block_code: 1706008,
    block_name: 'CHANCHODA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15004',
    district_code: 1502,
    district_name: 'BENGALURU',
    block_id: 'B-150032',
    block_code: 1502003,
    block_name: 'BANGALORE SOUTH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31362',
    district_code: 3110,
    district_name: 'MORADABAD',
    block_id: 'B-313662',
    block_code: 3110014,
    block_name: 'MORADABAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20374',
    block_code: 222012,
    block_name: 'KROSURU',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23008',
    district_code: 2302,
    district_name: 'PHEK',
    block_id: 'B-230043',
    block_code: 2302006,
    block_name: 'CHETHEBA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4012',
    district_code: 417,
    district_name: 'DIBRUGARH',
    block_id: 'B-40075',
    block_code: 417012,
    block_name: 'TENGAKHAT',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17003',
    district_code: 1746,
    district_name: 'ANUPPUR',
    block_id: 'B-170013',
    block_code: 1746001,
    block_name: 'KOTMA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12019',
    district_code: 1208,
    district_name: 'ROHTAK',
    block_id: 'B-120118',
    block_code: 1208004,
    block_name: 'LAKHAN MAJRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313729',
    block_code: 3133011,
    block_name: 'KHIRON',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50036',
    block_code: 545011,
    block_name: 'SHAMBHUGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360132',
    block_code: 3609006,
    block_name: 'HUZURABAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110191',
    block_code: 1102003,
    block_name: 'GONDAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313400',
    block_code: 3147024,
    block_name: 'BABHANJOT',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40062',
    block_code: 401005,
    block_name: 'CHAPOR SALKOCHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290034',
    block_code: 2903013,
    block_name: 'MANGALUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240009',
    block_code: 2405007,
    block_name: 'BAHANAGA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290083',
    block_code: 2938020,
    block_name: 'SANKARAPURAM',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200043',
    block_code: 2011007,
    block_name: 'SAITU GAMPHAZOL T D BLOCK',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240193',
    block_code: 2411017,
    block_name: 'BORIGUMMA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20608',
    block_code: 205007,
    block_name: 'AKIVIDU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313812',
    block_code: 3151001,
    block_name: 'KHUNIYAON',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26004',
    district_code: 2612,
    district_name: 'FARIDKOT',
    block_id: 'B-260022',
    block_code: 2612005,
    block_name: 'FARIDKOT',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12021',
    district_code: 1207,
    district_name: 'SONIPAT',
    block_id: 'B-120131',
    block_code: 1207008,
    block_name: 'KATHURA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20034',
    block_code: 216012,
    block_name: 'MAKAVARAPALEM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20467',
    block_code: 209025,
    block_name: 'NELLORE RURAL',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260114',
    block_code: 2609006,
    block_name: 'BHUNER HERI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20099',
    block_code: 224022,
    block_name: 'RAJAMPET',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11022',
    district_code: 1124,
    district_name: 'NARMADA',
    block_id: 'B-110163',
    block_code: 1124004,
    block_name: 'SAGBARA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240070',
    block_code: 2406037,
    block_name: 'TIGIRIA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20328',
    block_code: 226009,
    block_name: 'GOSPADU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360257',
    block_code: 3632009,
    block_name: 'WAZEED',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26016',
    district_code: 2616,
    district_name: 'MUKTSAR',
    block_id: 'B-260106',
    block_code: 2616003,
    block_name: 'MALOUT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290026',
    block_code: 2911005,
    block_name: 'THONDAMUTHUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3020',
    district_code: 311,
    district_name: 'TIRAP',
    block_id: 'B-30120',
    block_code: 311007,
    block_name: 'BARI BASIP',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360012',
    block_code: 3601013,
    block_name: 'NARNOOR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17018',
    district_code: 1706,
    district_name: 'GUNA',
    block_id: 'B-170112',
    block_code: 1706003,
    block_name: 'BAMORI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15019',
    district_code: 1519,
    district_name: 'KOLAR',
    block_id: 'B-150134',
    block_code: 1519012,
    block_name: 'KGF',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313147',
    block_code: 3181001,
    block_name: 'SHUKUL BAZAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20372',
    block_code: 222010,
    block_name: 'IPUR',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23008',
    district_code: 2302,
    district_name: 'PHEK',
    block_id: 'B-230044',
    block_code: 2302007,
    block_name: 'CHIZAMI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50093',
    block_code: 548009,
    block_name: 'Nawanagar',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17003',
    district_code: 1746,
    district_name: 'ANUPPUR',
    block_id: 'B-170011',
    block_code: 1746002,
    block_name: 'ANUPPUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12019',
    district_code: 1208,
    district_name: 'ROHTAK',
    block_id: 'B-120117',
    block_code: 1208006,
    block_name: 'KALANAUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313735',
    block_code: 3133012,
    block_name: 'SARENI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5004',
    district_code: 545,
    district_name: 'BANKA',
    block_id: 'B-50035',
    block_code: 545010,
    block_name: 'RAJAUN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360133',
    block_code: 3609007,
    block_name: 'JAMMIKUNTA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110194',
    block_code: 1102004,
    block_name: 'JETPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313402',
    block_code: 3147025,
    block_name: 'CHHAPIA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40069',
    block_code: 401008,
    block_name: 'RUPSHI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29004',
    district_code: 2903,
    district_name: 'CUDDALORE',
    block_id: 'B-290039',
    block_code: 2903014,
    block_name: 'SRIMUSHNAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240010',
    block_code: 2405001,
    block_name: 'BALESHWAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290085',
    block_code: 2938001,
    block_name: 'TIRUKOILUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200044',
    block_code: 2011011,
    block_name: 'TUIJANG VAICHONG T D BLOCK',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240192',
    block_code: 2411018,
    block_name: 'BOIPARIGUDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20622',
    block_code: 205001,
    block_name: 'TADEPALLIGUDEM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313809',
    block_code: 3151002,
    block_name: 'ITWA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26004',
    district_code: 2612,
    district_name: 'FARIDKOT',
    block_id: 'B-260024',
    block_code: 2612006,
    block_name: 'KOTKAPURA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12021',
    district_code: 1207,
    district_name: 'SONIPAT',
    block_id: 'B-120135',
    block_code: 1207011,
    block_name: 'RAI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20040',
    block_code: 216018,
    block_name: 'PAYAKARAOPETA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110092',
    block_code: 1123008,
    block_name: 'SANJELI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260122',
    block_code: 2609010,
    block_name: 'SANOUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20102',
    block_code: 224025,
    block_name: 'RAYACHOTY',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110020',
    block_code: 1105006,
    block_name: 'SAVARKUNDLA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240058',
    block_code: 2406038,
    block_name: 'BADAMBA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20332',
    block_code: 226013,
    block_name: 'KOTHAPALLE',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15023',
    district_code: 1523,
    district_name: 'RAICHUR',
    block_id: 'B-150164',
    block_code: 1523003,
    block_name: 'MANVI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26016',
    district_code: 2616,
    district_name: 'MUKTSAR',
    block_id: 'B-260104',
    block_code: 2616005,
    block_name: 'GIDDERBAHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290019',
    block_code: 2911002,
    block_name: 'MADUKKARAI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3020',
    district_code: 311,
    district_name: 'TIRAP',
    block_id: 'B-30082',
    block_code: 311006,
    block_name: 'BORDURIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360015',
    block_code: 3601016,
    block_name: 'TALAMADUGU',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17018',
    district_code: 1706,
    district_name: 'GUNA',
    block_id: 'B-170114',
    block_code: 1706004,
    block_name: 'GUNA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360383',
    block_code: 3622006,
    block_name: 'MUSTABAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313141',
    block_code: 3181007,
    block_name: 'GAURIGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20318',
    block_code: 213012,
    block_name: 'YEMMIGANUR',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230023',
    block_code: 2305007,
    block_name: 'CHUCHUYIMLANG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50095',
    block_code: 548011,
    block_name: 'Simri',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33030',
    district_code: 3332,
    district_name: 'SARANGARH BILAIGARH',
    block_id: 'B-330128',
    block_code: 3332009,
    block_name: 'BARAMKELA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12019',
    district_code: 1208,
    district_name: 'ROHTAK',
    block_id: 'B-120119',
    block_code: 1208005,
    block_name: 'MAHAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313728',
    block_code: 3133015,
    block_name: 'JAGATPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360136',
    block_code: 3609011,
    block_name: 'MANAKONDUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110190',
    block_code: 1102005,
    block_name: 'DHORAJI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29020',
    district_code: 2935,
    district_name: 'RANIPET',
    block_id: 'B-290187',
    block_code: 2935011,
    block_name: 'ARAKONAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40063',
    block_code: 401009,
    block_name: 'DEBITOLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31359',
    district_code: 3156,
    district_name: 'MAU',
    block_id: 'B-313631',
    block_code: 3156009,
    block_name: 'RANIPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240012',
    block_code: 2405003,
    block_name: 'BASTA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290086',
    block_code: 2938004,
    block_name: 'TIRUNAVALUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200039',
    block_code: 2011013,
    block_name: 'KANGCHUP GELJANG T D BLOCK',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15007',
    district_code: 1508,
    district_name: 'CHAMARAJA NAGARA',
    block_id: 'B-150046',
    block_code: 1508001,
    block_name: 'CHAMARAJANAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20625',
    block_code: 205011,
    block_name: 'VEERAVASARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313816',
    block_code: 3151005,
    block_name: 'SHOHARATGARH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26004',
    district_code: 2612,
    district_name: 'FARIDKOT',
    block_id: 'B-260023',
    block_code: 2612007,
    block_name: 'JAITO',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12009',
    district_code: 1214,
    district_name: 'JIND',
    block_id: 'B-120054',
    block_code: 1214002,
    block_name: 'UCHANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20039',
    block_code: 216017,
    block_name: 'PARAVADA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11012',
    district_code: 1123,
    district_name: 'DOHAD',
    block_id: 'B-110093',
    block_code: 1123009,
    block_name: 'SINGWAD',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26015',
    district_code: 2615,
    district_name: 'MOGA',
    block_id: 'B-260100',
    block_code: 2615005,
    block_name: 'KOT-ISE-KHAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20101',
    block_code: 224024,
    block_name: 'RAMASAMUDRAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110016',
    block_code: 1105007,
    block_name: 'KUNKAVAV VADIA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240065',
    block_code: 2406039,
    block_name: 'NARASINGHPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20338',
    block_code: 226019,
    block_name: 'PAGIDYALA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15023',
    district_code: 1523,
    district_name: 'RAICHUR',
    block_id: 'B-150166',
    block_code: 1523004,
    block_name: 'RAICHUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26016',
    district_code: 2616,
    district_name: 'MUKTSAR',
    block_id: 'B-260105',
    block_code: 2616004,
    block_name: 'LAMBI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290022',
    block_code: 2911011,
    block_name: 'POLLACHI SOUTH',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3020',
    district_code: 311,
    district_name: 'TIRAP',
    block_id: 'B-30083',
    block_code: 311003,
    block_name: 'DADAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360009',
    block_code: 3601010,
    block_name: 'INDERVELLY',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17018',
    district_code: 1706,
    district_name: 'GUNA',
    block_id: 'B-170115',
    block_code: 1706006,
    block_name: 'RAGHOGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360387',
    block_code: 3622011,
    block_name: 'VEMULAWADA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313144',
    block_code: 3181003,
    block_name: 'MUSAFIR KHANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20370',
    block_code: 222008,
    block_name: 'EDLAPADU',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230030',
    block_code: 2305008,
    block_name: 'TULI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50091',
    block_code: 548007,
    block_name: 'Itarhi',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33030',
    district_code: 3332,
    district_name: 'SARANGARH BILAIGARH',
    block_id: 'B-330130',
    block_code: 3332008,
    block_name: 'SARANGARH',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12019',
    district_code: 1208,
    district_name: 'ROHTAK',
    block_id: 'B-120120',
    block_code: 1208007,
    block_name: 'ROHTAK',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313733',
    block_code: 3133020,
    block_name: 'ROHANIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360138',
    block_code: 3609014,
    block_name: 'SHANKARAPATNAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110135',
    block_code: 1113001,
    block_name: 'MEHMEDABAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29020',
    district_code: 2935,
    district_name: 'RANIPET',
    block_id: 'B-290190',
    block_code: 2935012,
    block_name: 'NEMILI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40065',
    block_code: 401001,
    block_name: 'GOLOKGANJ',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160109',
    block_code: 1606009,
    block_name: 'OTTAPPALAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4022',
    district_code: 421,
    district_name: 'KARIMGANJ',
    block_id: 'B-40141',
    block_code: 421002,
    block_name: 'PATHARKANDI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290087',
    block_code: 2938005,
    block_name: 'ULUNDURPET',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200036',
    block_code: 2011002,
    block_name: 'BUNGTE CHIRU',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15007',
    district_code: 1508,
    district_name: 'CHAMARAJA NAGARA',
    block_id: 'B-150047',
    block_code: 1508002,
    block_name: 'GUNDLUPET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20624',
    block_code: 205006,
    block_name: 'UNDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313807',
    block_code: 3151006,
    block_name: 'BIRDPUR',
  },
  {
    state_id: 'S-23',
    state_code: 25,
    state_name: 'PUDUCHERRY',
    district_id: 'D-25002',
    district_code: 2501,
    district_name: 'PONDICHERRY',
    block_id: 'B-250003',
    block_code: 2501001,
    block_name: 'VILLIANUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12009',
    district_code: 1214,
    district_name: 'JIND',
    block_id: 'B-120048',
    block_code: 1214005,
    block_name: 'ALEWA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20041',
    block_code: 216019,
    block_name: 'RAMBILLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20451',
    block_code: 209014,
    block_name: 'DAGADARTHI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260116',
    block_code: 2609009,
    block_name: 'NABHA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20096',
    block_code: 224019,
    block_name: 'PENAGALUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11009',
    district_code: 1133,
    district_name: 'CHHOTA UDAIPUR',
    block_id: 'B-110072',
    block_code: 1133014,
    block_name: 'BODELI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240059',
    block_code: 2406040,
    block_name: 'BANKI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20327',
    block_code: 226008,
    block_name: 'GADIVEMULA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15023',
    district_code: 1523,
    district_name: 'RAICHUR',
    block_id: 'B-150163',
    block_code: 1523002,
    block_name: 'LINGASUGUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26002',
    district_code: 2621,
    district_name: 'BARNALA',
    block_id: 'B-260010',
    block_code: 2621001,
    block_name: 'BARNALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29003',
    district_code: 2911,
    district_name: 'COIMBATORE',
    block_id: 'B-290021',
    block_code: 2911010,
    block_name: 'POLLACHI NORTH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31328',
    district_code: 3177,
    district_name: 'CHITRAKOOT',
    block_id: 'B-313310',
    block_code: 3177005,
    block_name: 'KARWI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31315',
    district_code: 3167,
    district_name: 'AMROHA',
    block_id: 'B-313151',
    block_code: 3167006,
    block_name: 'DHANAURA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17018',
    district_code: 1706,
    district_name: 'GUNA',
    block_id: 'B-170111',
    block_code: 1706009,
    block_name: 'ARON',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360379',
    block_code: 3622002,
    block_name: 'CHANDURTHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313142',
    block_code: 3181002,
    block_name: 'JAGDISHPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20365',
    block_code: 222003,
    block_name: 'BELLAMKONDA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23008',
    district_code: 2302,
    district_name: 'PHEK',
    block_id: 'B-230048',
    block_code: 2302002,
    block_name: 'PHEK',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50086',
    block_code: 548002,
    block_name: 'Buxar',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33030',
    district_code: 3332,
    district_name: 'SARANGARH BILAIGARH',
    block_id: 'B-330129',
    block_code: 3332003,
    block_name: 'BILAIGARH',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12019',
    district_code: 1208,
    district_name: 'ROHTAK',
    block_id: 'B-120121',
    block_code: 1208008,
    block_name: 'SAMPLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313726',
    block_code: 3133021,
    block_name: 'DEENSHAH GAURA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360135',
    block_code: 3609010,
    block_name: 'KOTHAPALLY',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110136',
    block_code: 1113002,
    block_name: 'NADIAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29020',
    district_code: 2935,
    district_name: 'RANIPET',
    block_id: 'B-290191',
    block_code: 2935010,
    block_name: 'SHOLINGHUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4011',
    district_code: 401,
    district_name: 'DHUBRI',
    block_id: 'B-40067',
    block_code: 401010,
    block_name: 'MAHAMAYA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160110',
    block_code: 1606010,
    block_name: 'PALAKKAD',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4022',
    district_code: 421,
    district_name: 'KARIMGANJ',
    block_id: 'B-40137',
    block_code: 421005,
    block_name: 'BADARPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313296',
    block_code: 3117018,
    block_name: 'PAHASU',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200037',
    block_code: 2011010,
    block_name: 'CHAMPHAI T D BLOCK',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15007',
    district_code: 1508,
    district_name: 'CHAMARAJA NAGARA',
    block_id: 'B-150050',
    block_code: 1508004,
    block_name: 'YELANDUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20617',
    block_code: 205010,
    block_name: 'PALAKODERU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313815',
    block_code: 3151007,
    block_name: 'NAUGARH',
  },
  {
    state_id: 'S-23',
    state_code: 25,
    state_name: 'PUDUCHERRY',
    district_id: 'D-25002',
    district_code: 2501,
    district_name: 'PONDICHERRY',
    block_id: 'B-250002',
    block_code: 2501003,
    block_name: 'ARIANKUPPAM',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12009',
    district_code: 1214,
    district_name: 'JIND',
    block_id: 'B-120052',
    block_code: 1214006,
    block_name: 'PILLUKHERA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20035',
    block_code: 216013,
    block_name: 'MUNAGAPAKA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20478',
    block_code: 209016,
    block_name: 'VIDAVALUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26015',
    district_code: 2615,
    district_name: 'MOGA',
    block_id: 'B-260099',
    block_code: 2615003,
    block_name: 'BAGHAPURANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20097',
    block_code: 224020,
    block_name: 'PILER',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11022',
    district_code: 1124,
    district_name: 'NARMADA',
    block_id: 'B-110161',
    block_code: 1124005,
    block_name: 'GARUDESHWAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50080',
    block_code: 503010,
    block_name: 'Sahar',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20326',
    block_code: 226007,
    block_name: 'DORNIPADU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360249',
    block_code: 3632001,
    block_name: 'ETURNAGARAM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26002',
    district_code: 2621,
    district_name: 'BARNALA',
    block_id: 'B-260011',
    block_code: 2621002,
    block_name: 'MEHAL KALAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27018',
    district_code: 2718,
    district_name: 'JALORE',
    block_id: 'B-270193',
    block_code: 2718003,
    block_name: 'JALOR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31328',
    district_code: 3177,
    district_name: 'CHITRAKOOT',
    block_id: 'B-313312',
    block_code: 3177006,
    block_name: 'MAU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290293',
    block_code: 2916010,
    block_name: 'MUSIRI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240134',
    block_code: 2410001,
    block_name: 'BHAWANIPATNA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360385',
    block_code: 3622009,
    block_name: 'THANGALLAPALLI ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313143',
    block_code: 3181005,
    block_name: 'JAMO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20375',
    block_code: 222013,
    block_name: 'MACHAVARAM',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23008',
    district_code: 2302,
    district_name: 'PHEK',
    block_id: 'B-230045',
    block_code: 2302005,
    block_name: 'KIKRUMA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50090',
    block_code: 548006,
    block_name: 'Dumraon',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140168',
    block_code: 1401036,
    block_name: 'MAGAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160013',
    block_code: 1608001,
    block_name: 'ALANGAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313731',
    block_code: 3133003,
    block_name: 'MAHRAJGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15012',
    district_code: 1512,
    district_name: 'DAVANAGERE',
    block_id: 'B-150083',
    block_code: 1512003,
    block_name: 'HARIHARA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110132',
    block_code: 1113013,
    block_name: 'KHEDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29020',
    district_code: 2935,
    district_name: 'RANIPET',
    block_id: 'B-290188',
    block_code: 2935014,
    block_name: 'ARCOT',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260066',
    block_code: 2605005,
    block_name: 'LOHIAN',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160102',
    block_code: 1606002,
    block_name: 'ATTAPPADI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4022',
    district_code: 421,
    district_name: 'KARIMGANJ',
    block_id: 'B-40140',
    block_code: 421004,
    block_name: 'NORTH KARIMGJANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313300',
    block_code: 3117021,
    block_name: 'UNCHAGAON',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200041',
    block_code: 2011001,
    block_name: 'LHUNGTIN TD BLOCK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20138',
    block_code: 210024,
    block_name: 'GANGAVARAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20623',
    block_code: 205003,
    block_name: 'TANUKU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313810',
    block_code: 3151008,
    block_name: 'JOGIA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140137',
    block_code: 1415007,
    block_name: 'DRABSHALLA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12009',
    district_code: 1214,
    district_name: 'JIND',
    block_id: 'B-120053',
    block_code: 1214007,
    block_name: 'SAFIDON',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20037',
    block_code: 216015,
    block_name: 'NARSIPATNAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20460',
    block_code: 209017,
    block_name: 'KODAVALUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26015',
    district_code: 2615,
    district_name: 'MOGA',
    block_id: 'B-260103',
    block_code: 2615004,
    block_name: 'NIHAL SINGH WALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20106',
    block_code: 224030,
    block_name: 'VALMIKIPURAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110059',
    block_code: 1104006,
    block_name: 'GARIADHAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50074',
    block_code: 503004,
    block_name: 'Behea',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20321',
    block_code: 226003,
    block_name: 'BANAGANAPALLE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360250',
    block_code: 3632002,
    block_name: 'GOVINDARAOPET',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26002',
    district_code: 2621,
    district_name: 'BARNALA',
    block_id: 'B-260012',
    block_code: 2621003,
    block_name: 'SEHNA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313315',
    block_code: 3155016,
    block_name: 'BAITALPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31328',
    district_code: 3177,
    district_name: 'CHITRAKOOT',
    block_id: 'B-313311',
    block_code: 3177002,
    block_name: 'MANIKPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290296',
    block_code: 2916011,
    block_name: 'THOTTIAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240140',
    block_code: 2410005,
    block_name: 'KARLAMUNDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360386',
    block_code: 3622010,
    block_name: 'VEERNAPALLI ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313146',
    block_code: 3181006,
    block_name: 'SHAHGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20387',
    block_code: 222024,
    block_name: 'SATTENAPALLE',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23008',
    district_code: 2302,
    district_name: 'PHEK',
    block_id: 'B-230046',
    block_code: 2302001,
    block_name: 'MELURI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5008',
    district_code: 548,
    district_name: 'BUXAR',
    block_id: 'B-50092',
    block_code: 548008,
    block_name: 'Kesath',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140173',
    block_code: 1401030,
    block_name: 'QAZIABAD SUPERNAGAMA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160014',
    block_code: 1608002,
    block_name: 'ANGAMALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313730',
    block_code: 3133013,
    block_name: 'LALGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15012',
    district_code: 1512,
    district_name: 'DAVANAGERE',
    block_id: 'B-150082',
    block_code: 1512002,
    block_name: 'DAVANAGERE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110133',
    block_code: 1113014,
    block_name: 'MAHUDHA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27026',
    district_code: 2733,
    district_name: 'PRATAPGARH',
    block_id: 'B-270282',
    block_code: 2733004,
    block_name: 'DHARIYAWAD',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260063',
    block_code: 2605018,
    block_name: 'BHOGPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160105',
    block_code: 1606005,
    block_name: 'KUZHALMANNAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4015',
    district_code: 414,
    district_name: 'GOLAGHAT',
    block_id: 'B-40096',
    block_code: 414008,
    block_name: 'KAKODONGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313290',
    block_code: 3117024,
    block_name: 'DANPUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20009',
    district_code: 2011,
    district_name: 'KANGPOKPI',
    block_id: 'B-200038',
    block_code: 2011012,
    block_name: 'ISLAND T D BLOCK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20161',
    block_code: 210027,
    block_name: 'VENKATAGIRIKOTA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20613',
    block_code: 205008,
    block_name: 'KALLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313817',
    block_code: 3151009,
    block_name: 'USKA BAZAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140139',
    block_code: 1415008,
    block_name: 'KISHTWAR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12021',
    district_code: 1207,
    district_name: 'SONIPAT',
    block_id: 'B-120130',
    block_code: 1207006,
    block_name: 'GOHANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20029',
    block_code: 216007,
    block_name: 'GOLUGONDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20470',
    block_code: 209019,
    block_name: 'SANGAM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260121',
    block_code: 2609008,
    block_name: 'SAMANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20089',
    block_code: 224012,
    block_name: 'MADANAPALLE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110066',
    block_code: 1104009,
    block_name: 'UMRALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50075',
    block_code: 503005,
    block_name: 'Charpokhari',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20341',
    block_code: 226022,
    block_name: 'PEAPULLY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360252',
    block_code: 3632004,
    block_name: 'MANGAPET',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50101',
    block_code: 519006,
    block_name: 'DARBHANGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313327',
    block_code: 3155019,
    block_name: 'RAMPUR KARKHANA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31328',
    district_code: 3177,
    district_name: 'CHITRAKOOT',
    block_id: 'B-313314',
    block_code: 3177003,
    block_name: 'RAMNAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290300',
    block_code: 2916006,
    block_name: 'VAIYAMPATTY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240139',
    block_code: 2410012,
    block_name: 'KALAMPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360388',
    block_code: 3622012,
    block_name: 'VEMULAWADA RURAL ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313137',
    block_code: 3181008,
    block_name: 'AMETHI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20368',
    block_code: 222006,
    block_name: 'DACHEPALLE',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23008',
    district_code: 2302,
    district_name: 'PHEK',
    block_id: 'B-230047',
    block_code: 2302003,
    block_name: 'PFUTSERO',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4012',
    district_code: 417,
    district_name: 'DIBRUGARH',
    block_id: 'B-40073',
    block_code: 417008,
    block_name: 'LAHOWAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140179',
    block_code: 1401032,
    block_name: 'TARATHPORA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160015',
    block_code: 1608003,
    block_name: 'EDAPPALLY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313724',
    block_code: 3133014,
    block_name: 'DALMAU',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15012',
    district_code: 1512,
    district_name: 'DAVANAGERE',
    block_id: 'B-150084',
    block_code: 1512005,
    block_name: 'HONNALI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110134',
    block_code: 1113007,
    block_name: 'MATAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27026',
    district_code: 2733,
    district_name: 'PRATAPGARH',
    block_id: 'B-270279',
    block_code: 2733005,
    block_name: 'CHHOTI SADARI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260068',
    block_code: 2605020,
    block_name: 'NAKODAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160106',
    block_code: 1606006,
    block_name: 'MALAMPUZHA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240011',
    block_code: 2405004,
    block_name: 'BALIAPAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313288',
    block_code: 3117025,
    block_name: 'BHAWAN BAHADUR NAGAR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33021',
    district_code: 3315,
    district_name: 'MAHASAMUND',
    block_id: 'B-330094',
    block_code: 3315003,
    block_name: 'BAGBAHARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20158',
    block_code: 210012,
    block_name: 'SRIRANGARAJAPURAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20614',
    block_code: 205019,
    block_name: 'MOGALTHUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313808',
    block_code: 3151010,
    block_name: 'DOMARIYAGANJ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140142',
    block_code: 1415001,
    block_name: 'NAGSANI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12021',
    district_code: 1207,
    district_name: 'SONIPAT',
    block_id: 'B-120136',
    block_code: 1207007,
    block_name: 'SONIPAT',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20038',
    block_code: 216016,
    block_name: 'NATHAVARAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20450',
    block_code: 209020,
    block_name: 'CHEJERLA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260119',
    block_code: 2609011,
    block_name: 'PATRAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20083',
    block_code: 224006,
    block_name: 'KALAKADA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110064',
    block_code: 1104008,
    block_name: 'SHIHOR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50079',
    block_code: 503009,
    block_name: 'Piro',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20344',
    block_code: 226025,
    block_name: 'SIRIVEL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360254',
    block_code: 3632006,
    block_name: 'TADVAI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50103',
    block_code: 519008,
    block_name: 'GORA BAURAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313319',
    block_code: 3155022,
    block_name: 'BHALUANI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180296',
    block_code: 1811001,
    block_name: 'SATARA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290299',
    block_code: 2916014,
    block_name: 'UPPILIYAPURAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240141',
    block_code: 2410002,
    block_name: 'KESINGA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15004',
    district_code: 1502,
    district_name: 'BENGALURU',
    block_id: 'B-150033',
    block_code: 1502005,
    block_name: 'YELAHANKA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313788',
    block_code: 3127029,
    block_name: 'MADNAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20367',
    block_code: 222005,
    block_name: 'CHILAKALURIPET',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230022',
    block_code: 2305001,
    block_name: 'CHANGTONGYA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4012',
    district_code: 417,
    district_name: 'DIBRUGARH',
    block_id: 'B-40070',
    block_code: 417007,
    block_name: 'BORBORUAH',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140160',
    block_code: 1401033,
    block_name: 'HANDWARA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160016',
    block_code: 1608004,
    block_name: 'KOOVAPPADY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313738',
    block_code: 3133019,
    block_name: 'UNCHAHAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15012',
    district_code: 1512,
    district_name: 'DAVANAGERE',
    block_id: 'B-150085',
    block_code: 1512006,
    block_name: 'JAGALUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110130',
    block_code: 1113008,
    block_name: 'KAPADVANJ',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27026',
    district_code: 2733,
    district_name: 'PRATAPGARH',
    block_id: 'B-270283',
    block_code: 2733002,
    block_name: 'PEEPALKHOONT',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260062',
    block_code: 2605022,
    block_name: 'ADAMPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160111',
    block_code: 1606011,
    block_name: 'PATTAMBI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240013',
    block_code: 2405005,
    block_name: 'BHOGRAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313287',
    block_code: 3117028,
    block_name: 'ARANIYA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140007',
    block_code: 1406038,
    block_name: 'HILLER SHAHABAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20133',
    block_code: 210026,
    block_name: 'BAIREDDIPALLE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20615',
    block_code: 205018,
    block_name: 'NARSAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313804',
    block_code: 3151011,
    block_name: 'BANSI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140147',
    block_code: 1415006,
    block_name: 'WARWAN',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12021',
    district_code: 1207,
    district_name: 'SONIPAT',
    block_id: 'B-120129',
    block_code: 1207009,
    block_name: 'GANAUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20023',
    block_code: 216002,
    block_name: 'ACHUTAPURAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20445',
    block_code: 209021,
    block_name: 'ANANTHASAGARAM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260117',
    block_code: 2609007,
    block_name: 'PATIALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20103',
    block_code: 224026,
    block_name: 'SAMBEPALLE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110061',
    block_code: 1104013,
    block_name: 'JESAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50076',
    block_code: 503006,
    block_name: 'Garhani',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20335',
    block_code: 226016,
    block_name: 'NANDIKOTKUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360255',
    block_code: 3632007,
    block_name: 'VENKATAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50109',
    block_code: 519014,
    block_name: 'KUSHESHWAR ASTHAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313320',
    block_code: 3155024,
    block_name: 'BHATNI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180289',
    block_code: 1811003,
    block_name: 'KHANDALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313430',
    block_code: 3154001,
    block_name: 'PALI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240145',
    block_code: 2410003,
    block_name: 'NARALA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15019',
    district_code: 1519,
    district_name: 'KOLAR',
    block_id: 'B-150133',
    block_code: 1519002,
    block_name: 'BANGARAPET',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16003',
    district_code: 1609,
    district_name: 'IDUKKI',
    block_id: 'B-160032',
    block_code: 1609006,
    block_name: 'KATTAPPANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20386',
    block_code: 222023,
    block_name: 'ROMPICHERLA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230025',
    block_code: 2305003,
    block_name: 'LONGCHEM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50435',
    block_code: 518015,
    block_name: 'SHIVAJI NAGAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140161',
    block_code: 1401025,
    block_name: 'HAYHAMA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16002',
    district_code: 1608,
    district_name: 'ERNAKULAM',
    block_id: 'B-160026',
    block_code: 1608014,
    block_name: 'VYPPIN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31367',
    district_code: 3133,
    district_name: 'RAE BARELI',
    block_id: 'B-313734',
    block_code: 3133022,
    block_name: 'SALON',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15012',
    district_code: 1512,
    district_name: 'DAVANAGERE',
    block_id: 'B-150086',
    block_code: 1512007,
    block_name: 'NYAMATHI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110137',
    block_code: 1113010,
    block_name: 'THASRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313413',
    block_code: 3147010,
    block_name: 'RUPAIDEEH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260069',
    block_code: 2605014,
    block_name: 'NURMAHAL',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160112',
    block_code: 1606012,
    block_name: 'SREEKRISHNAPURAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240014',
    block_code: 2405006,
    block_name: 'JALESWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313293',
    block_code: 3117029,
    block_name: 'JAHANGIRABAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140015',
    block_code: 1406041,
    block_name: 'VERINAG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20148',
    block_code: 210025,
    block_name: 'PEDDAPANJANI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20621',
    block_code: 205015,
    block_name: 'PODURU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313814',
    block_code: 3151012,
    block_name: 'MITHWAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17028',
    district_code: 1716,
    district_name: 'MANDSAUR',
    block_id: 'B-170175',
    block_code: 1716005,
    block_name: 'SITAMAU',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12021',
    district_code: 1207,
    district_name: 'SONIPAT',
    block_id: 'B-120132',
    block_code: 1207010,
    block_name: 'KHARKHODA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20031',
    block_code: 216008,
    block_name: 'K KOTAPADU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20449',
    block_code: 209018,
    block_name: 'BUTCHIREDDIPALEM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260115',
    block_code: 2609004,
    block_name: 'GHANAUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20079',
    block_code: 224002,
    block_name: 'CHINNAMANDEM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110060',
    block_code: 1104002,
    block_name: 'GHOGHA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50077',
    block_code: 503007,
    block_name: 'Jagdishpur',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20331',
    block_code: 226012,
    block_name: 'KOLIMIGUNDLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360251',
    block_code: 3632003,
    block_name: 'KANNAIGUDEM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50107',
    block_code: 519012,
    block_name: 'KEOTIRANWAY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313329',
    block_code: 3155027,
    block_name: 'SALEMPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180291',
    block_code: 1811004,
    block_name: 'KOREGAON',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313433',
    block_code: 3154002,
    block_name: 'SAHJANAWA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240144',
    block_code: 2410004,
    block_name: 'MADANPUR    RAMPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15019',
    district_code: 1519,
    district_name: 'KOLAR',
    block_id: 'B-150135',
    block_code: 1519007,
    block_name: 'KOLAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16003',
    district_code: 1609,
    district_name: 'IDUKKI',
    block_id: 'B-160029',
    block_code: 1609003,
    block_name: 'DEVIKULAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20377',
    block_code: 222015,
    block_name: 'MUPPALLA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230026',
    block_code: 2305006,
    block_name: 'MANGKOLEMBA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50421',
    block_code: 518001,
    block_name: 'BIBHUTPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140163',
    block_code: 1401035,
    block_name: 'KERAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140188',
    block_code: 1411014,
    block_name: 'MANKOTE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360134',
    block_code: 3609009,
    block_name: 'KARIMNAGAR RURAL',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110131',
    block_code: 1113012,
    block_name: 'KATHLAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29020',
    district_code: 2935,
    district_name: 'RANIPET',
    block_id: 'B-290192',
    block_code: 2935015,
    block_name: 'THIMIRI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260071',
    block_code: 2605021,
    block_name: 'RURKA KALAN',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160101',
    block_code: 1606001,
    block_name: 'ALATHOOR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240020',
    block_code: 2405008,
    block_name: 'SORO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313292',
    block_code: 3117030,
    block_name: 'GULAOTHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140009',
    block_code: 1406039,
    block_name: 'LARNOO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20144',
    block_code: 210010,
    block_name: 'NAGARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20607',
    block_code: 205014,
    block_name: 'ACHANTA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313811',
    block_code: 3151013,
    block_name: 'KHESRAHA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260014',
    block_code: 2611008,
    block_name: 'BHAGTA BHAIKA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12021',
    district_code: 1207,
    district_name: 'SONIPAT',
    block_id: 'B-120134',
    block_code: 1207012,
    block_name: 'MURTHAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20026',
    block_code: 216004,
    block_name: 'CHEEDIKADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2019',
    district_code: 209,
    district_name: 'SPSR NELLORE',
    block_id: 'B-20464',
    block_code: 209031,
    block_name: 'MANUBOLU',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26015',
    district_code: 2615,
    district_name: 'MOGA',
    block_id: 'B-260101',
    block_code: 2615001,
    block_name: 'MOGA I',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20087',
    block_code: 224010,
    block_name: 'KURABALAKOTA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11009',
    district_code: 1133,
    district_name: 'CHHOTA UDAIPUR',
    block_id: 'B-110073',
    block_code: 1133009,
    block_name: 'CHHOTA UDAIPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240063',
    block_code: 2406003,
    block_name: 'KANTAPADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20320',
    block_code: 226002,
    block_name: 'ATMAKUR',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23007',
    district_code: 2311,
    district_name: 'PAREN',
    block_id: 'B-230039',
    block_code: 2311004,
    block_name: 'ATHIBUNG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5009',
    district_code: 519,
    district_name: 'DARBHANGA',
    block_id: 'B-50104',
    block_code: 519009,
    block_name: 'HANUMANNAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313324',
    block_code: 3155015,
    block_name: 'GAURI BAZAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180295',
    block_code: 1811005,
    block_name: 'PHALTAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313432',
    block_code: 3154003,
    block_name: 'PIPRAULI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240143',
    block_code: 2410006,
    block_name: 'LANJIGARH',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15019',
    district_code: 1519,
    district_name: 'KOLAR',
    block_id: 'B-150136',
    block_code: 1519008,
    block_name: 'MALUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16003',
    district_code: 1609,
    district_name: 'IDUKKI',
    block_id: 'B-160034',
    block_code: 1609008,
    block_name: 'THODUPUZHA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20382',
    block_code: 222020,
    block_name: 'PEDAKURAPADU',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230024',
    block_code: 2305002,
    block_name: 'KUBULONG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50428',
    block_code: 518008,
    block_name: 'MOHIUDDINAGAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140206',
    block_code: 1412010,
    block_name: 'BUDHAL NEW',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140190',
    block_code: 1411015,
    block_name: 'NANGALI SAHIB SAIN BABA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360140',
    block_code: 3609016,
    block_name: 'VEENAVANKA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110199',
    block_code: 1102006,
    block_name: 'UPLETA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29020',
    district_code: 2935,
    district_name: 'RANIPET',
    block_id: 'B-290193',
    block_code: 2935009,
    block_name: 'WALAJAH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260072',
    block_code: 2605016,
    block_name: 'SHAHKOT',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160103',
    block_code: 1606003,
    block_name: 'CHITTOOR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240019',
    block_code: 2405009,
    block_name: 'SIMULIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313295',
    block_code: 3117032,
    block_name: 'LAKHAOTHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140010',
    block_code: 1406036,
    block_name: 'PAHALGAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20136',
    block_code: 210005,
    block_name: 'CHOWDEPALLE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20609',
    block_code: 205005,
    block_name: 'ATTILI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313813',
    block_code: 3151014,
    block_name: 'LOTAN',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260021',
    block_code: 2611006,
    block_name: 'TALWANDI SABO',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12009',
    district_code: 1214,
    district_name: 'JIND',
    block_id: 'B-120055',
    block_code: 1214008,
    block_name: 'UJHANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20028',
    block_code: 216006,
    block_name: 'DEVARAPALLE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270215',
    block_code: 2705010,
    block_name: 'SINGHANA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26015',
    district_code: 2615,
    district_name: 'MOGA',
    block_id: 'B-260102',
    block_code: 2615002,
    block_name: 'MOGA II',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20105',
    block_code: 224027,
    block_name: 'T SUNDUPALLE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11009',
    district_code: 1133,
    district_name: 'CHHOTA UDAIPUR',
    block_id: 'B-110077',
    block_code: 1133007,
    block_name: 'SANKHEDA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5017',
    district_code: 542,
    district_name: 'KISHANGANJ',
    block_id: 'B-50207',
    block_code: 542005,
    block_name: 'POTHIA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20345',
    block_code: 226026,
    block_name: 'UYYALAWADA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23007',
    district_code: 2311,
    district_name: 'PAREN',
    block_id: 'B-230042',
    block_code: 2311003,
    block_name: 'TENNING',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313323',
    block_code: 3155017,
    block_name: 'DESAI DEORIA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180293',
    block_code: 1811006,
    block_name: 'MAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313420',
    block_code: 3154006,
    block_name: 'BHATHAT',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240146',
    block_code: 2410007,
    block_name: 'THUAMUL RAM PUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15019',
    district_code: 1519,
    district_name: 'KOLAR',
    block_id: 'B-150137',
    block_code: 1519009,
    block_name: 'MULBAGAL',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16003',
    district_code: 1609,
    district_name: 'IDUKKI',
    block_id: 'B-160028',
    block_code: 1609002,
    block_name: 'AZHUTHA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20381',
    block_code: 222019,
    block_name: 'NUZENDLA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230028',
    block_code: 2305005,
    block_name: 'ONGPANGKONG S',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50439',
    block_code: 518019,
    block_name: 'VIDYAPATI NAGAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140169',
    block_code: 1401028,
    block_name: 'MAWAR KALAMABAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140192',
    block_code: 1411016,
    block_name: 'SATHRA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360130',
    block_code: 3609004,
    block_name: 'GANGADHARA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110192',
    block_code: 1102007,
    block_name: 'JAMKANDORNA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18006',
    district_code: 1828,
    district_name: 'BHANDARA',
    block_id: 'B-180062',
    block_code: 1828021,
    block_name: 'TUMSAR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260070',
    block_code: 2605019,
    block_name: 'PHILLAUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160104',
    block_code: 1606004,
    block_name: 'KOLLANKODE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240015',
    block_code: 2405010,
    block_name: 'KHAIRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313285',
    block_code: 3117033,
    block_name: 'AGAUTA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140005',
    block_code: 1406035,
    block_name: 'CHATHERGUL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20156',
    block_code: 210007,
    block_name: 'SODAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20616',
    block_code: 205016,
    block_name: 'PALACOLE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27027',
    district_code: 2725,
    district_name: 'RAJSAMAND',
    block_id: 'B-270288',
    block_code: 2725008,
    block_name: 'DELWADA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260015',
    block_code: 2611009,
    block_name: 'GONIANA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33032',
    district_code: 3326,
    district_name: 'SURAJPUR',
    block_id: 'B-330139',
    block_code: 3326006,
    block_name: 'SURAJPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20033',
    block_code: 216011,
    block_name: 'MADUGULA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270310',
    block_code: 2713009,
    block_name: 'PATAN',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260118',
    block_code: 2609013,
    block_name: 'PATIALA RURAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20090',
    block_code: 224013,
    block_name: 'MULAKALACHERUVU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11009',
    district_code: 1133,
    district_name: 'CHHOTA UDAIPUR',
    block_id: 'B-110075',
    block_code: 1133013,
    block_name: 'KAWANT',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5017',
    district_code: 542,
    district_name: 'KISHANGANJ',
    block_id: 'B-50205',
    block_code: 542003,
    block_name: 'KISHANGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20342',
    block_code: 226023,
    block_name: 'RUDRAVARAM',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23007',
    district_code: 2311,
    district_name: 'PAREN',
    block_id: 'B-230040',
    block_code: 2311001,
    block_name: 'JALUKIE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313326',
    block_code: 3155018,
    block_name: 'PATHAR DEWA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180290',
    block_code: 1811007,
    block_name: 'KHATAV',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313431',
    block_code: 3154007,
    block_name: 'PIPRAICH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240135',
    block_code: 2410008,
    block_name: 'DHARAMAGARH',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15019',
    district_code: 1519,
    district_name: 'KOLAR',
    block_id: 'B-150138',
    block_code: 1519011,
    block_name: 'SRINIVASPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16003',
    district_code: 1609,
    district_name: 'IDUKKI',
    block_id: 'B-160031',
    block_code: 1609005,
    block_name: 'IDUKKI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20380',
    block_code: 222017,
    block_name: 'NEKARIKALLU',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23005',
    district_code: 2305,
    district_name: 'MOKOKCHUNG',
    block_id: 'B-230027',
    block_code: 2305004,
    block_name: 'ONGPANGKONG N',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50432',
    block_code: 518012,
    block_name: 'ROSERA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140214',
    block_code: 1412018,
    block_name: 'MOUGHLA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140185',
    block_code: 1411012,
    block_name: 'LASSANA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360141',
    block_code: 3609013,
    block_name: 'V SAIDAPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110196',
    block_code: 1102008,
    block_name: 'LODHIKA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18006',
    district_code: 1828,
    district_name: 'BHANDARA',
    block_id: 'B-180060',
    block_code: 1828022,
    block_name: 'PAUNI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260065',
    block_code: 2605015,
    block_name: 'JALANDHAR WEST',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160107',
    block_code: 1606007,
    block_name: 'MANNARKKAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240016',
    block_code: 2405018,
    block_name: 'NILGIRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313129',
    block_code: 3178005,
    block_name: 'BASKHARI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140012',
    block_code: 1406040,
    block_name: 'SAGAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20160',
    block_code: 210009,
    block_name: 'VEDURUKUPPAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20619',
    block_code: 205013,
    block_name: 'PENUGONDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27027',
    district_code: 2725,
    district_name: 'RAJSAMAND',
    block_id: 'B-270287',
    block_code: 2725001,
    block_name: 'BHIM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260017',
    block_code: 2611004,
    block_name: 'NATHANA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12009',
    district_code: 1214,
    district_name: 'JIND',
    block_id: 'B-120051',
    block_code: 1214001,
    block_name: 'NARWANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20032',
    block_code: 216010,
    block_name: 'KOTAURATLA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270304',
    block_code: 2713001,
    block_name: 'FATEHPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260123',
    block_code: 2609012,
    block_name: 'SHAMBHU KALAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20104',
    block_code: 224028,
    block_name: 'THAMBALLAPALLE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11009',
    district_code: 1133,
    district_name: 'CHHOTA UDAIPUR',
    block_id: 'B-110076',
    block_code: 1133010,
    block_name: 'NASVADI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5017',
    district_code: 542,
    district_name: 'KISHANGANJ',
    block_id: 'B-50208',
    block_code: 542006,
    block_name: 'TERHAGACHH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20324',
    block_code: 226005,
    block_name: 'CHAGALAMARRI',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23007',
    district_code: 2311,
    district_name: 'PAREN',
    block_id: 'B-230041',
    block_code: 2311002,
    block_name: 'PEREN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313322',
    block_code: 3155020,
    block_name: 'DEORIA SADAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180288',
    block_code: 1811008,
    block_name: 'KARAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313434',
    block_code: 3154008,
    block_name: 'SARDARNAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240138',
    block_code: 2410009,
    block_name: 'JUNAGARH',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15004',
    district_code: 1502,
    district_name: 'BENGALURU',
    block_id: 'B-150029',
    block_code: 1502001,
    block_name: 'ANEKAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313138',
    block_code: 3181013,
    block_name: 'BAHADURPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20383',
    block_code: 222021,
    block_name: 'PIDUGURALLA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23008',
    district_code: 2302,
    district_name: 'PHEK',
    block_id: 'B-230049',
    block_code: 2302004,
    block_name: 'SEKHRUZU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50431',
    block_code: 518011,
    block_name: 'PUSA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140216',
    block_code: 1412014,
    block_name: 'PANJGRIAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140186',
    block_code: 1411013,
    block_name: 'LORAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360128',
    block_code: 3609002,
    block_name: 'CHOPPADANDI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110197',
    block_code: 1102009,
    block_name: 'PADDHARI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18006',
    district_code: 1828,
    district_name: 'BHANDARA',
    block_id: 'B-180058',
    block_code: 1828023,
    block_name: 'LAKHANI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260064',
    block_code: 2605017,
    block_name: 'JALANDHAR EAST',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160113',
    block_code: 1606013,
    block_name: 'THRITHALA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240017',
    block_code: 2405019,
    block_name: 'OUPADA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313135',
    block_code: 3178006,
    block_name: 'RAM NAGAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140016',
    block_code: 1406042,
    block_name: 'VESSU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20157',
    block_code: 210006,
    block_name: 'SOMALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20611',
    block_code: 205017,
    block_name: 'ELAMANCHILI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27027',
    district_code: 2725,
    district_name: 'RAJSAMAND',
    block_id: 'B-270289',
    block_code: 2725002,
    block_name: 'DEOGARH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260020',
    block_code: 2611005,
    block_name: 'SANGAT',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12009',
    district_code: 1214,
    district_name: 'JIND',
    block_id: 'B-120049',
    block_code: 1214003,
    block_name: 'JIND',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20036',
    block_code: 216014,
    block_name: 'NAKKAPALLE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270306',
    block_code: 2713002,
    block_name: 'LACHHMANGARH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26018',
    district_code: 2609,
    district_name: 'PATIALA',
    block_id: 'B-260120',
    block_code: 2609005,
    block_name: 'RAJPURA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20085',
    block_code: 224008,
    block_name: 'KAMBHAMVARIPALLE',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11009',
    district_code: 1133,
    district_name: 'CHHOTA UDAIPUR',
    block_id: 'B-110074',
    block_code: 1133008,
    block_name: 'JETPUR PAVI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5017',
    district_code: 542,
    district_name: 'KISHANGANJ',
    block_id: 'B-50204',
    block_code: 542002,
    block_name: 'DIGHALBANK',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20339',
    block_code: 226020,
    block_name: 'PAMULAPADU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36018',
    district_code: 3632,
    district_name: 'MULUGU',
    block_id: 'B-360253',
    block_code: 3632005,
    block_name: 'MULUGU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313330',
    block_code: 3155030,
    block_name: 'TARKULWA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180294',
    block_code: 1811009,
    block_name: 'PATAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313429',
    block_code: 3154009,
    block_name: 'KHORABAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240137',
    block_code: 2410010,
    block_name: 'JAYAPATNA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360380',
    block_code: 3622003,
    block_name: 'ELLANTHAKUNTA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31314',
    district_code: 3181,
    district_name: 'AMETHI',
    block_id: 'B-313148',
    block_code: 3181004,
    block_name: 'SINGHPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20379',
    block_code: 222018,
    block_name: 'NARASARAOPETA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340242',
    block_code: 3404001,
    block_name: 'KURDEG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50440',
    block_code: 518020,
    block_name: 'WARISNAGAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140170',
    block_code: 1401029,
    block_name: 'MELIYAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14012',
    district_code: 1411,
    district_name: 'POONCH',
    block_id: 'B-140191',
    block_code: 1411001,
    block_name: 'POONCH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360131',
    block_code: 3609005,
    block_name: 'GANNERUVARAM ',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110193',
    block_code: 1102013,
    block_name: 'JASDAN',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18006',
    district_code: 1828,
    district_name: 'BHANDARA',
    block_id: 'B-180061',
    block_code: 1828024,
    block_name: 'SAKOLI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26023',
    district_code: 2620,
    district_name: 'TARAN TARAN',
    block_id: 'B-260146',
    block_code: 2620013,
    block_name: 'BHIKHIWIND',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16010',
    district_code: 1606,
    district_name: 'PALAKKAD',
    block_id: 'B-160108',
    block_code: 1606008,
    block_name: 'NENMARA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24002',
    district_code: 2405,
    district_name: 'BALESHWAR',
    block_id: 'B-240018',
    block_code: 2405002,
    block_name: 'REMUNA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313132',
    block_code: 3178007,
    block_name: 'JAHANGIR GANJ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140014',
    block_code: 1406017,
    block_name: 'SHANGUS',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20154',
    block_code: 210003,
    block_name: 'ROMPICHERLA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2025',
    district_code: 205,
    district_name: 'WEST GODAVARI',
    block_id: 'B-20612',
    block_code: 205004,
    block_name: 'IRAGAVARAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27027',
    district_code: 2725,
    district_name: 'RAJSAMAND',
    block_id: 'B-270286',
    block_code: 2725003,
    block_name: 'AMET',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260016',
    block_code: 2611007,
    block_name: 'MAUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12009',
    district_code: 1214,
    district_name: 'JIND',
    block_id: 'B-120050',
    block_code: 1214004,
    block_name: 'JULANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20027',
    block_code: 216005,
    block_name: 'CHODAVARAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270302',
    block_code: 2713004,
    block_name: 'DANTA RAMGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20078',
    block_code: 224001,
    block_name: 'B KOTHAKOTA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23002',
    district_code: 2309,
    district_name: 'KIPHIRE',
    block_id: 'B-230007',
    block_code: 2309005,
    block_name: 'KHONSA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50083',
    block_code: 503013,
    block_name: 'Tarari',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20333',
    block_code: 226014,
    block_name: 'MAHANANDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313106',
    block_code: 3120007,
    block_name: 'ETMADPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313328',
    block_code: 3155021,
    block_name: 'RUDRAPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180292',
    block_code: 1811011,
    block_name: 'MAHABALESHWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313421',
    block_code: 3154010,
    block_name: 'BRAHMPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240142',
    block_code: 2410011,
    block_name: 'KOKASARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360384',
    block_code: 3622007,
    block_name: 'RUDRANGI ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31373',
    district_code: 3127,
    district_name: 'SHAHJAHANPUR',
    block_id: 'B-313785',
    block_code: 3127018,
    block_name: 'KANTH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20364',
    block_code: 222001,
    block_name: 'ATCHEMPET',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340238',
    block_code: 3404002,
    block_name: 'BOLBA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50422',
    block_code: 518002,
    block_name: 'BITHAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140220',
    block_code: 1412016,
    block_name: 'SERI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360139',
    block_code: 3609015,
    block_name: 'THIMMAPUR L M D',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110138',
    block_code: 1113016,
    block_name: 'VASO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18006',
    district_code: 1828,
    district_name: 'BHANDARA',
    block_id: 'B-180057',
    block_code: 1828025,
    block_name: 'LAKHANDUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26023',
    district_code: 2620,
    district_name: 'TARAN TARAN',
    block_id: 'B-260153',
    block_code: 2620015,
    block_name: 'VALTOHA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170167',
    block_code: 1735008,
    block_name: 'MOHGAON',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26011',
    district_code: 2606,
    district_name: 'KAPURTHALA',
    block_id: 'B-260073',
    block_code: 2606005,
    block_name: 'DHILWAN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290327',
    block_code: 2902006,
    block_name: 'TIRUVALANGADU',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140013',
    block_code: 1406013,
    block_name: 'SHAHABAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20162',
    block_code: 210001,
    block_name: 'VIJAYAPURAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17008',
    district_code: 1702,
    district_name: 'BHIND',
    block_id: 'B-170051',
    block_code: 1702005,
    block_name: 'RON',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27027',
    district_code: 2725,
    district_name: 'RAJSAMAND',
    block_id: 'B-270291',
    block_code: 2725004,
    block_name: 'KUMBHALGARH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260018',
    block_code: 2611001,
    block_name: 'PHUL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140240',
    block_code: 1417007,
    block_name: 'KATRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20042',
    block_code: 216020,
    block_name: 'RAVIKAMATHAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270311',
    block_code: 2713007,
    block_name: 'PIPRALI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20092',
    block_code: 224015,
    block_name: 'NIMMANAPALLE',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23002',
    district_code: 2309,
    district_name: 'KIPHIRE',
    block_id: 'B-230009',
    block_code: 2309004,
    block_name: 'LONGMATRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5017',
    district_code: 542,
    district_name: 'KISHANGANJ',
    block_id: 'B-50209',
    block_code: 542007,
    block_name: 'THAKURGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20346',
    block_code: 226027,
    block_name: 'VELUGODU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313108',
    block_code: 3120001,
    block_name: 'FATEHPUR SIKRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313317',
    block_code: 3155023,
    block_name: 'BARHAJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313875',
    block_code: 3131009,
    block_name: 'SIKANDARPUR SAROSI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313427',
    block_code: 3154011,
    block_name: 'KAURI RAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24015',
    district_code: 2410,
    district_name: 'KALAHANDI',
    block_id: 'B-240136',
    block_code: 2410013,
    block_name: 'GOLAMUNDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360389',
    block_code: 3622013,
    block_name: 'YELLAREDDYPET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20069',
    block_code: 212018,
    block_name: 'RAYADURG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20371',
    block_code: 222009,
    block_name: 'GURAZALA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340244',
    block_code: 3404004,
    block_name: 'SIMDEGA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50426',
    block_code: 518006,
    block_name: 'KHANPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140171',
    block_code: 1401026,
    block_name: 'NUTNOOSA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340217',
    block_code: 3401019,
    block_name: 'TAMAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11018',
    district_code: 1113,
    district_name: 'KHEDA',
    block_id: 'B-110129',
    block_code: 1113015,
    block_name: 'GALTESHWAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18006',
    district_code: 1828,
    district_name: 'BHANDARA',
    block_id: 'B-180056',
    block_code: 1828026,
    block_name: 'BHANDARA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26023',
    district_code: 2620,
    district_name: 'TARAN TARAN',
    block_id: 'B-260152',
    block_code: 2620012,
    block_name: 'TARN TARAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170166',
    block_code: 1735009,
    block_name: 'MAWAI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26011',
    district_code: 2606,
    district_name: 'KAPURTHALA',
    block_id: 'B-260077',
    block_code: 2606003,
    block_name: 'SULTANPUR LODHI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290320',
    block_code: 2902008,
    block_name: 'PALLIPET',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140006',
    block_code: 1406022,
    block_name: 'DACHNIPORA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20151',
    block_code: 210004,
    block_name: 'PUNGANUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360160',
    block_code: 3610020,
    block_name: 'WYRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27027',
    district_code: 2725,
    district_name: 'RAJSAMAND',
    block_id: 'B-270293',
    block_code: 2725005,
    block_name: 'RAJSAMAND',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260019',
    block_code: 2611002,
    block_name: 'RAMPURA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140245',
    block_code: 1417008,
    block_name: 'THAKRAKOTE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20043',
    block_code: 216021,
    block_name: 'ROLUGUNTA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270308',
    block_code: 2713008,
    block_name: 'NEEM KA THANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20094',
    block_code: 224017,
    block_name: 'PEDDAMANDYAM',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23002',
    district_code: 2309,
    district_name: 'KIPHIRE',
    block_id: 'B-230008',
    block_code: 2309001,
    block_name: 'KIPHIRE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5017',
    district_code: 542,
    district_name: 'KISHANGANJ',
    block_id: 'B-50203',
    block_code: 542001,
    block_name: 'BAHADURGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2014',
    district_code: 226,
    district_name: 'NANDYAL',
    block_id: 'B-20319',
    block_code: 226001,
    block_name: 'ALLAGADDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313111',
    block_code: 3120006,
    block_name: 'KHANDAULI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313321',
    block_code: 3155025,
    block_name: 'BHATPAR RANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313867',
    block_code: 3131001,
    block_name: 'GANJ MORADABAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313416',
    block_code: 3154012,
    block_name: 'BANSGAON',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5033',
    district_code: 547,
    district_name: 'SHEIKHPURA',
    block_id: 'B-50461',
    block_code: 547001,
    block_name: 'ARIARI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360381',
    block_code: 3622004,
    block_name: 'GAMBHIRAOPET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20053',
    block_code: 212001,
    block_name: 'D HIREHAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20369',
    block_code: 222007,
    block_name: 'DURGI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340241',
    block_code: 3404005,
    block_name: 'KOLEBIRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50434',
    block_code: 518014,
    block_name: 'SARAIRANJAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140172',
    block_code: 1401027,
    block_name: 'QADIRABAD',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340203',
    block_code: 3401004,
    block_name: 'BURMU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11027',
    district_code: 1102,
    district_name: 'RAJKOT',
    block_id: 'B-110200',
    block_code: 1102014,
    block_name: 'VINCHHIYA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18006',
    district_code: 1828,
    district_name: 'BHANDARA',
    block_id: 'B-180059',
    block_code: 1828027,
    block_name: 'MOHADI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26023',
    district_code: 2620,
    district_name: 'TARAN TARAN',
    block_id: 'B-260149',
    block_code: 2620010,
    block_name: 'KHADOOR SAHIB',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170164',
    block_code: 1735007,
    block_name: 'GHUGHRI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26011',
    district_code: 2606,
    district_name: 'KAPURTHALA',
    block_id: 'B-260076',
    block_code: 2606004,
    block_name: 'PHAGWARA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290323',
    block_code: 2902002,
    block_name: 'PUZHAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140001',
    block_code: 1406020,
    block_name: 'ACHABAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20145',
    block_code: 210002,
    block_name: 'NINDRA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360143',
    block_code: 3610002,
    block_name: 'CHINTHAKANI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27027',
    district_code: 2725,
    district_name: 'RAJSAMAND',
    block_id: 'B-270292',
    block_code: 2725006,
    block_name: 'RAILMAGRA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26003',
    district_code: 2611,
    district_name: 'BATHINDA',
    block_id: 'B-260013',
    block_code: 2611003,
    block_name: 'BATHINDA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140246',
    block_code: 1417009,
    block_name: 'THUROO',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15006',
    district_code: 1506,
    district_name: 'BIDAR',
    block_id: 'B-150041',
    block_code: 1506004,
    block_name: 'BIDAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27011',
    district_code: 2704,
    district_name: 'CHURU',
    block_id: 'B-270123',
    block_code: 2704003,
    block_name: 'SARDAR SHAHAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20082',
    block_code: 224005,
    block_name: 'GURRAMKONDA',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23002',
    district_code: 2309,
    district_name: 'KIPHIRE',
    block_id: 'B-230010',
    block_code: 2309002,
    block_name: 'PUNGRO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240062',
    block_code: 2406001,
    block_name: 'CUTTACKSADAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15023',
    district_code: 1523,
    district_name: 'RAICHUR',
    block_id: 'B-150167',
    block_code: 1523005,
    block_name: 'SINDHNUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313109',
    block_code: 3120008,
    block_name: 'JAGNER',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313316',
    block_code: 3155026,
    block_name: 'BANKATA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313863',
    block_code: 3131002,
    block_name: 'BANGARMAU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313435',
    block_code: 3154013,
    block_name: 'URUWA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5033',
    district_code: 547,
    district_name: 'SHEIKHPURA',
    block_id: 'B-50465',
    block_code: 547005,
    block_name: 'SHEIKHPURA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360378',
    block_code: 3622001,
    block_name: 'BOINPALLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20058',
    block_code: 212023,
    block_name: 'KALYANDRUG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20376',
    block_code: 222014,
    block_name: 'MACHERLA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340239',
    block_code: 3404006,
    block_name: 'JALDEGA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50438',
    block_code: 518018,
    block_name: 'UJIARPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140176',
    block_code: 1401031,
    block_name: 'REDDI CHOWKIBAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340204',
    block_code: 3401005,
    block_name: 'CHANHO',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340024',
    block_code: 3422006,
    block_name: 'KAROWN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313401',
    block_code: 3147019,
    block_name: 'BELSAR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26023',
    district_code: 2620,
    district_name: 'TARAN TARAN',
    block_id: 'B-260150',
    block_code: 2620011,
    block_name: 'NAUSHEHRA PANNUAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17027',
    district_code: 1735,
    district_name: 'MANDLA',
    block_id: 'B-170163',
    block_code: 1735001,
    block_name: 'BIJADANDI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26011',
    district_code: 2606,
    district_name: 'KAPURTHALA',
    block_id: 'B-260075',
    block_code: 2606002,
    block_name: 'NADALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290322',
    block_code: 2902011,
    block_name: 'POONDI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140004',
    block_code: 1406021,
    block_name: 'BRENG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20163',
    block_code: 210021,
    block_name: 'YADAMARI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360151',
    block_code: 3610011,
    block_name: 'MUDIGONDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27027',
    district_code: 2725,
    district_name: 'RAJSAMAND',
    block_id: 'B-270290',
    block_code: 2725007,
    block_name: 'KHAMNORE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313482',
    block_code: 3158024,
    block_name: 'BADLA PUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140236',
    block_code: 1417005,
    block_name: 'BHOMAG',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15006',
    district_code: 1506,
    district_name: 'BIDAR',
    block_id: 'B-150038',
    block_code: 1506001,
    block_name: 'AURAD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270210',
    block_code: 2705001,
    block_name: 'JHUNJHUNU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20095',
    block_code: 224018,
    block_name: 'PEDDATHIPPASAMUDRAM',
  },
  {
    state_id: 'S-21',
    state_code: 23,
    state_name: 'NAGALAND',
    district_id: 'D-23002',
    district_code: 2309,
    district_name: 'KIPHIRE',
    block_id: 'B-230011',
    block_code: 2309003,
    block_name: 'SITIMI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240061',
    block_code: 2406002,
    block_name: 'BARANGA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15023',
    district_code: 1523,
    district_name: 'RAICHUR',
    block_id: 'B-150162',
    block_code: 1523001,
    block_name: 'DEVADURGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313113',
    block_code: 3120013,
    block_name: 'PINAHAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313318',
    block_code: 3155028,
    block_name: 'BHAGALPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313866',
    block_code: 3131003,
    block_name: 'FATEHPUR CHAURASI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313418',
    block_code: 3154016,
    block_name: 'BELGHAT',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5033',
    district_code: 547,
    district_name: 'SHEIKHPURA',
    block_id: 'B-50464',
    block_code: 547004,
    block_name: 'GHAT KUSUMBHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36025',
    district_code: 3622,
    district_name: 'RAJANNA SIRCILLA',
    block_id: 'B-360382',
    block_code: 3622005,
    block_name: 'KONARAOPET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20072',
    block_code: 212009,
    block_name: 'TADIPATRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20373',
    block_code: 222011,
    block_name: 'KAREMPUDI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340236',
    block_code: 3404007,
    block_name: 'BANO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50427',
    block_code: 518007,
    block_name: 'MOHANPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140212',
    block_code: 1412019,
    block_name: 'LAMBERI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340208',
    block_code: 3401010,
    block_name: 'LAPUNG',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340022',
    block_code: 3422001,
    block_name: 'DEOGHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313414',
    block_code: 3147020,
    block_name: 'TARABGANJ',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26023',
    district_code: 2620,
    district_name: 'TARAN TARAN',
    block_id: 'B-260151',
    block_code: 2620014,
    block_name: 'PATTI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4015',
    district_code: 414,
    district_name: 'GOLAGHAT',
    block_id: 'B-40092',
    block_code: 414001,
    block_name: 'GOLAGHAT NORTH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26011',
    district_code: 2606,
    district_name: 'KAPURTHALA',
    block_id: 'B-260074',
    block_code: 2606001,
    block_name: 'KAPURTHALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29032',
    district_code: 2902,
    district_name: 'TIRUVALLUR',
    block_id: 'B-290317',
    block_code: 2902005,
    block_name: 'GUMMIDIPOONDI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140008',
    block_code: 1406023,
    block_name: 'KHOVERIPORA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20155',
    block_code: 210029,
    block_name: 'SANTHIPURAM HO ARIMUTHANAPALLE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360158',
    block_code: 3610018,
    block_name: 'THIRUMALAYAPALEM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313806',
    block_code: 3151003,
    block_name: 'BHANWAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313492',
    block_code: 3158025,
    block_name: 'MAHARAJ GANJ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140237',
    block_code: 1417006,
    block_name: 'CHASSANA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15006',
    district_code: 1506,
    district_name: 'BIDAR',
    block_id: 'B-150039',
    block_code: 1506002,
    block_name: 'BASAVAKALYAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270312',
    block_code: 2713005,
    block_name: 'SRIMADHOPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20084',
    block_code: 224007,
    block_name: 'KALIKIRI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320124',
    block_code: 3218001,
    block_name: 'CHOPRA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24007',
    district_code: 2406,
    district_name: 'CUTTACK',
    block_id: 'B-240066',
    block_code: 2406004,
    block_name: 'NIALI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15023',
    district_code: 1523,
    district_name: 'RAICHUR',
    block_id: 'B-150165',
    block_code: 1523006,
    block_name: 'MASKI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313110',
    block_code: 3120015,
    block_name: 'JAITPUR KALAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31329',
    district_code: 3155,
    district_name: 'DEORIA',
    block_id: 'B-313325',
    block_code: 3155029,
    block_name: 'LAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313862',
    block_code: 3131005,
    block_name: 'AURAS',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313425',
    block_code: 3154017,
    block_name: 'GOLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5033',
    district_code: 547,
    district_name: 'SHEIKHPURA',
    block_id: 'B-50462',
    block_code: 547002,
    block_name: 'BARBIGHA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270080',
    block_code: 2724001,
    block_name: 'ASIND',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20275',
    block_code: 206021,
    block_name: 'GUDIVADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20384',
    block_code: 222028,
    block_name: 'RAJUPALEM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340245',
    block_code: 3404003,
    block_name: 'THETHAITANGAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50430',
    block_code: 518010,
    block_name: 'PATORI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140166',
    block_code: 1401002,
    block_name: 'LANGATE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340209',
    block_code: 3401011,
    block_name: 'MANDAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340027',
    block_code: 3422002,
    block_name: 'MOHANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313415',
    block_code: 3147021,
    block_name: 'WAZIRGANJ',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26023',
    district_code: 2620,
    district_name: 'TARAN TARAN',
    block_id: 'B-260148',
    block_code: 2620009,
    block_name: 'GANDIWIND',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4015',
    district_code: 414,
    district_name: 'GOLAGHAT',
    block_id: 'B-40090',
    block_code: 414002,
    block_name: 'GOLAGHAT CENTRAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290080',
    block_code: 2938017,
    block_name: 'KALLAKURICHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140003',
    block_code: 1406034,
    block_name: 'BIJIBEHARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20140',
    block_code: 210030,
    block_name: 'GUDUPALLE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360159',
    block_code: 3610019,
    block_name: 'VEMSOOR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31376',
    district_code: 3151,
    district_name: 'SIDDHARTH NAGAR',
    block_id: 'B-313805',
    block_code: 3151004,
    block_name: 'BARHNI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313502',
    block_code: 3158026,
    block_name: 'SUJAN GANJ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140242',
    block_code: 1417010,
    block_name: 'PANTHAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20046',
    block_code: 216024,
    block_name: 'YELAMANCHILI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270305',
    block_code: 2713006,
    block_name: 'KHANDELA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20098',
    block_code: 224021,
    block_name: 'PULLAMPETA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320128',
    block_code: 3218002,
    block_name: 'ISLAMPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50072',
    block_code: 503002,
    block_name: 'Arrah',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15023',
    district_code: 1523,
    district_name: 'RAICHUR',
    block_id: 'B-150168',
    block_code: 1523007,
    block_name: 'SIRWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313112',
    block_code: 3120009,
    block_name: 'KHERAGARH',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21010',
    district_code: 2105,
    district_name: 'WEST GARO HILLS',
    block_id: 'B-210038',
    block_code: 2105020,
    block_name: 'GAMBEGRE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313871',
    block_code: 3131008,
    block_name: 'NAWABGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313417',
    block_code: 3154018,
    block_name: 'BARHALGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5033',
    district_code: 547,
    district_name: 'SHEIKHPURA',
    block_id: 'B-50463',
    block_code: 547003,
    block_name: 'CHEWARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270084',
    block_code: 2724002,
    block_name: 'HURDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20285',
    block_code: 206020,
    block_name: 'NANDIVADA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20385',
    block_code: 222022,
    block_name: 'RENTACHINTALA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340243',
    block_code: 3404010,
    block_name: 'PAKARTANR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5031',
    district_code: 518,
    district_name: 'SAMASTIPUR',
    block_id: 'B-50437',
    block_code: 518017,
    block_name: 'TAJPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140174',
    block_code: 1401003,
    block_name: 'RAJWAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340212',
    block_code: 3401014,
    block_name: 'ORMANJHI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340028',
    block_code: 3422003,
    block_name: 'PALOJORI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313408',
    block_code: 3147023,
    block_name: 'MANKAPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26010',
    district_code: 2605,
    district_name: 'JALANDHAR',
    block_id: 'B-260067',
    block_code: 2605023,
    block_name: 'MEHATPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4015',
    district_code: 414,
    district_name: 'GOLAGHAT',
    block_id: 'B-40094',
    block_code: 414003,
    block_name: 'GOLAGHAT WEST',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290081',
    block_code: 2938022,
    block_name: 'KALRAYAN HILLS',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140011',
    block_code: 1406001,
    block_name: 'QAZIGUND',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20135',
    block_code: 210019,
    block_name: 'CHITTOOR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360142',
    block_code: 3610001,
    block_name: 'BONAKAL',
  },
  {
    state_id: 'S-36',
    state_code: 38,
    state_name: 'DNH AND DAMAN DIU',
    district_id: 'D-38003',
    district_code: 3803,
    district_name: 'DIU',
    block_id: 'B-380003',
    block_code: 3803001,
    block_name: 'DIU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313495',
    block_code: 3158027,
    block_name: 'MUNGRA BADSHAH PUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140238',
    block_code: 1417011,
    block_name: 'GULAB GARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20045',
    block_code: 216022,
    block_name: 'S RAYAVARAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270209',
    block_code: 2705002,
    block_name: 'CHIRAWA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20093',
    block_code: 224016,
    block_name: 'OBULAVARIPALLE',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320131',
    block_code: 3218005,
    block_name: 'KARANDIGHI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50084',
    block_code: 503014,
    block_name: 'Udwant Nagar',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11031',
    district_code: 1126,
    district_name: 'TAPI',
    block_id: 'B-110229',
    block_code: 1126007,
    block_name: 'KUKARMUNDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313107',
    block_code: 3120012,
    block_name: 'FATEHABAD',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21010',
    district_code: 2105,
    district_name: 'WEST GARO HILLS',
    block_id: 'B-210040',
    block_code: 2105019,
    block_name: 'SELSELLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313864',
    block_code: 3131010,
    block_name: 'BICHHIYA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313422',
    block_code: 3154092,
    block_name: 'CAMPIERGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5033',
    district_code: 547,
    district_name: 'SHEIKHPURA',
    block_id: 'B-50466',
    block_code: 547006,
    block_name: 'SHEKHOPUR SARAI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270092',
    block_code: 2724003,
    block_name: 'SHAHPURA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20286',
    block_code: 206018,
    block_name: 'PAMARRU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20363',
    block_code: 222002,
    block_name: 'AMARAVATHI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340237',
    block_code: 3404008,
    block_name: 'BANSJOR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140175',
    block_code: 1401004,
    block_name: 'RAMHAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340214',
    block_code: 3401016,
    block_name: 'RATU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340023',
    block_code: 3422004,
    block_name: 'DEVIPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32013',
    district_code: 3223,
    district_name: 'JHARGRAM',
    block_id: 'B-320179',
    block_code: 3223005,
    block_name: 'JHARGRAM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26023',
    district_code: 2620,
    district_name: 'TARAN TARAN',
    block_id: 'B-260147',
    block_code: 2620008,
    block_name: 'CHOHLA SAHIB',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4015',
    district_code: 414,
    district_name: 'GOLAGHAT',
    block_id: 'B-40091',
    block_code: 414004,
    block_name: 'GOLAGHAT EAST',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290084',
    block_code: 2938021,
    block_name: 'THIYAGADURGAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14001',
    district_code: 1406,
    district_name: 'ANANTNAG',
    block_id: 'B-140002',
    block_code: 1406037,
    block_name: 'ANANTNAG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20159',
    block_code: 210018,
    block_name: 'THAVANAMPALLE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360148',
    block_code: 3610008,
    block_name: 'KONIJERLA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17028',
    district_code: 1716,
    district_name: 'MANDSAUR',
    block_id: 'B-170173',
    block_code: 1716002,
    block_name: 'MALHARGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313491',
    block_code: 3158028,
    block_name: 'MACHCHALI SHAHAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140235',
    block_code: 1417001,
    block_name: 'ARNAS',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2002',
    district_code: 216,
    district_name: 'ANAKAPALLI',
    block_id: 'B-20044',
    block_code: 216023,
    block_name: 'SABBAVARAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270208',
    block_code: 2705003,
    block_name: 'BUHANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20091',
    block_code: 224014,
    block_name: 'NANDALUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320132',
    block_code: 3218006,
    block_name: 'RAIGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5017',
    district_code: 542,
    district_name: 'KISHANGANJ',
    block_id: 'B-50206',
    block_code: 542004,
    block_name: 'KOCHADHAMIN',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11031',
    district_code: 1126,
    district_name: 'TAPI',
    block_id: 'B-110231',
    block_code: 1126001,
    block_name: 'SONGADH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313103',
    block_code: 3120014,
    block_name: 'BAH',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21010',
    district_code: 2105,
    district_name: 'WEST GARO HILLS',
    block_id: 'B-210041',
    block_code: 2105014,
    block_name: 'TIKRIKILLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313874',
    block_code: 3131011,
    block_name: 'SIKANDARPUR KARAN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290289',
    block_code: 2916008,
    block_name: 'MANACHANALLUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32019',
    district_code: 3222,
    district_name: 'PASCHIM BARDHAMAN',
    block_id: 'B-320251',
    block_code: 3222016,
    block_name: 'RANIGANJ',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270082',
    block_code: 2724004,
    block_name: 'BANERA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20289',
    block_code: 206019,
    block_name: 'PEDAPARUPUDI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20388',
    block_code: 222025,
    block_name: 'SAVALYAPURAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34023',
    district_code: 3404,
    district_name: 'SIMDEGA',
    block_id: 'B-340240',
    block_code: 3404009,
    block_name: 'KERSAI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140177',
    block_code: 1401005,
    block_name: 'SOGAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340215',
    block_code: 3401017,
    block_name: 'SILLI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340025',
    block_code: 3422005,
    block_name: 'MADHUPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32013',
    district_code: 3223,
    district_name: 'JHARGRAM',
    block_id: 'B-320180',
    block_code: 3223001,
    block_name: 'NAYAGRAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24014',
    district_code: 2415,
    district_name: 'JHARSUGUDA',
    block_id: 'B-240132',
    block_code: 2415004,
    block_name: 'LAIKERA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4015',
    district_code: 414,
    district_name: 'GOLAGHAT',
    block_id: 'B-40093',
    block_code: 414005,
    block_name: 'GOLAGHAT SOUTH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29008',
    district_code: 2938,
    district_name: 'KALLAKURICHI',
    block_id: 'B-290079',
    block_code: 2938018,
    block_name: 'CHINNASALEM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240199',
    block_code: 2411008,
    block_name: 'LAMTAPUT',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20137',
    block_code: 210014,
    block_name: 'GANGADHARA NELLORE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360149',
    block_code: 3610009,
    block_name: 'KUSUMANCHI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17028',
    district_code: 1716,
    district_name: 'MANDSAUR',
    block_id: 'B-170172',
    block_code: 1716003,
    block_name: 'GAROTH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313493',
    block_code: 3158029,
    block_name: 'MARIYAHU',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140241',
    block_code: 1417002,
    block_name: 'MAHORE',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15006',
    district_code: 1506,
    district_name: 'BIDAR',
    block_id: 'B-150040',
    block_code: 1506003,
    block_name: 'BHALKI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270211',
    block_code: 2705004,
    block_name: 'KHETRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20086',
    block_code: 224009,
    block_name: 'KODUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320127',
    block_code: 3218007,
    block_name: 'HEMTABAD',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50078',
    block_code: 503008,
    block_name: 'Koilwar',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11031',
    district_code: 1126,
    district_name: 'TAPI',
    block_id: 'B-110232',
    block_code: 1126002,
    block_name: 'UCHCHHAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313607',
    block_code: 3123001,
    block_name: 'GHIROR',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21010',
    district_code: 2105,
    district_name: 'WEST GARO HILLS',
    block_id: 'B-210039',
    block_code: 2105015,
    block_name: 'RONGRAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313861',
    block_code: 3131012,
    block_name: 'ASOHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290297',
    block_code: 2916013,
    block_name: 'THURAIYUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320137',
    block_code: 3206001,
    block_name: 'CHINSURAH-MOGRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270088',
    block_code: 2724005,
    block_name: 'MANDAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2012',
    district_code: 206,
    district_name: 'KRISHNA',
    block_id: 'B-20276',
    block_code: 206022,
    block_name: 'GUDLAVALLERU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20366',
    block_code: 222004,
    block_name: 'BOLLAPALLE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31331',
    district_code: 3135,
    district_name: 'ETAWAH',
    block_id: 'B-313342',
    block_code: 3135027,
    block_name: 'CHAKARNAGAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140181',
    block_code: 1401006,
    block_name: 'TREHGAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340216',
    block_code: 3401018,
    block_name: 'SONAHATU',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340030',
    block_code: 3422007,
    block_name: 'SARWAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32013',
    district_code: 3223,
    district_name: 'JHARGRAM',
    block_id: 'B-320176',
    block_code: 3223002,
    block_name: 'GOPIBALLAVPUR ONE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24014',
    district_code: 2415,
    district_name: 'JHARSUGUDA',
    block_id: 'B-240133',
    block_code: 2415005,
    block_name: 'LAKHANPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4015',
    district_code: 414,
    district_name: 'GOLAGHAT',
    block_id: 'B-40095',
    block_code: 414006,
    block_name: 'GOMARIGURI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313298',
    block_code: 3117019,
    block_name: 'SIKANDRABAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240198',
    block_code: 2411016,
    block_name: 'KUNDURA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20149',
    block_code: 210015,
    block_name: 'PENUMURU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360161',
    block_code: 3610021,
    block_name: 'YERRUPALEM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17028',
    district_code: 1716,
    district_name: 'MANDSAUR',
    block_id: 'B-170174',
    block_code: 1716004,
    block_name: 'MANDSAUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290274',
    block_code: 2932012,
    block_name: 'VELLAKOVIL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140243',
    block_code: 1417003,
    block_name: 'POUNI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15006',
    district_code: 1506,
    district_name: 'BIDAR',
    block_id: 'B-150044',
    block_code: 1506005,
    block_name: 'HUMNABAD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270213',
    block_code: 2705005,
    block_name: 'NAWALGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20088',
    block_code: 224011,
    block_name: 'LAKKIREDDIPALLE',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320129',
    block_code: 3218009,
    block_name: 'ITAHAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5007',
    district_code: 503,
    district_name: 'BHOJPUR',
    block_id: 'B-50071',
    block_code: 503001,
    block_name: 'Agiaon',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11031',
    district_code: 1126,
    district_name: 'TAPI',
    block_id: 'B-110230',
    block_code: 1126003,
    block_name: 'NIZAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313611',
    block_code: 3123002,
    block_name: 'KURAOLI',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21010',
    district_code: 2105,
    district_name: 'WEST GARO HILLS',
    block_id: 'B-210036',
    block_code: 2105018,
    block_name: 'DALU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313869',
    block_code: 3131013,
    block_name: 'HILAULI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290298',
    block_code: 2916012,
    block_name: 'T.PET',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17041',
    district_code: 1729,
    district_name: 'SEHORE',
    block_id: 'B-170257',
    block_code: 1729001,
    block_name: 'SEHORE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270090',
    block_code: 2724006,
    block_name: 'RAIPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20050',
    block_code: 212002,
    block_name: 'BOMMANAHAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20390',
    block_code: 222027,
    block_name: 'VINUKONDA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3013',
    district_code: 304,
    district_name: 'LOWER SUBANSIRI',
    block_id: 'B-30056',
    block_code: 304002,
    block_name: 'ZIRO TWO YACHULI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140164',
    block_code: 1401007,
    block_name: 'KRALPORA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340205',
    block_code: 3401022,
    block_name: 'ITKI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340029',
    block_code: 3422008,
    block_name: 'SARATH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32013',
    district_code: 3223,
    district_name: 'JHARGRAM',
    block_id: 'B-320177',
    block_code: 3223003,
    block_name: 'GOPIBALLAVPUR TWO',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24014',
    district_code: 2415,
    district_name: 'JHARSUGUDA',
    block_id: 'B-240129',
    block_code: 2415007,
    block_name: 'JHARSUGUDA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4022',
    district_code: 421,
    district_name: 'KARIMGANJ',
    block_id: 'B-40143',
    block_code: 421003,
    block_name: 'SOUTH KARIMGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313297',
    block_code: 3117020,
    block_name: 'SHIKARPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240196',
    block_code: 2411001,
    block_name: 'KORAPUT',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20141',
    block_code: 210017,
    block_name: 'IRALA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360156',
    block_code: 3610016,
    block_name: 'SINGARENI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33001',
    district_code: 3321,
    district_name: 'BALOD',
    block_id: 'B-330002',
    block_code: 3321001,
    block_name: 'DONDI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290273',
    block_code: 2932011,
    block_name: 'UTHUKULI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140244',
    block_code: 1417004,
    block_name: 'REASI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15006',
    district_code: 1506,
    district_name: 'BIDAR',
    block_id: 'B-150043',
    block_code: 1506007,
    block_name: 'HULASURU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270217',
    block_code: 2705006,
    block_name: 'UDAIPURWATI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2004',
    district_code: 224,
    district_name: 'ANNAMAYYA',
    block_id: 'B-20081',
    block_code: 224004,
    block_name: 'GALIVEEDU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320130',
    block_code: 3218008,
    block_name: 'KALIYAGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150121',
    block_code: 1515005,
    block_name: 'GULBARGA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11031',
    district_code: 1126,
    district_name: 'TAPI',
    block_id: 'B-110234',
    block_code: 1126004,
    block_name: 'VYARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313605',
    block_code: 3123004,
    block_name: 'BARNAHAL',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21010',
    district_code: 2105,
    district_name: 'WEST GARO HILLS',
    block_id: 'B-210035',
    block_code: 2105013,
    block_name: 'DADENGGRE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313876',
    block_code: 3131016,
    block_name: 'SUMERPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290287',
    block_code: 2916001,
    block_name: 'ANDANALLUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17011',
    district_code: 1708,
    district_name: 'CHHATARPUR',
    block_id: 'B-170062',
    block_code: 1708003,
    block_name: 'NOWGOAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270091',
    block_code: 2724007,
    block_name: 'SAHARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20059',
    block_code: 212031,
    block_name: 'KAMBADUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20378',
    block_code: 222016,
    block_name: 'NADENDLA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3013',
    district_code: 304,
    district_name: 'LOWER SUBANSIRI',
    block_id: 'B-30055',
    block_code: 304001,
    block_name: 'ZIRO ONE ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140178',
    block_code: 1401008,
    block_name: 'TANGDAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340213',
    block_code: 3401023,
    block_name: 'RAHE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340031',
    block_code: 3422010,
    block_name: 'SONARAITHARI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32013',
    district_code: 3223,
    district_name: 'JHARGRAM',
    block_id: 'B-320175',
    block_code: 3223008,
    block_name: 'BINPUR TWO',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4021',
    district_code: 419,
    district_name: 'KARBI ANGLONG',
    block_id: 'B-40131',
    block_code: 419002,
    block_name: 'HOWRAGHAT',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4022',
    district_code: 421,
    district_name: 'KARIMGANJ',
    block_id: 'B-40139',
    block_code: 421006,
    block_name: 'LOWAIRPOA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313299',
    block_code: 3117022,
    block_name: 'SYANA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240204',
    block_code: 2411002,
    block_name: 'SEMILIGUDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20147',
    block_code: 210013,
    block_name: 'PALASAMUDRAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360150',
    block_code: 3610010,
    block_name: 'MADHIRA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33001',
    district_code: 3321,
    district_name: 'BALOD',
    block_id: 'B-330005',
    block_code: 3321002,
    block_name: 'GURUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290262',
    block_code: 2932001,
    block_name: 'AVINASHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14016',
    district_code: 1417,
    district_name: 'REASI',
    block_id: 'B-140239',
    block_code: 1417012,
    block_name: 'JIG BAGLI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15006',
    district_code: 1506,
    district_name: 'BIDAR',
    block_id: 'B-150042',
    block_code: 1506006,
    block_name: 'CHITAGUPPA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270207',
    block_code: 2705007,
    block_name: 'ALSISAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110058',
    block_code: 1104001,
    block_name: 'BHAVNAGAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320126',
    block_code: 3218004,
    block_name: 'GOALPOKHAR TWO',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15014',
    district_code: 1514,
    district_name: 'GADAG',
    block_id: 'B-150097',
    block_code: 1514002,
    block_name: 'MUNDARAGI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11031',
    district_code: 1126,
    district_name: 'TAPI',
    block_id: 'B-110233',
    block_code: 1126005,
    block_name: 'VALOD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313613',
    block_code: 3123006,
    block_name: 'SULTANGANJ',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21010',
    district_code: 2105,
    district_name: 'WEST GARO HILLS',
    block_id: 'B-210037',
    block_code: 2105023,
    block_name: 'DEMDEMA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31328',
    district_code: 3177,
    district_name: 'CHITRAKOOT',
    block_id: 'B-313313',
    block_code: 3177001,
    block_name: 'PAHARI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290290',
    block_code: 2916004,
    block_name: 'MANAPPARAI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17041',
    district_code: 1729,
    district_name: 'SEHORE',
    block_id: 'B-170256',
    block_code: 1729004,
    block_name: 'NASRULLAGANJ',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270319',
    block_code: 2701002,
    block_name: 'GANGANAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2003',
    district_code: 212,
    district_name: 'ANANTAPUR',
    block_id: 'B-20068',
    block_code: 212030,
    block_name: 'RAPTADU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2016',
    district_code: 222,
    district_name: 'PALNADU',
    block_id: 'B-20389',
    block_code: 222026,
    block_name: 'VELDURTHY',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3013',
    district_code: 304,
    district_name: 'LOWER SUBANSIRI',
    block_id: 'B-30053',
    block_code: 304012,
    block_name: 'HONG HARI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140182',
    block_code: 1401010,
    block_name: 'WAVOORA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340207',
    block_code: 3401024,
    block_name: 'KHELARI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34003',
    district_code: 3422,
    district_name: 'DEOGHAR',
    block_id: 'B-340026',
    block_code: 3422009,
    block_name: 'MARGOMUNDA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32013',
    district_code: 3223,
    district_name: 'JHARGRAM',
    block_id: 'B-320181',
    block_code: 3223004,
    block_name: 'SANKRAIL',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4021',
    district_code: 419,
    district_name: 'KARBI ANGLONG',
    block_id: 'B-40133',
    block_code: 419003,
    block_name: 'LUMBAJONG',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4022',
    district_code: 421,
    district_name: 'KARIMGANJ',
    block_id: 'B-40138',
    block_code: 421007,
    block_name: 'DULLAVCHERRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313286',
    block_code: 3117023,
    block_name: 'ANUPSHAHR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240203',
    block_code: 2411003,
    block_name: 'POTTANGI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20134',
    block_code: 210022,
    block_name: 'BANGARUPALEM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360147',
    block_code: 3610006,
    block_name: 'KHAMMAM  RURAL ',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33001',
    district_code: 3321,
    district_name: 'BALOD',
    block_id: 'B-330003',
    block_code: 3321003,
    block_name: 'DONDILOHARA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290265',
    block_code: 2932003,
    block_name: 'KANGEYAM',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4004',
    district_code: 433,
    district_name: 'BISWANATH',
    block_id: 'B-40018',
    block_code: 433005,
    block_name: 'BISWANATH',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15006',
    district_code: 1506,
    district_name: 'BIDAR',
    block_id: 'B-150045',
    block_code: 1506008,
    block_name: 'KAMALANAGARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27020',
    district_code: 2705,
    district_name: 'JHUNJHUNU',
    block_id: 'B-270216',
    block_code: 2705008,
    block_name: 'SURAJGARH',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110065',
    block_code: 1104003,
    block_name: 'TALAJA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32009',
    district_code: 3218,
    district_name: 'DINAJPUR UTTAR',
    block_id: 'B-320125',
    block_code: 3218003,
    block_name: 'GOALPOKHAR ONE',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15014',
    district_code: 1514,
    district_name: 'GADAG',
    block_id: 'B-150098',
    block_code: 1514003,
    block_name: 'NARAGUND',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11031',
    district_code: 1126,
    district_name: 'TAPI',
    block_id: 'B-110228',
    block_code: 1126006,
    block_name: 'DOLVAN',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3010',
    district_code: 318,
    district_name: 'LONGDING',
    block_id: 'B-30124',
    block_code: 318005,
    block_name: 'LAWNU',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1002',
    district_code: 103,
    district_name: 'NORTH AND MIDDLE ANDAMAN',
    block_id: 'B-10004',
    block_code: 103001,
    block_name: 'DIGLIPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313870',
    block_code: 3131006,
    block_name: 'MIYAGANJ',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290288',
    block_code: 2916007,
    block_name: 'LALGUDI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17041',
    district_code: 1729,
    district_name: 'SEHORE',
    block_id: 'B-170254',
    block_code: 1729005,
    block_name: 'BUDNI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270089',
    block_code: 2724011,
    block_name: 'MANDALGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360510',
    block_code: 3628008,
    block_name: 'PANGAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2013',
    district_code: 213,
    district_name: 'KURNOOL',
    block_id: 'B-20300',
    block_code: 213011,
    block_name: 'GONEGANDLA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3013',
    district_code: 304,
    district_name: 'LOWER SUBANSIRI',
    block_id: 'B-30054',
    block_code: 304011,
    block_name: 'PISTANA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140219',
    block_code: 1412001,
    block_name: 'RAJOURI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360137',
    block_code: 3609012,
    block_name: 'RAMADUGU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29020',
    district_code: 2935,
    district_name: 'RANIPET',
    block_id: 'B-290189',
    block_code: 2935013,
    block_name: 'KAVERIPAKKAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32013',
    district_code: 3223,
    district_name: 'JHARGRAM',
    block_id: 'B-320174',
    block_code: 3223007,
    block_name: 'BINPUR ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50516',
    block_code: 544009,
    block_name: 'SARAIGARH BHAPTIYAHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313289',
    block_code: 3117026,
    block_name: 'BULANDSHAHR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240200',
    block_code: 2411004,
    block_name: 'LAXMIPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20139',
    block_code: 210020,
    block_name: 'GUDIPALA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360144',
    block_code: 3610003,
    block_name: 'ENKOOR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33001',
    district_code: 3321,
    district_name: 'BALOD',
    block_id: 'B-330001',
    block_code: 3321004,
    block_name: 'BALOD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313484',
    block_code: 3158030,
    block_name: 'BARASATHI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5034',
    district_code: 543,
    district_name: 'SHEOHAR',
    block_id: 'B-50468',
    block_code: 543002,
    block_name: 'PIPRARHI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340120',
    block_code: 3416006,
    block_name: 'BISHNUGARH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27011',
    district_code: 2704,
    district_name: 'CHURU',
    block_id: 'B-270119',
    block_code: 2704007,
    block_name: 'BEEDASAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110062',
    block_code: 1104004,
    block_name: 'MAHUVA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17001',
    district_code: 1751,
    district_name: 'AGAR',
    block_id: 'B-170001',
    block_code: 1751004,
    block_name: 'AGAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15014',
    district_code: 1514,
    district_name: 'GADAG',
    block_id: 'B-150094',
    block_code: 1514001,
    block_name: 'GADAG',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35012',
    district_code: 3509,
    district_name: 'UDAM SINGH NAGAR',
    block_id: 'B-350088',
    block_code: 3509005,
    block_name: 'RUDRAPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3010',
    district_code: 318,
    district_name: 'LONGDING',
    block_id: 'B-30043',
    block_code: 318001,
    block_name: 'KANUBARI',
  },
  {
    state_id: 'S-01',
    state_code: 1,
    state_name: 'ANDAMAN AND NICOBAR',
    district_id: 'D-1002',
    district_code: 103,
    district_name: 'NORTH AND MIDDLE ANDAMAN',
    block_id: 'B-10005',
    block_code: 103002,
    block_name: 'MAYABUNDER',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180297',
    block_code: 1811002,
    block_name: 'WAI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290291',
    block_code: 2916002,
    block_name: 'MANIKANDAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17041',
    district_code: 1729,
    district_name: 'SEHORE',
    block_id: 'B-170253',
    block_code: 1729002,
    block_name: 'ASHTA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270323',
    block_code: 2701005,
    block_name: 'RAISINGHNAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360511',
    block_code: 3628009,
    block_name: 'PEBBAIR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50189',
    block_code: 524010,
    block_name: 'KATIHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31331',
    district_code: 3135,
    district_name: 'ETAWAH',
    block_id: 'B-313341',
    block_code: 3135022,
    block_name: 'BHARTHANA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140213',
    block_code: 1412002,
    block_name: 'MANJAKOTE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36010',
    district_code: 3609,
    district_name: 'KARIMNAGAR',
    block_id: 'B-360127',
    block_code: 3609001,
    block_name: 'CHIGURUMAMIDI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27026',
    district_code: 2733,
    district_name: 'PRATAPGARH',
    block_id: 'B-270280',
    block_code: 2733006,
    block_name: 'DALOT',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32013',
    district_code: 3223,
    district_name: 'JHARGRAM',
    block_id: 'B-320178',
    block_code: 3223006,
    block_name: 'JAMBONI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50510',
    block_code: 544003,
    block_name: 'KISHANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313291',
    block_code: 3117027,
    block_name: 'DIBAI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240201',
    block_code: 2411005,
    block_name: 'NANDAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20152',
    block_code: 210016,
    block_name: 'PUTHALAPATTU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360146',
    block_code: 3610005,
    block_name: 'KAMEPALLY',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33001',
    district_code: 3321,
    district_name: 'BALOD',
    block_id: 'B-330004',
    block_code: 3321005,
    block_name: 'GUNDERDEHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313485',
    block_code: 3158031,
    block_name: 'DHARMA PUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5034',
    district_code: 543,
    district_name: 'SHEOHAR',
    block_id: 'B-50471',
    block_code: 543005,
    block_name: 'TARIANI CHOWK',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340122',
    block_code: 3416014,
    block_name: 'CHOUPARAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270301',
    block_code: 2713010,
    block_name: 'AJEETGARH',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110063',
    block_code: 1104007,
    block_name: 'PALITANA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17001',
    district_code: 1751,
    district_name: 'AGAR',
    block_id: 'B-170004',
    block_code: 1751001,
    block_name: 'SUSNER',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15014',
    district_code: 1514,
    district_name: 'GADAG',
    block_id: 'B-150099',
    block_code: 1514004,
    block_name: 'RON',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35012',
    district_code: 3509,
    district_name: 'UDAM SINGH NAGAR',
    block_id: 'B-350085',
    block_code: 3509001,
    block_name: 'JASPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3010',
    district_code: 318,
    district_name: 'LONGDING',
    block_id: 'B-30045',
    block_code: 318002,
    block_name: 'PONGCHAU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20583',
    block_code: 202009,
    block_name: 'BONDAPALLE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18030',
    district_code: 1811,
    district_name: 'SATARA',
    block_id: 'B-180287',
    block_code: 1811010,
    block_name: 'JAOLI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290292',
    block_code: 2916005,
    block_name: 'MARUNGAPURI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17041',
    district_code: 1729,
    district_name: 'SEHORE',
    block_id: 'B-170255',
    block_code: 1729003,
    block_name: 'ICHHAWAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270324',
    block_code: 2701006,
    block_name: 'SADULSHAHAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360506',
    block_code: 3628004,
    block_name: 'GHANPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50190',
    block_code: 524011,
    block_name: 'KORHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31331',
    district_code: 3135,
    district_name: 'ETAWAH',
    block_id: 'B-313344',
    block_code: 3135016,
    block_name: 'MAHEWA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140215',
    block_code: 1412006,
    block_name: 'NOWSHERA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340200',
    block_code: 3401001,
    block_name: 'ANGARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27026',
    district_code: 2733,
    district_name: 'PRATAPGARH',
    block_id: 'B-270281',
    block_code: 2733007,
    block_name: 'DHAMOTAR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33005',
    district_code: 3322,
    district_name: 'BEMETARA',
    block_id: 'B-330024',
    block_code: 3322001,
    block_name: 'BEMETARA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50509',
    block_code: 544002,
    block_name: 'CHHATAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31326',
    district_code: 3117,
    district_name: 'BULANDSHAHR',
    block_id: 'B-313294',
    block_code: 3117031,
    block_name: 'KHURJA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240191',
    block_code: 2411006,
    block_name: 'BANDHUGAON',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20146',
    block_code: 210023,
    block_name: 'PALAMANER',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360152',
    block_code: 3610012,
    block_name: 'NELAKONDAPALLY',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17028',
    district_code: 1716,
    district_name: 'MANDSAUR',
    block_id: 'B-170171',
    block_code: 1716001,
    block_name: 'BHANPURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313496',
    block_code: 3158032,
    block_name: 'RAM NAGAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50306',
    block_code: 508011,
    block_name: 'RAJAULI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340128',
    block_code: 3416002,
    block_name: 'KATKAMSANDI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270307',
    block_code: 2713011,
    block_name: 'NECHWA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11007',
    district_code: 1104,
    district_name: 'BHAVNAGAR',
    block_id: 'B-110067',
    block_code: 1104012,
    block_name: 'VALLABHIPUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20014',
    district_code: 2013,
    district_name: 'TENGNOUPAL',
    block_id: 'B-200063',
    block_code: 2013001,
    block_name: 'TENGNOUPAL',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150124',
    block_code: 1515008,
    block_name: 'KAMALAPURA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35012',
    district_code: 3509,
    district_name: 'UDAM SINGH NAGAR',
    block_id: 'B-350086',
    block_code: 3509002,
    block_name: 'KASHIPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3010',
    district_code: 318,
    district_name: 'LONGDING',
    block_id: 'B-30046',
    block_code: 318003,
    block_name: 'WAKKA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20595',
    block_code: 202005,
    block_name: 'MERAKAMUDIDAM',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30003',
    district_code: 3006,
    district_name: 'KHOWAI',
    block_id: 'B-300020',
    block_code: 3006002,
    block_name: 'PADMABIL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313424',
    block_code: 3154014,
    block_name: 'GAGAHA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12006',
    district_code: 1210,
    district_name: 'GURUGRAM',
    block_id: 'B-120028',
    block_code: 1210002,
    block_name: 'FARRUKHNAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270326',
    block_code: 2701007,
    block_name: 'SURATGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360504',
    block_code: 3628002,
    block_name: 'ATMAKUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50195',
    block_code: 524016,
    block_name: 'SAMELI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31331',
    district_code: 3135,
    district_name: 'ETAWAH',
    block_id: 'B-313340',
    block_code: 3135017,
    block_name: 'BASREHAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140207',
    block_code: 1412003,
    block_name: 'DARHAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340201',
    block_code: 3401002,
    block_name: 'BERO',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27026',
    district_code: 2733,
    district_name: 'PRATAPGARH',
    block_id: 'B-270285',
    block_code: 2733008,
    block_name: 'SUHAGPURA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33005',
    district_code: 3322,
    district_name: 'BEMETARA',
    block_id: 'B-330025',
    block_code: 3322002,
    block_name: 'BERLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50515',
    block_code: 544008,
    block_name: 'RAGHOPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313128',
    block_code: 3178003,
    block_name: 'AKBARPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24020',
    district_code: 2411,
    district_name: 'KORAPUT',
    block_id: 'B-240202',
    block_code: 2411007,
    block_name: 'NARAYAN PATANA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20143',
    block_code: 210031,
    block_name: 'KUPPAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360145',
    block_code: 3610004,
    block_name: 'KALLUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140145',
    block_code: 1415012,
    block_name: 'THAKRAIE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313497',
    block_code: 3158033,
    block_name: 'RAM PUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50297',
    block_code: 508002,
    block_name: 'GOBINDPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340124',
    block_code: 3416017,
    block_name: 'DADI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27029',
    district_code: 2713,
    district_name: 'SIKAR',
    block_id: 'B-270309',
    block_code: 2713012,
    block_name: 'PALSANA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110010',
    block_code: 1105001,
    block_name: 'AMRELI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20014',
    district_code: 2013,
    district_name: 'TENGNOUPAL',
    block_id: 'B-200061',
    block_code: 2013004,
    block_name: 'MACHI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150123',
    block_code: 1515009,
    block_name: 'KALAGI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35012',
    district_code: 3509,
    district_name: 'UDAM SINGH NAGAR',
    block_id: 'B-350083',
    block_code: 3509003,
    block_name: 'BAJPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3010',
    district_code: 318,
    district_name: 'LONGDING',
    block_id: 'B-30044',
    block_code: 318004,
    block_name: 'NIAUSA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20599',
    block_code: 202002,
    block_name: 'RAMABHADRAPURAM',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30003',
    district_code: 3006,
    district_name: 'KHOWAI',
    block_id: 'B-300022',
    block_code: 3006003,
    block_name: 'TULASHIKHAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290294',
    block_code: 2916009,
    block_name: 'PULLAMPADI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12006',
    district_code: 1210,
    district_name: 'GURUGRAM',
    block_id: 'B-120029',
    block_code: 1210003,
    block_name: 'GURGAON',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270081',
    block_code: 2724013,
    block_name: 'BADNOR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360515',
    block_code: 3628014,
    block_name: 'WANAPARTHY',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50183',
    block_code: 524004,
    block_name: 'BARARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31331',
    district_code: 3135,
    district_name: 'ETAWAH',
    block_id: 'B-313346',
    block_code: 3135018,
    block_name: 'TAKHA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140205',
    block_code: 1412004,
    block_name: 'BUDHAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340202',
    block_code: 3401003,
    block_name: 'BUNDU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27026',
    district_code: 2733,
    district_name: 'PRATAPGARH',
    block_id: 'B-270278',
    block_code: 2733001,
    block_name: 'ARNOD',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33005',
    district_code: 3322,
    district_name: 'BEMETARA',
    block_id: 'B-330026',
    block_code: 3322003,
    block_name: 'NAWAGARH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50511',
    block_code: 544004,
    block_name: 'MARAUNA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313136',
    block_code: 3178004,
    block_name: 'TANDA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13003',
    district_code: 1303,
    district_name: 'HAMIRPUR',
    block_id: 'B-130012',
    block_code: 1303001,
    block_name: 'BAMSON',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20153',
    block_code: 210028,
    block_name: 'RAMAKUPPAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360154',
    block_code: 3610014,
    block_name: 'RAGHUNADHAPALEM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140141',
    block_code: 1415009,
    block_name: 'MUGHALMAIDAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313494',
    block_code: 3158034,
    block_name: 'MUFTI GANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50298',
    block_code: 508003,
    block_name: 'HISUA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340125',
    block_code: 3416018,
    block_name: 'DARU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31375',
    district_code: 3176,
    district_name: 'SHRAVASTI',
    block_id: 'B-313799',
    block_code: 3176002,
    block_name: 'EKONA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110013',
    block_code: 1105002,
    block_name: 'DHARI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20014',
    district_code: 2013,
    district_name: 'TENGNOUPAL',
    block_id: 'B-200062',
    block_code: 2013005,
    block_name: 'MOREH T D BLOCK',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150127',
    block_code: 1515011,
    block_name: 'YADRAMI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35012',
    district_code: 3509,
    district_name: 'UDAM SINGH NAGAR',
    block_id: 'B-350084',
    block_code: 3509004,
    block_name: 'GADARPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313612',
    block_code: 3123003,
    block_name: 'MAINPURI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20603',
    block_code: 202004,
    block_name: 'THERLAM',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30003',
    district_code: 3006,
    district_name: 'KHOWAI',
    block_id: 'B-300019',
    block_code: 3006004,
    block_name: 'MUNGIAKAMI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29029',
    district_code: 2916,
    district_name: 'TIRUCHIRAPPALLI',
    block_id: 'B-290295',
    block_code: 2916003,
    block_name: 'THIRUVERUMBUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12006',
    district_code: 1210,
    district_name: 'GURUGRAM',
    block_id: 'B-120030',
    block_code: 1210001,
    block_name: 'PATAUDI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270134',
    block_code: 2711011,
    block_name: 'RAMGARH PACHWARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360507',
    block_code: 3628005,
    block_name: 'GOPALPETA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50182',
    block_code: 524003,
    block_name: 'BALRAMPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31331',
    district_code: 3135,
    district_name: 'ETAWAH',
    block_id: 'B-313339',
    block_code: 3135021,
    block_name: 'BARHPURA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140210',
    block_code: 1412005,
    block_name: 'KALAKOTE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340206',
    block_code: 3401007,
    block_name: 'KANKE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27026',
    district_code: 2733,
    district_name: 'PRATAPGARH',
    block_id: 'B-270284',
    block_code: 2733003,
    block_name: 'PRATAPGARH',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33005',
    district_code: 3322,
    district_name: 'BEMETARA',
    block_id: 'B-330027',
    block_code: 3322004,
    block_name: 'SAJA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50518',
    block_code: 544011,
    block_name: 'TRIBENIGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313133',
    block_code: 3178008,
    block_name: 'JALAL PUR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13003',
    district_code: 1303,
    district_name: 'HAMIRPUR',
    block_id: 'B-130015',
    block_code: 1303004,
    block_name: 'HAMIRPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20150',
    block_code: 210008,
    block_name: 'PULICHERLA H/O REDDIVARIPALLE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360153',
    block_code: 3610013,
    block_name: 'PENUBALLY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140144',
    block_code: 1415011,
    block_name: 'PALMAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313487',
    block_code: 3158035,
    block_name: 'JALAL PUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50257',
    block_code: 526007,
    block_name: 'SANGRAMPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340118',
    block_code: 3416003,
    block_name: 'BARKAGAON',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31375',
    district_code: 3176,
    district_name: 'SHRAVASTI',
    block_id: 'B-313802',
    block_code: 3176001,
    block_name: 'JAMUNAHA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110015',
    block_code: 1105003,
    block_name: 'KHAMBHA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12005',
    district_code: 1218,
    district_name: 'FATEHABAD',
    block_id: 'B-120022',
    block_code: 1218024,
    block_name: 'BHUNA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150126',
    block_code: 1515010,
    block_name: 'SHAHABAD',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160127',
    block_code: 1614006,
    block_name: 'PARASSALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313609',
    block_code: 3123005,
    block_name: 'KARHAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20582',
    block_code: 202001,
    block_name: 'BOBBILI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30003',
    district_code: 3006,
    district_name: 'KHOWAI',
    block_id: 'B-300021',
    block_code: 3006005,
    block_name: 'TELIAMURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313426',
    block_code: 3154004,
    block_name: 'JANGAL KODIA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12006',
    district_code: 1210,
    district_name: 'GURUGRAM',
    block_id: 'B-120031',
    block_code: 1210004,
    block_name: 'SOHNA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27007',
    district_code: 2724,
    district_name: 'BHILWARA',
    block_id: 'B-270086',
    block_code: 2724014,
    block_name: 'KAREDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360512',
    block_code: 3628010,
    block_name: 'PEDDAMANDADI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50186',
    block_code: 524007,
    block_name: 'FALKA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31331',
    district_code: 3135,
    district_name: 'ETAWAH',
    block_id: 'B-313343',
    block_code: 3135020,
    block_name: 'JASWANTNAGAR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140222',
    block_code: 1412007,
    block_name: 'SUNDERBANI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340211',
    block_code: 3401013,
    block_name: 'NAMKUM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313405',
    block_code: 3147011,
    block_name: 'ITIATHOK',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24014',
    district_code: 2415,
    district_name: 'JHARSUGUDA',
    block_id: 'B-240130',
    block_code: 2415002,
    block_name: 'KIRMIRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50508',
    block_code: 544001,
    block_name: 'BASANTPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313130',
    block_code: 3178010,
    block_name: 'BHITI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13003',
    district_code: 1303,
    district_name: 'HAMIRPUR',
    block_id: 'B-130017',
    block_code: 1303006,
    block_name: 'TIHRA SUJANPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2006',
    district_code: 210,
    district_name: 'CHITTOOR',
    block_id: 'B-20142',
    block_code: 210011,
    block_name: 'KARVETINAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360155',
    block_code: 3610015,
    block_name: 'SATHUPALLY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140146',
    block_code: 1415013,
    block_name: 'TRIGAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313500',
    block_code: 3158036,
    block_name: 'SIRKONI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50302',
    block_code: 508007,
    block_name: 'NARDIGANJ',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340129',
    block_code: 3416004,
    block_name: 'KEREDARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31375',
    district_code: 3176,
    district_name: 'SHRAVASTI',
    block_id: 'B-313800',
    block_code: 3176003,
    block_name: 'GILAULA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110019',
    block_code: 1105004,
    block_name: 'RAJULA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12005',
    district_code: 1218,
    district_name: 'FATEHABAD',
    block_id: 'B-120024',
    block_code: 1218027,
    block_name: 'JAKHAL',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11028',
    district_code: 1109,
    district_name: 'SABAR KANTHA',
    block_id: 'B-110201',
    block_code: 1109001,
    block_name: 'HIMATNAGAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160128',
    block_code: 1614007,
    block_name: 'PERUMKADAVILA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31357',
    district_code: 3123,
    district_name: 'MAINPURI',
    block_id: 'B-313608',
    block_code: 3123008,
    block_name: 'JAGIR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20580',
    block_code: 202003,
    block_name: 'BADANGI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30003',
    district_code: 3006,
    district_name: 'KHOWAI',
    block_id: 'B-300017',
    block_code: 3006006,
    block_name: 'KALYANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31339',
    district_code: 3154,
    district_name: 'GORAKHPUR',
    block_id: 'B-313428',
    block_code: 3154015,
    block_name: 'KHAJANI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17011',
    district_code: 1708,
    district_name: 'CHHATARPUR',
    block_id: 'B-170056',
    block_code: 1708006,
    block_name: 'BADA MALEHARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270128',
    block_code: 2711008,
    block_name: 'BASWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360503',
    block_code: 3628001,
    block_name: 'AMARACHINTHA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50180',
    block_code: 524001,
    block_name: 'AMDABAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31331',
    district_code: 3135,
    district_name: 'ETAWAH',
    block_id: 'B-313345',
    block_code: 3135023,
    block_name: 'SEFAI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140180',
    block_code: 1401009,
    block_name: 'TEETHWAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34020',
    district_code: 3401,
    district_name: 'RANCHI',
    block_id: 'B-340210',
    block_code: 3401021,
    block_name: 'NAGRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313411',
    block_code: 3147012,
    block_name: 'PANDRI KRIPAL',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4021',
    district_code: 419,
    district_name: 'KARBI ANGLONG',
    block_id: 'B-40130',
    block_code: 419001,
    block_name: 'BOKAJAN',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50512',
    block_code: 544005,
    block_name: 'NIRMALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31313',
    district_code: 3178,
    district_name: 'AMBEDKAR NAGAR',
    block_id: 'B-313131',
    block_code: 3178009,
    block_name: 'BHIYAW',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13003',
    district_code: 1303,
    district_name: 'HAMIRPUR',
    block_id: 'B-130013',
    block_code: 1303002,
    block_name: 'BHORANJ',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350009',
    block_code: 3507001,
    block_name: 'SYALDEY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36011',
    district_code: 3610,
    district_name: 'KHAMMAM',
    block_id: 'B-360157',
    block_code: 3610017,
    block_name: 'THALLADA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140135',
    block_code: 1415010,
    block_name: 'BUNJWAH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313489',
    block_code: 3158037,
    block_name: 'KERAKAT',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5024',
    district_code: 508,
    district_name: 'NAWADA',
    block_id: 'B-50303',
    block_code: 508008,
    block_name: 'NARHAT',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340123',
    block_code: 3416005,
    block_name: 'CHURCHU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31375',
    district_code: 3176,
    district_name: 'SHRAVASTI',
    block_id: 'B-313803',
    block_code: 3176004,
    block_name: 'SIRSIYA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110014',
    block_code: 1105005,
    block_name: 'JAFRABAD',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12005',
    district_code: 1218,
    district_name: 'FATEHABAD',
    block_id: 'B-120023',
    block_code: 1218026,
    block_name: 'FATEHABAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11028',
    district_code: 1109,
    district_name: 'SABAR KANTHA',
    block_id: 'B-110205',
    block_code: 1109002,
    block_name: 'PRANTIJ',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160129',
    block_code: 1614008,
    block_name: 'POTHENCODE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18031',
    district_code: 1805,
    district_name: 'SINDHUDURG',
    block_id: 'B-180301',
    block_code: 1805001,
    block_name: 'KUDAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20594',
    block_code: 202007,
    block_name: 'MENTADA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30003',
    district_code: 3006,
    district_name: 'KHOWAI',
    block_id: 'B-300018',
    block_code: 3006001,
    block_name: 'KHOWAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31315',
    district_code: 3167,
    district_name: 'AMROHA',
    block_id: 'B-313152',
    block_code: 3167003,
    block_name: 'GAJRAULA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17011',
    district_code: 1708,
    district_name: 'CHHATARPUR',
    block_id: 'B-170061',
    block_code: 1708002,
    block_name: 'LAUNDI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270133',
    block_code: 2711010,
    block_name: 'NAGAL RAJAWATAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360505',
    block_code: 3628003,
    block_name: 'CHINNAMBAVI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50188',
    block_code: 524009,
    block_name: 'KADWA',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22009',
    district_code: 2203,
    district_name: 'SAIHA',
    block_id: 'B-220021',
    block_code: 2203005,
    block_name: 'SAIHA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140223',
    block_code: 1412008,
    block_name: 'THANAMANDI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290276',
    block_code: 2927002,
    block_name: 'KARUNGULAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313406',
    block_code: 3147013,
    block_name: 'JHANJHARI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4021',
    district_code: 419,
    district_name: 'KARBI ANGLONG',
    block_id: 'B-40134',
    block_code: 419004,
    block_name: 'NILIP',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50513',
    block_code: 544006,
    block_name: 'PIPRA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18024',
    district_code: 1835,
    district_name: 'PALGHAR',
    block_id: 'B-180224',
    block_code: 1835006,
    block_name: 'JAWHAR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13003',
    district_code: 1303,
    district_name: 'HAMIRPUR',
    block_id: 'B-130016',
    block_code: 1303005,
    block_name: 'NADAUN',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350011',
    block_code: 3507004,
    block_name: 'TARIKHET',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31351',
    district_code: 3128,
    district_name: 'KHERI',
    block_id: 'B-313557',
    block_code: 3128001,
    block_name: 'PALIA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140143',
    block_code: 1415002,
    block_name: 'PADDER',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3003',
    district_code: 303,
    district_name: 'EAST KAMENG',
    block_id: 'B-30015',
    block_code: 303008,
    block_name: 'BANA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50254',
    block_code: 526004,
    block_name: 'JAMALPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340126',
    block_code: 3416007,
    block_name: 'ICHAK',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31375',
    district_code: 3176,
    district_name: 'SHRAVASTI',
    block_id: 'B-313801',
    block_code: 3176005,
    block_name: 'HARIHARPUR RANI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110011',
    block_code: 1105008,
    block_name: 'BABRA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12005',
    district_code: 1218,
    district_name: 'FATEHABAD',
    block_id: 'B-120025',
    block_code: 1218028,
    block_name: 'NAGPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11028',
    district_code: 1109,
    district_name: 'SABAR KANTHA',
    block_id: 'B-110202',
    block_code: 1109003,
    block_name: 'IDAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160130',
    block_code: 1614009,
    block_name: 'VAMANAPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18031',
    district_code: 1805,
    district_name: 'SINDHUDURG',
    block_id: 'B-180305',
    block_code: 1805007,
    block_name: 'VENGURLA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20584',
    block_code: 202012,
    block_name: 'CHEEPURUPALLE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17034',
    district_code: 1709,
    district_name: 'PANNA',
    block_id: 'B-170202',
    block_code: 1709003,
    block_name: 'GUNOR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31315',
    district_code: 3167,
    district_name: 'AMROHA',
    block_id: 'B-313153',
    block_code: 3167004,
    block_name: 'GANGESHWARI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17011',
    district_code: 1708,
    district_name: 'CHHATARPUR',
    block_id: 'B-170059',
    block_code: 1708004,
    block_name: 'CHHATARPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270135',
    block_code: 2711009,
    block_name: 'SIKANDRA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360509',
    block_code: 3628007,
    block_name: 'MADANAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50194',
    block_code: 524015,
    block_name: 'PRANPUR',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22009',
    district_code: 2203,
    district_name: 'SAIHA',
    block_id: 'B-220022',
    block_code: 2203004,
    block_name: 'TUIPANG',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140165',
    block_code: 1401001,
    block_name: 'KUPWARA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290275',
    block_code: 2927004,
    block_name: 'ALWARTHIRUNAGARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313409',
    block_code: 3147014,
    block_name: 'MUJEHANA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4021',
    district_code: 419,
    district_name: 'KARBI ANGLONG',
    block_id: 'B-40136',
    block_code: 419010,
    block_name: 'SAMELANGSO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50514',
    block_code: 544007,
    block_name: 'PRATAPGANJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18024',
    district_code: 1835,
    district_name: 'PALGHAR',
    block_id: 'B-180225',
    block_code: 1835007,
    block_name: 'MOKHADA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13003',
    district_code: 1303,
    district_name: 'HAMIRPUR',
    block_id: 'B-130014',
    block_code: 1303003,
    block_name: 'BIJHARI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350010',
    block_code: 3507007,
    block_name: 'TAKULA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140140',
    block_code: 1415003,
    block_name: 'MARWAH',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3022',
    district_code: 313,
    district_name: 'UPPER SIANG',
    block_id: 'B-30095',
    block_code: 313001,
    block_name: 'YINGKIONG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5021',
    district_code: 526,
    district_name: 'MUNGER',
    block_id: 'B-50258',
    block_code: 526008,
    block_name: 'TARAPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340117',
    block_code: 3416012,
    block_name: 'BARHI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180036',
    block_code: 1815001,
    block_name: 'AURANGABAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110017',
    block_code: 1105009,
    block_name: 'LATHI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12005',
    district_code: 1218,
    district_name: 'FATEHABAD',
    block_id: 'B-120021',
    block_code: 1218021,
    block_name: 'BHATTU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11028',
    district_code: 1109,
    district_name: 'SABAR KANTHA',
    block_id: 'B-110207',
    block_code: 1109011,
    block_name: 'VADALI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160131',
    block_code: 1614010,
    block_name: 'VARKALA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18031',
    district_code: 1805,
    district_name: 'SINDHUDURG',
    block_id: 'B-180299',
    block_code: 1805008,
    block_name: 'DODAMARG',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20585',
    block_code: 202006,
    block_name: 'DATTIRAJERU',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140122',
    block_code: 1414022,
    block_name: 'DHAR MAHANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31315',
    district_code: 3167,
    district_name: 'AMROHA',
    block_id: 'B-313155',
    block_code: 3167005,
    block_name: 'JOYA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17011',
    district_code: 1708,
    district_name: 'CHHATARPUR',
    block_id: 'B-170063',
    block_code: 1708005,
    block_name: 'RAJNAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270320',
    block_code: 2701008,
    block_name: 'GHADSANA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360514',
    block_code: 3628012,
    block_name: 'SRIRANGAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50184',
    block_code: 524005,
    block_name: 'BARSOI',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21001',
    district_code: 2112,
    district_name: 'EASTERN WEST KHASI HILLS',
    block_id: 'B-210002',
    block_code: 2112006,
    block_name: 'MAWTHADRAISHAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14011',
    district_code: 1401,
    district_name: 'KUPWARA',
    block_id: 'B-140162',
    block_code: 1401011,
    block_name: 'KALAROOSE',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290285',
    block_code: 2927006,
    block_name: 'UDANGUDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313407',
    block_code: 3147015,
    block_name: 'KATRA BAZAR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4021',
    district_code: 419,
    district_name: 'KARBI ANGLONG',
    block_id: 'B-40132',
    block_code: 419011,
    block_name: 'LANGSOMEPI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5037',
    district_code: 544,
    district_name: 'SUPAUL',
    block_id: 'B-50517',
    block_code: 544010,
    block_name: 'SUPAUL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18024',
    district_code: 1835,
    district_name: 'PALGHAR',
    block_id: 'B-180227',
    block_code: 1835005,
    block_name: 'TALASARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20357',
    block_code: 220011,
    block_name: 'REDDIGUDEM',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350006',
    block_code: 3507009,
    block_name: 'HAWALBAG',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140136',
    block_code: 1415004,
    block_name: 'DACHHAN',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3022',
    district_code: 313,
    district_name: 'UPPER SIANG',
    block_id: 'B-30092',
    block_code: 313002,
    block_name: 'MARIYANG',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4004',
    district_code: 433,
    district_name: 'BISWANATH',
    block_id: 'B-40017',
    block_code: 433006,
    block_name: 'BEHALI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340130',
    block_code: 3416013,
    block_name: 'PADMA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180043',
    block_code: 1815004,
    block_name: 'SOEGAON',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110018',
    block_code: 1105010,
    block_name: 'LILIA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12005',
    district_code: 1218,
    district_name: 'FATEHABAD',
    block_id: 'B-120027',
    block_code: 1218023,
    block_name: 'TOHANA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11028',
    district_code: 1109,
    district_name: 'SABAR KANTHA',
    block_id: 'B-110206',
    block_code: 1109012,
    block_name: 'TALOD',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160132',
    block_code: 1614011,
    block_name: 'VELLANAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313104',
    block_code: 3120005,
    block_name: 'BARAULI AHIR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20589',
    block_code: 202011,
    block_name: 'GARIVIDI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140123',
    block_code: 1414023,
    block_name: 'DINGA AMB',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160135',
    block_code: 1607003,
    block_name: 'CHAVAKKAD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17011',
    district_code: 1708,
    district_name: 'CHHATARPUR',
    block_id: 'B-170058',
    block_code: 1708007,
    block_name: 'BUXWAHA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27031',
    district_code: 2701,
    district_name: 'SRI GANGANAGAR',
    block_id: 'B-270325',
    block_code: 2701009,
    block_name: 'SRI VIJAYNAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360508',
    block_code: 3628006,
    block_name: 'KOTHAKOTA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50192',
    block_code: 524013,
    block_name: 'MANIHARI',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21001',
    district_code: 2112,
    district_name: 'EASTERN WEST KHASI HILLS',
    block_id: 'B-210001',
    block_code: 2112001,
    block_name: 'MAIRANG',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140209',
    block_code: 1412009,
    block_name: 'DOONGI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290277',
    block_code: 2927009,
    block_name: 'KAYATHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313404',
    block_code: 3147016,
    block_name: 'HALDHARMAU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4021',
    district_code: 419,
    district_name: 'KARBI ANGLONG',
    block_id: 'B-40135',
    block_code: 419009,
    block_name: 'RONGMONGWE',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13007',
    district_code: 1307,
    district_name: 'LAHUL AND SPITI',
    block_id: 'B-130044',
    block_code: 1307002,
    block_name: 'SPITI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18024',
    district_code: 1835,
    district_name: 'PALGHAR',
    block_id: 'B-180228',
    block_code: 1835002,
    block_name: 'VASAI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20359',
    block_code: 220013,
    block_name: 'VATSAVAI',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350007',
    block_code: 3507010,
    block_name: 'LAMGARA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14009',
    district_code: 1415,
    district_name: 'KISHTWAR',
    block_id: 'B-140138',
    block_code: 1415005,
    block_name: 'INDERWAL',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3003',
    district_code: 303,
    district_name: 'EAST KAMENG',
    block_id: 'B-30020',
    block_code: 303001,
    block_name: 'SEPPA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4004',
    district_code: 433,
    district_name: 'BISWANATH',
    block_id: 'B-40020',
    block_code: 433014,
    block_name: 'PUB CHAIDUAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34011',
    district_code: 3416,
    district_name: 'HAZARIBAGH',
    block_id: 'B-340119',
    block_code: 3416015,
    block_name: 'BARKATHA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180042',
    block_code: 1815005,
    block_name: 'SILLOD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11002',
    district_code: 1105,
    district_name: 'AMRELI',
    block_id: 'B-110012',
    block_code: 1105011,
    block_name: 'BAGASARA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12005',
    district_code: 1218,
    district_name: 'FATEHABAD',
    block_id: 'B-120026',
    block_code: 1218025,
    block_name: 'RATIA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15014',
    district_code: 1514,
    district_name: 'GADAG',
    block_id: 'B-150100',
    block_code: 1514005,
    block_name: 'SHIRAHATT',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180033',
    block_code: 1824006,
    block_name: 'NANDGAON KHANDESHWAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31311',
    district_code: 3120,
    district_name: 'AGRA',
    block_id: 'B-313115',
    block_code: 3120011,
    block_name: 'SHAMSABAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20587',
    block_code: 202008,
    block_name: 'GAJAPATHINAGARAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140124',
    block_code: 1414019,
    block_name: 'DUGGAIN',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16013',
    district_code: 1607,
    district_name: 'THRISSUR',
    block_id: 'B-160133',
    block_code: 1607001,
    block_name: 'ANTHIKKAD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17011',
    district_code: 1708,
    district_name: 'CHHATARPUR',
    block_id: 'B-170057',
    block_code: 1708008,
    block_name: 'BIJAWAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27012',
    district_code: 2711,
    district_name: 'DAUSA',
    block_id: 'B-270131',
    block_code: 2711006,
    block_name: 'LAWAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360516',
    block_code: 3628013,
    block_name: 'WEEPANGANDLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50191',
    block_code: 524012,
    block_name: 'KURSELA',
  },
  {
    state_id: 'S-36',
    state_code: 38,
    state_name: 'DNH AND DAMAN DIU',
    district_id: 'D-38001',
    district_code: 3801,
    district_name: 'DADRA AND NAGAR HAVELI',
    block_id: 'B-380001',
    block_code: 3801001,
    block_name: 'DADRA NAGAR HAVELI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14014',
    district_code: 1412,
    district_name: 'RAJAURI',
    block_id: 'B-140211',
    block_code: 1412011,
    block_name: 'KHAWAS',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29028',
    district_code: 2927,
    district_name: 'THOOTHUKKUDI',
    block_id: 'B-290280',
    block_code: 2927012,
    block_name: 'PUDUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31338',
    district_code: 3147,
    district_name: 'GONDA',
    block_id: 'B-313403',
    block_code: 3147017,
    block_name: 'COLONELGANJ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24014',
    district_code: 2415,
    district_name: 'JHARSUGUDA',
    block_id: 'B-240131',
    block_code: 2415003,
    block_name: 'KOLABIRA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13007',
    district_code: 1307,
    district_name: 'LAHUL AND SPITI',
    block_id: 'B-130043',
    block_code: 1307001,
    block_name: 'LAHAUL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20350',
    block_code: 220003,
    block_name: 'G KONDURU',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350008',
    block_code: 3507005,
    block_name: 'SULT',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11015',
    district_code: 1101,
    district_name: 'JAMNAGAR',
    block_id: 'B-110106',
    block_code: 1101001,
    block_name: 'JAMNAGAR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3003',
    district_code: 303,
    district_name: 'EAST KAMENG',
    block_id: 'B-30014',
    block_code: 303002,
    block_name: 'BAMENG',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180040',
    block_code: 1815006,
    block_name: 'PAITHAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313192',
    block_code: 3157013,
    block_name: 'SATHIYAON',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180087',
    block_code: 1829010,
    block_name: 'RAJURA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11028',
    district_code: 1109,
    district_name: 'SABAR KANTHA',
    block_id: 'B-110203',
    block_code: 1109004,
    block_name: 'KHEDBRAHMA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180026',
    block_code: 1824013,
    block_name: 'CHANDURBAZAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31343',
    district_code: 3166,
    district_name: 'HATHRAS',
    block_id: 'B-313470',
    block_code: 3166001,
    block_name: 'SASNI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20590',
    block_code: 202010,
    block_name: 'GURLA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150020',
    block_code: 1504006,
    block_name: 'HUKERI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313620',
    block_code: 3119005,
    block_name: 'MATHURA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4023',
    district_code: 402,
    district_name: 'KOKRAJHAR',
    block_id: 'B-40147',
    block_code: 402002,
    block_name: 'KACHUGAON',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240244',
    block_code: 2430007,
    block_name: 'PAPADAHANDI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340157',
    block_code: 3406001,
    block_name: 'LATEHAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50187',
    block_code: 524008,
    block_name: 'HASANGANJ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50139',
    block_code: 511002,
    block_name: 'BARAULI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15013',
    district_code: 1513,
    district_name: 'DHARWAR',
    block_id: 'B-150090',
    block_code: 1513002,
    block_name: 'HUBLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20354',
    block_code: 220008,
    block_name: 'MYLAVARAM',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350005',
    block_code: 3507006,
    block_name: 'DWARAHAT',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11015',
    district_code: 1101,
    district_name: 'JAMNAGAR',
    block_id: 'B-110109',
    block_code: 1101002,
    block_name: 'LALPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3022',
    district_code: 313,
    district_name: 'UPPER SIANG',
    block_id: 'B-30094',
    block_code: 313003,
    block_name: 'TUTING',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180044',
    block_code: 1815008,
    block_name: 'VAIJAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313179',
    block_code: 3157014,
    block_name: 'JAHANAGANJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180076',
    block_code: 1829012,
    block_name: 'BALLARPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11028',
    district_code: 1109,
    district_name: 'SABAR KANTHA',
    block_id: 'B-110208',
    block_code: 1109005,
    block_name: 'VIJAYNAGAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18012',
    district_code: 1834,
    district_name: 'HINGOLI',
    block_id: 'B-180115',
    block_code: 1834008,
    block_name: 'AUNDHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31343',
    district_code: 3166,
    district_name: 'HATHRAS',
    block_id: 'B-313467',
    block_code: 3166002,
    block_name: 'HATHRAS',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20596',
    block_code: 202013,
    block_name: 'NELLIMARLA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150022',
    block_code: 1504007,
    block_name: 'KHANAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313619',
    block_code: 3119008,
    block_name: 'MAT',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4023',
    district_code: 402,
    district_name: 'KOKRAJHAR',
    block_id: 'B-40145',
    block_code: 402001,
    block_name: 'GOSSAIGAON',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240245',
    block_code: 2430008,
    block_name: 'RAIGHAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340154',
    block_code: 3406002,
    block_name: 'CHANDWA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50185',
    block_code: 524006,
    block_name: 'DANDKHORA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50145',
    block_code: 511008,
    block_name: 'KUCHAIKOTE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360365',
    block_code: 3621001,
    block_name: 'ANTHERGAON ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20349',
    block_code: 220004,
    block_name: 'GAMPALAGUDEM',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350001',
    block_code: 3507008,
    block_name: 'BHAISIACHHANA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11015',
    district_code: 1101,
    district_name: 'JAMNAGAR',
    block_id: 'B-110105',
    block_code: 1101003,
    block_name: 'JAMJODHPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3022',
    district_code: 313,
    district_name: 'UPPER SIANG',
    block_id: 'B-30090',
    block_code: 313004,
    block_name: 'GEKU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180041',
    block_code: 1815009,
    block_name: 'PHULAMBRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313189',
    block_code: 3157015,
    block_name: 'PAWAI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180083',
    block_code: 1829013,
    block_name: 'KORPANA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11028',
    district_code: 1109,
    district_name: 'SABAR KANTHA',
    block_id: 'B-110204',
    block_code: 1109013,
    block_name: 'POSHINA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180034',
    block_code: 1824004,
    block_name: 'TEOSA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31343',
    district_code: 3166,
    district_name: 'HATHRAS',
    block_id: 'B-313469',
    block_code: 3166004,
    block_name: 'SADABAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20597',
    block_code: 202014,
    block_name: 'PUSAPATIREGA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150027',
    block_code: 1504008,
    block_name: 'RAYBAG',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270065',
    block_code: 2717007,
    block_name: 'SHEO',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4023',
    district_code: 402,
    district_name: 'KOKRAJHAR',
    block_id: 'B-40148',
    block_code: 402003,
    block_name: 'KOKRAJHAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240247',
    block_code: 2430009,
    block_name: 'UMERKOTE',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340151',
    block_code: 3406003,
    block_name: 'BALUMATH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50181',
    block_code: 524002,
    block_name: 'AZAMNAGAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50141',
    block_code: 511004,
    block_name: 'BIJAIPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15013',
    district_code: 1513,
    district_name: 'DHARWAR',
    block_id: 'B-150089',
    block_code: 1513001,
    block_name: 'DHARWAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20360',
    block_code: 220014,
    block_name: 'VEERULLAPADU',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350003',
    block_code: 3507002,
    block_name: 'CHAUKHUTIA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11015',
    district_code: 1101,
    district_name: 'JAMNAGAR',
    block_id: 'B-110107',
    block_code: 1101008,
    block_name: 'JODIYA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3022',
    district_code: 313,
    district_name: 'UPPER SIANG',
    block_id: 'B-30091',
    block_code: 313005,
    block_name: 'JENGGING',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30004',
    district_code: 3003,
    district_name: 'NORTH TRIPURA',
    block_id: 'B-300027',
    block_code: 3003001,
    block_name: 'KADAMTALA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313190',
    block_code: 3157016,
    block_name: 'PHULPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180089',
    block_code: 1829014,
    block_name: 'SINDEWAHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360278',
    block_code: 3618001,
    block_name: 'ADAVIDEVULAPALLI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180027',
    block_code: 1824005,
    block_name: 'CHANDUR RAILWAY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31343',
    district_code: 3166,
    district_name: 'HATHRAS',
    block_id: 'B-313472',
    block_code: 3166006,
    block_name: 'SIKANDRARAO',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20581',
    block_code: 202015,
    block_name: 'BHOGHAPURAM',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150017',
    block_code: 1504003,
    block_name: 'BELGAUM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180307',
    block_code: 1813002,
    block_name: 'BARSHI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50123',
    block_code: 507010,
    block_name: 'Gaya Town C D',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24023',
    district_code: 2430,
    district_name: 'NABARANGAPUR',
    block_id: 'B-240246',
    block_code: 2430010,
    block_name: 'TENTULIKHUNTI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340159',
    block_code: 3406004,
    block_name: 'MANIKA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50138',
    block_code: 511001,
    block_name: 'BAIKUNTHPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15013',
    district_code: 1513,
    district_name: 'DHARWAR',
    block_id: 'B-150091',
    block_code: 1513003,
    block_name: 'KALGHATGI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20362',
    block_code: 220016,
    block_name: 'VISSANNAPET',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35001',
    district_code: 3507,
    district_name: 'ALMORA',
    block_id: 'B-350002',
    block_code: 3507003,
    block_name: 'BHIKIASAIN',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11015',
    district_code: 1101,
    district_name: 'JAMNAGAR',
    block_id: 'B-110108',
    block_code: 1101010,
    block_name: 'KALAVAD',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3003',
    district_code: 303,
    district_name: 'EAST KAMENG',
    block_id: 'B-30016',
    block_code: 303003,
    block_name: 'CHAYANGTAJO',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30004',
    district_code: 3003,
    district_name: 'NORTH TRIPURA',
    block_id: 'B-300030',
    block_code: 3003002,
    block_name: 'PANISAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313183',
    block_code: 3157017,
    block_name: 'MARTINGANJ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180086',
    block_code: 1829016,
    block_name: 'POMBHURNA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360300',
    block_code: 3618023,
    block_name: 'NEREDUGOMMU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180024',
    block_code: 1824009,
    block_name: 'ANJANGAON SURJI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313354',
    block_code: 3143011,
    block_name: 'AIRAYA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20586',
    block_code: 202016,
    block_name: 'DENKADA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150016',
    block_code: 1504002,
    block_name: 'BAILAHONGAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180315',
    block_code: 1813001,
    block_name: 'SOLAPUR NORTH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50128',
    block_code: 507001,
    block_name: 'Konch',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24001',
    district_code: 2421,
    district_name: 'ANGUL',
    block_id: 'B-240007',
    block_code: 2421007,
    block_name: 'PALLAHADA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340153',
    block_code: 3406005,
    block_name: 'BARWADIH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50142',
    block_code: 511005,
    block_name: 'GOPALGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15013',
    district_code: 1513,
    district_name: 'DHARWAR',
    block_id: 'B-150092',
    block_code: 1513004,
    block_name: 'KUNDGOL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20353',
    block_code: 220007,
    block_name: 'KANCHIKACHERLA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180003',
    block_code: 1809008,
    block_name: 'KARJAT',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11015',
    district_code: 1101,
    district_name: 'JAMNAGAR',
    block_id: 'B-110104',
    block_code: 1101009,
    block_name: 'DHROL',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3003',
    district_code: 303,
    district_name: 'EAST KAMENG',
    block_id: 'B-30018',
    block_code: 303007,
    block_name: 'PIPU',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30004',
    district_code: 3003,
    district_name: 'NORTH TRIPURA',
    block_id: 'B-300024',
    block_code: 3003006,
    block_name: 'DASDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313195',
    block_code: 3157018,
    block_name: 'THEKMA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313182',
    block_code: 3157004,
    block_name: 'MAHRAJGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150117',
    block_code: 1515001,
    block_name: 'AFZALPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180030',
    block_code: 1824015,
    block_name: 'DHAMANGAON RAILWAY',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18009',
    district_code: 1807,
    district_name: 'DHULE',
    block_id: 'B-180091',
    block_code: 1807001,
    block_name: 'DHULE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20606',
    block_code: 202017,
    block_name: 'VIZIANAGARAM',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150015',
    block_code: 1504001,
    block_name: 'ATHNI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180306',
    block_code: 1813003,
    block_name: 'AKKALKOT',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50137',
    block_code: 507008,
    block_name: 'Wazirganj',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110006',
    block_code: 1112003,
    block_name: 'DHOLKA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340155',
    block_code: 3406006,
    block_name: 'GARU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50151',
    block_code: 511014,
    block_name: 'UCHKAGAON',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15013',
    district_code: 1513,
    district_name: 'DHARWAR',
    block_id: 'B-150093',
    block_code: 1513005,
    block_name: 'NAVALGUND',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20361',
    block_code: 220015,
    block_name: 'VIJAYAWADA RURAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180013',
    block_code: 1809009,
    block_name: 'SHRIGONDA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35005',
    district_code: 3502,
    district_name: 'DEHRADUN',
    block_id: 'B-350032',
    block_code: 3502004,
    block_name: 'SAHASPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3003',
    district_code: 303,
    district_name: 'EAST KAMENG',
    block_id: 'B-30115',
    block_code: 303012,
    block_name: 'LADA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30004',
    district_code: 3003,
    district_name: 'NORTH TRIPURA',
    block_id: 'B-300023',
    block_code: 3003007,
    block_name: 'DAMCHERRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313181',
    block_code: 3157019,
    block_name: 'LALGANJ',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160077',
    block_code: 1604004,
    block_name: 'KOZHIKKODE',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150118',
    block_code: 1515002,
    block_name: 'ALAND',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18012',
    district_code: 1834,
    district_name: 'HINGOLI',
    block_id: 'B-180116',
    block_code: 1834007,
    block_name: 'BASMATH',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18009',
    district_code: 1807,
    district_name: 'DHULE',
    block_id: 'B-180092',
    block_code: 1807002,
    block_name: 'SAKRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20588',
    block_code: 202018,
    block_name: 'GANTYADA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150028',
    block_code: 1504010,
    block_name: 'SAVADATHI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180312',
    block_code: 1813005,
    block_name: 'MOHOL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50118',
    block_code: 507003,
    block_name: 'Belaganj',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110004',
    block_code: 1112004,
    block_name: 'DHANDHUKA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340158',
    block_code: 3406007,
    block_name: 'MAHUADANR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50140',
    block_code: 511003,
    block_name: 'BHOREY',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15013',
    district_code: 1513,
    district_name: 'DHARWAR',
    block_id: 'B-150087',
    block_code: 1513007,
    block_name: 'ALNAVARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20348',
    block_code: 220002,
    block_name: 'CHANDARLAPADU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180007',
    block_code: 1809010,
    block_name: 'PARNER',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35005',
    district_code: 3502,
    district_name: 'DEHRADUN',
    block_id: 'B-350031',
    block_code: 3502005,
    block_name: 'RAIPUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3003',
    district_code: 303,
    district_name: 'EAST KAMENG',
    block_id: 'B-30017',
    block_code: 303010,
    block_name: 'KHENEWA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30004',
    district_code: 3003,
    district_name: 'NORTH TRIPURA',
    block_id: 'B-300025',
    block_code: 3003008,
    block_name: 'JAMPUI HILLS',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313184',
    block_code: 3157020,
    block_name: 'MEHNAGAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160080',
    block_code: 1604007,
    block_name: 'MELADY',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150119',
    block_code: 1515003,
    block_name: 'CHINCHOLI',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22010',
    district_code: 2211,
    district_name: 'SAITUAL',
    block_id: 'B-220023',
    block_code: 2211002,
    block_name: 'NGOPA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18009',
    district_code: 1807,
    district_name: 'DHULE',
    block_id: 'B-180094',
    block_code: 1807009,
    block_name: 'SHIRPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20602',
    block_code: 202019,
    block_name: 'SRUNGAVARAPUKOTA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150026',
    block_code: 1504009,
    block_name: 'RAMDURG',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180311',
    block_code: 1813006,
    block_name: 'MANGALVEDHE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50115',
    block_code: 507006,
    block_name: 'Atri',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110008',
    block_code: 1112005,
    block_name: 'SANAND',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340152',
    block_code: 3406008,
    block_name: 'BARIYATU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50150',
    block_code: 511013,
    block_name: 'THAWE',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15013',
    district_code: 1513,
    district_name: 'DHARWAR',
    block_id: 'B-150088',
    block_code: 1513006,
    block_name: 'ANNIGERI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20358',
    block_code: 220012,
    block_name: 'TIRUVURU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180011',
    block_code: 1809012,
    block_name: 'SANGAMNER',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35005',
    district_code: 3502,
    district_name: 'DEHRADUN',
    block_id: 'B-350029',
    block_code: 3502006,
    block_name: 'DOIWALA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3022',
    district_code: 313,
    district_name: 'UPPER SIANG',
    block_id: 'B-30093',
    block_code: 313006,
    block_name: 'SINGA-GELLING',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180038',
    block_code: 1815003,
    block_name: 'KANNAD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313194',
    block_code: 3157021,
    block_name: 'TARWA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160084',
    block_code: 1604011,
    block_name: 'TUNERI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150120',
    block_code: 1515004,
    block_name: 'CHITAPUR',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22010',
    district_code: 2211,
    district_name: 'SAITUAL',
    block_id: 'B-220024',
    block_code: 2211001,
    block_name: 'PHULLEN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313356',
    block_code: 3143014,
    block_name: 'ASODHAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20605',
    block_code: 202020,
    block_name: 'VEPADA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150023',
    block_code: 1504012,
    block_name: 'KITTUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180313',
    block_code: 1813007,
    block_name: 'PANDHARPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50133',
    block_code: 507012,
    block_name: 'Paraiya',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110009',
    block_code: 1112006,
    block_name: 'VIRAMGAM',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340156',
    block_code: 3406009,
    block_name: 'HERHANJ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240120',
    block_code: 2420002,
    block_name: 'BARI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360375',
    block_code: 3621011,
    block_name: 'RAMAGIRI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20356',
    block_code: 220010,
    block_name: 'PENUGANCHIPROLU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180004',
    block_code: 1809013,
    block_name: 'KOPARGAON',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35005',
    district_code: 3502,
    district_name: 'DEHRADUN',
    block_id: 'B-350028',
    block_code: 3502001,
    block_name: 'CHAKRATA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3003',
    district_code: 303,
    district_name: 'EAST KAMENG',
    block_id: 'B-30019',
    block_code: 303011,
    block_name: 'SAWA  BORDER BLOCK ',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180037',
    block_code: 1815007,
    block_name: 'GANGAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313187',
    block_code: 3157022,
    block_name: 'PALHANA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160085',
    block_code: 1604012,
    block_name: 'VATAKARA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150122',
    block_code: 1515006,
    block_name: 'JEVARGI',
  },
  {
    state_id: 'S-36',
    state_code: 38,
    state_name: 'DNH AND DAMAN DIU',
    district_id: 'D-38002',
    district_code: 3802,
    district_name: 'DAMAN',
    block_id: 'B-380002',
    block_code: 3802001,
    block_name: 'DAMAN',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18009',
    district_code: 1807,
    district_name: 'DHULE',
    block_id: 'B-180093',
    block_code: 1807010,
    block_name: 'SHINDKHEDE',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20593',
    block_code: 202021,
    block_name: 'LAKKAVARAPUKOTA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11021',
    district_code: 1130,
    district_name: 'MORBI',
    block_id: 'B-110158',
    block_code: 1130016,
    block_name: 'TANKARA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180310',
    block_code: 1813009,
    block_name: 'MALSHIRAS',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50125',
    block_code: 507013,
    block_name: 'Gurua',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110001',
    block_code: 1112009,
    block_name: 'BAVLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36031',
    district_code: 3628,
    district_name: 'WANAPARTHY',
    block_id: 'B-360513',
    block_code: 3628011,
    block_name: 'REVALLY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24013',
    district_code: 2420,
    district_name: 'JAJPUR',
    block_id: 'B-240124',
    block_code: 2420004,
    block_name: 'DHARMASALA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360373',
    block_code: 3621009,
    block_name: 'PALAKURTHY ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20351',
    block_code: 220005,
    block_name: 'IBRAHIMPATNAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31370',
    district_code: 3183,
    district_name: 'SAMBHAL',
    block_id: 'B-313758',
    block_code: 3183001,
    block_name: 'BANIYAKHERA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35005',
    district_code: 3502,
    district_name: 'DEHRADUN',
    block_id: 'B-350030',
    block_code: 3502002,
    block_name: 'KALSI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290272',
    block_code: 2932010,
    block_name: 'UDUMALPET',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18004',
    district_code: 1815,
    district_name: 'CHATRAPATI SAMBHAJINAGAR',
    block_id: 'B-180039',
    block_code: 1815002,
    block_name: 'KHULTABAD',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290155',
    block_code: 2908012,
    block_name: 'RASIPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180077',
    block_code: 1829002,
    block_name: 'BHADRAVATI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15014',
    district_code: 1514,
    district_name: 'GADAG',
    block_id: 'B-150095',
    block_code: 1514006,
    block_name: 'GAJENDRAGHADA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17052',
    district_code: 1727,
    district_name: 'VIDISHA',
    block_id: 'B-170310',
    block_code: 1727001,
    block_name: 'LATERI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4031',
    district_code: 428,
    district_name: 'SOUTH SALMARA-MANKACHAR',
    block_id: 'B-40199',
    block_code: 428007,
    block_name: 'SOUTH SALMARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20591',
    block_code: 202022,
    block_name: 'JAMI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11021',
    district_code: 1130,
    district_name: 'MORBI',
    block_id: 'B-110157',
    block_code: 1130015,
    block_name: 'MORBI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180308',
    block_code: 1813010,
    block_name: 'KARMALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50114',
    block_code: 507014,
    block_name: 'Amas',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110007',
    block_code: 1112011,
    block_name: 'MANDAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34015',
    district_code: 3406,
    district_name: 'LATEHAR',
    block_id: 'B-340264',
    block_code: 3406010,
    block_name: 'SARYU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50144',
    block_code: 511007,
    block_name: 'KATIYA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360369',
    block_code: 3621005,
    block_name: 'KAMANPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20352',
    block_code: 220006,
    block_name: 'JAGGAYYAPETA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31370',
    district_code: 3183,
    district_name: 'SAMBHAL',
    block_id: 'B-313763',
    block_code: 3183002,
    block_name: 'SAMBHAL',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35005',
    district_code: 3502,
    district_name: 'DEHRADUN',
    block_id: 'B-350033',
    block_code: 3502003,
    block_name: 'VIKASNAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290264',
    block_code: 2932013,
    block_name: 'GUDIMANGALAM',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30004',
    district_code: 3003,
    district_name: 'NORTH TRIPURA',
    block_id: 'B-300026',
    block_code: 3003009,
    block_name: 'JUBARAJNAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290145',
    block_code: 2908002,
    block_name: 'ERUMAPATTY',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180155',
    block_code: 1821002,
    block_name: 'AHMADPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15014',
    district_code: 1514,
    district_name: 'GADAG',
    block_id: 'B-150096',
    block_code: 1514007,
    block_name: 'LAKSHMESHWARA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17052',
    district_code: 1727,
    district_name: 'VIDISHA',
    block_id: 'B-170312',
    block_code: 1727002,
    block_name: 'SIRONJ',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4031',
    district_code: 428,
    district_name: 'SOUTH SALMARA-MANKACHAR',
    block_id: 'B-40197',
    block_code: 428013,
    block_name: 'FEKAMARI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20592',
    block_code: 202023,
    block_name: 'KOTHAVALASA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11021',
    district_code: 1130,
    district_name: 'MORBI',
    block_id: 'B-110156',
    block_code: 1130011,
    block_name: 'MALIYA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180309',
    block_code: 1813011,
    block_name: 'MADHA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50126',
    block_code: 507016,
    block_name: 'Imamganj',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110002',
    block_code: 1112002,
    block_name: 'DASKROI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270114',
    block_code: 2729007,
    block_name: 'DUNGLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50149',
    block_code: 511012,
    block_name: 'SIDHWALIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360371',
    block_code: 3621007,
    block_name: 'MUTHARAM  MANTHANI ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20355',
    block_code: 220009,
    block_name: 'NANDIGAMA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31370',
    district_code: 3183,
    district_name: 'SAMBHAL',
    block_id: 'B-313761',
    block_code: 3183004,
    block_name: 'PANWASA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36017',
    district_code: 3616,
    district_name: 'MEDCHAL MALKAJGIRI',
    block_id: 'B-360247',
    block_code: 3616012,
    block_name: 'MUDUCHINTHALAPALLY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313643',
    block_code: 3115008,
    block_name: 'SARDHANA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30004',
    district_code: 3003,
    district_name: 'NORTH TRIPURA',
    block_id: 'B-300029',
    block_code: 3003010,
    block_name: 'LALJURI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290146',
    block_code: 2908003,
    block_name: 'KABILARMALAI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180082',
    block_code: 1829015,
    block_name: 'JIWATI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360290',
    block_code: 3618013,
    block_name: 'KETHE PALLY',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17052',
    district_code: 1727,
    district_name: 'VIDISHA',
    block_id: 'B-170309',
    block_code: 1727003,
    block_name: 'KURWAI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4031',
    district_code: 428,
    district_name: 'SOUTH SALMARA-MANKACHAR',
    block_id: 'B-40198',
    block_code: 428006,
    block_name: 'MANKACHAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20604',
    block_code: 202024,
    block_name: 'VANGARA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11021',
    district_code: 1130,
    district_name: 'MORBI',
    block_id: 'B-110159',
    block_code: 1130012,
    block_name: 'WANKANER',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180316',
    block_code: 1813004,
    block_name: 'SOLAPUR SOUTH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50130',
    block_code: 507017,
    block_name: 'Mohanpur',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110005',
    block_code: 1112012,
    block_name: 'DHOLERA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270117',
    block_code: 2729009,
    block_name: 'NIMBAHERA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5011',
    district_code: 511,
    district_name: 'GOPALGANJ',
    block_id: 'B-50148',
    block_code: 511011,
    block_name: 'PHULWARIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360366',
    block_code: 3621002,
    block_name: 'DHARMARAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2015',
    district_code: 220,
    district_name: 'NTR',
    block_id: 'B-20347',
    block_code: 220001,
    block_name: 'A KONDURU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31370',
    district_code: 3183,
    district_name: 'SAMBHAL',
    block_id: 'B-313756',
    block_code: 3183003,
    block_name: 'ASMOLI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36017',
    district_code: 3616,
    district_name: 'MEDCHAL MALKAJGIRI',
    block_id: 'B-360246',
    block_code: 3616008,
    block_name: 'MEDCHAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313483',
    block_code: 3158038,
    block_name: 'BAKSHA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30004',
    district_code: 3003,
    district_name: 'NORTH TRIPURA',
    block_id: 'B-300028',
    block_code: 3003011,
    block_name: 'KALACHERRA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290147',
    block_code: 2908004,
    block_name: 'KOLLIHILLS',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180088',
    block_code: 1829011,
    block_name: 'SAWALI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360305',
    block_code: 3618028,
    block_name: 'THIPPARTHI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17052',
    district_code: 1727,
    district_name: 'VIDISHA',
    block_id: 'B-170311',
    block_code: 1727005,
    block_name: 'NATERAN',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260043',
    block_code: 2601005,
    block_name: 'DHARIWAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20600',
    block_code: 202025,
    block_name: 'REGIDI AMADALAVALASA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11021',
    district_code: 1130,
    district_name: 'MORBI',
    block_id: 'B-110155',
    block_code: 1130006,
    block_name: 'HALVAD',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18032',
    district_code: 1813,
    district_name: 'SOLAPUR',
    block_id: 'B-180314',
    block_code: 1813008,
    block_name: 'SANGOLA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50121',
    block_code: 507018,
    block_name: 'Dumaria',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11001',
    district_code: 1112,
    district_name: 'AHMADABAD',
    block_id: 'B-110003',
    block_code: 1112010,
    block_name: 'DETROJ',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270112',
    block_code: 2729014,
    block_name: 'BHOPALSAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360372',
    block_code: 3621008,
    block_name: 'ODELA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15031',
    district_code: 1530,
    district_name: 'YADGIR',
    block_id: 'B-150230',
    block_code: 1530008,
    block_name: 'SHAHPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31370',
    district_code: 3183,
    district_name: 'SAMBHAL',
    block_id: 'B-313757',
    block_code: 3183005,
    block_name: 'BAHJOI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36017',
    district_code: 3616,
    district_name: 'MEDCHAL MALKAJGIRI',
    block_id: 'B-360244',
    block_code: 3616004,
    block_name: 'GHATKESAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313486',
    block_code: 3158039,
    block_name: 'DOBHI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290157',
    block_code: 2908014,
    block_name: 'TIRUCHENGODE',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21006',
    district_code: 2107,
    district_name: 'RI BHOI',
    block_id: 'B-210022',
    block_code: 2107005,
    block_name: 'BHOIRYMBONG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360285',
    block_code: 3618008,
    block_name: 'DEVARAKONDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17052',
    district_code: 1727,
    district_name: 'VIDISHA',
    block_id: 'B-170308',
    block_code: 1727006,
    block_name: 'GYARASPUR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260044',
    block_code: 2601006,
    block_name: 'DINANAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20598',
    block_code: 202026,
    block_name: 'RAJAM',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17011',
    district_code: 1708,
    district_name: 'CHHATARPUR',
    block_id: 'B-170060',
    block_code: 1708001,
    block_name: 'GAURIHAR',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22008',
    district_code: 2204,
    district_name: 'MAMIT',
    block_id: 'B-220020',
    block_code: 2204001,
    block_name: 'ZAWLNUAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50120',
    block_code: 507020,
    block_name: 'Dobhi',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17031',
    district_code: 1734,
    district_name: 'NARSINGHPUR',
    block_id: 'B-170193',
    block_code: 1734006,
    block_name: 'KARELI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27010',
    district_code: 2729,
    district_name: 'CHITTORGARH',
    block_id: 'B-270108',
    block_code: 2729011,
    block_name: 'BADISADRI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360367',
    block_code: 3621003,
    block_name: 'ELIGAID',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15031',
    district_code: 1530,
    district_name: 'YADGIR',
    block_id: 'B-150228',
    block_code: 1530011,
    block_name: 'GURUMITKAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31370',
    district_code: 3183,
    district_name: 'SAMBHAL',
    block_id: 'B-313759',
    block_code: 3183006,
    block_name: 'GUNNAUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36017',
    district_code: 3616,
    district_name: 'MEDCHAL MALKAJGIRI',
    block_id: 'B-360245',
    block_code: 3616006,
    block_name: 'KEESARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313490',
    block_code: 3158040,
    block_name: 'KHUTHAN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290151',
    block_code: 2908007,
    block_name: 'NAMAKKAL',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21006',
    district_code: 2107,
    district_name: 'RI BHOI',
    block_id: 'B-210024',
    block_code: 2107002,
    block_name: 'UMLING',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360295',
    block_code: 3618018,
    block_name: 'MUNUGODE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17052',
    district_code: 1727,
    district_name: 'VIDISHA',
    block_id: 'B-170313',
    block_code: 1727007,
    block_name: 'VIDISHA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260048',
    block_code: 2601008,
    block_name: 'KAHNUWAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2024',
    district_code: 202,
    district_name: 'VIZIANAGARAM',
    block_id: 'B-20601',
    block_code: 202027,
    block_name: 'SANTHAKAVATI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360531',
    block_code: 3631004,
    block_name: 'BHONGIR',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22008',
    district_code: 2204,
    district_name: 'MAMIT',
    block_id: 'B-220019',
    block_code: 2204002,
    block_name: 'WEST PHAILENG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50122',
    block_code: 507023,
    block_name: 'Fatehpur',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17031',
    district_code: 1734,
    district_name: 'NARSINGHPUR',
    block_id: 'B-170194',
    block_code: 1734005,
    block_name: 'NARSINGHPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27025',
    district_code: 2720,
    district_name: 'PALI',
    block_id: 'B-270267',
    block_code: 2720011,
    block_name: 'BAGRI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360374',
    block_code: 3621010,
    block_name: 'PEDDAPALLI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15031',
    district_code: 1530,
    district_name: 'YADGIR',
    block_id: 'B-150232',
    block_code: 1530013,
    block_name: 'VADAGERA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31370',
    district_code: 3183,
    district_name: 'SAMBHAL',
    block_id: 'B-313762',
    block_code: 3183007,
    block_name: 'RAJPURA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36017',
    district_code: 3616,
    district_name: 'MEDCHAL MALKAJGIRI',
    block_id: 'B-360248',
    block_code: 3616011,
    block_name: 'SHAMIRPET',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313499',
    block_code: 3158041,
    block_name: 'SIKRARA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29016',
    district_code: 2908,
    district_name: 'NAMAKKAL',
    block_id: 'B-290153',
    block_code: 2908010,
    block_name: 'PARAMATHY',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21006',
    district_code: 2107,
    district_name: 'RI BHOI',
    block_id: 'B-210023',
    block_code: 2107003,
    block_name: 'JIRANG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360297',
    block_code: 3618020,
    block_name: 'NALGONDA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120066',
    block_code: 1205001,
    block_name: 'INDRI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260049',
    block_code: 2601009,
    block_name: 'KALANAUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35007',
    district_code: 3508,
    district_name: 'NAINITAL',
    block_id: 'B-350046',
    block_code: 3508003,
    block_name: 'RAMGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360540',
    block_code: 3631013,
    block_name: 'RAJAPET',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22008',
    district_code: 2204,
    district_name: 'MAMIT',
    block_id: 'B-220018',
    block_code: 2204003,
    block_name: 'REIEK',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50117',
    block_code: 507024,
    block_name: 'Barachatti',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15029',
    district_code: 1531,
    district_name: 'VIJAYANAGARA',
    block_id: 'B-150209',
    block_code: 1531002,
    block_name: 'HADAGALLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313373',
    block_code: 3121001,
    block_name: 'NARKHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360370',
    block_code: 3621006,
    block_name: 'MANTHANI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15031',
    district_code: 1530,
    district_name: 'YADGIR',
    block_id: 'B-150229',
    block_code: 1530012,
    block_name: 'HUNASAGI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31370',
    district_code: 3183,
    district_name: 'SAMBHAL',
    block_id: 'B-313760',
    block_code: 3183008,
    block_name: 'JUNAWAI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290266',
    block_code: 2932004,
    block_name: 'KUNDADAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313639',
    block_code: 3115016,
    block_name: 'MEERUT',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180163',
    block_code: 1821008,
    block_name: 'SHIRUR ANANTPAL',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21006',
    district_code: 2107,
    district_name: 'RI BHOI',
    block_id: 'B-210025',
    block_code: 2107004,
    block_name: 'UMSNING',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15017',
    district_code: 1515,
    district_name: 'KALABURAGI',
    block_id: 'B-150125',
    block_code: 1515007,
    block_name: 'SEDAM',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12001',
    district_code: 1201,
    district_name: 'AMBALA',
    block_id: 'B-120005',
    block_code: 1201011,
    block_name: 'SAHA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260046',
    block_code: 2601012,
    block_name: 'FATEHGARH CHURIAN',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35007',
    district_code: 3508,
    district_name: 'NAINITAL',
    block_id: 'B-350041',
    block_code: 3508004,
    block_name: 'BHIMTAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360543',
    block_code: 3631015,
    block_name: 'VALIGONDA',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22008',
    district_code: 2204,
    district_name: 'MAMIT',
    block_id: 'B-220028',
    block_code: 2204004,
    block_name: 'KAWRTETHAWVENG',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4023',
    district_code: 402,
    district_name: 'KOKRAJHAR',
    block_id: 'B-40144',
    block_code: 402004,
    block_name: 'DOTOMA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15029',
    district_code: 1531,
    district_name: 'VIJAYANAGARA',
    block_id: 'B-150210',
    block_code: 1531003,
    block_name: 'HAGARIBOMMANAHALLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313367',
    block_code: 3121008,
    block_name: 'ARAON',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360376',
    block_code: 3621013,
    block_name: 'SRIRAMPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15031',
    district_code: 1530,
    district_name: 'YADGIR',
    block_id: 'B-150233',
    block_code: 1530010,
    block_name: 'YADGIR',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30001',
    district_code: 3004,
    district_name: 'DHALAI',
    block_id: 'B-300002',
    block_code: 3004002,
    block_name: 'CHAWMANU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290268',
    block_code: 2932006,
    block_name: 'MULANUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313641',
    block_code: 3115017,
    block_name: 'RAJPURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313175',
    block_code: 3157001,
    block_name: 'ATRAULIA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17025',
    district_code: 1725,
    district_name: 'KHANDWA',
    block_id: 'B-170148',
    block_code: 1725002,
    block_name: 'HARSUD',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360304',
    block_code: 3618027,
    block_name: 'SHALI GOURARAM',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12018',
    district_code: 1211,
    district_name: 'REWARI',
    block_id: 'B-120113',
    block_code: 1211008,
    block_name: 'JATUSANA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260050',
    block_code: 2601014,
    block_name: 'QADIAN',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35007',
    district_code: 3508,
    district_name: 'NAINITAL',
    block_id: 'B-350045',
    block_code: 3508006,
    block_name: 'OKHALKANDA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150021',
    block_code: 1504011,
    block_name: 'KAGWAD',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33017',
    district_code: 3329,
    district_name: 'KHAIRGARH CHHUIKHADAN GANDAI',
    block_id: 'B-330079',
    block_code: 3329006,
    block_name: 'CHHUIKHADAN',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4023',
    district_code: 402,
    district_name: 'KOKRAJHAR',
    block_id: 'B-40146',
    block_code: 402005,
    block_name: 'HATIDHURA',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15029',
    district_code: 1531,
    district_name: 'VIJAYANAGARA',
    block_id: 'B-150214',
    block_code: 1531005,
    block_name: 'KUDLIGI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31334',
    district_code: 3121,
    district_name: 'FIROZABAD',
    block_id: 'B-313372',
    block_code: 3121009,
    block_name: 'MADANPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360368',
    block_code: 3621004,
    block_name: 'JULAPALLI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15031',
    district_code: 1530,
    district_name: 'YADGIR',
    block_id: 'B-150231',
    block_code: 1530009,
    block_name: 'SURPUR',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30001',
    district_code: 3004,
    district_name: 'DHALAI',
    block_id: 'B-300003',
    block_code: 3004003,
    block_name: 'DUMBURNAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290270',
    block_code: 2932008,
    block_name: 'PONGALUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33032',
    district_code: 3326,
    district_name: 'SURAJPUR',
    block_id: 'B-330134',
    block_code: 3326001,
    block_name: 'BHAIYATHAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313180',
    block_code: 3157002,
    block_name: 'KOILSA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17025',
    district_code: 1725,
    district_name: 'KHANDWA',
    block_id: 'B-170152',
    block_code: 1725004,
    block_name: 'PUNASA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360283',
    block_code: 3618006,
    block_name: 'CHITYALA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12018',
    district_code: 1211,
    district_name: 'REWARI',
    block_id: 'B-120115',
    block_code: 1211009,
    block_name: 'NAHAR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260047',
    block_code: 2601007,
    block_name: 'GURDASPUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35007',
    district_code: 3508,
    district_name: 'NAINITAL',
    block_id: 'B-350047',
    block_code: 3508001,
    block_name: 'RAMNAGAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150024',
    block_code: 1504013,
    block_name: 'MOODALAGI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33017',
    district_code: 3329,
    district_name: 'KHAIRGARH CHHUIKHADAN GANDAI',
    block_id: 'B-330080',
    block_code: 3329005,
    block_name: 'KHAIRAGARH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50119',
    block_code: 507021,
    block_name: 'Bodh Gaya',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15029',
    district_code: 1531,
    district_name: 'VIJAYANAGARA',
    block_id: 'B-150212',
    block_code: 1531004,
    block_name: 'HOSPET',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270262',
    block_code: 2714005,
    block_name: 'MUNDAWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36024',
    district_code: 3621,
    district_name: 'PEDDAPALLI',
    block_id: 'B-360377',
    block_code: 3621014,
    block_name: 'SULTHANABAD',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34012',
    district_code: 3412,
    district_name: 'JAMTARA',
    block_id: 'B-340137',
    block_code: 3412001,
    block_name: 'NALA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30001',
    district_code: 3004,
    district_name: 'DHALAI',
    block_id: 'B-300006',
    block_code: 3004004,
    block_name: 'MANU',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290263',
    block_code: 2932002,
    block_name: 'DHARAPURAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33032',
    district_code: 3326,
    district_name: 'SURAJPUR',
    block_id: 'B-330135',
    block_code: 3326002,
    block_name: 'ODAGI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31318',
    district_code: 3157,
    district_name: 'AZAMGARH',
    block_id: 'B-313174',
    block_code: 3157003,
    block_name: 'AHIRAULA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17025',
    district_code: 1725,
    district_name: 'KHANDWA',
    block_id: 'B-170150',
    block_code: 1725005,
    block_name: 'KHANDWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360289',
    block_code: 3618012,
    block_name: 'KATTANGOOR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12018',
    district_code: 1211,
    district_name: 'REWARI',
    block_id: 'B-120114',
    block_code: 1211010,
    block_name: 'KHOL AT REWARI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260041',
    block_code: 2601010,
    block_name: 'BATALA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35007',
    district_code: 3508,
    district_name: 'NAINITAL',
    block_id: 'B-350042',
    block_code: 3508005,
    block_name: 'DHARI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150025',
    block_code: 1504014,
    block_name: 'NIPPANI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240283',
    block_code: 2401023,
    block_name: 'BAMRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50135',
    block_code: 507022,
    block_name: 'Tan Kuppa',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15029',
    district_code: 1531,
    district_name: 'VIJAYANAGARA',
    block_id: 'B-150213',
    block_code: 1531010,
    block_name: 'KOTTURU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270257',
    block_code: 2714011,
    block_name: 'KUCHAMANCITY',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270096',
    block_code: 2703002,
    block_name: 'DUNGARGARH',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34012',
    district_code: 3412,
    district_name: 'JAMTARA',
    block_id: 'B-340136',
    block_code: 3412002,
    block_name: 'KUNDHIT',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30001',
    district_code: 3004,
    district_name: 'DHALAI',
    block_id: 'B-300008',
    block_code: 3004005,
    block_name: 'SALEMA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290267',
    block_code: 2932005,
    block_name: 'MADATHUKULAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33032',
    district_code: 3326,
    district_name: 'SURAJPUR',
    block_id: 'B-330136',
    block_code: 3326003,
    block_name: 'PRATAPPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160074',
    block_code: 1604001,
    block_name: 'BALUSSERI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17025',
    district_code: 1725,
    district_name: 'KHANDWA',
    block_id: 'B-170151',
    block_code: 1725007,
    block_name: 'PANDHANA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360296',
    block_code: 3618019,
    block_name: 'NAKREKAL',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12001',
    district_code: 1201,
    district_name: 'AMBALA',
    block_id: 'B-120004',
    block_code: 1201005,
    block_name: 'NARAINGARH',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260042',
    block_code: 2601011,
    block_name: 'DERA BABA NANAK',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35007',
    district_code: 3508,
    district_name: 'NAINITAL',
    block_id: 'B-350043',
    block_code: 3508007,
    block_name: 'HALDWANI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360528',
    block_code: 3631001,
    block_name: 'ADDA GUDURU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50263',
    block_code: 515004,
    block_name: 'BOCHAHA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50134',
    block_code: 507019,
    block_name: 'Sherghati',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15029',
    district_code: 1531,
    district_name: 'VIJAYANAGARA',
    block_id: 'B-150211',
    block_code: 1531008,
    block_name: 'HARAPPANAHALLI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270253',
    block_code: 2714007,
    block_name: 'DEGANA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270095',
    block_code: 2703001,
    block_name: 'BIKANER',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34012',
    district_code: 3412,
    district_name: 'JAMTARA',
    block_id: 'B-340134',
    block_code: 3412003,
    block_name: 'JAMTARA',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30001',
    district_code: 3004,
    district_name: 'DHALAI',
    block_id: 'B-300001',
    block_code: 3004001,
    block_name: 'AMBASSA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290269',
    block_code: 2932007,
    block_name: 'PALLADAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20257',
    block_code: 218012,
    block_name: 'MALIKIPURAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160075',
    block_code: 1604002,
    block_name: 'CHELANNUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33028',
    district_code: 3304,
    district_name: 'RAJNANDAGON',
    block_id: 'B-330123',
    block_code: 3304001,
    block_name: 'RAJNANDGAON',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360279',
    block_code: 3618002,
    block_name: 'ANUMULA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12001',
    district_code: 1201,
    district_name: 'AMBALA',
    block_id: 'B-120003',
    block_code: 1201007,
    block_name: 'BARARA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260051',
    block_code: 2601013,
    block_name: 'SRIHARGOBIND PUR',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35007',
    district_code: 3508,
    district_name: 'NAINITAL',
    block_id: 'B-350040',
    block_code: 3508008,
    block_name: 'BETALGHAT',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360542',
    block_code: 3631008,
    block_name: 'THURKAPALLY',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50262',
    block_code: 515003,
    block_name: 'BARURAJ  MOTIPUR ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50131',
    block_code: 507007,
    block_name: 'Muhra',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270266',
    block_code: 2714008,
    block_name: 'RIYAN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270265',
    block_code: 2714010,
    block_name: 'PARBATSAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270098',
    block_code: 2703003,
    block_name: 'KOLAYAT',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34012',
    district_code: 3412,
    district_name: 'JAMTARA',
    block_id: 'B-340138',
    block_code: 3412004,
    block_name: 'NARAYANPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180005',
    block_code: 1809001,
    block_name: 'NAGAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29027',
    district_code: 2932,
    district_name: 'THIRPPUR',
    block_id: 'B-290271',
    block_code: 2932009,
    block_name: 'TIRUPPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20260',
    block_code: 218015,
    block_name: 'MUMMIDIVARAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160076',
    block_code: 1604003,
    block_name: 'KODUVALLY',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17025',
    district_code: 1725,
    district_name: 'KHANDWA',
    block_id: 'B-170146',
    block_code: 1725001,
    block_name: 'BALADI  KILLOD ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360284',
    block_code: 3618007,
    block_name: 'DAMERACHERLA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12018',
    district_code: 1211,
    district_name: 'REWARI',
    block_id: 'B-120110',
    block_code: 1211006,
    block_name: 'BAWAL',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26008',
    district_code: 2601,
    district_name: 'GURDASPUR',
    block_id: 'B-260045',
    block_code: 2601017,
    block_name: 'DORANGLA',
  },
  {
    state_id: 'S-33',
    state_code: 35,
    state_name: 'UTTARAKHAND',
    district_id: 'D-35007',
    district_code: 3508,
    district_name: 'NAINITAL',
    block_id: 'B-350044',
    block_code: 3508002,
    block_name: 'KOTABAG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360536',
    block_code: 3631017,
    block_name: 'GUNDALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50264',
    block_code: 515005,
    block_name: 'DHOLI  MORAUL ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50116',
    block_code: 507015,
    block_name: 'Banke Bazar',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27017',
    district_code: 2716,
    district_name: 'JAISALMER',
    block_id: 'B-270185',
    block_code: 2716006,
    block_name: 'MOHANGARH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270259',
    block_code: 2714009,
    block_name: 'MAKRANA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270069',
    block_code: 2707011,
    block_name: 'BHUSAWAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34012',
    district_code: 3412,
    district_name: 'JAMTARA',
    block_id: 'B-340133',
    block_code: 3412005,
    block_name: 'FATEHPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180009',
    block_code: 1809014,
    block_name: 'RAHATA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313638',
    block_code: 3115010,
    block_name: 'MAWANA KALAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20251',
    block_code: 218005,
    block_name: 'AMBAJIPETA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160078',
    block_code: 1604005,
    block_name: 'KUNNAMANGALAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33028',
    district_code: 3304,
    district_name: 'RAJNANDAGON',
    block_id: 'B-330120',
    block_code: 3304003,
    block_name: 'CHHURIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360287',
    block_code: 3618010,
    block_name: 'GURRAMPODE',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12018',
    district_code: 1211,
    district_name: 'REWARI',
    block_id: 'B-120116',
    block_code: 1211007,
    block_name: 'REWARI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24012',
    district_code: 2419,
    district_name: 'JAGATSINGHAPUR',
    block_id: 'B-240117',
    block_code: 2419002,
    block_name: 'RAGHUNATHPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313873',
    block_code: 3131004,
    block_name: 'SAFIPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150018',
    block_code: 1504004,
    block_name: 'CHIKODI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4007',
    district_code: 432,
    district_name: 'CHARAIDEO',
    block_id: 'B-40045',
    block_code: 432006,
    block_name: 'SAPEKHATI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50127',
    block_code: 507004,
    block_name: 'Khizirsarai',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27017',
    district_code: 2716,
    district_name: 'JAISALMER',
    block_id: 'B-270182',
    block_code: 2716004,
    block_name: 'BANIYANA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27017',
    district_code: 2716,
    district_name: 'JAISALMER',
    block_id: 'B-270184',
    block_code: 2716001,
    block_name: 'JAISALMER',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270094',
    block_code: 2703008,
    block_name: 'BAJJU KHALSA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34012',
    district_code: 3412,
    district_name: 'JAMTARA',
    block_id: 'B-340135',
    block_code: 3412006,
    block_name: 'KARMATANR VIDYASAGAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180001',
    block_code: 1809011,
    block_name: 'AKOLE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313634',
    block_code: 3115011,
    block_name: 'HASTINAPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20247',
    block_code: 218001,
    block_name: 'AINAVILLI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160079',
    block_code: 1604006,
    block_name: 'KUNNUMMAL',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33028',
    district_code: 3304,
    district_name: 'RAJNANDAGON',
    block_id: 'B-330122',
    block_code: 3304004,
    block_name: 'DONGARGARH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360306',
    block_code: 3618030,
    block_name: 'TIRUMALAGIRI SAGAR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12001',
    district_code: 1201,
    district_name: 'AMBALA',
    block_id: 'B-120001',
    block_code: 1201009,
    block_name: 'AMBALA1',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50064',
    block_code: 527010,
    block_name: 'Naugachhia',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313868',
    block_code: 3131007,
    block_name: 'HASANGANJ',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15003',
    district_code: 1504,
    district_name: 'BELAGAVI',
    block_id: 'B-150019',
    block_code: 1504005,
    block_name: 'GOKAK',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4007',
    district_code: 432,
    district_name: 'CHARAIDEO',
    block_id: 'B-40044',
    block_code: 432005,
    block_name: 'MAHMORA SONARI ',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5010',
    district_code: 507,
    district_name: 'GAYA',
    block_id: 'B-50132',
    block_code: 507005,
    block_name: 'Neem Chak Bathani',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27017',
    district_code: 2716,
    district_name: 'JAISALMER',
    block_id: 'B-270183',
    block_code: 2716005,
    block_name: 'FATEHGARH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27017',
    district_code: 2716,
    district_name: 'JAISALMER',
    block_id: 'B-270188',
    block_code: 2716002,
    block_name: 'SANKRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270102',
    block_code: 2703009,
    block_name: 'POOGAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29035',
    district_code: 2905,
    district_name: 'VELLORE',
    block_id: 'B-290364',
    block_code: 2905001,
    block_name: 'VELLORE',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30001',
    district_code: 3004,
    district_name: 'DHALAI',
    block_id: 'B-300004',
    block_code: 3004006,
    block_name: 'DURGACHOWMUHANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313640',
    block_code: 3115012,
    block_name: 'PARIKSHITGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20255',
    block_code: 218010,
    block_name: 'KATRENIKONA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160081',
    block_code: 1604008,
    block_name: 'PANTHALAYANI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20001',
    district_code: 2006,
    district_name: 'BISHNUPUR',
    block_id: 'B-200003',
    block_code: 2006005,
    block_name: 'NAMBOL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360293',
    block_code: 3618016,
    block_name: 'MARRIGUDA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12001',
    district_code: 1201,
    district_name: 'AMBALA',
    block_id: 'B-120002',
    block_code: 1201010,
    block_name: 'AMBALA2',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50063',
    block_code: 527009,
    block_name: 'Nathnagar',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313872',
    block_code: 3131014,
    block_name: 'PURWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360537',
    block_code: 3631009,
    block_name: 'MOTAKONDURU',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4007',
    district_code: 432,
    district_name: 'CHARAIDEO',
    block_id: 'B-40043',
    block_code: 432008,
    block_name: 'LAKUWA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18021',
    district_code: 1831,
    district_name: 'NANDURBAR',
    block_id: 'B-180195',
    block_code: 1831003,
    block_name: 'AKRANI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27017',
    district_code: 2716,
    district_name: 'JAISALMER',
    block_id: 'B-270186',
    block_code: 2716007,
    block_name: 'NACHANA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27017',
    district_code: 2716,
    district_name: 'JAISALMER',
    block_id: 'B-270187',
    block_code: 2716003,
    block_name: 'SAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270097',
    block_code: 2703006,
    block_name: 'KHAJUWALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29035',
    district_code: 2905,
    district_name: 'VELLORE',
    block_id: 'B-290361',
    block_code: 2905005,
    block_name: 'KATPADI',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30001',
    district_code: 3004,
    district_name: 'DHALAI',
    block_id: 'B-300007',
    block_code: 3004007,
    block_name: 'RAISHYABARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313637',
    block_code: 3115013,
    block_name: 'MACHRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20253',
    block_code: 218007,
    block_name: 'I  POLAVARAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160082',
    block_code: 1604009,
    block_name: 'PERAMBRA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20001',
    district_code: 2006,
    district_name: 'BISHNUPUR',
    block_id: 'B-200001',
    block_code: 2006003,
    block_name: 'BISHNUPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360294',
    block_code: 3618017,
    block_name: 'MIRYALAGUDA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120070',
    block_code: 1205002,
    block_name: 'NILOKHERI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50068',
    block_code: 527014,
    block_name: 'Shahkund',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31380',
    district_code: 3131,
    district_name: 'UNNAO',
    block_id: 'B-313865',
    block_code: 3131015,
    block_name: 'BIGHAPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34019',
    district_code: 3423,
    district_name: 'RAMGARH',
    block_id: 'B-340194',
    block_code: 3423001,
    block_name: 'CHITARPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4007',
    district_code: 432,
    district_name: 'CHARAIDEO',
    block_id: 'B-40046',
    block_code: 432007,
    block_name: 'SONARI  WEST ABHOIPUR ',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17023',
    district_code: 1721,
    district_name: 'JHABUA',
    block_id: 'B-170139',
    block_code: 1721001,
    block_name: 'THANDLA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270256',
    block_code: 2714014,
    block_name: 'KHEEWSAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270260',
    block_code: 2714012,
    block_name: 'MAULASAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270075',
    block_code: 2707010,
    block_name: 'PAHARI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29035',
    district_code: 2905,
    district_name: 'VELLORE',
    block_id: 'B-290362',
    block_code: 2905006,
    block_name: 'K.V. KUPPAM',
  },
  {
    state_id: 'S-28',
    state_code: 30,
    state_name: 'TRIPURA',
    district_id: 'D-30001',
    district_code: 3004,
    district_name: 'DHALAI',
    block_id: 'B-300005',
    block_code: 3004008,
    block_name: 'GANGANAGAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313642',
    block_code: 3115014,
    block_name: 'ROHTA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20250',
    block_code: 218004,
    block_name: 'AMALAPURAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16008',
    district_code: 1604,
    district_name: 'KOZHIKKODE',
    block_id: 'B-160083',
    block_code: 1604010,
    block_name: 'THODANNUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20001',
    district_code: 2006,
    district_name: 'BISHNUPUR',
    block_id: 'B-200002',
    block_code: 2006004,
    block_name: 'MOIRANG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360292',
    block_code: 3618015,
    block_name: 'MADUGULAPALLY',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120067',
    block_code: 1205004,
    block_name: 'KARNAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50067',
    block_code: 527013,
    block_name: 'Sabour',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27009',
    district_code: 2723,
    district_name: 'BUNDI',
    block_id: 'B-270103',
    block_code: 2723005,
    block_name: 'BUNDI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34019',
    district_code: 3423,
    district_name: 'RAMGARH',
    block_id: 'B-340195',
    block_code: 3423002,
    block_name: 'DULMI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240286',
    block_code: 2401003,
    block_name: 'JUJOMURA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17023',
    district_code: 1721,
    district_name: 'JHABUA',
    block_id: 'B-170136',
    block_code: 1721002,
    block_name: 'PETLAWAD',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270264',
    block_code: 2714013,
    block_name: 'NAWA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270252',
    block_code: 2714015,
    block_name: 'BHERUNDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270101',
    block_code: 2703007,
    block_name: 'PANCHOO',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29035',
    district_code: 2905,
    district_name: 'VELLORE',
    block_id: 'B-290363',
    block_code: 2905008,
    block_name: 'PERNAMBET',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28002',
    district_code: 2804,
    district_name: 'GYALSHING',
    block_id: 'B-280008',
    block_code: 2804001,
    block_name: 'GYALSHING',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313635',
    block_code: 3115015,
    block_name: 'JANIKHURD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20249',
    block_code: 218003,
    block_name: 'ALLAVARAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180085',
    block_code: 1829005,
    block_name: 'NAGBHID',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33028',
    district_code: 3304,
    district_name: 'RAJNANDAGON',
    block_id: 'B-330121',
    block_code: 3304002,
    block_name: 'DONGARGAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17001',
    district_code: 1751,
    district_name: 'AGAR',
    block_id: 'B-170002',
    block_code: 1751003,
    block_name: 'BADOD',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120063',
    block_code: 1205093,
    block_name: 'ASSANDH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50058',
    block_code: 527004,
    block_name: 'Ismailpur',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27009',
    district_code: 2723,
    district_name: 'BUNDI',
    block_id: 'B-270104',
    block_code: 2723001,
    block_name: 'HINDOLI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34019',
    district_code: 3423,
    district_name: 'RAMGARH',
    block_id: 'B-340196',
    block_code: 3423003,
    block_name: 'GOLA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240291',
    block_code: 2401004,
    block_name: 'RENGALI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17023',
    district_code: 1721,
    district_name: 'JHABUA',
    block_id: 'B-170135',
    block_code: 1721003,
    block_name: 'MEGHNAGAR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270258',
    block_code: 2714001,
    block_name: 'LADNU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313695',
    block_code: 3144008,
    block_name: 'SANDWA CHANDRIKA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270099',
    block_code: 2703004,
    block_name: 'LUNKARANSAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29035',
    district_code: 2905,
    district_name: 'VELLORE',
    block_id: 'B-290359',
    block_code: 2905007,
    block_name: 'GUDIYATHAM',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28002',
    district_code: 2804,
    district_name: 'GYALSHING',
    block_id: 'B-280007',
    block_code: 2804004,
    block_name: 'DENTAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313636',
    block_code: 3115018,
    block_name: 'KHARKHODA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20258',
    block_code: 218013,
    block_name: 'MAMIDIKUDURU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180160',
    block_code: 1821001,
    block_name: 'LATUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17025',
    district_code: 1725,
    district_name: 'KHANDWA',
    block_id: 'B-170147',
    block_code: 1725006,
    block_name: 'CHHAIGAON MAKHAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17001',
    district_code: 1751,
    district_name: 'AGAR',
    block_id: 'B-170003',
    block_code: 1751002,
    block_name: 'NALKHEDA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12001',
    district_code: 1201,
    district_name: 'AMBALA',
    block_id: 'B-120006',
    block_code: 1201012,
    block_name: 'SHAHZADPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50062',
    block_code: 527008,
    block_name: 'Narayanpur',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27009',
    district_code: 2723,
    district_name: 'BUNDI',
    block_id: 'B-270106',
    block_code: 2723002,
    block_name: 'NAINWA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34019',
    district_code: 3423,
    district_name: 'RAMGARH',
    block_id: 'B-340199',
    block_code: 3423006,
    block_name: 'RAMGARH',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240287',
    block_code: 2401022,
    block_name: 'KUCHINDA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17023',
    district_code: 1721,
    district_name: 'JHABUA',
    block_id: 'B-170134',
    block_code: 1721004,
    block_name: 'JHABUA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270254',
    block_code: 2714002,
    block_name: 'DIDWANA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313691',
    block_code: 3144010,
    block_name: 'MANDHATA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27008',
    district_code: 2703,
    district_name: 'BIKANER',
    block_id: 'B-270100',
    block_code: 2703005,
    block_name: 'NOKHA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29035',
    district_code: 2905,
    district_name: 'VELLORE',
    block_id: 'B-290360',
    block_code: 2905002,
    block_name: 'KANIYAMBADI',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28002',
    district_code: 2804,
    district_name: 'GYALSHING',
    block_id: 'B-280010',
    block_code: 2804003,
    block_name: 'YUKSOM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31330',
    district_code: 3122,
    district_name: 'ETAH',
    block_id: 'B-313334',
    block_code: 3122008,
    block_name: 'JALESAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20248',
    block_code: 218002,
    block_name: 'ALAMURU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180164',
    block_code: 1821003,
    block_name: 'UDGIR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4020',
    district_code: 426,
    district_name: 'KAMRUP-METRO',
    block_id: 'B-40129',
    block_code: 426003,
    block_name: 'DIMORIA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340052',
    block_code: 3410009,
    block_name: 'BAHRAGORA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120064',
    block_code: 1205096,
    block_name: 'CHIRAO',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50060',
    block_code: 527006,
    block_name: 'Kahalgaon',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27009',
    district_code: 2723,
    district_name: 'BUNDI',
    block_id: 'B-270107',
    block_code: 2723004,
    block_name: 'TALERA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360534',
    block_code: 3631012,
    block_name: 'B POCHAMPALLY',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240285',
    block_code: 2401024,
    block_name: 'JAMANKIRA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17023',
    district_code: 1721,
    district_name: 'JHABUA',
    block_id: 'B-170138',
    block_code: 1721012,
    block_name: 'RANAPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270255',
    block_code: 2714003,
    block_name: 'JAYAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313690',
    block_code: 3144011,
    block_name: 'MAGRAURA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270076',
    block_code: 2707001,
    block_name: 'RUPBAS',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29035',
    district_code: 2905,
    district_name: 'VELLORE',
    block_id: 'B-290358',
    block_code: 2905003,
    block_name: 'ANAICUT',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28002',
    district_code: 2804,
    district_name: 'GYALSHING',
    block_id: 'B-280006',
    block_code: 2804018,
    block_name: 'ARITHANG CHONG RANG',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31330',
    district_code: 3122,
    district_name: 'ETAH',
    block_id: 'B-313332',
    block_code: 3122009,
    block_name: 'AWAGARH',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20266',
    block_code: 218020,
    block_name: 'RAZOLE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180161',
    block_code: 1821004,
    block_name: 'NILANGA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50376',
    block_code: 513011,
    block_name: 'TETARIYA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340058',
    block_code: 3410002,
    block_name: 'GOLMURI CUM JUGSALAI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12018',
    district_code: 1211,
    district_name: 'REWARI',
    block_id: 'B-120111',
    block_code: 1211011,
    block_name: 'DAHINA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50070',
    block_code: 527016,
    block_name: 'Sultanganj',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3020',
    district_code: 311,
    district_name: 'TIRAP',
    block_id: 'B-30086',
    block_code: 311001,
    block_name: 'NAMSANG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360529',
    block_code: 3631002,
    block_name: 'ALAIR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240289',
    block_code: 2401029,
    block_name: 'NAKTIDEUL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17023',
    district_code: 1721,
    district_name: 'JHABUA',
    block_id: 'B-170137',
    block_code: 1721005,
    block_name: 'RAMA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270263',
    block_code: 2714004,
    block_name: 'NAGAUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313681',
    block_code: 3144013,
    block_name: 'ASPUR DEOSARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270071',
    block_code: 2707002,
    block_name: 'KAMAN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29014',
    district_code: 2936,
    district_name: 'MAYILADUTHURAI',
    block_id: 'B-290136',
    block_code: 2936009,
    block_name: 'SEMBANARKOIL',
  },
  {
    state_id: 'S-26',
    state_code: 28,
    state_name: 'SIKKIM',
    district_id: 'D-28002',
    district_code: 2804,
    district_name: 'GYALSHING',
    block_id: 'B-280009',
    block_code: 2804020,
    block_name: 'HEE MAR TAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31330',
    district_code: 3122,
    district_name: 'ETAH',
    block_id: 'B-313335',
    block_code: 3122010,
    block_name: 'MAREHRA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20262',
    block_code: 218016,
    block_name: 'P GANNAVARAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180156',
    block_code: 1821005,
    block_name: 'AUSA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50356',
    block_code: 513015,
    block_name: 'CHIRAIYA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34006',
    district_code: 3410,
    district_name: 'EAST SINGHBUM',
    block_id: 'B-340059',
    block_code: 3410011,
    block_name: 'GURABANDA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12018',
    district_code: 1211,
    district_name: 'REWARI',
    block_id: 'B-120112',
    block_code: 1211012,
    block_name: 'DHARUHERA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50061',
    block_code: 527007,
    block_name: 'Kharik',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13001',
    district_code: 1301,
    district_name: 'BILASPUR',
    block_id: 'B-130003',
    block_code: 1301003,
    block_name: 'JHANDUTTA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360530',
    block_code: 3631003,
    block_name: 'ATMAKUR  M ',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24028',
    district_code: 2401,
    district_name: 'SAMBALPUR',
    block_id: 'B-240290',
    block_code: 2401028,
    block_name: 'RAIRAKHOL',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40169',
    block_code: 413003,
    block_name: 'JURIA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27024',
    district_code: 2714,
    district_name: 'NAGAUR',
    block_id: 'B-270261',
    block_code: 2714006,
    block_name: 'MERTA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313697',
    block_code: 3144014,
    block_name: 'SHIVGARH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270074',
    block_code: 2707003,
    block_name: 'NAGAR PAHARI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29014',
    district_code: 2936,
    district_name: 'MAYILADUTHURAI',
    block_id: 'B-290137',
    block_code: 2936010,
    block_name: 'SIRKALI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20007',
    district_code: 2012,
    district_name: 'KAKCHING',
    block_id: 'B-200030',
    block_code: 2012002,
    block_name: 'KAKCHING',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31330',
    district_code: 3122,
    district_name: 'ETAH',
    block_id: 'B-313336',
    block_code: 3122011,
    block_name: 'NIDHAULI KALAN',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20254',
    block_code: 218009,
    block_name: 'KAPILESWARAPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180162',
    block_code: 1821006,
    block_name: 'RENAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50368',
    block_code: 513017,
    block_name: 'PAKRIDAYAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29025',
    district_code: 2921,
    district_name: 'THENI',
    block_id: 'B-290252',
    block_code: 2921006,
    block_name: 'CHINNAMANUR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120068',
    block_code: 1205095,
    block_name: 'KUNJPURA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50059',
    block_code: 527005,
    block_name: 'Jagdishpur',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13001',
    district_code: 1301,
    district_name: 'BILASPUR',
    block_id: 'B-130001',
    block_code: 1301001,
    block_name: 'BILASPUR SADAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360532',
    block_code: 3631005,
    block_name: 'BIBINAGAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50045',
    block_code: 517009,
    block_name: 'CHHORAHI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40171',
    block_code: 413007,
    block_name: 'KATHIATOLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313523',
    block_code: 3137007,
    block_name: 'CHAUBEYPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313685',
    block_code: 3144015,
    block_name: 'GAURA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270070',
    block_code: 2707004,
    block_name: 'DEEG',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29014',
    district_code: 2936,
    district_name: 'MAYILADUTHURAI',
    block_id: 'B-290135',
    block_code: 2936007,
    block_name: 'MAYILADUTHURAI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20007',
    district_code: 2012,
    district_name: 'KAKCHING',
    block_id: 'B-200031',
    block_code: 2012005,
    block_name: 'LANGMEIDONG',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31330',
    district_code: 3122,
    district_name: 'ETAH',
    block_id: 'B-313338',
    block_code: 3122012,
    block_name: 'SHITALPUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20263',
    block_code: 218017,
    block_name: 'RAMACHANDRAPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180157',
    block_code: 1821007,
    block_name: 'CHAKUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50353',
    block_code: 513021,
    block_name: 'BANJARIYA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29025',
    district_code: 2921,
    district_name: 'THENI',
    block_id: 'B-290250',
    block_code: 2921001,
    block_name: 'ANDIPATTI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12011',
    district_code: 1205,
    district_name: 'KARNAL',
    block_id: 'B-120069',
    block_code: 1205094,
    block_name: 'MUNAK',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50056',
    block_code: 527002,
    block_name: 'Gopalpur',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13001',
    district_code: 1301,
    district_name: 'BILASPUR',
    block_id: 'B-130002',
    block_code: 1301002,
    block_name: 'GHUMARWIN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360535',
    block_code: 3631007,
    block_name: 'CHOUTUPPAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50053',
    block_code: 517017,
    block_name: 'SHAMHO AKHA KURHA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40168',
    block_code: 413096,
    block_name: 'DOLONGGHAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313527',
    block_code: 3137008,
    block_name: 'PATARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313682',
    block_code: 3144017,
    block_name: 'BABA BELKHARNATH DHAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270073',
    block_code: 2707005,
    block_name: 'NADBAI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360418',
    block_code: 3624007,
    block_name: 'KALHER',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140078',
    block_code: 1409026,
    block_name: 'CHILLI PINGAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31330',
    district_code: 3122,
    district_name: 'ETAH',
    block_id: 'B-313337',
    block_code: 3122013,
    block_name: 'SAKIT',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20264',
    block_code: 218018,
    block_name: 'RAVULAPALEM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180159',
    block_code: 1821009,
    block_name: 'JALKOT',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50371',
    block_code: 513026,
    block_name: 'PIPRA KOTHI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29025',
    district_code: 2921,
    district_name: 'THENI',
    block_id: 'B-290255',
    block_code: 2921003,
    block_name: 'PERIYAKULAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160061',
    block_code: 1613010,
    block_name: 'SASTHAMCOTTA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24012',
    district_code: 2419,
    district_name: 'JAGATSINGHAPUR',
    block_id: 'B-240114',
    block_code: 2419001,
    block_name: 'JAGATSINGHPUR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13001',
    district_code: 1301,
    district_name: 'BILASPUR',
    block_id: 'B-130004',
    block_code: 1301004,
    block_name: 'SHRI NAINA DEVI JI AT SWARGHAT',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360538',
    block_code: 3631010,
    block_name: 'MOTHKUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50039',
    block_code: 517003,
    block_name: 'BALIA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40166',
    block_code: 413097,
    block_name: 'BARHAMPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313521',
    block_code: 3137009,
    block_name: 'BHITARGAON',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313522',
    block_code: 3137004,
    block_name: 'BILHAUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270072',
    block_code: 2707006,
    block_name: 'KUMHER',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360420',
    block_code: 3624009,
    block_name: 'KANGTI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140084',
    block_code: 1409028,
    block_name: 'KAHARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31330',
    district_code: 3122,
    district_name: 'ETAH',
    block_id: 'B-313333',
    block_code: 3122014,
    block_name: 'JAITHARA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20256',
    block_code: 218011,
    block_name: 'KOTHAPETA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18016',
    district_code: 1821,
    district_name: 'LATUR',
    block_id: 'B-180158',
    block_code: 1821010,
    block_name: 'DEONI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50361',
    block_code: 513006,
    block_name: 'KESARIA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29025',
    district_code: 2921,
    district_name: 'THENI',
    block_id: 'B-290256',
    block_code: 2921004,
    block_name: 'THENI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13006',
    district_code: 1306,
    district_name: 'KULLU',
    block_id: 'B-130042',
    block_code: 1306005,
    block_name: 'NIRMAND',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24012',
    district_code: 2419,
    district_name: 'JAGATSINGHAPUR',
    block_id: 'B-240112',
    block_code: 2419003,
    block_name: 'BIRIDI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17054',
    district_code: 1754,
    district_name: 'MAUGANJ',
    block_id: 'B-170228',
    block_code: 1754006,
    block_name: 'MAUGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360539',
    block_code: 3631011,
    block_name: 'NARAYANAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50051',
    block_code: 517015,
    block_name: 'NAOKOTHI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40175',
    block_code: 413098,
    block_name: 'PAKHIMORIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313530',
    block_code: 3137011,
    block_name: 'VIDHUNU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313524',
    block_code: 3137010,
    block_name: 'GHATAMPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270079',
    block_code: 2707008,
    block_name: 'WEIR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360427',
    block_code: 3624016,
    block_name: 'NARAYANKHED',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140085',
    block_code: 1409029,
    block_name: 'KASTIGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31330',
    district_code: 3122,
    district_name: 'ETAH',
    block_id: 'B-313331',
    block_code: 3122015,
    block_name: 'ALIGANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20265',
    block_code: 218019,
    block_name: 'RAYAVARAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180079',
    block_code: 1829001,
    block_name: 'CHANDRAPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50360',
    block_code: 513007,
    block_name: 'KALYANPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29025',
    district_code: 2921,
    district_name: 'THENI',
    block_id: 'B-290254',
    block_code: 2921002,
    block_name: 'K MYLADUMPARAI',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13006',
    district_code: 1306,
    district_name: 'KULLU',
    block_id: 'B-130038',
    block_code: 1306002,
    block_name: 'BANJAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24012',
    district_code: 2419,
    district_name: 'JAGATSINGHAPUR',
    block_id: 'B-240116',
    block_code: 2419004,
    block_name: 'NAUGAON',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17054',
    district_code: 1754,
    district_name: 'MAUGANJ',
    block_id: 'B-170229',
    block_code: 1754007,
    block_name: 'NAIGARHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360544',
    block_code: 3631016,
    block_name: 'YADAGIRIGUTTA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50271',
    block_code: 515012,
    block_name: 'MUSAHRI',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40165',
    block_code: 413100,
    block_name: 'BAJIAGAON',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31322',
    district_code: 3142,
    district_name: 'BANDA',
    block_id: 'B-313236',
    block_code: 3142001,
    block_name: 'JASPURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31322',
    district_code: 3142,
    district_name: 'BANDA',
    block_id: 'B-313233',
    block_code: 3142004,
    block_name: 'BABERU',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27006',
    district_code: 2707,
    district_name: 'BHARATPUR',
    block_id: 'B-270068',
    block_code: 2707009,
    block_name: 'BAYANA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360437',
    block_code: 3624026,
    block_name: 'ZAHIRABAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140079',
    block_code: 1409025,
    block_name: 'CHIRALLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313644',
    block_code: 3115007,
    block_name: 'SARURPUR KHURD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20252',
    block_code: 218006,
    block_name: 'ATREYAPURAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180090',
    block_code: 1829003,
    block_name: 'WARORA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50359',
    block_code: 513008,
    block_name: 'HARSIDHI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29025',
    district_code: 2921,
    district_name: 'THENI',
    block_id: 'B-290253',
    block_code: 2921008,
    block_name: 'CUMBUM',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13006',
    district_code: 1306,
    district_name: 'KULLU',
    block_id: 'B-130040',
    block_code: 1306003,
    block_name: 'KULLU',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24012',
    district_code: 2419,
    district_name: 'JAGATSINGHAPUR',
    block_id: 'B-240118',
    block_code: 2419005,
    block_name: 'TIRTOL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17054',
    district_code: 1754,
    district_name: 'MAUGANJ',
    block_id: 'B-170226',
    block_code: 1754005,
    block_name: 'HANUMANA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360541',
    block_code: 3631014,
    block_name: 'RAMANNAPETA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50270',
    block_code: 515011,
    block_name: 'MINAPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40174',
    block_code: 413101,
    block_name: 'PACHIM KALIABOR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31322',
    district_code: 3142,
    district_name: 'BANDA',
    block_id: 'B-313240',
    block_code: 3142002,
    block_name: 'TINDWARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31322',
    district_code: 3142,
    district_name: 'BANDA',
    block_id: 'B-313239',
    block_code: 3142008,
    block_name: 'NARAINI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27030',
    district_code: 2719,
    district_name: 'SIROHI',
    block_id: 'B-270316',
    block_code: 2719001,
    block_name: 'SHEOGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360419',
    block_code: 3624008,
    block_name: 'KANDI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140076',
    block_code: 1409021,
    block_name: 'BHALLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31360',
    district_code: 3115,
    district_name: 'MEERUT',
    block_id: 'B-313633',
    block_code: 3115009,
    block_name: 'DAURALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20268',
    block_code: 218022,
    block_name: 'UPPALAGUPTAM',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180080',
    block_code: 1829004,
    block_name: 'CHIMUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50377',
    block_code: 513009,
    block_name: 'TURKAULIA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29025',
    district_code: 2921,
    district_name: 'THENI',
    block_id: 'B-290251',
    block_code: 2921005,
    block_name: 'BODINAICKANUR',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13006',
    district_code: 1306,
    district_name: 'KULLU',
    block_id: 'B-130037',
    block_code: 1306001,
    block_name: 'ANNI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24012',
    district_code: 2419,
    district_name: 'JAGATSINGHAPUR',
    block_id: 'B-240115',
    block_code: 2419006,
    block_name: 'KUJANG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360021',
    block_code: 3602004,
    block_name: 'ASWARAOPETA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34019',
    district_code: 3423,
    district_name: 'RAMGARH',
    block_id: 'B-340197',
    block_code: 3423004,
    block_name: 'MANDU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50269',
    block_code: 515010,
    block_name: 'MARWAN',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40176',
    block_code: 413095,
    block_name: 'RAHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31322',
    district_code: 3142,
    district_name: 'BANDA',
    block_id: 'B-313234',
    block_code: 3142003,
    block_name: 'BADOKHAR KHURD',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313687',
    block_code: 3144003,
    block_name: 'KUNDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27030',
    district_code: 2719,
    district_name: 'SIROHI',
    block_id: 'B-270317',
    block_code: 2719002,
    block_name: 'SIROHI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360424',
    block_code: 3624013,
    block_name: 'MOGUDAMPALLY',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140080',
    block_code: 1409024,
    block_name: 'DALI UDHYANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313501',
    block_code: 3158021,
    block_name: 'SUITHA KALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20259',
    block_code: 218014,
    block_name: 'MANDAPETA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180078',
    block_code: 1829006,
    block_name: 'BRAHMAPURI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50365',
    block_code: 513010,
    block_name: 'MOTIHARI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29025',
    district_code: 2921,
    district_name: 'THENI',
    block_id: 'B-290257',
    block_code: 2921007,
    block_name: 'UTHAMAPALAYAM',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13006',
    district_code: 1306,
    district_name: 'KULLU',
    block_id: 'B-130041',
    block_code: 1306004,
    block_name: 'NAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24012',
    district_code: 2419,
    district_name: 'JAGATSINGHAPUR',
    block_id: 'B-240113',
    block_code: 2419007,
    block_name: 'ERASAMA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360023',
    block_code: 3602006,
    block_name: 'BURGAMPAHAD',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34019',
    district_code: 3423,
    district_name: 'RAMGARH',
    block_id: 'B-340198',
    block_code: 3423005,
    block_name: 'PATRATU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50037',
    block_code: 517001,
    block_name: 'BACHHWARA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40177',
    block_code: 413005,
    block_name: 'RUPAHIHUT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31322',
    district_code: 3142,
    district_name: 'BANDA',
    block_id: 'B-313237',
    block_code: 3142005,
    block_name: 'KAMASIN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313692',
    block_code: 3144012,
    block_name: 'PATTI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360431',
    block_code: 3624020,
    block_name: 'RAIKODE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140072',
    block_code: 1409015,
    block_name: 'ASSAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313498',
    block_code: 3158022,
    block_name: 'SHAH GANJ',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20267',
    block_code: 218021,
    block_name: 'SAKHINETIPALLE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180084',
    block_code: 1829008,
    block_name: 'MUL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50351',
    block_code: 513012,
    block_name: 'ADAPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160057',
    block_code: 1613006,
    block_name: 'KOTTARAKKARA',
  },
  {
    state_id: 'S-11',
    state_code: 13,
    state_name: 'HIMACHAL PRADESH',
    district_id: 'D-13006',
    district_code: 1306,
    district_name: 'KULLU',
    block_id: 'B-130039',
    block_code: 1306006,
    block_name: 'BHUNTAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24012',
    district_code: 2419,
    district_name: 'JAGATSINGHAPUR',
    block_id: 'B-240111',
    block_code: 2419008,
    block_name: 'BALIKUDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360031',
    block_code: 3602014,
    block_name: 'KARAKAGUDEM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36033',
    district_code: 3631,
    district_name: 'YADADRI  BHONGIR',
    block_id: 'B-360533',
    block_code: 3631006,
    block_name: 'BOMMALA RAMARAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50054',
    block_code: 517018,
    block_name: 'TEGHRA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40172',
    block_code: 413001,
    block_name: 'KHAGORIJAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31322',
    district_code: 3142,
    district_name: 'BANDA',
    block_id: 'B-313235',
    block_code: 3142006,
    block_name: 'BISANDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313689',
    block_code: 3144016,
    block_name: 'LALGANJ',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360413',
    block_code: 3624002,
    block_name: 'ANDOLE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140087',
    block_code: 1409016,
    block_name: 'MARMAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31345',
    district_code: 3158,
    district_name: 'JAUNPUR',
    block_id: 'B-313488',
    block_code: 3158023,
    block_name: 'KARANJA KALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2011',
    district_code: 218,
    district_name: 'KONASEEMA',
    block_id: 'B-20261',
    block_code: 218008,
    block_name: 'PAMARRU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18008',
    district_code: 1829,
    district_name: 'CHANDRAPUR',
    block_id: 'B-180081',
    block_code: 1829009,
    block_name: 'GONDPIPRI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5027',
    district_code: 513,
    district_name: 'PURBI CHAMPARAN',
    block_id: 'B-50358',
    block_code: 513013,
    block_name: 'GHORASAHAN',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160060',
    block_code: 1613009,
    block_name: 'PATHANAPURAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11023',
    district_code: 1125,
    district_name: 'NAVSARI',
    block_id: 'B-110170',
    block_code: 1125005,
    block_name: 'VANSDA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50066',
    block_code: 527012,
    block_name: 'Rangra Chowk',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360018',
    block_code: 3602001,
    block_name: 'ALLAPALLI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3019',
    district_code: 301,
    district_name: 'TAWANG',
    block_id: 'B-30080',
    block_code: 301001,
    block_name: 'TAWANG',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50047',
    block_code: 517011,
    block_name: 'GARHPURA',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40167',
    block_code: 413002,
    block_name: 'BATADRABA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31322',
    district_code: 3142,
    district_name: 'BANDA',
    block_id: 'B-313238',
    block_code: 3142007,
    block_name: 'MAHUVA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313693',
    block_code: 3144018,
    block_name: 'PRATAPGARH-SADAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340001',
    block_code: 3420003,
    block_name: 'BERMO',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140082',
    block_code: 1409017,
    block_name: 'GUNDANA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340114',
    block_code: 3403011,
    block_name: 'PALKOT',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34016',
    district_code: 3402,
    district_name: 'LOHARDAGA',
    block_id: 'B-340164',
    block_code: 3402001,
    block_name: 'LOHARDAGA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17007',
    district_code: 1731,
    district_name: 'BETUL',
    block_id: 'B-170040',
    block_code: 1731001,
    block_name: 'BHIMPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18023',
    district_code: 1820,
    district_name: 'OSMANABAD',
    block_id: 'B-180221',
    block_code: 1820036,
    block_name: 'TULJAPUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160123',
    block_code: 1614002,
    block_name: 'CHIRAYINKEEZHU',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110221',
    block_code: 1103007,
    block_name: 'DHRANGADHRA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50055',
    block_code: 527001,
    block_name: 'Bihpur',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360019',
    block_code: 3602002,
    block_name: 'ANNAPUREDDYPALLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20556',
    block_code: 223014,
    block_name: 'NARAYANAVANAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5005',
    district_code: 517,
    district_name: 'BEGUSARAI',
    block_id: 'B-50048',
    block_code: 517012,
    block_name: 'KHUDABANDPUR',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40170',
    block_code: 413004,
    block_name: 'KALIABOR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313686',
    block_code: 3144001,
    block_name: 'KALAKANKAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313526',
    block_code: 3137001,
    block_name: 'KALYANPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340008',
    block_code: 3420004,
    block_name: 'NAWADIH',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140073',
    block_code: 1409007,
    block_name: 'BHADERWAH',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340107',
    block_code: 3403008,
    block_name: 'BHARNO',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34016',
    district_code: 3402,
    district_name: 'LOHARDAGA',
    block_id: 'B-340162',
    block_code: 3402002,
    block_name: 'KISKO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18023',
    district_code: 1820,
    district_name: 'OSMANABAD',
    block_id: 'B-180219',
    block_code: 1820037,
    block_name: 'OSMANABAD',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160125',
    block_code: 1614004,
    block_name: 'NEDUMANGAD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110222',
    block_code: 1103009,
    block_name: 'LAKHTAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50069',
    block_code: 527015,
    block_name: 'Sonhaula',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360032',
    block_code: 3602016,
    block_name: 'LAXMIDEVIPALLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20562',
    block_code: 223020,
    block_name: 'RAMACHANDRAPURAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50272',
    block_code: 515013,
    block_name: 'PAROO',
  },
  {
    state_id: 'S-04',
    state_code: 4,
    state_name: 'ASSAM',
    district_id: 'D-4027',
    district_code: 413,
    district_name: 'NAGAON',
    block_id: 'B-40173',
    block_code: 413006,
    block_name: 'LAWKHOWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313683',
    block_code: 3144002,
    block_name: 'BABAGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313528',
    block_code: 3137003,
    block_name: 'SARSOL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340004',
    block_code: 3420001,
    block_name: 'CHAS',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140088',
    block_code: 1409008,
    block_name: 'THATHRI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340113',
    block_code: 3403010,
    block_name: 'KAMDARA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34016',
    district_code: 3402,
    district_name: 'LOHARDAGA',
    block_id: 'B-340166',
    block_code: 3402003,
    block_name: 'SENHA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18023',
    district_code: 1820,
    district_name: 'OSMANABAD',
    block_id: 'B-180222',
    block_code: 1820038,
    block_name: 'WASHI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160052',
    block_code: 1613001,
    block_name: 'ANCHAL',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110226',
    block_code: 1103011,
    block_name: 'THANGADH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50057',
    block_code: 527003,
    block_name: 'Goradih',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360492',
    block_code: 3627008,
    block_name: 'KOTEPALLY',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20558',
    block_code: 223016,
    block_name: 'PAKALA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50275',
    block_code: 515016,
    block_name: 'SARAIYA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260060',
    block_code: 2607003,
    block_name: 'TALWARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313684',
    block_code: 3144004,
    block_name: 'BIHAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313525',
    block_code: 3137005,
    block_name: 'KAKWAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36027',
    district_code: 3624,
    district_name: 'SANGAREDDY',
    block_id: 'B-360432',
    block_code: 3624021,
    block_name: 'RAMCHANDRAPURAM',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140081',
    block_code: 1409006,
    block_name: 'DODA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34010',
    district_code: 3403,
    district_name: 'GUMLA',
    block_id: 'B-340105',
    block_code: 3403012,
    block_name: 'ALBERT EKKA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34016',
    district_code: 3402,
    district_name: 'LOHARDAGA',
    block_id: 'B-340163',
    block_code: 3402004,
    block_name: 'KURU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18023',
    district_code: 1820,
    district_name: 'OSMANABAD',
    block_id: 'B-180215',
    block_code: 1820031,
    block_name: 'BHOOM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160053',
    block_code: 1613002,
    block_name: 'CHADAYAMANGALAM',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11023',
    district_code: 1125,
    district_name: 'NAVSARI',
    block_id: 'B-110169',
    block_code: 1125001,
    block_name: 'NAVSARI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5006',
    district_code: 527,
    district_name: 'BHAGALPUR',
    block_id: 'B-50065',
    block_code: 527011,
    block_name: 'Pirpainti',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360024',
    block_code: 3602007,
    block_name: 'CHANDRUGONDA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20554',
    block_code: 223012,
    block_name: 'NAGALAPURAM',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50273',
    block_code: 515014,
    block_name: 'SAHEBGANJ',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260053',
    block_code: 2607001,
    block_name: 'DASUYA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313696',
    block_code: 3144005,
    block_name: 'SANGIPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31348',
    district_code: 3137,
    district_name: 'KANPUR NAGAR',
    block_id: 'B-313529',
    block_code: 3137006,
    block_name: 'SHIVRAJPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34001',
    district_code: 3420,
    district_name: 'BOKARO',
    block_id: 'B-340003',
    block_code: 3420009,
    block_name: 'CHANDRAPURA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14005',
    district_code: 1409,
    district_name: 'DODA',
    block_id: 'B-140074',
    block_code: 1409005,
    block_name: 'BHAGWAH',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27028',
    district_code: 2710,
    district_name: 'SAWAI MADHOPUR',
    block_id: 'B-270299',
    block_code: 2710007,
    block_name: 'MALARNA DOONGAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34016',
    district_code: 3402,
    district_name: 'LOHARDAGA',
    block_id: 'B-340160',
    block_code: 3402005,
    block_name: 'BHANDRA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180054',
    block_code: 1818008,
    block_name: 'SHIRUR KASAR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160054',
    block_code: 1613003,
    block_name: 'CHAVARA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11023',
    district_code: 1125,
    district_name: 'NAVSARI',
    block_id: 'B-110167',
    block_code: 1125002,
    block_name: 'JALALPORE',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360493',
    block_code: 3627009,
    block_name: 'KULKACHARLA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20570',
    block_code: 223028,
    block_name: 'VADAMALAPETA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5022',
    district_code: 515,
    district_name: 'MUZAFFARPUR',
    block_id: 'B-50266',
    block_code: 515007,
    block_name: 'KANTI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260052',
    block_code: 2607005,
    block_name: 'BHUNGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313694',
    block_code: 3144006,
    block_name: 'RAMPUR SANRAMGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31365',
    district_code: 3144,
    district_name: 'PRATAPGARH',
    block_id: 'B-313688',
    block_code: 3144007,
    block_name: 'LAKSHAMANPUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290368',
    block_code: 2904007,
    block_name: 'KOLIYANUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29026',
    district_code: 2912,
    district_name: 'THE NILGIRIS',
    block_id: 'B-290258',
    block_code: 2912002,
    block_name: 'COONOOR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34016',
    district_code: 3402,
    district_name: 'LOHARDAGA',
    block_id: 'B-340161',
    block_code: 3402006,
    block_name: 'KAIRO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180049',
    block_code: 1818002,
    block_name: 'GEORAI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160055',
    block_code: 1613004,
    block_name: 'CHITTUMALA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11023',
    district_code: 1125,
    district_name: 'NAVSARI',
    block_id: 'B-110166',
    block_code: 1125003,
    block_name: 'GANDEVI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360026',
    block_code: 3602009,
    block_name: 'CHUNCHUPALLI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20569',
    block_code: 223027,
    block_name: 'TIRUPATI (RURAL)',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3019',
    district_code: 301,
    district_name: 'TAWANG',
    block_id: 'B-30078',
    block_code: 301002,
    block_name: 'LUMLA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260058',
    block_code: 2607009,
    block_name: 'MAHILPUR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15002',
    district_code: 1505,
    district_name: 'BALLARI',
    block_id: 'B-150013',
    block_code: 1505006,
    block_name: 'SANDUR',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21012',
    district_code: 2103,
    district_name: 'WEST KHASI HILLS',
    block_id: 'B-210046',
    block_code: 2103003,
    block_name: 'NONGSTOIN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290367',
    block_code: 2904008,
    block_name: 'KANDAMANGALAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29026',
    district_code: 2912,
    district_name: 'THE NILGIRIS',
    block_id: 'B-290260',
    block_code: 2912003,
    block_name: 'KOTAGIRI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34016',
    district_code: 3402,
    district_name: 'LOHARDAGA',
    block_id: 'B-340165',
    block_code: 3402007,
    block_name: 'PESHRAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180052',
    block_code: 1818011,
    block_name: 'PARLI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160056',
    block_code: 1613005,
    block_name: 'ITHIKKARA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11023',
    district_code: 1125,
    district_name: 'NAVSARI',
    block_id: 'B-110165',
    block_code: 1125004,
    block_name: 'CHIKHALI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360037',
    block_code: 3602021,
    block_name: 'SUJATHANAGAR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20563',
    block_code: 223021,
    block_name: 'RENIGUNTA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3019',
    district_code: 301,
    district_name: 'TAWANG',
    block_id: 'B-30079',
    block_code: 301003,
    block_name: 'MUKTO-BONGKHAR',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260059',
    block_code: 2607002,
    block_name: 'MUKERIAN',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15002',
    district_code: 1505,
    district_name: 'BALLARI',
    block_id: 'B-150014',
    block_code: 1505007,
    block_name: 'SIRUGUPPA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21005',
    district_code: 2110,
    district_name: 'NORTH GARO HILLS',
    block_id: 'B-210020',
    block_code: 2110002,
    block_name: 'KHARKUTTA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290373',
    block_code: 2904010,
    block_name: 'OLAKKUR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29026',
    district_code: 2912,
    district_name: 'THE NILGIRIS',
    block_id: 'B-290259',
    block_code: 2912004,
    block_name: 'GUDALUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313698',
    block_code: 3145015,
    block_name: 'BAHADURPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180047',
    block_code: 1818001,
    block_name: 'BEED',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160058',
    block_code: 1613007,
    block_name: 'MUKHATHALA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110219',
    block_code: 1103010,
    block_name: 'CHUDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360028',
    block_code: 3602011,
    block_name: 'DUMMUGUDEM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20551',
    block_code: 223009,
    block_name: 'GUDUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3012',
    district_code: 324,
    district_name: 'LOWER SIANG',
    block_id: 'B-30050',
    block_code: 324003,
    block_name: 'GENSI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260054',
    block_code: 2607008,
    block_name: 'GARHSHANKAR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15002',
    district_code: 1505,
    district_name: 'BALLARI',
    block_id: 'B-150010',
    block_code: 1505001,
    block_name: 'BELLARY',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21005',
    district_code: 2110,
    district_name: 'NORTH GARO HILLS',
    block_id: 'B-210019',
    block_code: 2110003,
    block_name: 'BAJENGDOBA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290369',
    block_code: 2904011,
    block_name: 'MAILAM',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27028',
    district_code: 2710,
    district_name: 'SAWAI MADHOPUR',
    block_id: 'B-270300',
    block_code: 2710001,
    block_name: 'SAWAI MADHOPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313701',
    block_code: 3145022,
    block_name: 'CHAKA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18005',
    district_code: 1818,
    district_name: 'BEED',
    block_id: 'B-180051',
    block_code: 1818003,
    block_name: 'MAJALGAON',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160059',
    block_code: 1613008,
    block_name: 'OACHIRA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110227',
    block_code: 1103001,
    block_name: 'WADHWAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360029',
    block_code: 3602012,
    block_name: 'GUNDALA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20548',
    block_code: 223006,
    block_name: 'CHITTAMUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3012',
    district_code: 324,
    district_name: 'LOWER SIANG',
    block_id: 'B-30051',
    block_code: 324009,
    block_name: 'LIKABALI',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260061',
    block_code: 2607004,
    block_name: 'TANDA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11014',
    district_code: 1132,
    district_name: 'GIR SOMNATH',
    block_id: 'B-110102',
    block_code: 1132003,
    block_name: 'TALALA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21012',
    district_code: 2103,
    district_name: 'WEST KHASI HILLS',
    block_id: 'B-210045',
    block_code: 2103004,
    block_name: 'MAWSHYNRUT',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290376',
    block_code: 2904013,
    block_name: 'VANUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27028',
    district_code: 2710,
    district_name: 'SAWAI MADHOPUR',
    block_id: 'B-270298',
    block_code: 2710002,
    block_name: 'KHANDAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313702',
    block_code: 3145018,
    block_name: 'DHANUPUR',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22003',
    district_code: 2209,
    district_name: 'HNAHTHIAL',
    block_id: 'B-220007',
    block_code: 2209001,
    block_name: 'HNAHTHIAL',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16006',
    district_code: 1613,
    district_name: 'KOLLAM',
    block_id: 'B-160062',
    block_code: 1613011,
    block_name: 'VETTIKKAVALA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110223',
    block_code: 1103002,
    block_name: 'LIMBDI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360033',
    block_code: 3602017,
    block_name: 'MANUGURU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20564',
    block_code: 223022,
    block_name: 'SATYAVEDU',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3012',
    district_code: 324,
    district_name: 'LOWER SIANG',
    block_id: 'B-30052',
    block_code: 324001,
    block_name: 'RAMLE BANGO',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260055',
    block_code: 2607012,
    block_name: 'HAJIPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11014',
    district_code: 1132,
    district_name: 'GIR SOMNATH',
    block_id: 'B-110103',
    block_code: 1132015,
    block_name: 'UNA',
  },
  {
    state_id: 'S-19',
    state_code: 21,
    state_name: 'MEGHALAYA',
    district_id: 'D-21005',
    district_code: 2110,
    district_name: 'NORTH GARO HILLS',
    block_id: 'B-210021',
    block_code: 2110001,
    block_name: 'RESUBELPARA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290365',
    block_code: 2904014,
    block_name: 'GINGEE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27028',
    district_code: 2710,
    district_name: 'SAWAI MADHOPUR',
    block_id: 'B-270297',
    block_code: 2710003,
    block_name: 'GANGAPUR CITY',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313703',
    block_code: 3145019,
    block_name: 'HANDIA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320327',
    block_code: 3214003,
    block_name: 'HURA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180032',
    block_code: 1824002,
    block_name: 'MORSHI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110225',
    block_code: 1103003,
    block_name: 'SAYLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360036',
    block_code: 3602020,
    block_name: 'PINAPAKA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20561',
    block_code: 223019,
    block_name: 'PUTTUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3012',
    district_code: 324,
    district_name: 'LOWER SIANG',
    block_id: 'B-30129',
    block_code: 324010,
    block_name: 'KANGKU',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260056',
    block_code: 2607006,
    block_name: 'HOSHIARPUR I',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11014',
    district_code: 1132,
    district_name: 'GIR SOMNATH',
    block_id: 'B-110098',
    block_code: 1132018,
    block_name: 'GIRGADHADA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17031',
    district_code: 1734,
    district_name: 'NARSINGHPUR',
    block_id: 'B-170192',
    block_code: 1734001,
    block_name: 'GOTEGAON',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290374',
    block_code: 2904003,
    block_name: 'T.V. NALLUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27028',
    district_code: 2710,
    district_name: 'SAWAI MADHOPUR',
    block_id: 'B-270294',
    block_code: 2710004,
    block_name: 'BAMANWAS',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313704',
    block_code: 3145010,
    block_name: 'HOLAGARH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320336',
    block_code: 3214004,
    block_name: 'PUNCHA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180035',
    block_code: 1824003,
    block_name: 'WARUD',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110218',
    block_code: 1103004,
    block_name: 'CHOTILA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360025',
    block_code: 3602008,
    block_name: 'CHERLA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20571',
    block_code: 223029,
    block_name: 'VAKADU',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3019',
    district_code: 301,
    district_name: 'TAWANG',
    block_id: 'B-30076',
    block_code: 301004,
    block_name: 'JANG-THINGBU',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26009',
    district_code: 2607,
    district_name: 'HOSHIARPUR',
    block_id: 'B-260057',
    block_code: 2607007,
    block_name: 'HOSHIARPUR II',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11014',
    district_code: 1132,
    district_name: 'GIR SOMNATH',
    block_id: 'B-110099',
    block_code: 1132017,
    block_name: 'KODINAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17031',
    district_code: 1734,
    district_name: 'NARSINGHPUR',
    block_id: 'B-170195',
    block_code: 1734003,
    block_name: 'SAIKHEDA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290377',
    block_code: 2904009,
    block_name: 'VIKKIRAVANDI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27028',
    district_code: 2710,
    district_name: 'SAWAI MADHOPUR',
    block_id: 'B-270295',
    block_code: 2710005,
    block_name: 'BONLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313705',
    block_code: 3145020,
    block_name: 'JASRA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320326',
    block_code: 3214007,
    block_name: 'BUNDWAN',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180025',
    block_code: 1824007,
    block_name: 'BHATKULI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110224',
    block_code: 1103005,
    block_name: 'MULI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360027',
    block_code: 3602010,
    block_name: 'DAMMAPETA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20573',
    block_code: 223031,
    block_name: 'VENKATAGIRI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3019',
    district_code: 301,
    district_name: 'TAWANG',
    block_id: 'B-30077',
    block_code: 301005,
    block_name: 'KITPI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240105',
    block_code: 2412017,
    block_name: 'POLOSARA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11014',
    district_code: 1132,
    district_name: 'GIR SOMNATH',
    block_id: 'B-110100',
    block_code: 1132004,
    block_name: 'PATAN VERAVAL',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17031',
    district_code: 1734,
    district_name: 'NARSINGHPUR',
    block_id: 'B-170190',
    block_code: 1734004,
    block_name: 'BABAI CHICHLI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290371',
    block_code: 2904012,
    block_name: 'MERKANAM',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29026',
    district_code: 2912,
    district_name: 'THE NILGIRIS',
    block_id: 'B-290261',
    block_code: 2912001,
    block_name: 'UDHAGAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313707',
    block_code: 3145024,
    block_name: 'KAUDHIYARA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320322',
    block_code: 3214008,
    block_name: 'ARSHA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180029',
    block_code: 1824008,
    block_name: 'DARYAPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11023',
    district_code: 1125,
    district_name: 'NAVSARI',
    block_id: 'B-110168',
    block_code: 1125006,
    block_name: 'KHERGAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360039',
    block_code: 3602023,
    block_name: 'YELLANDU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20543',
    block_code: 223001,
    block_name: 'BALAYAPALLE',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3019',
    district_code: 301,
    district_name: 'TAWANG',
    block_id: 'B-30081',
    block_code: 301006,
    block_name: 'ZEMITHANG-DUDUNGKHAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240106',
    block_code: 2412018,
    block_name: 'PURUSHOTTAMPUR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11014',
    district_code: 1132,
    district_name: 'GIR SOMNATH',
    block_id: 'B-110101',
    block_code: 1132016,
    block_name: 'SUTRAPADA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12016',
    district_code: 1217,
    district_name: 'PANCHKULA',
    block_id: 'B-120102',
    block_code: 1217003,
    block_name: 'PINJORE',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290375',
    block_code: 2904015,
    block_name: 'VALLAM',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3018',
    district_code: 321,
    district_name: 'SIANG',
    block_id: 'B-30072',
    block_code: 321002,
    block_name: 'PANGIN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313708',
    block_code: 3145009,
    block_name: 'KAURIHAR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320324',
    block_code: 3214009,
    block_name: 'BALARAMPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180031',
    block_code: 1824010,
    block_name: 'DHARNI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11030',
    district_code: 1103,
    district_name: 'SURENDRANAGAR',
    block_id: 'B-110220',
    block_code: 1103008,
    block_name: 'DASADA PATDI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360484',
    block_code: 3627001,
    block_name: 'BANTWARAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20572',
    block_code: 223030,
    block_name: 'VARADAIAHPALEM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160039',
    block_code: 1602005,
    block_name: 'KANNUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240109',
    block_code: 2412021,
    block_name: 'SHERAGADA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17006',
    district_code: 1742,
    district_name: 'BARWANI',
    block_id: 'B-170034',
    block_code: 1742007,
    block_name: 'SENDHWA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12016',
    district_code: 1217,
    district_name: 'PANCHKULA',
    block_id: 'B-120101',
    block_code: 1217004,
    block_name: 'MORNI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290370',
    block_code: 2904016,
    block_name: 'MELMALAYANUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3018',
    district_code: 321,
    district_name: 'SIANG',
    block_id: 'B-30075',
    block_code: 321004,
    block_name: 'RUMGONG',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313710',
    block_code: 3145028,
    block_name: 'MANDA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320323',
    block_code: 3214010,
    block_name: 'BAGMUNDI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180028',
    block_code: 1824011,
    block_name: 'CHIKHALDARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27019',
    district_code: 2732,
    district_name: 'JHALAWAR',
    block_id: 'B-270204',
    block_code: 2732001,
    block_name: 'KHANPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360489',
    block_code: 3627005,
    block_name: 'DOMA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20566',
    block_code: 223024,
    block_name: 'SULLURPETA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160035',
    block_code: 1602001,
    block_name: 'EDAKKAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240110',
    block_code: 2412022,
    block_name: 'SURADA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17055',
    district_code: 1755,
    district_name: 'PANDHURNA',
    block_id: 'B-170073',
    block_code: 1755009,
    block_name: 'SAUSAR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12016',
    district_code: 1217,
    district_name: 'PANCHKULA',
    block_id: 'B-120100',
    block_code: 1217005,
    block_name: 'BARWALA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290372',
    block_code: 2904002,
    block_name: 'MUGAIYUR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3018',
    district_code: 321,
    district_name: 'SIANG',
    block_id: 'B-30071',
    block_code: 321001,
    block_name: 'KAYING-PAYUM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313712',
    block_code: 3145026,
    block_name: 'MEJA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320325',
    block_code: 3214011,
    block_name: 'BARABAZAR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180022',
    block_code: 1824014,
    block_name: 'ACHALPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27019',
    district_code: 2732,
    district_name: 'JHALAWAR',
    block_id: 'B-270203',
    block_code: 2732002,
    block_name: 'JHALRAPATAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360485',
    block_code: 3627002,
    block_name: 'BASHEERABAD',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20550',
    block_code: 223008,
    block_name: 'DORAVARISATRAM',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160036',
    block_code: 1602002,
    block_name: 'IRIKKUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50285',
    block_code: 502010,
    block_name: 'ISLAMPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17055',
    district_code: 1755,
    district_name: 'PANDHURNA',
    block_id: 'B-170071',
    block_code: 1755011,
    block_name: 'PANDHURNA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12016',
    district_code: 1217,
    district_name: 'PANCHKULA',
    block_id: 'B-120103',
    block_code: 1217002,
    block_name: 'RAIPURRANI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29036',
    district_code: 2904,
    district_name: 'VILLUPURAM',
    block_id: 'B-290366',
    block_code: 2904006,
    block_name: 'KANAI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3018',
    district_code: 321,
    district_name: 'SIANG',
    block_id: 'B-30073',
    block_code: 321003,
    block_name: 'REBO-PARGING',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313714',
    block_code: 3145016,
    block_name: 'PRATAPPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320335',
    block_code: 3214017,
    block_name: 'PARA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18003',
    district_code: 1824,
    district_name: 'AMRAVATI',
    block_id: 'B-180023',
    block_code: 1824016,
    block_name: 'AMRAVATI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27019',
    district_code: 2732,
    district_name: 'JHALAWAR',
    block_id: 'B-270200',
    block_code: 2732003,
    block_name: 'BAKANI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360498',
    block_code: 3627014,
    block_name: 'PEDDEMUL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20560',
    block_code: 223018,
    block_name: 'PITCHATUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160037',
    block_code: 1602003,
    block_name: 'IRITTY',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50292',
    block_code: 502017,
    block_name: 'RAJGIR',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15002',
    district_code: 1505,
    district_name: 'BALLARI',
    block_id: 'B-150011',
    block_code: 1505009,
    block_name: 'KAMPLI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17031',
    district_code: 1734,
    district_name: 'NARSINGHPUR',
    block_id: 'B-170191',
    block_code: 1734002,
    block_name: 'CHAWARPATHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313125',
    block_code: 3118003,
    block_name: 'KHAIR',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3018',
    district_code: 321,
    district_name: 'SIANG',
    block_id: 'B-30074',
    block_code: 321005,
    block_name: 'RIGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313716',
    block_code: 3145017,
    block_name: 'SAIDABAD',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320331',
    block_code: 3214018,
    block_name: 'KASHIPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18012',
    district_code: 1834,
    district_name: 'HINGOLI',
    block_id: 'B-180118',
    block_code: 1834006,
    block_name: 'KALAMNURI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27019',
    district_code: 2732,
    district_name: 'JHALAWAR',
    block_id: 'B-270205',
    block_code: 2732004,
    block_name: 'MANOHARTHANA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360020',
    block_code: 3602003,
    block_name: 'ASWAPURAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20544',
    block_code: 223002,
    block_name: 'BUCHINADIDU KHANDRIGA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160038',
    block_code: 1602004,
    block_name: 'KALLIASSERI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50289',
    block_code: 502014,
    block_name: 'NOORSARAI',
  },
  {
    state_id: 'S-13',
    state_code: 15,
    state_name: 'KARNATAKA',
    district_id: 'D-15002',
    district_code: 1505,
    district_name: 'BALLARI',
    block_id: 'B-150012',
    block_code: 1505011,
    block_name: 'KURUGODU',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5015',
    district_code: 524,
    district_name: 'KATIHAR',
    block_id: 'B-50193',
    block_code: 524014,
    block_name: 'MANSAHI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313127',
    block_code: 3118001,
    block_name: 'TAPPAL',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3018',
    district_code: 321,
    district_name: 'SIANG',
    block_id: 'B-30125',
    block_code: 321007,
    block_name: 'PAYUM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31366',
    district_code: 3145,
    district_name: 'PRAYAGRAJ',
    block_id: 'B-313718',
    block_code: 3145012,
    block_name: 'SORAON',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320334',
    block_code: 3214019,
    block_name: 'NETURIA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18012',
    district_code: 1834,
    district_name: 'HINGOLI',
    block_id: 'B-180119',
    block_code: 1834009,
    block_name: 'SENGAON',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27019',
    district_code: 2732,
    district_name: 'JHALAWAR',
    block_id: 'B-270202',
    block_code: 2732005,
    block_name: 'DAG',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360022',
    block_code: 3602005,
    block_name: 'BHADRACHALAM',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20574',
    block_code: 223032,
    block_name: 'YERPEDU',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160040',
    block_code: 1602006,
    block_name: 'KUTHUPARAMBA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50293',
    block_code: 502018,
    block_name: 'SARMERA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340258',
    block_code: 3408010,
    block_name: 'MANJHGAON',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370009',
    block_code: 3702012,
    block_name: 'PASHKUM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313119',
    block_code: 3118002,
    block_name: 'CHANDAUS',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3018',
    district_code: 321,
    district_name: 'SIANG',
    block_id: 'B-30070',
    block_code: 321006,
    block_name: 'BOLENG',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27023',
    district_code: 2730,
    district_name: 'KOTA',
    block_id: 'B-270249',
    block_code: 2730001,
    block_name: 'LADPURA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320328',
    block_code: 3214012,
    block_name: 'JAIPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18012',
    district_code: 1834,
    district_name: 'HINGOLI',
    block_id: 'B-180117',
    block_code: 1834010,
    block_name: 'HINGOLI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27019',
    district_code: 2732,
    district_name: 'JHALAWAR',
    block_id: 'B-270206',
    block_code: 2732006,
    block_name: 'PIRAWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360035',
    block_code: 3602019,
    block_name: 'PALVANCHA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20559',
    block_code: 223017,
    block_name: 'PELLAKUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160041',
    block_code: 1602007,
    block_name: 'PANOOR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50284',
    block_code: 502009,
    block_name: 'HILSA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340248',
    block_code: 3408001,
    block_name: 'CHAIBASA',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370010',
    block_code: 3702003,
    block_name: 'SANKOO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313124',
    block_code: 3118004,
    block_name: 'JAWAN SIKANDERPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27028',
    district_code: 2710,
    district_name: 'SAWAI MADHOPUR',
    block_id: 'B-270296',
    block_code: 2710006,
    block_name: 'CHAUTH KA BARWADA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27023',
    district_code: 2730,
    district_name: 'KOTA',
    block_id: 'B-270251',
    block_code: 2730002,
    block_name: 'SULTANPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320329',
    block_code: 3214013,
    block_name: 'JHALDA ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18034',
    district_code: 1826,
    district_name: 'WARDHA',
    block_id: 'B-180329',
    block_code: 1826001,
    block_name: 'WARDHA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27019',
    district_code: 2732,
    district_name: 'JHALAWAR',
    block_id: 'B-270201',
    block_code: 2732007,
    block_name: 'BHAWANI MANDI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360491',
    block_code: 3627007,
    block_name: 'KODANGAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20549',
    block_code: 223007,
    block_name: 'DAKKILI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160043',
    block_code: 1602009,
    block_name: 'PERAVOOR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50290',
    block_code: 502015,
    block_name: 'PARBALPUR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340254',
    block_code: 3408003,
    block_name: 'JHINKPANI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370002',
    block_code: 3702010,
    block_name: 'BHIMBAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313126',
    block_code: 3118005,
    block_name: 'LODHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31374',
    district_code: 3184,
    district_name: 'SHAMLI',
    block_id: 'B-313794',
    block_code: 3184001,
    block_name: 'KAIRANA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320330',
    block_code: 3214014,
    block_name: 'JHALDA TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18034',
    district_code: 1826,
    district_name: 'WARDHA',
    block_id: 'B-180328',
    block_code: 1826002,
    block_name: 'SELOO',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27019',
    district_code: 2732,
    district_name: 'JHALAWAR',
    block_id: 'B-270199',
    block_code: 2732008,
    block_name: 'AKLERA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360495',
    block_code: 3627011,
    block_name: 'MOMINPET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20555',
    block_code: 223013,
    block_name: 'NAIDUPETA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160044',
    block_code: 1602011,
    block_name: 'TALIPARAMBA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50277',
    block_code: 502002,
    block_name: 'BEN',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340263',
    block_code: 3408004,
    block_name: 'TONTO',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17006',
    district_code: 1742,
    district_name: 'BARWANI',
    block_id: 'B-170030',
    block_code: 1742006,
    block_name: 'NIWALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313120',
    block_code: 3118006,
    block_name: 'DHANIPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31374',
    district_code: 3184,
    district_name: 'SHAMLI',
    block_id: 'B-313797',
    block_code: 3184002,
    block_name: 'SHAMLI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320337',
    block_code: 3214001,
    block_name: 'PURULIA ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18034',
    district_code: 1826,
    district_name: 'WARDHA',
    block_id: 'B-180327',
    block_code: 1826003,
    block_name: 'SAMUDRAPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31343',
    district_code: 3166,
    district_name: 'HATHRAS',
    block_id: 'B-313468',
    block_code: 3166003,
    block_name: 'MURSAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360496',
    block_code: 3627012,
    block_name: 'NAWABPET',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20546',
    block_code: 223004,
    block_name: 'CHILLAKUR',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160042',
    block_code: 1602008,
    block_name: 'PAYYANUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50276',
    block_code: 502001,
    block_name: 'ASTHAWAN',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340262',
    block_code: 3408005,
    block_name: 'TANTNAGAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17006',
    district_code: 1742,
    district_name: 'BARWANI',
    block_id: 'B-170029',
    block_code: 1742001,
    block_name: 'BARWANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313122',
    block_code: 3118007,
    block_name: 'GONDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31374',
    district_code: 3184,
    district_name: 'SHAMLI',
    block_id: 'B-313795',
    block_code: 3184003,
    block_name: 'KANDHALA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320338',
    block_code: 3214002,
    block_name: 'PURULIA TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18034',
    district_code: 1826,
    district_name: 'WARDHA',
    block_id: 'B-180325',
    block_code: 1826004,
    block_name: 'HINGANGHAT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31343',
    district_code: 3166,
    district_name: 'HATHRAS',
    block_id: 'B-313471',
    block_code: 3166005,
    block_name: 'SEHPAU',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360488',
    block_code: 3627004,
    block_name: 'DHARUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20557',
    block_code: 223015,
    block_name: 'OZILI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16004',
    district_code: 1602,
    district_name: 'KANNUR',
    block_id: 'B-160045',
    block_code: 1602010,
    block_name: 'THALASSERI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50278',
    block_code: 502003,
    block_name: 'BIHAR',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340257',
    block_code: 3408006,
    block_name: 'MANJHARI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17006',
    district_code: 1742,
    district_name: 'BARWANI',
    block_id: 'B-170032',
    block_code: 1742002,
    block_name: 'PATI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313118',
    block_code: 3118013,
    block_name: 'BIJAULI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31374',
    district_code: 3184,
    district_name: 'SHAMLI',
    block_id: 'B-313798',
    block_code: 3184004,
    block_name: 'THANABHAWAN',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320332',
    block_code: 3214005,
    block_name: 'MANBAZAR ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18034',
    district_code: 1826,
    district_name: 'WARDHA',
    block_id: 'B-180324',
    block_code: 1826005,
    block_name: 'DEOLI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31343',
    district_code: 3166,
    district_name: 'HATHRAS',
    block_id: 'B-313466',
    block_code: 3166007,
    block_name: 'HASAYAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360497',
    block_code: 3627013,
    block_name: 'PARGI',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20567',
    block_code: 223025,
    block_name: 'TADA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320146',
    block_code: 3206002,
    block_name: 'POLBA-DADPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240095',
    block_code: 2412007,
    block_name: 'CHIKITI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340253',
    block_code: 3408007,
    block_name: 'JAGANNATHPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17006',
    district_code: 1742,
    district_name: 'BARWANI',
    block_id: 'B-170035',
    block_code: 1742003,
    block_name: 'THIKRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313121',
    block_code: 3118014,
    block_name: 'GANGIRI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180097',
    block_code: 1830012,
    block_name: 'BHAMRAGAD',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320339',
    block_code: 3214015,
    block_name: 'RAGHUNATH PUR ONE',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18034',
    district_code: 1826,
    district_name: 'WARDHA',
    block_id: 'B-180322',
    block_code: 1826006,
    block_name: 'ARVI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313359',
    block_code: 3143001,
    block_name: 'DEVMAI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360499',
    block_code: 3627015,
    block_name: 'PUDUR',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20545',
    block_code: 223003,
    block_name: 'CHANDRAGIRI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320138',
    block_code: 3206003,
    block_name: 'DHANIAKHALI',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50282',
    block_code: 502007,
    block_name: 'GIRIAK',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340260',
    block_code: 3408008,
    block_name: 'NOAMUNDI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17006',
    district_code: 1742,
    district_name: 'BARWANI',
    block_id: 'B-170033',
    block_code: 1742004,
    block_name: 'RAJPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313116',
    block_code: 3118015,
    block_name: 'AKRABAD',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180102',
    block_code: 1830001,
    block_name: 'GADCHIROLI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320333',
    block_code: 3214006,
    block_name: 'MANBAZAR TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18034',
    district_code: 1826,
    district_name: 'WARDHA',
    block_id: 'B-180323',
    block_code: 1826007,
    block_name: 'ASHTI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313364',
    block_code: 3143002,
    block_name: 'MALWAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360494',
    block_code: 3627010,
    block_name: 'MARPALLY',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20565',
    block_code: 223023,
    block_name: 'SRIKALAHASTI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320145',
    block_code: 3206004,
    block_name: 'PANDUA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50288',
    block_code: 502013,
    block_name: 'NAGAR NAUSA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340246',
    block_code: 3408016,
    block_name: 'ANANDPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17006',
    district_code: 1742,
    district_name: 'BARWANI',
    block_id: 'B-170031',
    block_code: 1742005,
    block_name: 'PANSEMAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313123',
    block_code: 3118008,
    block_name: 'IGLAS',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180096',
    block_code: 1830002,
    block_name: 'ARMORI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320340',
    block_code: 3214016,
    block_name: 'RAGHUNATHPUR TWO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18034',
    district_code: 1826,
    district_name: 'WARDHA',
    block_id: 'B-180326',
    block_code: 1826008,
    block_name: 'KARANJA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313355',
    block_code: 3143003,
    block_name: 'AMAULI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360502',
    block_code: 3627018,
    block_name: 'YALAL',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20568',
    block_code: 223026,
    block_name: 'THOTTAMBEDU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320134',
    block_code: 3206005,
    block_name: 'BALAGARH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50279',
    block_code: 502004,
    block_name: 'BIND',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340251',
    block_code: 3408017,
    block_name: 'GUDRI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20012',
    district_code: 2001,
    district_name: 'SENAPATI',
    block_id: 'B-200056',
    block_code: 2001006,
    block_name: 'TADUBI MAO-MARAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31312',
    district_code: 3118,
    district_name: 'ALIGARH',
    block_id: 'B-313117',
    block_code: 3118012,
    block_name: 'ATRAULI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180104',
    block_code: 1830003,
    block_name: 'KURKHEDA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32023',
    district_code: 3214,
    district_name: 'PURULIA',
    block_id: 'B-320341',
    block_code: 3214020,
    block_name: 'SANTURI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160124',
    block_code: 1614003,
    block_name: 'KILIMANOOR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313363',
    block_code: 3143004,
    block_name: 'KHAJUHA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360486',
    block_code: 3627003,
    block_name: 'BOMRASPETA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20575',
    block_code: 223033,
    block_name: 'YERRAVARIPALEM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320149',
    block_code: 3206006,
    block_name: 'SINGUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50291',
    block_code: 502016,
    block_name: 'RAHUI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340255',
    block_code: 3408002,
    block_name: 'KHUNTPANI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20012',
    district_code: 2001,
    district_name: 'SENAPATI',
    block_id: 'B-200053',
    block_code: 2001009,
    block_name: 'PHAIBUNG KHULLEN',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180010',
    block_code: 1809002,
    block_name: 'RAHURI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180100',
    block_code: 1830004,
    block_name: 'DHANORA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32024',
    district_code: 3204,
    district_name: 'SILIGURI MAHAKUMA PARISHAD DMMU ',
    block_id: 'B-320345',
    block_code: 3204003,
    block_name: 'PHANSIDEWA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16012',
    district_code: 1614,
    district_name: 'THIRUVANANTHAPURAM',
    block_id: 'B-160126',
    block_code: 1614005,
    block_name: 'NEMOM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313365',
    block_code: 3143005,
    block_name: 'TELYANI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360030',
    block_code: 3602013,
    block_name: 'JULURUPADU',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20552',
    block_code: 223011,
    block_name: 'KOTA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320141',
    block_code: 3206007,
    block_name: 'HARIPAL',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50294',
    block_code: 502019,
    block_name: 'SILAO',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340249',
    block_code: 3408011,
    block_name: 'CHAKRADHARPUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20012',
    district_code: 2001,
    district_name: 'SENAPATI',
    block_id: 'B-200057',
    block_code: 2001008,
    block_name: 'WILLONG',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180014',
    block_code: 1809003,
    block_name: 'SHRIRAMPUR',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180101',
    block_code: 1830005,
    block_name: 'ETAPALLI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32024',
    district_code: 3204,
    district_name: 'SILIGURI MAHAKUMA PARISHAD DMMU ',
    block_id: 'B-320344',
    block_code: 3204010,
    block_name: 'NAXALBARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313597',
    block_code: 3152009,
    block_name: 'PANIYARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313358',
    block_code: 3143006,
    block_name: 'BHITAURA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360034',
    block_code: 3602018,
    block_name: 'MULAKALAPALLY',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20553',
    block_code: 223010,
    block_name: 'K V B PURAM',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320150',
    block_code: 3206008,
    block_name: 'TARAKESWAR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50281',
    block_code: 502006,
    block_name: 'EKANGARSARAI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340247',
    block_code: 3408012,
    block_name: 'BANDGAON',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20012',
    district_code: 2001,
    district_name: 'SENAPATI',
    block_id: 'B-200052',
    block_code: 2001001,
    block_name: 'PAOMATA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180006',
    block_code: 1809004,
    block_name: 'NEVASA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180106',
    block_code: 1830006,
    block_name: 'SIRONCHA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32024',
    district_code: 3204,
    district_name: 'SILIGURI MAHAKUMA PARISHAD DMMU ',
    block_id: 'B-320343',
    block_code: 3204009,
    block_name: 'MATIGARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313589',
    block_code: 3152006,
    block_name: 'BRIDGEMANGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313361',
    block_code: 3143007,
    block_name: 'HASWA',
  },
  {
    state_id: 'S-02',
    state_code: 2,
    state_name: 'ANDHRA PRADESH',
    district_id: 'D-2022',
    district_code: 223,
    district_name: 'TIRUPATI',
    block_id: 'B-20547',
    block_code: 223005,
    block_name: 'CHINNAGOTTIGALLU',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320133',
    block_code: 3206015,
    block_name: 'ARAMBAGH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50283',
    block_code: 502008,
    block_name: 'HARNAUT',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340259',
    block_code: 3408013,
    block_name: 'MANOHARPUR',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20012',
    district_code: 2001,
    district_name: 'SENAPATI',
    block_id: 'B-200054',
    block_code: 2001005,
    block_name: 'PURUL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180012',
    block_code: 1809005,
    block_name: 'SHEVGAON',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180095',
    block_code: 1830007,
    block_name: 'AHERI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32024',
    district_code: 3204,
    district_name: 'SILIGURI MAHAKUMA PARISHAD DMMU ',
    block_id: 'B-320342',
    block_code: 3204004,
    block_name: 'KHORIBARI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313598',
    block_code: 3152010,
    block_name: 'PARTAWAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313357',
    block_code: 3143008,
    block_name: 'BAHUA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360008',
    block_code: 3601009,
    block_name: 'ICHODA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320147',
    block_code: 3206018,
    block_name: 'PURSURAH',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50286',
    block_code: 502011,
    block_name: 'KARAI PARSURAI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340261',
    block_code: 3408014,
    block_name: 'SONUA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20012',
    district_code: 2001,
    district_name: 'SENAPATI',
    block_id: 'B-200055',
    block_code: 2001015,
    block_name: 'SONG SONG TD BLOCK',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180008',
    block_code: 1809006,
    block_name: 'PATHARDI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180098',
    block_code: 1830008,
    block_name: 'CHAMORSHI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33027',
    district_code: 3316,
    district_name: 'RAIPUR',
    block_id: 'B-330118',
    block_code: 3316012,
    block_name: 'DHARSIWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313593',
    block_code: 3152007,
    block_name: 'MAHRAJGANJ',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313362',
    block_code: 3143010,
    block_name: 'HATHGAON',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360013',
    block_code: 3601014,
    block_name: 'NERADIGONDA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320142',
    block_code: 3206012,
    block_name: 'JANGIPARA',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50280',
    block_code: 502005,
    block_name: 'CHANDI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340256',
    block_code: 3408009,
    block_name: 'KUMARDUNGI',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12002',
    district_code: 1213,
    district_name: 'BHIWANI',
    block_id: 'B-120010',
    block_code: 1213009,
    block_name: 'KAIRU',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18001',
    district_code: 1809,
    district_name: 'AHMEDNAGAR',
    block_id: 'B-180002',
    block_code: 1809007,
    block_name: 'JAMKHED',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180105',
    block_code: 1830009,
    block_name: 'MULCHERA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33033',
    district_code: 3305,
    district_name: 'SURGUJA',
    block_id: 'B-330146',
    block_code: 3305003,
    block_name: 'UDAIPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270149',
    block_code: 2727008,
    block_name: 'JOTHALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313366',
    block_code: 3143012,
    block_name: 'VIJAYIPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360016',
    block_code: 3601017,
    block_name: 'TAMSI',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32019',
    district_code: 3222,
    district_name: 'PASCHIM BARDHAMAN',
    block_id: 'B-320247',
    block_code: 3222014,
    block_name: 'DURGAPUR FARIDPUR',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50295',
    block_code: 502020,
    block_name: 'THARTHARI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340252',
    block_code: 3408018,
    block_name: 'HATGAMHARIA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12002',
    district_code: 1213,
    district_name: 'BHIWANI',
    block_id: 'B-120008',
    block_code: 1213010,
    block_name: 'BEHAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180103',
    block_code: 1830010,
    block_name: 'KORCHI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33033',
    district_code: 3305,
    district_name: 'SURGUJA',
    block_id: 'B-330141',
    block_code: 3305007,
    block_name: 'BATAULI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270145',
    block_code: 2727007,
    block_name: 'CHIKHALI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31333',
    district_code: 3143,
    district_name: 'FATEHPUR',
    block_id: 'B-313360',
    block_code: 3143013,
    block_name: 'DHATA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360010',
    block_code: 3601011,
    block_name: 'JAINATH',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320139',
    block_code: 3206013,
    block_name: 'GOGHAT ONE',
  },
  {
    state_id: 'S-05',
    state_code: 5,
    state_name: 'BIHAR',
    district_id: 'D-5023',
    district_code: 502,
    district_name: 'NALANDA',
    block_id: 'B-50287',
    block_code: 502012,
    block_name: 'KATRISARAI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34024',
    district_code: 3408,
    district_name: 'WEST SINGHBHUM',
    block_id: 'B-340250',
    block_code: 3408015,
    block_name: 'GOILKERA',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12002',
    district_code: 1213,
    district_name: 'BHIWANI',
    block_id: 'B-120007',
    block_code: 1213001,
    block_name: 'BAWANI KHERA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31374',
    district_code: 3184,
    district_name: 'SHAMLI',
    block_id: 'B-313796',
    block_code: 3184005,
    block_name: 'OON',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33027',
    district_code: 3316,
    district_name: 'RAIPUR',
    block_id: 'B-330117',
    block_code: 3316015,
    block_name: 'ARANG',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270147',
    block_code: 2727001,
    block_name: 'DUNGARPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360281',
    block_code: 3618004,
    block_name: 'CHANDUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360003',
    block_code: 3601004,
    block_name: 'BELA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320140',
    block_code: 3206014,
    block_name: 'GOGHAT TWO',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26021',
    district_code: 2619,
    district_name: 'SAS NAGAR',
    block_id: 'B-260138',
    block_code: 2619005,
    block_name: 'KHARAR',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370003',
    block_code: 3702002,
    block_name: 'DRASS',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12002',
    district_code: 1213,
    district_name: 'BHIWANI',
    block_id: 'B-120009',
    block_code: 1213002,
    block_name: 'BHIWANI',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18010',
    district_code: 1830,
    district_name: 'GADCHIROLI',
    block_id: 'B-180099',
    block_code: 1830011,
    block_name: 'DESAIGANJ',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33027',
    district_code: 3316,
    district_name: 'RAIPUR',
    block_id: 'B-330119',
    block_code: 3316007,
    block_name: 'TILDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270143',
    block_code: 2727002,
    block_name: 'ASPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360307',
    block_code: 3618029,
    block_name: 'TRIPURARAM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360001',
    block_code: 3601002,
    block_name: 'ADILABAD RURAL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320148',
    block_code: 3206009,
    block_name: 'SERAMPORE-UTTARPARA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26021',
    district_code: 2619,
    district_name: 'SAS NAGAR',
    block_id: 'B-260137',
    block_code: 2619007,
    block_name: 'DERA BASSI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370013',
    block_code: 3702015,
    block_name: 'SODH',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12002',
    district_code: 1213,
    district_name: 'BHIWANI',
    block_id: 'B-120011',
    block_code: 1213006,
    block_name: 'LOHARU',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33015',
    district_code: 3310,
    district_name: 'KANKER',
    block_id: 'B-330071',
    block_code: 3310008,
    block_name: 'DURGUKONDAL',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33027',
    district_code: 3316,
    district_name: 'RAIPUR',
    block_id: 'B-330116',
    block_code: 3316008,
    block_name: 'ABHANPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270151',
    block_code: 2727003,
    block_name: 'SAGWARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360308',
    block_code: 3618031,
    block_name: 'VEMULA PALLY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360011',
    block_code: 3601012,
    block_name: 'MAVALA ',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320143',
    block_code: 3206016,
    block_name: 'KHANAKUL ONE',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26021',
    district_code: 2619,
    district_name: 'SAS NAGAR',
    block_id: 'B-260139',
    block_code: 2619006,
    block_name: 'MAJRI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370015',
    block_code: 3702006,
    block_name: 'ZANSKAR',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12002',
    district_code: 1213,
    district_name: 'BHIWANI',
    block_id: 'B-120013',
    block_code: 1213007,
    block_name: 'TOSHAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33015',
    district_code: 3310,
    district_name: 'KANKER',
    block_id: 'B-330073',
    block_code: 3310009,
    block_name: 'KOILEBEDA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33033',
    district_code: 3305,
    district_name: 'SURGUJA',
    block_id: 'B-330140',
    block_code: 3305001,
    block_name: 'AMBIKAPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270152',
    block_code: 2727004,
    block_name: 'SIMALWARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360280',
    block_code: 3618003,
    block_name: 'CHANDAMPET',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360017',
    block_code: 3601018,
    block_name: 'UTNOOR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32019',
    district_code: 3222,
    district_name: 'PASCHIM BARDHAMAN',
    block_id: 'B-320248',
    block_code: 3222017,
    block_name: 'JAMURIA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26021',
    district_code: 2619,
    district_name: 'SAS NAGAR',
    block_id: 'B-260140',
    block_code: 2619008,
    block_name: 'MOHALI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370012',
    block_code: 3702004,
    block_name: 'SHARGOL',
  },
  {
    state_id: 'S-10',
    state_code: 12,
    state_name: 'HARYANA',
    district_id: 'D-12002',
    district_code: 1213,
    district_name: 'BHIWANI',
    block_id: 'B-120012',
    block_code: 1213008,
    block_name: 'SIWANI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33015',
    district_code: 3310,
    district_name: 'KANKER',
    block_id: 'B-330068',
    block_code: 3310010,
    block_name: 'ANTAGARH',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33033',
    district_code: 3305,
    district_name: 'SURGUJA',
    block_id: 'B-330142',
    block_code: 3305002,
    block_name: 'LAKHANPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270144',
    block_code: 2727005,
    block_name: 'BICHHIWARA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360301',
    block_code: 3618024,
    block_name: 'NIDAMANOOR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360004',
    block_code: 3601005,
    block_name: 'BHEEMPUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32019',
    district_code: 3222,
    district_name: 'PASCHIM BARDHAMAN',
    block_id: 'B-320246',
    block_code: 3222019,
    block_name: 'BARABANI',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370008',
    block_code: 3702008,
    block_name: 'LUNGNAK',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260009',
    block_code: 2602005,
    block_name: 'VERKA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33015',
    district_code: 3310,
    district_name: 'KANKER',
    block_id: 'B-330070',
    block_code: 3310011,
    block_name: 'CHARAMA',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33033',
    district_code: 3305,
    district_name: 'SURGUJA',
    block_id: 'B-330143',
    block_code: 3305005,
    block_name: 'LUNDRA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270148',
    block_code: 2727006,
    block_name: 'GALIYAKOT',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360299',
    block_code: 3618022,
    block_name: 'NARKETPALLY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360006',
    block_code: 3601007,
    block_name: 'GADIGUDA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32019',
    district_code: 3222,
    district_name: 'PASCHIM BARDHAMAN',
    block_id: 'B-320250',
    block_code: 3222035,
    block_name: 'PANDAVESWAR',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370004',
    block_code: 3702009,
    block_name: 'GM PORA TRESPONE',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260003',
    block_code: 2602002,
    block_name: 'CHOGAWAN',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33015',
    district_code: 3310,
    district_name: 'KANKER',
    block_id: 'B-330069',
    block_code: 3310012,
    block_name: 'BHANUPRATAPPUR',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33033',
    district_code: 3305,
    district_name: 'SURGUJA',
    block_id: 'B-330145',
    block_code: 3305006,
    block_name: 'SITAPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270146',
    block_code: 2727009,
    block_name: 'DOBDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360282',
    block_code: 3618005,
    block_name: 'CHINTHA PALLY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36001',
    district_code: 3601,
    district_name: 'ADILABAD',
    block_id: 'B-360014',
    block_code: 3601015,
    block_name: 'SIRIKONDA',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320135',
    block_code: 3206010,
    block_name: 'CHANDITALA ONE',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370005',
    block_code: 3702001,
    block_name: 'KARGIL',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260005',
    block_code: 2602003,
    block_name: 'JANDIALA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27014',
    district_code: 2727,
    district_name: 'DUNGARPUR',
    block_id: 'B-270150',
    block_code: 2727010,
    block_name: 'SAABLA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360286',
    block_code: 3618009,
    block_name: 'GUNDLAPALLY DINDI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36002',
    district_code: 3602,
    district_name: 'BADRADRI',
    block_id: 'B-360038',
    block_code: 3602022,
    block_name: 'TEKULAPALLY',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320144',
    block_code: 3206017,
    block_name: 'KHANAKUL TWO',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370011',
    block_code: 3702005,
    block_name: 'SHAKER-CHAKTAN',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260006',
    block_code: 2602004,
    block_name: 'MAJITHA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313599',
    block_code: 3152013,
    block_name: 'PHARENDA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360302',
    block_code: 3618025,
    block_name: 'PEDDA ADISERLA PALLY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360490',
    block_code: 3627006,
    block_name: 'DOULATABAD',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32019',
    district_code: 3222,
    district_name: 'PASCHIM BARDHAMAN',
    block_id: 'B-320252',
    block_code: 3222020,
    block_name: 'SALANPUR',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370014',
    block_code: 3702007,
    block_name: 'TAISURU',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260007',
    block_code: 2602006,
    block_name: 'RAYYA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18011',
    district_code: 1833,
    district_name: 'GONDIA',
    block_id: 'B-180110',
    block_code: 1833001,
    block_name: 'GONDIA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360291',
    block_code: 3618014,
    block_name: 'KONDAMALLEPALLY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360500',
    block_code: 3627016,
    block_name: 'TANDUR',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32019',
    district_code: 3222,
    district_name: 'PASCHIM BARDHAMAN',
    block_id: 'B-320245',
    block_code: 3222015,
    block_name: 'ANDAL',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370001',
    block_code: 3702013,
    block_name: 'BARSOO',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260008',
    block_code: 2602007,
    block_name: 'TARSIKKA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18011',
    district_code: 1833,
    district_name: 'GONDIA',
    block_id: 'B-180112',
    block_code: 1833006,
    block_name: 'SADAK ARJUNI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360303',
    block_code: 3618026,
    block_name: 'PEDDAVOORA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36030',
    district_code: 3627,
    district_name: 'VIKARABAD',
    block_id: 'B-360501',
    block_code: 3627017,
    block_name: 'VIKARABAD',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32019',
    district_code: 3222,
    district_name: 'PASCHIM BARDHAMAN',
    block_id: 'B-320249',
    block_code: 3222013,
    block_name: 'KANKSA',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370006',
    block_code: 3702014,
    block_name: 'KARSHA',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260004',
    block_code: 2602016,
    block_name: 'HARSHA CHHINA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313591',
    block_code: 3152008,
    block_name: 'GHUGHULI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360288',
    block_code: 3618011,
    block_name: 'KANAGAL',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290216',
    block_code: 2925002,
    block_name: 'KALAIYARKOIL',
  },
  {
    state_id: 'S-30',
    state_code: 32,
    state_name: 'WEST BENGAL',
    district_id: 'D-32010',
    district_code: 3206,
    district_name: 'HOOGHLY',
    block_id: 'B-320136',
    block_code: 3206011,
    block_name: 'CHANDITALA TWO',
  },
  {
    state_id: 'S-35',
    state_code: 37,
    state_name: 'LADAKH',
    district_id: 'D-37001',
    district_code: 3702,
    district_name: 'KARGIL',
    block_id: 'B-370007',
    block_code: 3702011,
    block_name: 'LOTCHUM',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260001',
    block_code: 2602001,
    block_name: 'AJNALA',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16014',
    district_code: 1603,
    district_name: 'WAYANAD',
    block_id: 'B-160150',
    block_code: 1603002,
    block_name: 'MANANTHAVADY',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36020',
    district_code: 3618,
    district_name: 'NALGONDA',
    block_id: 'B-360298',
    block_code: 3618021,
    block_name: 'NAMPALLY',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290221',
    block_code: 2925007,
    block_name: 'SINGAMPUNARI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340224',
    block_code: 3413001,
    block_name: 'SAHIBGANJ',
  },
  {
    state_id: 'S-24',
    state_code: 26,
    state_name: 'PUNJAB',
    district_id: 'D-26001',
    district_code: 2602,
    district_name: 'AMRITSAR',
    block_id: 'B-260002',
    block_code: 2602017,
    block_name: 'ATTARI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16014',
    district_code: 1603,
    district_name: 'WAYANAD',
    block_id: 'B-160149',
    block_code: 1603001,
    block_name: 'KALPETTA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3006',
    district_code: 320,
    district_name: 'KRA DAADI',
    block_id: 'B-30026',
    block_code: 320001,
    block_name: 'CHAMBANG',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290220',
    block_code: 2925008,
    block_name: 'SAKKOTTAI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340221',
    block_code: 3413002,
    block_name: 'MANDRO',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16014',
    district_code: 1603,
    district_name: 'WAYANAD',
    block_id: 'B-160151',
    block_code: 1603003,
    block_name: 'PANAMARAM',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3006',
    district_code: 320,
    district_name: 'KRA DAADI',
    block_id: 'B-30028',
    block_code: 320003,
    block_name: 'PALIN',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290217',
    block_code: 2925009,
    block_name: 'KALLAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340225',
    block_code: 3413005,
    block_name: 'TALJHARI',
  },
  {
    state_id: 'S-14',
    state_code: 16,
    state_name: 'KERALA',
    district_id: 'D-16014',
    district_code: 1603,
    district_name: 'WAYANAD',
    block_id: 'B-160152',
    block_code: 1603004,
    block_name: 'SULTHAN BATHERY',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3006',
    district_code: 320,
    district_name: 'KRA DAADI',
    block_id: 'B-30030',
    block_code: 320005,
    block_name: 'TALI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270047',
    block_code: 2717018,
    block_name: 'AADEL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340223',
    block_code: 3413006,
    block_name: 'RAJMAHAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18011',
    district_code: 1833,
    district_name: 'GONDIA',
    block_id: 'B-180111',
    block_code: 1833003,
    block_name: 'GOREGAON',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3006',
    district_code: 320,
    district_name: 'KRA DAADI',
    block_id: 'B-30027',
    block_code: 320002,
    block_name: 'GANGTE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270050',
    block_code: 2717019,
    block_name: 'BARMER RURAL',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340226',
    block_code: 3413007,
    block_name: 'UDHWA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18011',
    district_code: 1833,
    district_name: 'GONDIA',
    block_id: 'B-180107',
    block_code: 1833004,
    block_name: 'AMGAON',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3006',
    district_code: 320,
    district_name: 'KRA DAADI',
    block_id: 'B-30029',
    block_code: 320004,
    block_name: 'PIPSORANG',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270055',
    block_code: 2717020,
    block_name: 'FAGLIYA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340222',
    block_code: 3413008,
    block_name: 'PATHNA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18011',
    district_code: 1833,
    district_name: 'GONDIA',
    block_id: 'B-180113',
    block_code: 1833005,
    block_name: 'SALEKASA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3006',
    district_code: 320,
    district_name: 'KRA DAADI',
    block_id: 'B-30031',
    block_code: 320006,
    block_name: 'YANGTE',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270060',
    block_code: 2717021,
    block_name: 'PANYLA KLA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340219',
    block_code: 3413009,
    block_name: 'BARHARWA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18011',
    district_code: 1833,
    district_name: 'GONDIA',
    block_id: 'B-180108',
    block_code: 1833007,
    block_name: 'ARJUNI MORGAON',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22007',
    district_code: 2202,
    district_name: 'LUNGLEI',
    block_id: 'B-220015',
    block_code: 2202005,
    block_name: 'BUNGHMUN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270057',
    block_code: 2717015,
    block_name: 'GIDA',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340220',
    block_code: 3413003,
    block_name: 'BORIO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18011',
    district_code: 1833,
    district_name: 'GONDIA',
    block_id: 'B-180109',
    block_code: 1833008,
    block_name: 'DEORI',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22007',
    district_code: 2202,
    district_name: 'LUNGLEI',
    block_id: 'B-220017',
    block_code: 2202002,
    block_name: 'LUNGSEN',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270063',
    block_code: 2717012,
    block_name: 'SAMDADI',
  },
  {
    state_id: 'S-32',
    state_code: 34,
    state_name: 'JHARKHAND',
    district_id: 'D-34021',
    district_code: 3413,
    district_name: 'SAHEBGANJ',
    block_id: 'B-340218',
    block_code: 3413004,
    block_name: 'BARHAIT',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31355',
    district_code: 3152,
    district_name: 'MAHARAJGANJ',
    block_id: 'B-313594',
    block_code: 3152004,
    block_name: 'MITHAURA',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22007',
    district_code: 2202,
    district_name: 'LUNGLEI',
    block_id: 'B-220016',
    block_code: 2202003,
    block_name: 'LUNGLEI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290225',
    block_code: 2925004,
    block_name: 'THIRUPPUVANAM',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313748',
    block_code: 3112002,
    block_name: 'MUZAFFARABAD',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18011',
    district_code: 1833,
    district_name: 'GONDIA',
    block_id: 'B-180114',
    block_code: 1833002,
    block_name: 'TIRODA',
  },
  {
    state_id: 'S-20',
    state_code: 22,
    state_name: 'MIZORAM',
    district_id: 'D-22007',
    district_code: 2202,
    district_name: 'LUNGLEI',
    block_id: 'B-220027',
    block_code: 2202006,
    block_name: 'TLABUNG',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290223',
    block_code: 2925012,
    block_name: 'S.PUDUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313752',
    block_code: 3112003,
    block_name: 'PUWARKA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20002',
    district_code: 2004,
    district_name: 'CHANDEL',
    block_id: 'B-200007',
    block_code: 2004006,
    block_name: 'KHENGJOY T D BLOCK',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17017',
    district_code: 1745,
    district_name: 'DINDORI',
    block_id: 'B-170110',
    block_code: 1745001,
    block_name: 'SHAHPURA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270053',
    block_code: 2717009,
    block_name: 'DHANAU',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313745',
    block_code: 3112004,
    block_name: 'BALLIA KHERI',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20002',
    district_code: 2004,
    district_name: 'CHANDEL',
    block_id: 'B-200005',
    block_code: 2004002,
    block_name: 'CHANDEL T D BLOCK',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17017',
    district_code: 1745,
    district_name: 'DINDORI',
    block_id: 'B-170106',
    block_code: 1745002,
    block_name: 'DINDORI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270059',
    block_code: 2717010,
    block_name: 'KALYANPUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313749',
    block_code: 3112009,
    block_name: 'NAGAL',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20002',
    district_code: 2004,
    district_name: 'CHANDEL',
    block_id: 'B-200006',
    block_code: 2004007,
    block_name: 'KHANGBAROL T D BLOCK',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17020',
    district_code: 1743,
    district_name: 'HARDA',
    block_id: 'B-170122',
    block_code: 1743003,
    block_name: 'TIMARNI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270064',
    block_code: 2717011,
    block_name: 'SEDWA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313751',
    block_code: 3112010,
    block_name: 'NANAUTA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20002',
    district_code: 2004,
    district_name: 'CHANDEL',
    block_id: 'B-200004',
    block_code: 2004003,
    block_name: 'CHAKPIKARONG T D BLOCK',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33002',
    district_code: 3319,
    district_name: 'BALODA BAZAR',
    block_id: 'B-330007',
    block_code: 3319002,
    block_name: 'BHATAPARA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270062',
    block_code: 2717013,
    block_name: 'RAMSAR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313755',
    block_code: 3112005,
    block_name: 'SARSAWAN',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140154',
    block_code: 1421017,
    block_name: 'KUND',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33002',
    district_code: 3319,
    district_name: 'BALODA BAZAR',
    block_id: 'B-330008',
    block_code: 3319004,
    block_name: 'KASDOL',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270058',
    block_code: 2717014,
    block_name: 'GUDHAMALANI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313569',
    block_code: 3172001,
    block_name: 'PADRAUNA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140157',
    block_code: 1421014,
    block_name: 'POMBAY',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33002',
    district_code: 3319,
    district_name: 'BALODA BAZAR',
    block_id: 'B-330009',
    block_code: 3319005,
    block_name: 'PALARI',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270067',
    block_code: 2717008,
    block_name: 'SIWANA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313566',
    block_code: 3172002,
    block_name: 'KHADDA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140151',
    block_code: 1421015,
    block_name: 'DK MARG',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33002',
    district_code: 3319,
    district_name: 'BALODA BAZAR',
    block_id: 'B-330010',
    block_code: 3319006,
    block_name: 'SIMGA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290218',
    block_code: 2925011,
    block_name: 'KANNANGUDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313574',
    block_code: 3172003,
    block_name: 'VISHUNPURA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140152',
    block_code: 1421016,
    block_name: 'FRISAL',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33002',
    district_code: 3319,
    district_name: 'BALODA BAZAR',
    block_id: 'B-330006',
    block_code: 3319001,
    block_name: 'BALODABAZAR',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290215',
    block_code: 2925005,
    block_name: 'ILAYANGUDI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313568',
    block_code: 3172004,
    block_name: 'NEBUA NAURANGIA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140155',
    block_code: 1421012,
    block_name: 'MANZGAM',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33031',
    district_code: 3325,
    district_name: 'SUKMA',
    block_id: 'B-330131',
    block_code: 3325001,
    block_name: 'CHHINDGARH',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290224',
    block_code: 2925006,
    block_name: 'THIRUPPATHUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313563',
    block_code: 3172005,
    block_name: 'HATA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140148',
    block_code: 1421013,
    block_name: 'BEHI BAGH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17017',
    district_code: 1745,
    district_name: 'DINDORI',
    block_id: 'B-170107',
    block_code: 1745006,
    block_name: 'KARANJIYA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290222',
    block_code: 2925001,
    block_name: 'SIVAGANGA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313567',
    block_code: 3172006,
    block_name: 'MOTICHAK',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140158',
    block_code: 1421005,
    block_name: 'QUIMOH',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17017',
    district_code: 1745,
    district_name: 'DINDORI',
    block_id: 'B-170108',
    block_code: 1745007,
    block_name: 'MEHANDWANI',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290219',
    block_code: 2925003,
    block_name: 'MANAMADURAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313564',
    block_code: 3172008,
    block_name: 'KAPTAINGANJ',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140156',
    block_code: 1421004,
    block_name: 'PAHLOO',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17020',
    district_code: 1743,
    district_name: 'HARDA',
    block_id: 'B-170121',
    block_code: 1743001,
    block_name: 'KHIRKIYA',
  },
  {
    state_id: 'S-27',
    state_code: 29,
    state_name: 'TAMIL NADU',
    district_id: 'D-29022',
    district_code: 2925,
    district_name: 'SIVAGANGAI',
    block_id: 'B-290214',
    block_code: 2925010,
    block_name: 'DEVAKOTTAI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313570',
    block_code: 3172009,
    block_name: 'RAMKOLA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140149',
    block_code: 1421002,
    block_name: 'DEVSAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17020',
    district_code: 1743,
    district_name: 'HARDA',
    block_id: 'B-170120',
    block_code: 1743002,
    block_name: 'HARDA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270048',
    block_code: 2717001,
    block_name: 'BALOTRA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313571',
    block_code: 3172010,
    block_name: 'SEORAHI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140153',
    block_code: 1421003,
    block_name: 'KULGAM',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20013',
    district_code: 2002,
    district_name: 'TAMENGLONG',
    block_id: 'B-200058',
    block_code: 2002001,
    block_name: 'TAMEI T D BLOCK',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270049',
    block_code: 2717002,
    block_name: 'BARMER',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313565',
    block_code: 3172011,
    block_name: 'KASAYA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14010',
    district_code: 1421,
    district_name: 'KULGAM',
    block_id: 'B-140150',
    block_code: 1421001,
    block_name: 'D H PORA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20013',
    district_code: 2002,
    district_name: 'TAMENGLONG',
    block_id: 'B-200060',
    block_code: 2002002,
    block_name: 'TOUSEM T D BLOCK',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270051',
    block_code: 2717003,
    block_name: 'BAYTOO',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313573',
    block_code: 3172012,
    block_name: 'TAMKUHIRAJ',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11032',
    district_code: 1115,
    district_name: 'VADODARA',
    block_id: 'B-110238',
    block_code: 1115003,
    block_name: 'PADRA',
  },
  {
    state_id: 'S-18',
    state_code: 20,
    state_name: 'MANIPUR',
    district_id: 'D-20013',
    district_code: 2002,
    district_name: 'TAMENGLONG',
    block_id: 'B-200059',
    block_code: 2002003,
    block_name: 'TAMENGLONG T D BLOCK',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270052',
    block_code: 2717004,
    block_name: 'CHOHTAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313562',
    block_code: 3172013,
    block_name: 'FAZILNAGAR',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11032',
    district_code: 1115,
    district_name: 'VADODARA',
    block_id: 'B-110239',
    block_code: 1115004,
    block_name: 'SAVLI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33031',
    district_code: 3325,
    district_name: 'SUKMA',
    block_id: 'B-330132',
    block_code: 3325002,
    block_name: 'KONTA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270054',
    block_code: 2717005,
    block_name: 'DHORIMANNA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313561',
    block_code: 3172014,
    block_name: 'DUDHAHI',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11032',
    district_code: 1115,
    district_name: 'VADODARA',
    block_id: 'B-110235',
    block_code: 1115006,
    block_name: 'DABHOI',
  },
  {
    state_id: 'S-31',
    state_code: 33,
    state_name: 'CHHATTISGARH',
    district_id: 'D-33031',
    district_code: 3325,
    district_name: 'SUKMA',
    block_id: 'B-330133',
    block_code: 3325003,
    block_name: 'SUKMA',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270066',
    block_code: 2717006,
    block_name: 'SINDHARI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3025',
    district_code: 306,
    district_name: 'WEST SIANG',
    block_id: 'B-30114',
    block_code: 306004,
    block_name: 'LIROMOBA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11032',
    district_code: 1115,
    district_name: 'VADODARA',
    block_id: 'B-110240',
    block_code: 1115012,
    block_name: 'SINOR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17017',
    district_code: 1745,
    district_name: 'DINDORI',
    block_id: 'B-170109',
    block_code: 1745005,
    block_name: 'SAMNAPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270056',
    block_code: 2717016,
    block_name: 'GADRAROAD',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3025',
    district_code: 306,
    district_name: 'WEST SIANG',
    block_id: 'B-30111',
    block_code: 306008,
    block_name: 'AALO EAST',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11032',
    district_code: 1115,
    district_name: 'VADODARA',
    block_id: 'B-110241',
    block_code: 1115001,
    block_name: 'VADODARA',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17017',
    district_code: 1745,
    district_name: 'DINDORI',
    block_id: 'B-170104',
    block_code: 1745003,
    block_name: 'AMARPUR',
  },
  {
    state_id: 'S-25',
    state_code: 27,
    state_name: 'RAJASTHAN',
    district_id: 'D-27005',
    district_code: 2717,
    district_name: 'BARMER',
    block_id: 'B-270061',
    block_code: 2717017,
    block_name: 'PATAUDI',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3025',
    district_code: 306,
    district_name: 'WEST SIANG',
    block_id: 'B-30112',
    block_code: 306001,
    block_name: 'AALO WEST',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11032',
    district_code: 1115,
    district_name: 'VADODARA',
    block_id: 'B-110236',
    block_code: 1115013,
    block_name: 'DESAR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17017',
    district_code: 1745,
    district_name: 'DINDORI',
    block_id: 'B-170105',
    block_code: 1745004,
    block_name: 'BAJAG',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313621',
    block_code: 3119001,
    block_name: 'NANDGAON',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3025',
    district_code: 306,
    district_name: 'WEST SIANG',
    block_id: 'B-30117',
    block_code: 306014,
    block_name: 'BAGRA',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11032',
    district_code: 1115,
    district_name: 'VADODARA',
    block_id: 'B-110237',
    block_code: 1115002,
    block_name: 'KARJAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313615',
    block_code: 3119003,
    block_name: 'CHAUMUHA',
  },
  {
    state_id: 'S-03',
    state_code: 3,
    state_name: 'ARUNACHAL PRADESH',
    district_id: 'D-3025',
    district_code: 306,
    district_name: 'WEST SIANG',
    block_id: 'B-30113',
    block_code: 306012,
    block_name: 'DARAK',
  },
  {
    state_id: 'S-09',
    state_code: 11,
    state_name: 'GUJARAT',
    district_id: 'D-11032',
    district_code: 1115,
    district_name: 'VADODARA',
    block_id: 'B-110242',
    block_code: 1115005,
    block_name: 'VAGHODIA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313618',
    block_code: 3119004,
    block_name: 'GOVARDHAN',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313750',
    block_code: 3112006,
    block_name: 'NAKUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360342',
    block_code: 3620029,
    block_name: 'CHANDUR',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313617',
    block_code: 3119006,
    block_name: 'FARAH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313753',
    block_code: 3112008,
    block_name: 'RAMPUR MANIHARAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360350',
    block_code: 3620012,
    block_name: 'MENDORA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313622',
    block_code: 3119007,
    block_name: 'NOHJHIL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313746',
    block_code: 3112011,
    block_name: 'DEOBAND',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360364',
    block_code: 3620027,
    block_name: 'YERGATLA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313623',
    block_code: 3119009,
    block_name: 'RAYA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18021',
    district_code: 1831,
    district_name: 'NANDURBAR',
    block_id: 'B-180199',
    block_code: 1831004,
    block_name: 'TALODA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360352',
    block_code: 3620028,
    block_name: 'MOSARA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313614',
    block_code: 3119010,
    block_name: 'BALDEO',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18021',
    district_code: 1831,
    district_name: 'NANDURBAR',
    block_id: 'B-180198',
    block_code: 1831005,
    block_name: 'SHAHADA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360354',
    block_code: 3620015,
    block_name: 'MUPKAL',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31358',
    district_code: 3119,
    district_name: 'MATHURA',
    block_id: 'B-313616',
    block_code: 3119002,
    block_name: 'CHHATA',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18021',
    district_code: 1831,
    district_name: 'NANDURBAR',
    block_id: 'B-180197',
    block_code: 1831007,
    block_name: 'NAVAPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360339',
    block_code: 3620002,
    block_name: 'BALKONDA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313747',
    block_code: 3112007,
    block_name: 'GANGOH',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360340',
    block_code: 3620003,
    block_name: 'BHEEMGAL',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18021',
    district_code: 1831,
    district_name: 'NANDURBAR',
    block_id: 'B-180194',
    block_code: 1831002,
    block_name: 'AKKALKUWA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360341',
    block_code: 3620004,
    block_name: 'BODHAN',
  },
  {
    state_id: 'S-16',
    state_code: 18,
    state_name: 'MAHARASHTRA',
    district_id: 'D-18021',
    district_code: 1831,
    district_name: 'NANDURBAR',
    block_id: 'B-180196',
    block_code: 1831006,
    block_name: 'NANDURBAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360346',
    block_code: 3620008,
    block_name: 'JAKRANPALLE',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31369',
    district_code: 3112,
    district_name: 'SAHARANPUR',
    block_id: 'B-313754',
    block_code: 3112001,
    block_name: 'SADAULI QADEEM',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360348',
    block_code: 3620010,
    block_name: 'KOTGIRI',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31352',
    district_code: 3172,
    district_name: 'KUSHI NAGAR',
    block_id: 'B-313572',
    block_code: 3172007,
    block_name: 'SUKRAULI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360349',
    block_code: 3620011,
    block_name: 'MAKLOOR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140128',
    block_code: 1414024,
    block_name: 'KEERIAN GANGYAL',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360351',
    block_code: 3620013,
    block_name: 'MORTAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140132',
    block_code: 1414027,
    block_name: 'MARHEEN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360355',
    block_code: 3620016,
    block_name: 'NANDIPET',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140133',
    block_code: 1414028,
    block_name: 'NAGRI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360356',
    block_code: 3620017,
    block_name: 'NAVIPET',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140116',
    block_code: 1414020,
    block_name: 'BAGGAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360360',
    block_code: 3620023,
    block_name: 'SIRKONDA',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140120',
    block_code: 1414021,
    block_name: 'BHOOND',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360361',
    block_code: 3620024,
    block_name: 'VARNI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140118',
    block_code: 1414001,
    block_name: 'BARNOTI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360362',
    block_code: 3620025,
    block_name: 'VELPUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140125',
    block_code: 1414005,
    block_name: 'DUGGAN',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360343',
    block_code: 3620005,
    block_name: 'DHARPALLE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140129',
    block_code: 1414008,
    block_name: 'LOHAI-MALHAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360338',
    block_code: 3620001,
    block_name: 'ARMOOR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140117',
    block_code: 1414003,
    block_name: 'BANI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360347',
    block_code: 3620009,
    block_name: 'KAMMARAPALLE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140121',
    block_code: 1414006,
    block_name: 'BILLAWAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360357',
    block_code: 3620020,
    block_name: 'NIZAMABAD',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140126',
    block_code: 1414007,
    block_name: 'HIRANAGAR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360358',
    block_code: 3620021,
    block_name: 'RENJAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140127',
    block_code: 1414002,
    block_name: 'KATHUA',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360353',
    block_code: 3620014,
    block_name: 'MUGPAL',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140119',
    block_code: 1414004,
    block_name: 'BASHOLI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360344',
    block_code: 3620006,
    block_name: 'DICHPALLE',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140130',
    block_code: 1414025,
    block_name: 'MAHANPUR',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360345',
    block_code: 3620007,
    block_name: 'INDALWAI',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140131',
    block_code: 1414026,
    block_name: 'MANDLI',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360359',
    block_code: 3620022,
    block_name: 'RUDRUR',
  },
  {
    state_id: 'S-12',
    state_code: 14,
    state_name: 'JAMMU AND KASHMIR',
    district_id: 'D-14008',
    district_code: 1414,
    district_name: 'KATHUA',
    block_id: 'B-140134',
    block_code: 1414029,
    block_name: 'NAGROTA GUJROO',
  },
  {
    state_id: 'S-34',
    state_code: 36,
    state_name: 'TELANGANA',
    district_id: 'D-36023',
    district_code: 3620,
    district_name: 'NIZAMABAD',
    block_id: 'B-360363',
    block_code: 3620026,
    block_name: 'YEDAPALLE',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17029',
    district_code: 1701,
    district_name: 'MORENA',
    block_id: 'B-170180',
    block_code: 1701004,
    block_name: 'PAHADGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31332',
    district_code: 3134,
    district_name: 'FARRUKHABAD',
    block_id: 'B-313351',
    block_code: 3134002,
    block_name: 'NAWABGANJ',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17029',
    district_code: 1701,
    district_name: 'MORENA',
    block_id: 'B-170176',
    block_code: 1701001,
    block_name: 'AMBAH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31332',
    district_code: 3134,
    district_name: 'FARRUKHABAD',
    block_id: 'B-313353',
    block_code: 3134003,
    block_name: 'SHAMSABAD',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17029',
    district_code: 1701,
    district_name: 'MORENA',
    block_id: 'B-170181',
    block_code: 1701002,
    block_name: 'PORSA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31332',
    district_code: 3134,
    district_name: 'FARRUKHABAD',
    block_id: 'B-313352',
    block_code: 3134004,
    block_name: 'RAJEPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17029',
    district_code: 1701,
    district_name: 'MORENA',
    block_id: 'B-170179',
    block_code: 1701003,
    block_name: 'MORENA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31332',
    district_code: 3134,
    district_name: 'FARRUKHABAD',
    block_id: 'B-313349',
    block_code: 3134007,
    block_name: 'KAMALGANJ',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17029',
    district_code: 1701,
    district_name: 'MORENA',
    block_id: 'B-170177',
    block_code: 1701005,
    block_name: 'JOURA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31332',
    district_code: 3134,
    district_name: 'FARRUKHABAD',
    block_id: 'B-313347',
    block_code: 3134008,
    block_name: 'BARHPUR',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17029',
    district_code: 1701,
    district_name: 'MORENA',
    block_id: 'B-170178',
    block_code: 1701006,
    block_name: 'KAILARAS',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313450',
    block_code: 3130020,
    block_name: 'BHARAWAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17029',
    district_code: 1701,
    district_name: 'MORENA',
    block_id: 'B-170182',
    block_code: 1701007,
    block_name: 'SABALGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313448',
    block_code: 3130021,
    block_name: 'BAWAN',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17034',
    district_code: 1709,
    district_name: 'PANNA',
    block_id: 'B-170201',
    block_code: 1709001,
    block_name: 'AJAIGARH',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313451',
    block_code: 3130023,
    block_name: 'BHARKHANI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17034',
    district_code: 1709,
    district_name: 'PANNA',
    block_id: 'B-170203',
    block_code: 1709002,
    block_name: 'PANNA',
  },
  {
    state_id: 'S-29',
    state_code: 31,
    state_name: 'UTTAR PRADESH',
    district_id: 'D-31342',
    district_code: 3130,
    district_name: 'HARDOI',
    block_id: 'B-313460',
    block_code: 3130026,
    block_name: 'SANDI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17034',
    district_code: 1709,
    district_name: 'PANNA',
    block_id: 'B-170204',
    block_code: 1709004,
    block_name: 'PAWAI',
  },
  {
    state_id: 'S-15',
    state_code: 17,
    state_name: 'MADHYA PRADESH',
    district_id: 'D-17034',
    district_code: 1709,
    district_name: 'PANNA',
    block_id: 'B-170205',
    block_code: 1709005,
    block_name: 'SHAHNAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240090',
    block_code: 2412002,
    block_name: 'BEGUNIAPADA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240091',
    block_code: 2412003,
    block_name: 'BELLAGUNTHA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240103',
    block_code: 2412015,
    block_name: 'KUKUDAKHANDI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240107',
    block_code: 2412019,
    block_name: 'RANGEILUNDA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240108',
    block_code: 2412020,
    block_name: 'SANAKHEMUNDI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240089',
    block_code: 2412001,
    block_name: 'ASKA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240092',
    block_code: 2412004,
    block_name: 'BHANJANAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240093',
    block_code: 2412005,
    block_name: 'BUGUDA',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240094',
    block_code: 2412006,
    block_name: 'CHATRAPUR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240096',
    block_code: 2412008,
    block_name: 'DHARAKOTE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240097',
    block_code: 2412009,
    block_name: 'DIGAPAHANDI',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240098',
    block_code: 2412010,
    block_name: 'GANJAM',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240099',
    block_code: 2412011,
    block_name: 'HINJILICUT',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240100',
    block_code: 2412012,
    block_name: 'JAGANNATHPRASAD',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240101',
    block_code: 2412013,
    block_name: 'KABISURYANAGAR',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240102',
    block_code: 2412014,
    block_name: 'KHALLIKOTE',
  },
  {
    state_id: 'S-22',
    state_code: 24,
    state_name: 'ODISHA',
    district_id: 'D-24011',
    district_code: 2412,
    district_name: 'GANJAM',
    block_id: 'B-240104',
    block_code: 2412016,
    block_name: 'PATRAPUR',
  }
];